(function ()
{
    'use strict';

    angular
        .module('app.spaces',
            [
                // 3rd Party Dependencies
                'datatables',
                'ui.calendar',
                'base64'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.spaces', {
            url      : '/spaces',
            resolve : {
            	accesstypes: function (msApi)
                {
                    return msApi.resolve('accesstypes@get');
                }
            },
            views    : {
                'content@app': {
                    templateUrl: 'app/main/spaces/spaces.html',
                    controller : 'SpacesController as vm'
                }
            },
            bodyClass: 'dashboard-server'
        });
        
        // Api
        //msApiProvider.register('learningspaces.project', ['app/data/learningspaces/data.json']);
       
        msApiProvider.register('accesstypes', ['app/data/accesstypes/space_event.json']); 
                
        msNavigationServiceProvider.saveItem('spaces', {
            title: "LearningSpaces", 
            state: 'app.spaces',
            weight: 1,
            icon: 'icon-bulletin-board'
        });

        $translatePartialLoaderProvider.addPart('app/main/spaces');
    }

})();
(function ()
{
    'use strict';

    angular.module('app.spaces')
        .controller('SpaceFormDialogController', SpaceFormDialogController);

    /** @ngInject */
    function SpaceFormDialogController(
        $mdDialog, 
        cvicRequestService, 
        dialogData, 
        __env, 
        $scope, 
        cvicImageService, 
        $base64, 
        cvicJWTService,
        uuid,
        ApiEndPoints
        )
    {
        var vm = this;

        // Data
        vm.dialogType = dialogData.type;
        vm.space = dialogData.space;
    	vm.accessTypes = dialogData.accessTypes;

        // Methods
        vm.saveSpace = saveSpace;
        vm.closeDialog = closeDialog;

        //TODO depends on data
        if( vm.space.coverImage != null ) {
            $scope.varImgSrc = __env.apiUrl + ApiEndPoints.ImageController.getImage + vm.space.coverImage.uid + '.jpg';
            $scope.bImageIsAdded = true;
        }
        else {
            $scope.varImgSrc = 'assets/images/dummy/classroom.jpg';
            $scope.bImageIsAdded = false;
        }
        
        $scope.fnAddImage = fnAddImage;
        $scope.fnRemoveImage = fnRemoveImage;

        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
            // Figure out the title
            if(vm.dialogType == 'edit') {
                vm.dialogTitle = 'EditSpace';
            } else {
        	   vm.dialogTitle = 'AddSpace';	    	
            }
        }
        
        function failResponseData(response) {
        	//TODO
            return {};
        } 
        
        function successResponseData(response) {
        	return response.data;
        }

        /**
         * Save the space
         */
        function saveSpace()
        { 
            var response = {
            		type  : vm.dialogType,
            		space : vm.space
            };

            var url = null;

            if(vm.dialogType == 'edit') {
                url = ApiEndPoints.SpaceController.updateSpace;
            } else {
                url = ApiEndPoints.SpaceController.createSpace;
            }


            var bFileIsAdded = (document.getElementById('space-img-file').files.length == 1)
            
            //File added means there was an upload
            if ( bFileIsAdded ) {
                var objFile = document.getElementById('space-img-file').files[0];
                var objFileReader = new FileReader();
                var strMimeType = objFile.type;
                var strTitle = objFile.name;

                cvicImageService.getTemplate().then( function (objImgTpl) {

                        
                    objFileReader.onload = function (e) {
                        var arrBytes = e.target.result;
                        var strEncodedContent = cvicImageService.arrayBufferToBase64(arrBytes);
                            

                        objImgTpl.title = strTitle;
                        objImgTpl.mimeType = strMimeType;
                        objImgTpl.content = strEncodedContent;
                        objImgTpl.owner.uid = cvicJWTService.currentUserId();
                        objImgTpl.uid = uuid.v4();
                        vm.space.coverImage = objImgTpl;

                        executeRequest();

                    };
                        
                    objFileReader.readAsArrayBuffer(objFile);
                } );

            }
            else {
                //This means that the user doesn't want an image on this group.
                if ( !$scope.bImageIsAdded ) {
                    vm.space.coverImage = null;
                }
                executeRequest();
            }

            function executeRequest() {

                cvicRequestService
                    .requestJsonData(__env.apiUrl + url, 'POST', successResponseData, failResponseData, vm.space)
                    .then(function(space) {                     
                        if (!angular.equals(space, {})) {
                            response.space = space;
                            $mdDialog.hide(response);
                        }
                        else {
                            //TODO
                        }
                });
            }

        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }

        function fnAddImage(event) {

            if(event.target.files.length == 1) {
                var objFile = event.target.files[0];
                var objReader = new FileReader();

                objReader.onload = function (e) {
                    $scope.varImgSrc = e.target.result;
                    $scope.bImageIsAdded = true;
                    $('#title').focus();
                }

                objReader.readAsDataURL(objFile);
            }

        }

        function fnRemoveImage() {
            $scope.varImgSrc = 'assets/images/dummy/classroom.jpg';
            $('#space-img-file').val(null);
            $scope.bImageIsAdded = false;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.profile', [
                                // 3rd Party Dependencies
                                'ngMaterial',
                                'xeditable'
                            ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $provide)
    {
        $stateProvider.state('app.profile', {
            url      : '/profile/:userUid?openGrades',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            },
            bodyClass: 'profile'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/profile');        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.profile')
        .controller('OrderChildController', OrderChildController);

    /** @ngInject */
    function OrderChildController(
    		$q,
    		$scope,
    		$rootScope,
    		$mdDialog,  
    		$state, 
    		$translate,
    		cvicRequestService, 
    		cvicJWTService,
            cvicOptionsData,
            ApiEndPoints,
            __env,
            $sce)
    {
        var vm = this;
        vm.loadingTeachers = false;
        vm.teachers = [];
        vm.endSearchTeachers = endSearchTeachers;
        vm.childNameMinLen = 7;
        vm.childEmailMinLen = 4;
        vm.toManyMatchesWithFilter = false;
        vm.hdnDisableReadyBtn = null;
        
        var pendingSearch, pendingRequest, cancelSearch = angular.noop;
        var lastSearch;
         
        vm.filter = {childName: null, childEmail: null, childClass: null, school: null};
 
        cvicOptionsData.schoolsRequest().then( function( schools ) {
        	vm.schools = schools;
        	return;
        });
        
        vm.closeDialog = function() {
        	$mdDialog.cancel();
        };
        
        //"trm_title", "trm_email", "trm_clazz", "org"
        vm.searchTeachers =  function(field){	
        	vm.toManyMatchesWithFilter = false;
        	if (( vm.filter.childName && vm.filter.childName.length > vm.childNameMinLen ) 
        			&& ( !vm.filter.childEmail || (vm.filter.childEmail.length > vm.childEmailMinLen && vm.filter.childEmail.indexOf("@") > -1)) 
        	) {
        		delayedQuerySearch();
        	}
        };
        
        //teacher_uid, notes, token
        vm.sendChildRequest = function() {       	
        	var objPostData = {};
            objPostData.teacher_uid = vm.teacher;
            objPostData.notes = vm.message;
            objPostData.token = vm.token; 
            objPostData.phone = vm.parentPhone;  
        	
        	cvicRequestService
		    	.fnPostJsonData(__env.apiUrl + ApiEndPoints.ParentController.sendRequest, objPostData)
		    	.then(function(response) {		    		 
		    		var alertMsg = $mdDialog.alert({
	 	    	        htmlContent: $translate.instant("ORDER_CHILD.PARENT_REQUEST_FEEDBACK"),
	 	    	        ok: $translate.instant("ORDER_CHILD.CLOSE"),
	 	    	        clickOutsideToClose: true
	 				});
	
	 				$mdDialog.show( alertMsg ).finally(function() { alertMsg = undefined;});
	 				vm.closeDialog();
		    	});
	          
            return;
        };
        
        function endSearchTeachers(teachers, token){ 
        	vm.teachers = teachers;
        	vm.token = token;
        	vm.loadingTeachers = false;
        	return vm.teachers;
        }
        
        /**
         * Async search for contacts
         * Also debounce the queries; since the md-contact-chips does not support this
         */
        function delayedQuerySearch() {           
	        cancelSearch();
	        pendingSearch = $q(function(resolve, reject) {
		          cancelSearch = reject;
		          
		        //"trm_title", "trm_email", "trm_clazz", "org"
		          var objPostData = {};
                  objPostData.trm_title = vm.filter.childName;
                  objPostData.trm_email = vm.filter.childEmail;
                  objPostData.trm_clazz = vm.filter.childClass;
              	  objPostData.org = vm.filter.school;
		           
              	  vm.loadingTeachers = true;
              	  
		          cvicRequestService
			    	.fnPostJsonData(__env.apiUrl + ApiEndPoints.ParentController.suggestTeacher, objPostData)
			    	.then(function(response) {			    		 
			    		 //console.log(JSON.stringify(response.data));			    		 
			    		 if (response.data.teachers && response.data.teachers.length > 0 ) {
			    			 resolve( vm.endSearchTeachers(response.data.teachers, response.data.token) );
			    		 }
			    		 else {
			    			 if (response.data.error) {
			    				 vm.toManyMatchesWithFilter = true;
			    			 }			    			 
			    			 resolve( vm.endSearchTeachers([], null) );
			    		 }
		    			 refreshDebounce();
			    	}); //cvicRequestService
		          
	        });//$q
	          
            return pendingSearch;
        }
        
        function refreshDebounce() {
          lastSearch = 0;
          pendingSearch = null;
          cancelSearch = angular.noop;
        }
        
        /**
         * Debounce if querying faster than 300ms
         */
        function debounceSearch() {
          var now = new Date().getMilliseconds();
          lastSearch = lastSearch || now;
          return false;//((now - lastSearch) < 300);
        }
                
    }
})();             
(function ()
{
    'use strict';

    angular
        .module('app.mail',
            [
                // 3rd Party Dependencies
                'textAngular',
                'ngMaterial'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, $urlRouterProvider, msApiProvider, msNavigationServiceProvider, $provide)
    {
        // State
        $stateProvider
            .state('app.mail', {
               // abstract: true,
                url     : '/mail',
                resolve : {
                    Folders: function (msApi)
                    {
                        return msApi.resolve('mail.folders@get');
                    },
                    Labels : function (msApi)
                    {
                        return msApi.resolve('mail.labels@get');
                    }
                }
            })
            .state('app.mail.threads', {
                url      : '/{type:(?:label)}/:filter',
                parent	 : 'app.mail',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/mail/mail.html',
                        controller : 'MailController as vm'
                    }
                },
                params   : {
                    type: {
                        value : null,
                        squash: true
                    }
                },
                bodyClass: 'mail'
            })
            .state('app.mail.threads.thread', {
                url      : '/:threadId',
                parent	 : 'app.mail.threads',
                bodyClass: 'mail'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/mail');

        // Api
        msApiProvider.register('mail.folders', ['app/data/mail/folders.json']);
        msApiProvider.register('mail.labels', ['app/data/mail/labels.json']);

        // Navigation
        $urlRouterProvider.when('/mail','/mail/system');
        msNavigationServiceProvider.saveItem('mail', {
            title      : 'MAIL.MAILBOX',
            state      : 'app.mail.threads',
            stateParams: {
                filter: 'system'
            },
            weight     : 1,
            icon: 'icon-email'
        });

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.mail')
        .controller('ComposeDialogController', ComposeDialogController);

    /** @ngInject */
    /**
     * @param dialogData : {
          		message: null,
                spaceUid: null,//space uid
                eventUid: null,//event uid
                rpTo:  [],//user audience
                fwTo:  false
           }
     */
    function ComposeDialogController($scope, $mdDialog,	$timeout, cvicJWTService, cvicRequestService, cvicAudienceService, dialogData, __env)
    {
        var vm = this;        
        $scope.audience = [];
        
        vm.message = dialogData.message;
        vm.spaceUid = dialogData.spaceUid;
        vm.eventUid = dialogData.eventUid;
        vm.rpTo = ( dialogData.rpTo ? dialogData.rpTo : []);
        vm.sdTo = ( dialogData.sdTo ? dialogData.sdTo : []);
        vm.sndTo = ( dialogData.sndTo ? dialogData.sndTo : []);
        vm.fwTo = dialogData.fwTo;        
                
        vm.currentUserAudience = currentUserAudience(vm.message);
        vm.groupAudienceTempl = groupAudienceTempl(vm.message);
        
        // Data
        vm.form = { from: '', to: null };
        vm.hiddenCC = true;
        vm.hiddenBCC = true;
        
        vm.recipientsRequired = false;
        vm.bodyRequired = false;
        vm.subjectRequired = false;

        // If replying
        if ( angular.isDefined(vm.rpTo) && vm.rpTo.length > 0 ) {
        	//alert(JSON.stringify(vm.rpTo));
            vm.form.to = vm.rpTo[0].title + " <" + vm.rpTo[0].email + ">";
            vm.form.subject = 'RE: ' + vm.message.subject;
            vm.form.message = '<blockquote>' +  vm.message.body + '</blockquote>';
            $scope.audience = vm.rpTo;
        }
        
        if( angular.isDefined(vm.sndTo) && vm.sndTo.length > 0) {
        	vm.form.to = vm.sndTo[0].title + " <" + vm.sndTo[0].email + ">";
            $scope.audience = vm.sndTo;
        }

        // If creating new with preset audience
        if( angular.isDefined(vm.sdTo) && vm.sdTo.length > 0) {
            /*vm.form.to = vm.sdTo;

            for(var index = 0; index < vm.sdTo.length; ++index ) {
                vm.form.to = vm.sdTo;
            }*/

            vm.form.subject = vm.message.subject;

            $scope.audience = vm.sdTo;
        }
        
        // If fw
        if ( angular.isDefined(vm.fwTo) && vm.fwTo ) { 
            vm.form.subject = 'FW: ' +  vm.message.subject;
            vm.form.message = '<blockquote>' +  vm.message.body + '</blockquote>';
        }

        // Methods
        vm.closeDialog = closeDialog;
        vm.sendDialog = sendDialog;
        
        //////////
        function sendDialog()
        { 
        	var submitMessage = jQuery.extend(true, {}, vm.message);
        	submitMessage.title = submitMessage.subject = vm.form.subject;
        	submitMessage.description = submitMessage.body = vm.form.message;
        	        	        	
        	submitMessage.userAudience = cvicAudienceService.getUserAudience( $scope.audience, vm.currentUserAudience);
        	submitMessage.userAudience.push(vm.currentUserAudience);
        	submitMessage.groupAudience = cvicAudienceService.getGroupAudience( $scope.audience, vm.groupAudienceTempl);
        	
        	vm.recipientsRequired = ($scope.audience.length == 0 
					            		&& ( (vm.spaceUid === undefined || vm.spaceUid == null) 
					        				&& (vm.eventUid === undefined || vm.eventUid == null)));        	
        	vm.bodyRequired = (vm.form.message === undefined || vm.form.message == null || vm.form.message.length == 0);
        	vm.subjectRequired = (vm.form.subject === undefined || vm.form.subject == null || vm.form.subject.length == 0);
        	
        	if (vm.recipientsRequired == true || vm.bodyRequired == true || vm.subjectRequired == true ) {
        		$timeout(function() {
        			vm.recipientsRequired = false;
        			vm.bodyRequired = false;
        			vm.subjectRequired = false;
        		}, 6000, true);
        	}
        	else {
	        	cvicRequestService
	     		.requestJsonData(__env.apiUrl + '/m/create', 'POST', successResponseData, failResponseData, submitMessage)
	     		.then(function(message) { 
	     			if (!angular.equals(message, {})) {
	     				$mdDialog.hide(message);
	     			}
	     			else {
	     				//TODO
	     			}
	     		});
        	}
        }

        function closeDialog()
        {
        	$mdDialog.cancel();
        }
                
        function failResponseData(response) {
            return {};
        }//failResponseData 
        
        function successResponseData(response) {
        	return response.data;
        }//successResponseData
        
        function groupAudienceTempl(message){
        	var groupAudience;
            for (var i = 0; i < message.groupAudience.length; i++) {
         	   var groupAudience = jQuery.extend(true, {}, message.groupAudience[i]);
         	   groupAudience.uid = null;
         	   break;
            }
            
            message.groupAudience = [];
            
            return groupAudience;
        }//groupAudienceTempl
        
        function currentUserAudience(message){
           var userAudience;
           for (var i = 0; i < message.userAudience.length; i++) {
        	   var userAudience = message.userAudience[i];
        	   if (userAudience.user.uid == cvicJWTService.currentUserId()) {
        		   break;
        	   }
           }
           
           return userAudience;
        }//currentUserAudience
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.file-manager',
            [
                // 3rd Party Dependencies
                'flow',
                'ng-sortable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.file-manager', {
            url      : '/file-manager',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/file-manager/file-manager.html',
                    controller : 'FileManagerController as vm'
                }
            },
            bodyClass: 'file-manager'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/file-manager');
        
        // Navigation
        msNavigationServiceProvider.saveItem('file-manager', {
            title : 'FM.DOCUMENTS',
            state : 'app.file-manager',
            weight: 1,
            icon: 'icon-folder'
        });
    }

})();
(function ()
{
    'use strict';

    angular.module('app.file-manager')
        .controller('RenameFolderFormDialogController', RenameFolderFormDialogController);

    /** @ngInject */
    function RenameFolderFormDialogController($mdDialog, cvicRequestService, dialogData, __env)
    {
        var vm = this;

        // Data
        vm.folder = dialogData.folder;

        // Methods
        vm.renameFolder = renameFolder;
        vm.closeDialog = closeDialog;

        //////////    
        function failResponseData(response) {
        	$state.go('app.file-manager');
        } 
        
        function successResponseData(response) {
        	return response.data;
        }
        
        /**
         * rename folder
         */
        function renameFolder()
        {                            
            if ( vm.folder.title.length > 0 ) { 
           
	            cvicRequestService
	         		.requestJsonData(__env.apiUrl + '/f/update', 'POST', successResponseData, failResponseData, vm.folder)
	         		.then(function(folder) {          			
	         			if (!angular.equals(folder, {})) {
	         				$mdDialog.hide(folder);
	         			}
	         			else {
	         				//TODO
	         			}
	         	});
            }
        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'ngRoute'
            ]);
})();
(function ()
{
    'use strict';

    angular.module('app.core')
        .controller('PlayDocumentDialogController', PlayDocumentDialogController);

    /** @ngInject */
    function PlayDocumentDialogController($mdDialog, $window, $document, cvicRequestService, ApiEndPoints, dialogData, $sce, __env)
    {
        var vm = this;
        vm.closeDialog = closeDialog;

        // Data
        vm.documentItem = dialogData.document; 
        
        /**
        * documentMode is an IE-only property
        * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
        */
        var msie = $document[0].documentMode;
        
        cvicRequestService
        	.requestHtmlData(__env.apiUrl + ApiEndPoints.DownloadController.play + vm.documentItem.uid, 'GET' )
        	.then(function(response) {
        		if ( vm.documentItem.simpleType == 'video' || vm.documentItem.simpleType == 'image' || vm.documentItem.simpleType == 'flash' ) {
        			angular.element(document.querySelector('#player')).html(response.data);
        		} else if (vm.documentItem.simpleType == 'zip') {
        			if ( msie ) {
        				$window.open($sce.trustAsResourceUrl( __env.apiUrl + response.data ), '_blank');
        				closeDialog();
        			}
        			else {
        				vm.playerIFrameSrc = $sce.trustAsResourceUrl( __env.apiUrl + response.data );
        			}
        		} else {
        			vm.playerIFrameSrc = $sce.trustAsResourceUrl( response.data );
        		}
        	});
        
        /**
         * Close the dialog
         */
        function closeDialog() { $mdDialog.cancel(); }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.file-manager')
        .controller('NewFolderFormDialogController', NewFolderFormDialogController);

    /** @ngInject */
    function NewFolderFormDialogController($mdDialog, cvicRequestService, cvicJWTService, dialogData, __env, uuid)
    {
        var vm = this;

        // Data
        vm.folder = {title:""};
        vm.space = dialogData.space;
        vm.parentFolder = dialogData.parentFolder;

        // Methods
        vm.newFolder = newFolder;
        vm.closeDialog = closeDialog;

        //////////  
        function successResponseData(response) {
        	return response.data;
        }
        
        function failObjectResponseData(response) {
            return {};
        } 
        
        /**
         * newFolder
         */
        function newFolder()
        {                            
            if ( vm.folder.title.length > 0 ) { 
           
            	cvicRequestService
 	         	.requestJsonData(__env.apiUrl + '/f/templ', 'GET', successResponseData, failObjectResponseData)
 	         	.then(function(data) {                    
                     data.uid = uuid.v4();
                     data.owner.uid = cvicJWTService.currentUserId();
                     if (vm.space != null) {
                     	data.space = vm.space; 
                     }
                     if ( vm.parentFolder != null ) { 
                     	data.container =  vm.parentFolder;
                     	data.parentFolder =  data.container;
                     }
                     data.title = vm.folder.title;
                    
                     cvicRequestService
              		.requestJsonData(__env.apiUrl + '/f/create', 'POST', successResponseData, failObjectResponseData, data)
              		.then(function(folder) {          			
              			if (!angular.equals(folder, {})) {
              				$mdDialog.hide(folder);
              			}
              			else {
              				//TODO
              			}
              		});
                     
                     
 	         	});
            }
        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular.module('app.core')
        .controller('EditDocumentFormDialogController', EditDocumentFormDialogController);

    /** @ngInject */
    function EditDocumentFormDialogController(
    		$scope,
    		$state,
    		$mdDialog, 
    		cvicRequestService, 
    		cvicFileService,
    		cvicImageService,
    		cvicJWTService,
    		dialogData,
    		__env,
    		ApiEndPoints)
    {
        var vm = this;

        // Data
        vm.document = dialogData.document; 
        vm.freediskspace = dialogData.freeDiskSpace;
        vm.documentSaving = false;
        
        vm.cvicFileService = cvicFileService;
        vm.cvicJWTService = cvicJWTService;
        
        var scope = $scope;
        scope.domFileInput = null;
        scope.newtitle = "";
        scope.newsize = "";
        scope.newsizebytes = 0;
        scope.mimetype = ""; 
        scope.executeUpdateUpload = executeUpdateUpload;
        scope.fileuploading = false;
        
        // Methods
        vm.saveDocument = saveDocument;
        vm.closeDialog = closeDialog; 
        vm.disableSave = function(){
        	return scope.fileuploading == true 
					|| scope.newsizebytes > vm.freediskspace
					|| scope.newsizebytes > vm.cvicJWTService.maxLimitedFileUploadSize();
        };
                        
        //////////    
        function failResponseData(response) {
        	$state.go('app.file-manager');
        } 
        
        function successResponseData(response) {
        	return response.data;
        }
        
        /**
         * saveDocument
         */
        function saveDocument()
        {                          
            if ( vm.document.title.length > 0 && vm.document.size <= vm.freediskspace ) {   
            	vm.documentSaving = true;
	            cvicRequestService
	         		.requestJsonData(__env.apiUrl + ApiEndPoints.DocumentController.update, 'POST', successResponseData, failResponseData, vm.document)
	         		.then(function(document) {          			
	         			if (!angular.equals(document, {})) {
	         				vm.documentSaving = false;
	         				$mdDialog.hide(document);
	         			}
	         			else {
	         				//TODO
	         			}
	         	});
            }
        }
                
        function executeUpdateUpload(event) { 
        	scope.newtitle = "";
        	scope.mimetype = "";
        	scope.newsizebytes = 0;
            scope.newsize = "";
	        scope.fileuploading = true;
	        scope.domFileInput = event.target;  
	
	        //important
	        angular.element(document.querySelector('#title')).focus();
	        
            if(scope.domFileInput.files.length == 1) { 
                var objFile = event.target.files[0];                
                var objFileReader = new FileReader(); 
                scope.newsizebytes = objFile.size;
                scope.newtitle = objFile.name;
                scope.mimetype = objFile.type;
                                 
                objFileReader.onloadend = function (e) {   
                	var arrBytes = e.target.result;
                    vm.document.content = cvicImageService.arrayBufferToBase64(arrBytes);                    
                    vm.document.size = scope.newsizebytes;
                    vm.document.mimeType = scope.mimetype; 
                    scope.newsize = cvicFileService.formatFileSize(scope.newsizebytes);
                    scope.domFileInput.value = "";
                    scope.fileuploading = false;
                    
                    //important
                    angular.element(document.querySelector('#title')).focus();
                }

                objFileReader.readAsArrayBuffer(objFile);
            }

        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.core')
        .controller('ChooseDocumentDialogController', ChooseDocumentDialogController);

    /** @ngInject */
    function ChooseDocumentDialogController( 
    		$scope, 
    		$mdDialog,
    		cvicSearchService,
    		cvicImageService,
    		cvicDateService,
    		dialogData
    		){
        var vm = this;
        
        vm.container = dialogData.container; 
        vm.strSearchTerm = "";
        // Data
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        
        $scope.cvicSearchService = cvicSearchService;
        $scope.cvicImageService = cvicImageService;
        
        //Methods
        vm.closeDialog = closeDialog;
        vm.chooseDocuments = chooseDocuments; 
        
        $scope.cvicSearchService.fnModifySearchType($scope.cvicSearchService.enumSearchType.Documents);
        $scope.cvicSearchService.fnSetSelectorMode(true);
        
        $scope.fnDisplayDate = function(intDate) {
            return cvicDateService.formatDate( new Date(intDate) );
        }

        $scope.fnChangePage = function (intNewPage) {
        	$scope.cvicSearchService.fnChangePage(intNewPage);
        };

        $scope.fnNextPage = function () {
        	$scope.cvicSearchService.fnNextPage();
        };

        $scope.fnPreviousPage = function () {
        	$scope.cvicSearchService.fnPreviousPage();
        };
                
        $scope.fnGoToItem = function (objItem) {
        	$scope.cvicSearchService.toggleSelected(objItem);
        };
        
        $scope.fnExecuteSearch = function () {
            //GRZ-4550
            //да разрешим търсене по празен стринг при закачане на документи в УП/Събитие
            //if (strTerm != null && strTerm.length >= 3) {
        		$scope.cvicSearchService.fnModifyTerm(vm.strSearchTerm);
            //}

        };
        
        cvicSearchService.fnModifyTerm(null);
         
        function chooseDocuments() {   
        	$mdDialog.hide(cvicSearchService.selectedItems());
        }

        /**
         * Close the dialog
         */
        function closeDialog() { 
            $mdDialog.cancel();
        }
    }
})();

( function () {
    'use strict';

    angular.module('app.core')
        .controller('EventsScheduleController', EventsScheduleController);

    /** @ngInject */
    function EventsScheduleController(
    		$rootScope,
    		$scope,
    		cvicRequestService, 
    		cvicDateService, 
    		cvicFormService, 
    		cvicListService,
    		cvicImageService,
            $window
    )
    {
        var evtSchCtrl = this;
        
        var userAudience = $scope.$parent.event.userAudience.map( function(ua){return ua.user.uid} );
        $scope.localChildren = [];
        $scope.findChildren = $rootScope.userDataRequest().then( function( userInfo ) {
    		var data = userInfo.children.filter( function( c ) { return userAudience.indexOf( c.uid ) >= 0; } );
    		$scope.localChildren = data;
    		return data;
        });
        
        $scope.avatar = function getUserAvatar( user ) {
            var img = user['coverImage'];

            if( img === null || user['coverImage']['uid'] === null ) {
                return 'assets/images/avatars/profile.jpg';
            }

            return cvicImageService.fnGetResizedImageUrl( 40, 40, user['coverImage']['uid'] );
        }

        
        evtSchCtrl.displayDate = function(intDate) {
            return cvicDateService.formatDate( new Date(intDate) );
        };
        
        
        evtSchCtrl.title = function( event ) {
        	var userAudience = event.userAudience.map( function(ua){return ua.user.uid} );
        	
        	var newTitle = $rootScope.userDataRequest().then( function( userInfo ) {
    			return userInfo.children
    				.filter( function( c ) {
    					return userAudience.indexOf( c.uid ) >= 0;
    				} )
    				.map( function( c ) {
    					return c.title.split(" ")[0];
    				} ); 
    		} ).then( function( children ) {
    			return children.join( ", " );
    		} ).then( function( prefix ) {
    			if ( !event.title.startsWith( prefix ) ) {
    				event.title = prefix + " » " + event.title;	
    			}
    		} );

        	return event.title;
        }
        
        evtSchCtrl.eventDetails = function(event, e) {
            cvicFormService.showEventDetailDialog( cvicListService.calendarEvent(event), null, e);
        };
        
        evtSchCtrl.openConfLink = function(event){
            $window.open(event.externalLink);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.eventsconferences',
            [
                // 3rd Party Dependencies
                'datatables',
                'ui.calendar'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.eventsconferences', {
        	url      : '/eventsconferences',
            resolve : {
            	accesstypes: function (msApi)
                {
                    return msApi.resolve('accesstypes@get');
                },
                eventtypes: function (msApi)
                {
                    return msApi.resolve('eventtypes@get');
                },
                conferencetypes: function (msApi) {
                    return msApi.resolve('conferencetypes@get');
                }
            },
            views    : {
                'content@app': {
                    templateUrl: 'app/main/eventsconferences/eventsconferences.html',
                    controller : 'EventsConferencesController as vm'
                }
            },
            bodyClass: 'dashboard-server'
        });
        
        //msApi
        msApiProvider.register('accesstypes', ['app/data/accesstypes/space_event.json']); 
        msApiProvider.register('eventtypes', ['app/data/event/types.json']);
        msApiProvider.register('conferencetypes', ['app/data/conference/types.json']);

        msNavigationServiceProvider.saveItem('eventsconferences', {
            title: 'EventsAndConferences',
            state: 'app.eventsconferences',
            weight: 1,
            icon: 'icon-calendar-blank'
        });

        $translatePartialLoaderProvider.addPart('app/main/eventsconferences');
    }

})();
(function ()
{
    'use strict';

    angular.module('app.eventsconferences')
        .controller('EventCalendarErrorController', EventCalendarErrorController);

    /** @ngInject */
    function EventCalendarErrorController($mdDialog, errorType)
    {
        var vm = this;


        vm.closeDialog = closeDialog;
        vm.error = errorType;

        //////////

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.eventsconferences')
        .controller('EventFormDialogController', EventFormDialogController);

    /** @ngInject */
    function EventFormDialogController($mdDialog, dialogData, cvicRequestService, cvicJWTService, __env, $scope, ApiEndPoints, cvicImageService, uuid)
    {
        var userUid = cvicJWTService.currentUserId();

        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.notifications = ['15 minutes before', '30 minutes before', '1 hour before'];

        vm.isPasswordEditDisabled = true;
        vm.showDateError = false;

        vm.accessTypes = dialogData.accessTypes;
        vm.eventTypes = dialogData.eventTypes;
        vm.conferenceTypes = dialogData.conferenceTypes;
        vm.calendarEvent = {};
        vm.now = new Date();

        // Methods
        vm.saveEvent = saveEvent;
        vm.removeEvent = removeEvent;
        vm.closeDialog = closeDialog;
        vm.showAdminPassword = showAdminPassword;
        
        $scope.fnAddImage = fnAddImage;
        $scope.fnRemoveImage = fnRemoveImage;
        $scope.showConferenceStep = showConferenceStep;

        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {

            // Figure out the title
            switch ( vm.dialogData.type )
            {
                case 'add' :
                    vm.dialogTitle = 'ADD';
                    vm.showDeleteEvent = false;

                    break;

                case 'edit' :
                    vm.dialogTitle = 'EDIT';
                    vm.showDeleteEvent = true;

                    break;

                default:
                    break;
            }

            // Edit
            if ( vm.dialogData.calendarEvent )
            {
                // Clone the calendarEvent object before doing anything
                // to make sure we are not going to brake FullCalendar
                vm.calendarEvent = angular.copy(vm.dialogData.calendarEvent);

                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.calendarEvent.start) )
                {
                    vm.calendarEvent.start = vm.calendarEvent.start.toDate();
                    
                    vm.calendarEvent.startTime = vm.calendarEvent.start;
                    vm.calendarEvent.startTime.setSeconds(0);
                    vm.calendarEvent.startTime.setMilliseconds(0);
                }

                if ( moment.isMoment(vm.calendarEvent.end) )
                {
                    vm.calendarEvent.end = vm.calendarEvent.end.toDate();

                    vm.calendarEvent.endTime = vm.calendarEvent.end;
                    vm.calendarEvent.endTime.setSeconds(0);
                    vm.calendarEvent.endTime.setMilliseconds(0);
                }
            }
            // Add
            else
            {
                var now = moment(new Date());

                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.dialogData.start) ) {
                    vm.dialogData.start = vm.dialogData.start.toDate();

                    if(vm.dialogData.start.getTime() < now.toDate().getTime()) {
                        vm.dialogData.start = now.toDate();
                    }

                    vm.dialogData.startTime = vm.dialogData.start;
                    vm.dialogData.startTime.setSeconds(0);
                    vm.dialogData.startTime.setMilliseconds(0);
                }

                vm.dialogData.end = moment(vm.dialogData.start);
                if ( moment.isMoment( vm.dialogData.end ) ) {
                	var initDuration = (cvicJWTService.maxConferenceDuration() > 20) ? 20 : cvicJWTService.maxConferenceDuration();


                    vm.dialogData.end = vm.dialogData.end.add( initDuration, 'minute' ).toDate();
                    
                    vm.dialogData.endTime = vm.dialogData.end;
                    vm.dialogData.endTime.setSeconds(0);
                    vm.dialogData.endTime.setMilliseconds(0);
                }

                vm.calendarEvent = {
                    start: vm.dialogData.start,
                    startTime: vm.dialogData.startTime,
                    end: vm.dialogData.end,
                    endTime: vm.dialogData.endTime,

                    notifications: []
                };
            }

            if(vm.calendarEvent.baseObj != undefined && vm.calendarEvent.baseObj.settings.joinPassword != undefined && vm.calendarEvent.baseObj.settings.adminPassword != undefined) {
                vm.calendarEvent.joinPassword = vm.calendarEvent.baseObj.settings.joinPassword;
                vm.calendarEvent.adminPassword = vm.calendarEvent.baseObj.settings.adminPassword;
            } else {
                cvicRequestService.requestJsonData(__env.apiUrl + '/conferencePasswords', 'GET', function(response) {
                    var data = response.data;

                    vm.calendarEvent.joinPassword = data.joinPassword;
                    vm.calendarEvent.adminPassword = data.adminPassword;
                }, function(response) {
                    vm.joinPassword = undefined;
                    vm.adminPassword = undefined;
                });
            }

            if( vm.calendarEvent.coverImage == null ) {
                $scope.varImgSrc = 'assets/images/dummy/children.jpeg';
                $scope.bImageIsAdded = false;
            }
            else {
                $scope.varImgSrc = __env.apiUrl + ApiEndPoints.ImageController.getImage + vm.calendarEvent.coverImage.uid + '.jpg';
                $scope.bImageIsAdded = true;
            }
        }

        /**
         * Save the event
         */
        function saveEvent()
        {
            vm.showDateError = false;
            vm.showUnacceptableStartDate = false;
            vm.showDurationError = false;

            vm.calendarEvent.start.setHours(vm.calendarEvent.startTime.getHours());
            vm.calendarEvent.start.setMinutes(vm.calendarEvent.startTime.getMinutes());

            vm.calendarEvent.end.setHours(vm.calendarEvent.endTime.getHours());
            vm.calendarEvent.end.setMinutes(vm.calendarEvent.endTime.getMinutes());

            // Convert the javascript date objects back to the moment.js dates
            var dates = {
                start: moment.utc(vm.calendarEvent.start),
                end  : moment.utc(vm.calendarEvent.end)
            };

            checkEventDuration();

            if(vm.showDateError || vm.showUnacceptableStartDate || vm.showDurationError) {
                return;
            }

            var response = {
                type         : vm.dialogData.type,
                calendarEvent: angular.extend({}, vm.calendarEvent, dates)
            };



            var bFileIsAdded = (document.getElementById('event-img-file').files.length == 1);

            if ( bFileIsAdded ) {

                var objFile = document.getElementById('event-img-file').files[0];
                var objFileReader = new FileReader();
                var strMimeType = objFile.type;
                var strTitle = objFile.name;

                cvicImageService.getTemplate().then(function (objImgTpl) {
                    objFileReader.onload = function (e) {
                        var arrBytes = e.target.result;
                        var strEncodedContent = cvicImageService.arrayBufferToBase64(arrBytes);

                        objImgTpl.title = strTitle;
                        objImgTpl.mimeType = strMimeType;
                        objImgTpl.content = strEncodedContent;
                        objImgTpl.owner.uid = cvicJWTService.currentUserId();
                        objImgTpl.uid = uuid.v4();
                        response.calendarEvent.coverImage = objImgTpl;

                        $mdDialog.hide(response);

                    };
                        
                    objFileReader.readAsArrayBuffer(objFile);
                });
            }
            else {

                if ( $scope.bImageIsAdded == false ) {
                    response.calendarEvent.coverImage = null;
                }

                $mdDialog.hide(response);

            }
        }

        function checkEventDuration() {
            $scope.showMinutes = false;
            $scope.showHours = false;

            if(vm.calendarEvent.start.getTime() > vm.calendarEvent.end.getTime()) {
                vm.showDateError = true;

                return;
            }

            if(vm.calendarEvent.end.getTime() < (new Date()).getTime()) {
                vm.showUnacceptableStartDate = true;

                return;
            }

            var duration = vm.calendarEvent.end.getTime() - vm.calendarEvent.start.getTime();

            //milliseconds in one minute
            var maxDuration = 60000;
            if(vm.calendarEvent.eventType === 'conference' || vm.calendarEvent.eventType === 'consultation') {
                vm.durationLimit = cvicJWTService.maxConferenceDuration();

                $scope.showMinutes = true;

                maxDuration *= vm.durationLimit;
            } else {
                vm.durationLimit = cvicJWTService.maxEventDuration();
                
                $scope.showHours = true;

                maxDuration *= vm.durationLimit;
                vm.durationLimit /= 60;
            }

            if(duration > maxDuration) {
                vm.showDurationError = true;

                return;
            }
        }

        /**
         * Remove the event
         */
        function removeEvent()
        {
            var response = {
                type         : 'remove',
                calendarEvent: vm.calendarEvent
            };

            $mdDialog.hide(response);
        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }

        function showAdminPassword() {
            if ( vm.dialogData.calendarEvent ) {
                var eventOwner = vm.dialogData.calendarEvent.baseObj.owner.uid;

                return eventOwner === userUid;
            } else {
                return true;
            }
        }

        function fnAddImage(event) {
        	if( event.target.files.length == 1 ) {
                var objFile = event.target.files[0];
                var objReader = new FileReader();

                objReader.onload = function (e) {
                    $scope.varImgSrc = e.target.result;
                    $scope.bImageIsAdded = true;
                    $('#title').focus();
                }

                objReader.readAsDataURL(objFile);
            }

        }

        function fnRemoveImage() {
            $scope.varImgSrc = 'assets/images/dummy/children.jpeg';
            $('#event-img-file').val(null);
            $scope.bImageIsAdded = false;
        }

        function showConferenceStep() {
            if(vm.calendarEvent.eventType) {
                return vm.calendarEvent.eventType === 'conference' || vm.calendarEvent.eventType === 'consultation';
            }

            return false;
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.eventsconferences')
        .controller('EventDetailDialogController', EventDetailDialogController);

    /** @ngInject */
    function EventDetailDialogController($mdDialog, $state, $filter, calendarEvent, cvicEventService, showEventFormDialog, event, cvicJWTService, __env, ApiEndPoints)
    {
        var vm = this;

        // Data
        vm.calendarEvent = calendarEvent;

        counstructAudience(vm.calendarEvent);

        vm.currentUserId = cvicJWTService.currentUserId();
        vm.showEditEvent = allowEditEvent();

        vm.monthStartTransKey = "CALENDAR.MONTHS_FULL." + $filter('date')(new Date(vm.calendarEvent.start), "MMM");
        vm.monthEndTransKey = "CALENDAR.MONTHS_FULL." + $filter('date')(new Date(vm.calendarEvent.end), "MMM");

        // Methods
        vm.editEvent = editEvent;
        vm.closeDialog = closeDialog;
        vm.openSpace = openSpace;
        
        function counstructAudience(calendarEvent) {
            vm.users = [];

            var audience = calendarEvent.baseObj.userAudience;

            for(var i = 0; i < calendarEvent.baseObj.userAudience.length; ++i) {
                var user = {
                    title: audience[i].user.title
                };

                var img = audience[i].user.coverImage;
                if(img === null) {
                     user.image = 'assets/images/avatars/profile.jpg';
                } else {
                    user.image = __env.apiUrl + ApiEndPoints.ImageController.getImage + img.uid + '.jpg';
                }

                vm.users.push(user);
            }
        }

        //////////

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        function allowEditEvent() {
            return cvicEventService.allowEditEvent(vm.calendarEvent.baseObj, (new Date()).getTime());
        }
        
        /**
         * Edit the calendar event
         *
         * @param calendarEvent
         */
        function editEvent(calendarEvent)
        {
            closeDialog();
            $state.go('app.eventdetails', {uid:calendarEvent.baseObj.uid});
        }
        
        function openSpace( calendarEvent ) {
            closeDialog();
            $state.go('app.spacedetails', {uid: calendarEvent.baseObj.container.uid });        	
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.spacestatistics',
            [
                // 3rd Party Dependencies
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.spacestatistics', {
        	url      : '/spacesstatistics/:type',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/dashboard/statistics_list/spaces_list/spaces_statistics.html',
                    controller : 'SpacesStatisticsController as vm'
                }
            },
            bodyClass: 'dashboard-server'
        });

        /*msNavigationServiceProvider.saveItem('eventsconferences', {
            title: 'EventsAndConferences',
            state: 'app.eventsconferences',
            weight: 1,
            icon: 'icon-calendar-blank'
        });*/
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.spacestatistics')
        .controller('SpacesStatisticsController', SpacesStatisticsController);

    /** @ngInject */
    function SpacesStatisticsController(
        $scope, 
        $stateParams,
        $rootScope,
        cvicRequestService, 
        cvicListService, 
        cvicMessageService, 
        cvicJWTService, 
        cvicAudienceService,
        __env,
        ApiEndPoints,
        $state
        )
    {
        var vm = this;

        //VM Data
        vm.type = $stateParams.type;

        selectTitle();

        if(vm.type !== 'my_spaces') {
            //cvic-messages service
            vm.openThread = cvicMessageService.openThread;
            vm.closeThread = cvicMessageService.closeThread;
            vm.currentThread = cvicMessageService.currentThread;
            vm.currentFilter = {
                type  : 'message',
                filter: vm.type
            };

            vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
            vm.selectedAccount = '';

            //methods
            vm.rejectEntityAudience = rejectEntityAudience;
            vm.acceptEntityAudience = acceptEntityAudience;

            vm.composeDialog = function(ev){ 
                cvicMessageService.composeDialog(ev, vm, { spaceUid: vm.uid });
            };

            vm.replyDialog = function(ev){
                if ( vm.currentThread() ){
                    if ( vm.currentThread().entity.owner.uid != cvicJWTService.currentUserId() ) {
                        var rpTo = [];
                        rpTo.push(vm.currentThread().entity.owner); 
                        var dialogData = {
                                message: vm.currentThread().entity,
                                rpTo: rpTo,
                                spaceUid: vm.uid
                        };
                        cvicMessageService.composeDialog(ev, vm, dialogData);
                    }
                }
            };
            
            vm.printMail = function(thread){
            	cvicMessageService.printMail(thread);
            };

            function handleAudienceUpdateResponseByMessage(response, thread) {
                for(var i = 0; i < vm.threads.length; ++i) {
                    if(thread.uid == vm.threads[i].uid) {
                        vm.threads[i]["Accept"] = false;
                        vm.threads[i]["Reject"] = false;
                    }
                }

                if(vm.currentThread()) {
                    vm.currentThread()["Accept"] = false;
                    vm.currentThread()["Reject"] = false;
                }
            }

            function acceptEntityAudience(entity, userId, event, messageUid, thread) {
                if ( event ) {
                    event.stopPropagation();
                }

                cvicAudienceService.updateUserAudience(entity, vm.audienceUpdateUrl + "/" + messageUid + "/" + userId, 'Accept').then(function(response) {
                    if(response.status === 200) {
                        handleAudienceUpdateResponseByMessage(response, thread);
                    } else {
                        // TODO
                    }
                });
            }

            function rejectEntityAudience(entity, userId, event, messageUid, thread) {
                if ( event ) {
                    event.stopPropagation();
                }

                cvicAudienceService.updateUserAudience(entity, vm.audienceUpdateUrl + "/" + messageUid + "/" + userId, 'Reject').then(function(response) {
                    if(response.status === 200) {

                        handleAudienceUpdateResponseByMessage(response, thread);
                    } else {
                        // TODO
                    }
                });
            }

        } else {
            vm.spaces = [];
        }
        
        $scope.fnExecuteSearch = fnExecuteSearch;

        initSpaces();

        function failResponseData(response) {
            return [];
        }

        function successResultSetData(response) {
            return response.data.elements;
        }


        function initSpaces() {
            cvicRequestService.requestJsonData(__env.apiUrl + ApiEndPoints.SpaceController.spacesStatistics + vm.type, 'GET', successResultSetData, failResponseData)
            .then(function(spaces) {
                if(vm.type === 'my_spaces') {
                    for(var i = 0; i < spaces.length; i++) {
                        vm.spaces.push(cvicListService.spaceRow(spaces[i], false));
                    }
                } else {
                    vm.threads = cvicListService.rows(spaces, cvicListService.messageRow);

                    // Hide the loading screen
                    vm.loadingThreads = false;
                     
                    // Open the thread if needed
                    if ( $stateParams.threadId )
                    {
                        for ( var i = 0; i < vm.threads.length; i++ )
                        {
                            if ( vm.threads[i].id === $stateParams.threadId )
                            {
                                vm.openThread(vm, vm.threads[i]);
                                break;
                            }
                        }
                    }
                }
            });
        }

        function selectTitle() {
            if(vm.type == 'activity') {
                vm.title = 'DASHBOARD_WIDGET.SPACES.ACTIVITIES';
            } else if(vm.type == 'comments') {
                vm.title = 'DASHBOARD_WIDGET.SPACES.COMMENTS';
            } else {
                vm.title = 'DASHBOARD_WIDGET.SPACES.MY';
            }
        }


        function fnExecuteSearch() {
            var strTerm = vm.strSearch;

            if (strTerm != null && strTerm.length >= 3) {
            	$rootScope.cvicSearchService.fnExecuteSearch(strTerm, $rootScope.cvicSearchService.enumSearchType.Spaces).then(function success(objResultSet) {

                    $state.go('app.pages_search');

                });
            }
            
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.recordingstatistics',
            [
                // 3rd Party Dependencies
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.recordingstatistics', {
        	url      : '/recordingstatistics/:type',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/dashboard/statistics_list/recordings_list/recordings_statistics.html',
                    controller : 'RecordingsStatisticsController as vm'
                }
            },
            bodyClass: 'dashboard-server'
        });

        /*msNavigationServiceProvider.saveItem('eventsconferences', {
            title: 'EventsAndConferences',
            state: 'app.eventsconferences',
            weight: 1,
            icon: 'icon-calendar-blank'
        });*/
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.recordingstatistics')
        .controller('RecordingsStatisticsController', RecordingsStatisticsController);

    /** @ngInject */
    function RecordingsStatisticsController(
        $scope, 
        $stateParams,
        $window,
        $rootScope,
        cvicRequestService, 
        cvicAudienceService,
        cvicListService, 
        cvicJWTService, 
        __env,
        ApiEndPoints,
        $state
        )
    {
        var vm = this;

        //VM Data
        vm.type = $stateParams.type;
        vm.recordings = [];

        selectTitle();
        
        $scope.fnExecuteSearch = fnExecuteSearch;
        $scope.redirectToPlayback = redirectToPlayback;

        initRecordings();

        function failResponseData(response) {
            return [];
        }

        function successResultSetData(response) {
            vm.recordings =  cvicListService.rows(response.data.elements, cvicListService.recordingRow);
        }


        function initRecordings() {
            cvicRequestService.requestJsonData(__env.apiUrl + ApiEndPoints.RecordingController.recordingsStatistics + vm.type, 'GET', successResultSetData, failResponseData);
        }

        function selectTitle() {
            if(vm.type === 'all') {
                vm.title = 'STATISTICS.RECORDINGS_TITLE.ALL';
            } else if(vm.type === 'new') {
                vm.title = 'STATISTICS.RECORDINGS_TITLE.NEW';
            } else {
                vm.title = 'STATISTICS.RECORDINGS_TITLE.OLD';
            }
        }

        function redirectToPlayback(recordingRow) {
            $window.open(recordingRow.media.playback, '_blank');
        }

        function fnExecuteSearch() {
            var strTerm = vm.strSearch;

            if (strTerm != null && strTerm.length >= 3) {
            	$rootScope.cvicSearchService.fnExecuteSearch(strTerm, $rootScope.cvicSearchService.enumSearchType.MIXED).then(function success(objResultSet) {

                    $state.go('app.pages_search');

                });
            }
            
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.messagestatistics',
            [
                // 3rd Party Dependencies
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.messagestatistics', {
        	url      : '/messagesstatistics/:type',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/dashboard/statistics_list/messages_list/messages_statistics.html',
                    controller : 'MessagesStatisticsController as vm'
                }
            },
            bodyClass: 'dashboard-server'
        });

        /*msNavigationServiceProvider.saveItem('eventsconferences', {
            title: 'EventsAndConferences',
            state: 'app.eventsconferences',
            weight: 1,
            icon: 'icon-calendar-blank'
        });*/
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.messagestatistics')
        .controller('MessagesStatisticsController', MessagesStatisticsController);

    /** @ngInject */
    function MessagesStatisticsController(
        $scope, 
        $stateParams,
        $rootScope,
        cvicRequestService, 
        cvicMessageService,
        cvicAudienceService,
        cvicListService, 
        cvicJWTService, 
        __env,
        ApiEndPoints,
        $state
        )
    {
        var vm = this;

        //VM Data
        vm.type = $stateParams.type;

        selectTitle();

        //cvic-messages service
        vm.openThread = cvicMessageService.openThread;
        vm.closeThread = cvicMessageService.closeThread;
        vm.currentThread = cvicMessageService.currentThread;
        vm.currentFilter = {
            type  : 'message',
            filter: vm.type
        };

        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.selectedAccount = '';

        //methods
        vm.rejectEntityAudience = rejectEntityAudience;
        vm.acceptEntityAudience = acceptEntityAudience;
        
        $scope.fnExecuteSearch = fnExecuteSearch;

        vm.composeDialog = function(ev){ 
            cvicMessageService.composeDialog(ev, vm, { spaceUid: vm.uid });
        };

        vm.replyDialog = function(ev){
            if ( vm.currentThread() ){
                if ( vm.currentThread().entity.owner.uid != cvicJWTService.currentUserId() ) {
                    var rpTo = [];
                    rpTo.push(vm.currentThread().entity.owner); 
                    var dialogData = {
                            message: vm.currentThread().entity,
                            rpTo: rpTo,
                            spaceUid: vm.uid
                    };
                    cvicMessageService.composeDialog(ev, vm, dialogData);
                }
            }
        };
        
        vm.printMail = function(thread){
        	cvicMessageService.printMail(thread);
        };

        initMessages();

        function failResponseData(response) {
            return [];
        }

        function successResultSetData(response) {
            return response.data.elements;
        }


        function initMessages() {
            cvicRequestService.requestJsonData(__env.apiUrl + ApiEndPoints.MessagesController.messagesStatistics + vm.type, 'GET', successResultSetData, failResponseData)
            .then(function(data) { 
                 vm.threads = cvicListService.rows(data, cvicListService.messageRow);

                 // Hide the loading screen
                 vm.loadingThreads = false;
                 
                 // Open the thread if needed
                 if ( $stateParams.threadId )
                 {
                     for ( var i = 0; i < vm.threads.length; i++ )
                     {
                         if ( vm.threads[i].id === $stateParams.threadId )
                         {
                             vm.openThread(vm, vm.threads[i]);
                             break;
                         }
                     }
                 }
            });
        }


        function handleAudienceUpdateResponseByMessage(response, thread) {
            for(var i = 0; i < vm.threads.length; ++i) {
                if(thread.uid == vm.threads[i].uid) {
                    vm.threads[i]["Accept"] = false;
                    vm.threads[i]["Reject"] = false;
                }
            }

            if(vm.currentThread()) {
                vm.currentThread()["Accept"] = false;
                vm.currentThread()["Reject"] = false;
            }
        }

        function acceptEntityAudience(entity, userId, event, messageUid, thread) {
            if ( event ) {
                event.stopPropagation();
            }

            cvicAudienceService.updateUserAudience(entity, vm.audienceUpdateUrl + "/" + messageUid + "/" + userId, 'Accept').then(function(response) {
                if(response.status === 200) {
                    handleAudienceUpdateResponseByMessage(response, thread);
                } else {
                    // TODO
                }
            });
        }

        function rejectEntityAudience(entity, userId, event, messageUid, thread) {
            if ( event ) {
                event.stopPropagation();
            }

            cvicAudienceService.updateUserAudience(entity, vm.audienceUpdateUrl + "/" + messageUid + "/" + userId, 'Reject').then(function(response) {
                if(response.status === 200) {

                    handleAudienceUpdateResponseByMessage(response, thread);
                } else {
                    // TODO
                }
            });
        }

        function selectTitle() {
            if(vm.type === 'all') {
                vm.title = 'DASHBOARD_WIDGET.MESSAGES.NEW';
            } else if(vm.type === 'system') {
                vm.title = 'DASHBOARD_WIDGET.MESSAGES.SYSTEM';
            } else if(vm.type === 'user') {
                vm.title = 'DASHBOARD_WIDGET.MESSAGES.ALL';
            }
        }


        function fnExecuteSearch() {
            var strTerm = vm.strSearch;

            if (strTerm != null && strTerm.length >= 3) {
            	$rootScope.cvicSearchService.fnExecuteSearch(strTerm, $rootScope.cvicSearchService.enumSearchType.MIXED).then(function success(objResultSet) {

                    $state.go('app.pages_search');

                });
            }
            
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.eventstatistics',
            [
                // 3rd Party Dependencies
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.eventstatistics', {
        	url      : '/eventstatistics/:type',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/dashboard/statistics_list/events_list/events_statistics.html',
                    controller : 'EventsStatisticsController as vm'
                }
            },
            bodyClass: 'dashboard-server'
        });

        /*msNavigationServiceProvider.saveItem('eventsconferences', {
            title: 'EventsAndConferences',
            state: 'app.eventsconferences',
            weight: 1,
            icon: 'icon-calendar-blank'
        });*/
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.eventstatistics')
        .controller('EventsStatisticsController', EventsStatisticsController);

    /** @ngInject */
    function EventsStatisticsController(
        $scope, 
        $stateParams,
        $rootScope,
        cvicRequestService, 
        cvicFormService, 
        cvicListService, 
        cvicDateService, 
        cvicJWTService, 
        cvicEventService,
        cvicMessageService, 
        cvicAudienceService,
        __env,
        ApiEndPoints,
        $state
        )
    {
        var vm = this;

        //VM Data
        vm.type = $stateParams.type;

        selectTitle();

        if(vm.type !== 'my_events') {
            //cvic-messages service
            vm.openThread = cvicMessageService.openThread;
            vm.closeThread = cvicMessageService.closeThread;
            vm.currentThread = cvicMessageService.currentThread;
            vm.currentFilter = {
                type  : 'message',
                filter: vm.type
            };

            vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
            vm.selectedAccount = '';

            //methods
            vm.rejectEntityAudience = rejectEntityAudience;
            vm.acceptEntityAudience = acceptEntityAudience;

            vm.composeDialog = function(ev){ 
                cvicMessageService.composeDialog(ev, vm, { spaceUid: vm.uid });
            };

            vm.replyDialog = function(ev){
                if ( vm.currentThread() ){
                    if ( vm.currentThread().entity.owner.uid != cvicJWTService.currentUserId() ) {
                        var rpTo = [];
                        rpTo.push(vm.currentThread().entity.owner); 
                        var dialogData = {
                                message: vm.currentThread().entity,
                                rpTo: rpTo,
                                spaceUid: vm.uid
                        };
                        cvicMessageService.composeDialog(ev, vm, dialogData);
                    }
                }
            };
            
            vm.printMail = function(thread){
            	cvicMessageService.printMail(thread);
            };

            function handleAudienceUpdateResponseByMessage(response, thread) {
                for(var i = 0; i < vm.threads.length; ++i) {
                    if(thread.uid == vm.threads[i].uid) {
                        vm.threads[i]["Accept"] = false;
                        vm.threads[i]["Reject"] = false;
                    }
                }

                if(vm.currentThread()) {
                    vm.currentThread()["Accept"] = false;
                    vm.currentThread()["Reject"] = false;
                }
            }

            function acceptEntityAudience(entity, userId, event, messageUid, thread) {
                if ( event ) {
                    event.stopPropagation();
                }

                cvicAudienceService.updateUserAudience(entity, vm.audienceUpdateUrl + "/" + messageUid + "/" + userId, 'Accept').then(function(response) {
                    if(response.status === 200) {
                        handleAudienceUpdateResponseByMessage(response, thread);
                    } else {
                        // TODO
                    }
                });
            }

            function rejectEntityAudience(entity, userId, event, messageUid, thread) {
                if ( event ) {
                    event.stopPropagation();
                }

                cvicAudienceService.updateUserAudience(entity, vm.audienceUpdateUrl + "/" + messageUid + "/" + userId, 'Reject').then(function(response) {
                    if(response.status === 200) {

                        handleAudienceUpdateResponseByMessage(response, thread);
                    } else {
                        // TODO
                    }
                });
            }

        } else {
            vm.pastEvents = [];
            vm.nextEvents = [];
        }
        
        $scope.fnExecuteSearch = fnExecuteSearch;

        initMyEvents();

        function failResponseData(response) {
            return [];
        }

        function successResultSetData(response) {
            return response.data.elements;
        }


        function initMyEvents() {
            cvicRequestService.requestJsonData(__env.apiUrl + ApiEndPoints.EventController.eventsStatistics + vm.type, 'GET', successResultSetData, failResponseData)
            .then(function(events) {
                if(vm.type === 'my_events') {
                    for(var i = 0; i < events.length; i++) {
                        var event = events[i];

                        var row = cvicListService.eventRow(event, false);

                        if(vm.type === 'public') {
                            vm.nextEvents.push(row);
                        } else {
                            if( cvicEventService.hasEventExpired(event) ) {
                                vm.pastEvents.push(row);
                            } else {
                                vm.nextEvents.push(row);
                            }
                        }
                    }
                } else {
                    vm.threads = cvicListService.rows(events, cvicListService.messageRow);

                    // Hide the loading screen
                    vm.loadingThreads = false;
                     
                    // Open the thread if needed
                    if ( $stateParams.threadId )
                    {
                        for ( var i = 0; i < vm.threads.length; i++ )
                        {
                            if ( vm.threads[i].id === $stateParams.threadId )
                            {
                                vm.openThread(vm, vm.threads[i]);
                                break;
                            }
                        }
                    }
                }
            });
        }

        function selectTitle() {
            if(vm.type == 'activity') {
                vm.title = 'DASHBOARD_WIDGET.EVENTS.ACTIVITIES';
            } else if(vm.type == 'comments') {
            	vm.title = 'DASHBOARD_WIDGET.EVENTS.COMMENTS';
            } else  {
                vm.title = 'DASHBOARD_WIDGET.EVENTS.MY';
            }
        }


        function fnExecuteSearch() {
            var strTerm = vm.strSearch;

            if ( strTerm != null && strTerm.length >= 3 ) {
            	$rootScope.cvicSearchService.fnExecuteSearch(strTerm, $rootScope.cvicSearchService.enumSearchType.Events).then(function success(objResultSet) {

                    $state.go('app.pages_search');

                });
            }

            
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_reset-password', {
            url      : '/auth/passwd/reset',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_reset-password': {
                    templateUrl: 'app/main/auth/passwd/reset/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'reset-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/passwd/reset');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController( $scope, $state, cvicRequestService, ApiEndPoints, __env )
    {
    	
        $scope.checkPasswords = function( val ) {
        	return !!( val == $scope.resetPasswordForm.password.$viewValue );
        };

    	$scope.submit = function() {
            
            cvicRequestService.requestJsonData(
                __env.apiUrl + '/p/resetPassword', 
                'POST', 
                function ok( response ) {
                	// TODO: show OK message
                	localStorage.setItem( 'id_token', response.data );
                	$state.go( 'app.profile' );
                },
                function fail( response ) {                	
                	// TODO: something went wrong
                },
                JSON.stringify( { 
                	'passwd': $scope.vm.form.password
                } )
            );            
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url      : '/auth/passwd/forgot',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/main/auth/passwd/forgot/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/passwd/forgot');
    }
})();
(function ()
{
    'use strict';

    angular
    	.module( 'app.pages.auth.forgot-password' )
    	.controller( 'ForgotPasswordController', ForgotPasswordController );

    /** @ngInject */
    function ForgotPasswordController( $scope, $state, $location, cvicRequestService, ApiEndPoints, __env, vcRecaptchaService )
    {

        $scope.response = null;
        $scope.widgetId = null;

        $scope.setResponse = function( response ) {
            $scope.response = response;
        };
        $scope.setWidgetId = function( widgetId ) {
            $scope.widgetId = widgetId;
        };
        $scope.cbExpiration = function() {
            vcRecaptchaService.reload($scope.widgetId);
            $scope.response = null;
        };

        $scope.checkPasswords = function( val ) {
        	return !!( val == $scope.forgotPasswordForm.password.$viewValue );
        };
        
    	$scope.submit = function() {
            
            cvicRequestService.requestJsonData(
                __env.apiUrl + '/common/passwd', 
                'POST', 
                function ok( response ) {
                	// TODO: show OK message
                	$state.go( 'app.pages_auth_login-v2' );
                },
                function fail( response ) {                	
                	// TODO: something went wrong
                },
                JSON.stringify( { 
                	'email': $scope.vm.form.email,
                	'passwd': $scope.vm.form.password,
                	'location': $location.absUrl().replace( $location.path(), '' ),
                	'g-recaptcha-response': $scope.response
                } )
            );            
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.add-audience', [])
        .controller('EntityAudienceController', EntityAudienceController);

    function EntityAudienceController($scope, $translate, $mdDialog, cvicJWTService, cvicRequestService, cvicAudienceService, ApiEndPoints, cvicListService, cvicFormService, __env)
    {
        var eactrl = this;

        eactrl.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            iDisplayLength:  50,
            responsive: true,
            language: {
                "emptyTable":     $translate.instant("AUDIENCE_TABLE.DATA_TABLE.EMPTY_TABLE"),
                "info":           $translate.instant("AUDIENCE_TABLE.DATA_TABLE.INFO"),
                "infoEmpty":      $translate.instant("AUDIENCE_TABLE.DATA_TABLE.INFO_EMPTY"),
                "infoFiltered":   $translate.instant("AUDIENCE_TABLE.DATA_TABLE.INFO_FILTERED"),
                "infoPostFix":    "",
                "lengthMenu":     $translate.instant("AUDIENCE_TABLE.DATA_TABLE.LENGTH_MENU"),
                "processing":     $translate.instant("AUDIENCE_TABLE.DATA_TABLE.PROCESSING"),
                "search":         $translate.instant("AUDIENCE_TABLE.DATA_TABLE.SEARCH"),
                "zeroRecords":    $translate.instant("AUDIENCE_TABLE.DATA_TABLE.ZERO_RECORDS"),
                "paginate": {
                    "first":      $translate.instant("AUDIENCE_TABLE.DATA_TABLE.PAGINATE.FIRST"),
                    "last":       $translate.instant("AUDIENCE_TABLE.DATA_TABLE.PAGINATE.LAST"),
                    "next":       $translate.instant("AUDIENCE_TABLE.DATA_TABLE.PAGINATE.NEXT"),
                    "previous":   $translate.instant("AUDIENCE_TABLE.DATA_TABLE.PAGINATE.PREVIOUS")
                },
                "aria": {
                    "sortAscending":  "",
                    "sortDescending": ""
                }
            }
        };
        
        $scope.init = function(initAsync) {
            initAsync.then(function(settings)  {
                $scope.settings = settings;

                eactrl.vm = settings.vm;
                setCanManageContainer();
                initAudience();
                eactrl.url = settings.url;

                eactrl.readonly = function()  {
                    if(!settings.showDelete) {
                        return 'readonly';
                    } else {
                        return '';
                    }
                }

                setAudienceLimits();
                
                cvicAudienceService.userAudienceTempl().then(function(templ) {
                    eactrl.currentUserAudience = templ;
                });
                
                cvicAudienceService.groupAudienceTempl().then(function(templ) {
                    eactrl.groupAudienceTempl = templ;
                });

                getContainerSpaceAudience();
            });
        };

        $scope.removeUserFromTableAudience = removeUserFromTableAudience;
        $scope.showTableUserActions = showTableUserActions;

        eactrl.submitDialog = submitDialog;
        eactrl.addContainerAudience = addContainerAudience;
        eactrl.deleteAudience = deleteAudience;
        eactrl.deleteTableAudience = deleteTableAudience;
        eactrl.isDeleteNewAudienceDisabled = isDeleteNewAudienceDisabled;
        eactrl.acceptEntityAudience = acceptEntityAudience;
        eactrl.rejectEntityAudience = rejectEntityAudience;

        function initAudience() {
            $scope.audience = [];
            $scope.tableAudience = convertToChipAudience(cvicListService.rows(eactrl.vm.container().userAudience, cvicListService.userAudienceRow));

            if($scope.tableAudience.length < eactrl.dtOptions.iDisplayLength) {
                eactrl.dtOptions.paging = false;
            }
        }

        function setAudienceLimits() {
            var item = eactrl.vm.container();

            if(item['@class'].indexOf('.Event') != -1 ) {
                $scope.maxParticipants = cvicJWTService.maxConferenceParticipants();
            }
        }

        function getLastActionDate(chip, audience) {/**/
            if(audience.lastAction === "Invite") {
                chip.date = audience.dateInvited;

                return;
            }

            if(audience.lastAction === 'Accept') {
                chip.date = audience.dateAccepted;

                return;
            }

            if(audience.lastAction === 'Request') {
                chip.date = audience.dateRequested;

                return;
            }

            if(audience.lastAction === 'Reject') {
                chip.date = audience.dateRejected;

                return;
            }
        }

        function convertToChipAudience(audience) {
            var currAudience = [];

            for( var i = 0; i < audience.length; ++i ) {
                if(audience[i].type === 'user') {

                    var userContact = {
                        uid: audience[i].uid,    
                        name: audience[i].name,
                        email: audience[i].email,
                        image: audience[i].avatar,
                        baseObj: audience[i].baseObj
                    };

                    getLastActionDate(userContact, audience[i].baseObj);

                    userContact._lowername = userContact.name.toLowerCase();

                    currAudience.push(userContact);
                } else {
                    var groupContact = {
                        uid: audience[i].uid,   
                        name: audience[i].name,
                        email: '',
                        image: 'assets/images/dummy/parent_meeting.jpg'
                    };

                    groupContact._lowername = groupContact.name.toLowerCase();

                    currAudience.push(groupContact);
                }
            }

            return currAudience;
        }

        function failResponseData(response) {
            return {};
        }

        function successResponseData(response) {
             return response.data;
        }

        function setCanManageContainer() {
            var item = eactrl.vm.container();

            $scope.canManage =  cvicAudienceService.canManageAudience(item);
        }

        function getContainerSpaceAudience() {
            var item = eactrl.vm.container();

            if(item.container) {
                cvicRequestService
                    .requestJsonData(__env.apiUrl + ApiEndPoints.SpaceController.getSpace + item.container.uid, 'GET', 
                        function(response) {
                            $scope.containerAudience = convertToChipAudience(cvicListService.audience(response.data.userAudience,response.data.groupAudience));

                            setDeleteAudienceMarginClass();
                        }, 
                        function (response) { 
                            $scope.containerAudience = [];
                        }
                );
            } else {
                setDeleteAudienceMarginClass();
            }
        }


        function checkAudienceLimit() {
            var audienceSize = $scope.tableAudience.length;

            for(var index = 0; index < $scope.audience.length; ++index) {
                var contact = $scope.audience[index];

                if(contact.size) {
                    audienceSize += contact.size;
                } else {
                    ++audienceSize;
                }

                
            }

            var item = eactrl.vm.container();

            if(item['@class'].indexOf('.Event') != -1 ) {
                if(audienceSize <= $scope.maxParticipants) {
                    $scope.audienceForm.recipientsRequired.$setValidity('limit', true);

                    return true;
                } else {
                    $scope.audienceForm.recipientsRequired.$setValidity('limit', false);

                    return false;
                }
                
            } else {
                $scope.audienceForm.recipientsRequired.$setValidity('limit', true);

                return true;
            }

        }

        function removeUserFromTableAudience(audience)  {
            var confirmDialog = $mdDialog.confirm()
                        .title( $translate.instant( 'AUDIENCE.CONFIRM_DIALOG.REMOVE_USER.TITLE' ) )
                        .htmlContent( $translate.instant( 'AUDIENCE.CONFIRM_DIALOG.REMOVE_USER.TEXT' ) )
                        .ok( $translate.instant('AUDIENCE.CONFIRM_DIALOG.REMOVE_USER.OK') )
                        .cancel( $translate.instant('AUDIENCE.CONFIRM_DIALOG.REMOVE_USER.CANCEL') );

            $mdDialog.show(confirmDialog).then(function agree() {
                
                for(var i = 0; i < $scope.tableAudience.length; ++i) {
                    if(audience.uid === $scope.tableAudience[i].uid) {
                        $scope.tableAudience.splice(i, 1);

                        $scope.audienceForm.$setDirty();

                        return;
                    }
                }

            });
        }

        function submitDialog() {
            if(checkAudienceLimit()) {
                $scope.audienceForm.recipientsRequired.$setValidity('limit', true);

                var item = eactrl.vm.container();

                var newAudience = $scope.audience.concat($scope.tableAudience);

                var existingAudience = cvicAudienceService.createAudienceMap(item);

                item.userAudience = cvicAudienceService.getUserAudience( newAudience, eactrl.currentUserAudience, existingAudience);

                item.groupAudience = cvicAudienceService.getGroupAudience( $scope.audience, eactrl.groupAudienceTempl);

                cvicRequestService
                    .requestJsonData(__env.apiUrl + eactrl.url, 'POST', 
                                        successResponseData, failResponseData,
                                        item)
                    .then(function(item) { 
                        if (!angular.equals(item, {})) {
                            $scope.audienceForm.$setPristine();

                            eactrl.vm.updateContainer(item);
                            initAudience();

                            cvicFormService.showErrorDialog('AUDIENCE_SAVED');
                        }
                        else {
                            checkAudienceLimit();

                            cvicFormService.showErrorDialog('AUDIENCE_SAVE_ERROR');
                        }
                    }
                );
            } else {
                $scope.audienceForm.recipientsRequired.$setValidity('limit', false);
            }
        }

        function isDeleteNewAudienceDisabled() {
            if(!$scope.audience || $scope.audience.length === 0) {
                return true;
            } else  {
                return false;
            }
        }

        function setDeleteAudienceMarginClass() {
            if($scope.containerAudience) {
                $scope.marginClass = "margin-left-gt-md-20";
            } else {
                $scope.marginClass = "";
            }
        }

        function addContainerAudience() {
            var currAudience = cvicAudienceService.createAudienceChipMap($scope.audience);

            for(var i = 0; i < $scope.containerAudience.length; ++i ) {
                var audUid = $scope.containerAudience[i].uid;

                if(!currAudience[audUid]) {
                    $scope.audience.push($scope.containerAudience[i]);
                }
            }

            $scope.audienceForm.$setDirty();
        }

        function showTableUserActions(tableUser) {
            var ownerUid = eactrl.vm.container().owner.uid;

            return tableUser.uid !== ownerUid;
        }

        function deleteAudience() {
            $scope.audienceForm.$setDirty();

            $scope.audience = [];
        }

        function deleteTableAudience() {
            var confirmDialog = $mdDialog.confirm()
                        .title( $translate.instant( 'AUDIENCE.CONFIRM_DIALOG.REMOVE_USERS.TITLE' ) )
                        .htmlContent( $translate.instant( 'AUDIENCE.CONFIRM_DIALOG.REMOVE_USERS.TEXT' ) )
                        .ok( $translate.instant('AUDIENCE.CONFIRM_DIALOG.REMOVE_USERS.OK') )
                        .cancel( $translate.instant('AUDIENCE.CONFIRM_DIALOG.REMOVE_USERS.CANCEL') );

            $mdDialog.show(confirmDialog).then(function agree() {


                $scope.audienceForm.$setDirty();

                var ownerUid = eactrl.vm.container().owner.uid;

                for(var i = 0; i < $scope.tableAudience.length; ++i) {
                    var owner = $scope.tableAudience[i];

                    if(owner.uid === ownerUid) {
                        break;
                    }
                } 

                $scope.tableAudience = [];

                if(owner) {
                    $scope.tableAudience.push(owner); 
                }


            });      
        }


        function constructAudienceUpdateUrl(entity) {
            var url = undefined;

            if(entity['@class'] === 'com.tetracom.cvic.model.space.Space') {
                url = __env.apiUrl + ApiEndPoints.UserAudienceController.spaceAudienceDataAction;
            } else if(entity['@class'] === 'com.tetracom.cvic.model.event.Event') {
                url = __env.apiUrl + ApiEndPoints.UserAudienceController.eventAudienceDataAction;
            }

            return url;
        }

        function handleAudienceUpdateResponse(response, userId, newLastAction) {
            eactrl.vm.refreshContainer();

            for(var i = 0; i < $scope.tableAudience.length; ++i) {
                if(userId === $scope.tableAudience[i].uid) {
                    var audience = angular.copy($scope.tableAudience[i]);

                    audience.baseObj.lastAction = newLastAction;

                    $scope.tableAudience[i] = audience;

                    return;
                }
            }
        }

        function acceptEntityAudience(userId, event) {
            if ( event ) {
                event.stopPropagation();
            }

            var entity = eactrl.vm.container();

            var url = constructAudienceUpdateUrl(entity);
            if(url == undefined) {
                // TODO show notification
                return;
            }

            updateUserAudience(url, userId, entity, 'Accept').then(function(response) {
                if(response.status === 200) {
                    handleAudienceUpdateResponse(response, userId, "Accept");
                } else {
                    // TODO
                }
            });
        }

        function rejectEntityAudience(userId, event) {
            if ( event ) {
                event.stopPropagation();
            }

            var entity = eactrl.vm.container();

            var url = constructAudienceUpdateUrl(entity);
            if(url == undefined) {
                // TODO show notification
                return;
            }

            updateUserAudience(url, userId, entity, 'Reject').then(function(response) {
                if(response.status === 200) {

                    handleAudienceUpdateResponse(response, userId, "Reject");
                } else {
                    // TODO
                }
            });
        }

        function updateUserAudience(reqUrl, userId, auEntity, audienceAction) {
             var data = {
                affectingUserUid: userId,
                entity:  auEntity,
                audienceAction: audienceAction
            };

            return cvicRequestService.requestJsonData(
                reqUrl, 
                'POST', 
                function(response) {
                    return {
                        userAudience: response.data,
                        status: response.status
                    };
                }, function(response) {
                    return {
                        status: response.status
                    };
                },
                data
            );
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.tetracom.general',[])
        .config(function ($logProvider) {
            $logProvider.debugEnabled(true);
        });
})();
(function ()
{
    'use strict';

    angular
        .module('app.tetracom.general')
        .directive('uploadFile', uploadFile);

    /** @ngInject */
    function uploadFile($parse, $timeout)
    {
        return {
            restrict   : 'A',
            link       : function (scope, element, attrs)
            {
                
                element.bind('click', function (e) {
                	var objFileInput = document.getElementById(attrs.fileInputId);
                    
                    if( objFileInput != null ) {
                        objFileInput.click();
                    }
                    
                });
                
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.tetracom.general')
        .directive('keyPressAction', keypressAction);

    /** @ngInject */
    function keypressAction($parse, $timeout)
    {
        return {
            restrict   : 'A',
            link       : function (scope, element, attrs)
            {
                
                element.bind('keypress', function (event) {
                    var intKeyCode = event.which || event.keyCode;

                    if ( intKeyCode == attrs.keyPressCode ) {
                        scope.$apply(function () {
                            scope.$eval(attrs.keyPressAction, {$event: event});
                        });
                    }
                });
                
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.tetracom.general')
        .directive('fileChange', fileChange);

    /** @ngInject */
    function fileChange($parse, $timeout)
    {
        return {
            restrict   : 'A',
            link       : function (scope, element, attrs)
            {
                var fnChangeHandler = scope.$eval(attrs.fnChangeHandler);
                element.bind('change', fnChangeHandler);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.tetracom.general')
        .constant('ApiEndPoints', {
        	'ImageController' : {
        		'getTemplate': '/common/img/tpl',
        		'getImage': '/common/i/'
        	},
            'DashboardController': {
                'widgets': '/dashboard/widgets',
                'search': '/dashboard/list/search'
            },
        	'DocumentController': {
        		'getTemplate': '/d/template',
        		'upload': '/fm/document/upload',
        		'download': '/d/',
                'search': '/fm/list/search',
                'delete': '/d/delete',
                'undelete': '/d/undelete',
                'update': '/d/update'
        	},
        	'FolderController': {
        		'deleteFolder': '/f/delete'
        	},
            'EventController': {
                'eventGet': '/event/',
                'newEvent': '/new_event',
                'updateEvent': '/edit_event',
                'detachFiles': '/event/detachFiles',
                'getCalendarEvents': '/calendar_events',
                'eventDocument': '/event/d/',
                'conferencePasswords': '/conferencePasswords',
                'eventMessage': '/e/message/',
                'deleteEvent': '/remove_event',
                'getPublicEvents': '/events/list/search',
                'eventTemplate': '/event_template/false',
                'eventsStatistics': '/events/statistics/',
                'undelete': '/undelete_event'
            },
            'MessagesController': {
                'messagesStatistics': '/m/statistics/',
                'delete': '/m/delete',
                'undelete': '/m/undelete'
            },
            'UserAudienceController': {
                'eventAudienceAction': '/event/audience/action',
                'eventAudienceDataAction': '/event/audience/action_data',
                'spaceAudienceAction': '/space/audience/action',
                'spaceAudienceDataAction': '/space/audience/action_data',
            },
            'RecordingController': {
                'recordingsStatistics': '/common/recording/statistics/'
            },
            'SpaceController': {
                'getSpace': '/s/',
                'updateSpace': '/s/update',
                'createSpace': '/s/create',
                'detachFiles': '/s/detachFiles',
                'spaceDocument': '/space/d/',
                'spaceMessage': '/s/message/',
                'spaceEventConference': '/s/event/',
                'spacesStatistics': '/spaces/statistics/',
                'getPublicSpaces': '/spaces/list/search/',
                'delete': '/s/delete',
                'undelete': '/s/undelete'
            },
            'TrashController': {
                'list'      : '/trash/list'
            },
            'DownloadController': {
                'download'      : '/d/',
                'play'      	: '/d/play/'
            },
            'UserController': {
                'getUserInformation'        : '/common/userInformation/', 
                'getMostFrequentContacts'   : '/common/user/contacts/frequent/',
                'userAggregationData'		: '/common/user/aggregation/',
                'participantWithMe'			: '/common/user/contacts/group/participant_with_me',
                'participantInMy'			: '/common/user/contacts/group/participant_in_my',
                'participantTo'				: '/common/user/contacts/group/participant_to',
                'getAdminContact'           : '/common/user/admin'
            },
            'ProfileController': {
                'about': '/p/',
                'activity': '/p/activity',
                'grades': '/p/grades/',
                'payments': '/p/payments',
                'edit': '/p/edit',
                'resetPassword': '/p/resetPassword',
                'portfolio': '/p/portfolio/',
                'detachFiles': '/p/detachFiles',
            },
            'PaymentController': {
            	'page': '/payment/'
            },
            'GroupController': {
            	'myGroups': '/common/user/my/groups',
            	'create':'/group/create',
            	'save':'/group/save',
            	'detachUsers':'/group/detach_users',
            	'deleteGroup': '/group/delete',
            	'groupTempl': '/group/templ'
            },
            'ParentController' : {
                'getOtherParents'   : '/parent/other/',
        		'suggestTeacher'	: '/parent/search',
        		'sendRequest'		: '/parent/submit'
        	},
        	'Help':'https://mtc.classbg.online/asset/1:cvic-manual'
        });
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.register-v2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_register-v2', {
            url      : '/auth/register',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_register-v2': {
                    templateUrl: 'app/main/auth/register/register-v2.html',
                    controller : 'RegisterV2Controller as vm'
                }
            },
            bodyClass: 'register-v2'
        });

        // Translate
        $translatePartialLoaderProvider.addPart('app/main/auth/register');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.register-v2')
        .controller('RegisterV2Controller', RegisterV2Controller);

    /** @ngInject */
    function RegisterV2Controller($rootScope, $scope, $state, cvicRequestService, cvicOptionsData, ApiEndPoints, __env, vcRecaptchaService)
    {
    	init();
    	 
        $scope.response = null;
        $scope.widgetId = null;
        
        $scope.removeErrors = function() {
        	$scope.removeMatchError();
        }

        $scope.setResponse = function (response) {
            $scope.response = response;
        };
        $scope.setWidgetId = function (widgetId) {
            $scope.widgetId = widgetId;
        };
        $scope.cbExpiration = function() {
            vcRecaptchaService.reload($scope.widgetId);
            $scope.response = null;
        };

        $scope.userPlans = [
            {trans: 'DEMO', value: 'demo'}, 
            {trans: 'BONUS', value: 'bonus'},
            {trans: 'PARENT', value: 'parent'}
        ];

        $scope.vm.error = false;

        $scope.removeMatchError = function() {
            $scope.registerForm.passwordConfirm.$setValidity('match', true);
        };
       
        $scope.getOrganizations = function(searchText) {
            return cvicOptionsData.getOrganizations(searchText, $scope);
        }

        $scope.organizationErrorCheck = function(searchText) {            
            return cvicOptionsData.organizationErrorCheck(searchText, $scope.registerForm, $scope);
        }

        $scope.submit = function() {
            $scope.vm.error = false;

            cvicRequestService.requestJsonData(
                __env.apiUrl + '/common/register', 
                'POST', 
                function (response) {
                	
                	$rootScope.userInformation = null;
                	
                	if( response.headers() != null && response.headers()["filename"] != null ) {
                		window.location.href = __env.apiUrl + ApiEndPoints.PaymentController.page + response.headers()["filename"];
                	} else {

                        if(response.data.hasErrors) {
                            if(response.data['name'] != undefined) {
                                $scope.registerForm.username.$setValidity(response.data['name'], false);
                            }

                            if(response.data['email'] != undefined) {
                                $scope.registerForm.email.$setValidity(response.data['email'], false);
                            }

                            if(response.data['password'] != undefined) {
                                $scope.registerForm.password.$setValidity(response.data['password'], false);
                            }

                            if(response.data['passwordConfirm'] != undefined) {
                                $scope.registerForm.passwordConfirm.$setValidity(response.data['passwordConfirm'], false);
                            }
                            
                            if(response.data['organization'] != undefined) {
                                $scope.registerForm.organization.$setValidity(response.data['organization'], false);
                            }

                            if(response.data['plan'] != undefined) {
                                $scope.registerForm.plan.$setValidity(response.data['plan'], false);
                            }

                            if(response.data['terms'] != undefined) {
                                $scope.registerForm.terms.$setValidity(response.data['terms'], false);
                            }

                            $scope.cbExpiration();
                        } else {
                            localStorage.setItem('id_token', response.data);
                            $state.go('app.dashboard');
                        }

                	}
                }, 
                function (response) {
                    $scope.vm.error = true;

                    $scope.cbExpiration();
                },
                JSON.stringify( 
                    { 
                        'name': $scope.vm.form.username,
                        'email': $scope.vm.form.email, 
                        'password': $scope.vm.form.password,
                        'organization':	( $scope.vm.form.organization && $scope.vm.form.organization.uid ? $scope.vm.form.organization.uid : null),
                        'rep_pass': $scope.vm.form.passwordConfirm,
                        'plan': $scope.vm.form.plan,
                        'terms': $scope.data.cb1,
                        'g-recaptcha-response': $scope.response
                    }
                )
            );
        };
        
        function init() {            
        	cvicOptionsData.schoolsRequest().then( function( schools ) {
            	$scope.organizations = cvicOptionsData.filter('external');
            	return;
            });
        } 
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.login-v2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login-v2', {
            url      : '/auth/login',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login-v2': {
                    templateUrl: 'app/main/auth/login/login-v2.html',
                    controller : 'LoginV2Controller as vm'
                }
            },
            bodyClass: 'login-v2'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/login');
    }

})();
(function ()
{
    'use strict';

    angular
        .module( 'app.auth.login-v2' )
        .controller('LoginV2Controller', LoginV2Controller);

    /** @ngInject */
    function LoginV2Controller($rootScope, $translate, $scope, $state, cvicRequestService, cvicOptionsData, ApiEndPoints, __env)
    {

        init();

        /*$scope.organization_label = $translate.instant("LOGIN_V2.ORGANIZATION");*/

        $scope.removeErrors = function() {
            $scope.removeInvalidError();
            $scope.removePatternError();
            $scope.removeNoAccessError();
        }

        $scope.removeInvalidError = function() {
            $scope.loginForm.email.$setValidity("invalid", true);
            $scope.loginForm.password.$setValidity("invalid", true);
        };

        $scope.removeNoAccessError = function() {
            $scope.loginForm.email.$setValidity("no_access", true);
        }

        $scope.removePatternError = function() {
            $scope.loginForm.email.$setValidity("pattern", true);
        }

        $scope.getOrganizations = function(searchText) {
            return cvicOptionsData.getOrganizations(searchText, $scope);
        }

        $scope.organizationErrorCheck = function(searchText) {            
            return cvicOptionsData.organizationErrorCheck(searchText, $scope.loginForm, $scope);
        }

        $scope.submit = function() {
            
            var organization = $scope.vm.form.organization;

            var reqData = { 'email': $scope.vm.form.email, 'password': $scope.vm.form.password };
            if(organization)  {
                if(organization.uid) {
                    reqData['organization'] = organization.uid;
                } else {
                    $scope.loginForm.organization.$setValidity("real_orgranization", false);

                    return;
                }
            }

            cvicRequestService.requestJsonData(
                __env.apiUrl + '/common/login', 
                'POST', 
                function (response) {
                	
                	$rootScope.userInformation = null;
                	
                	if( response.headers() != null && response.headers()["filename"] != null ) {
                		window.location.href = __env.apiUrl + ApiEndPoints.PaymentController.page + response.headers()["filename"];
                	} else {
                        if(response.data.hasErrors) {
                            if(response.data['email'] != undefined) {
                                $scope.loginForm.email.$setValidity(response.data['email'], false);
                            }

                            if(response.data['password'] != undefined) {
                                $scope.loginForm.password.$setValidity(response.data['password'], false);
                            }

                            if(response.data['no_access']) {
                                $scope.loginForm.email.$setValidity(response.data['no_access'], false);
                            }
                        } else {
                            localStorage.setItem('id_token', response.data);

                            if ( $rootScope.toState ) {
                                // redirect to previously requested state.
                                $state.go( $rootScope.toState, $rootScope.toParmas );
                                $rootScope.toState= null;
                                $rootScope.toParams= null;
                            } else {
                                $state.go( 'app.dashboard' );
                            }
                        }
                	}
                },
                function fail(response) {                	
                    $scope.loginForm.email.$setValidity('invalid', false);
                    $scope.loginForm.password.$setValidity('invalid', false);
                },
                JSON.stringify( reqData )
            );            
        };

        function init() {            
        	cvicOptionsData.schoolsRequest().then( function( schools ) {
            	$scope.organizations = schools;
            	return;
            });
        }
    }
})();
(function () {
  'use strict';
 
  angular
  	  .module('app.audiencechips', ['ngMaterial'])
      .controller('AudienceChipController', AudienceChipController);
  
  function AudienceChipController (
		  $rootScope, 
		  $translate, 
		  $q, 
		  cvicRequestService, 
		  cvicListService, ApiEndPoints,
		  __env) {
    var vm = this;
    var pendingSearch, cancelSearch = angular.noop;
    var lastSearch;

    $rootScope.audience = [];
         
    vm.allContacts = [];
    vm.allContactsUids = [];
    vm.criteriaList = []; 
    
    vm.filterSelected = true;
    vm.querySearch = querySearch;
    vm.delayedQuerySearch = delayedQuerySearch;
  
    vm.groupsAreLoaded = false;
    vm.loadGroups = loadGroups;
    vm.loadUsers = loadUsers;
    
    /**
     * Search for contacts; use a random delay to simulate a remote call
     */
    function querySearch (criteria) {
      return criteria ? vm.allContacts.filter(createFilterFor(criteria)) : [];
    }  
    
    /**
     * Async search for contacts
     * Also debounce the queries; since the md-contact-chips does not support this
     */
    function delayedQuerySearch(criteria) { 
      
    	if ( !pendingSearch || !debounceSearch() )  {
	        cancelSearch();
	        pendingSearch = $q(function(resolve, reject) {
		          cancelSearch = reject;
		           
		          if (vm.criteriaList.indexOf(criteria) == -1 ){ 
		        	  vm.criteriaList.push(criteria);
		        	   
		        	  if (vm.groupsAreLoaded) {
		        		  vm.loadUsers(criteria, resolve);
		        	  }
		        	  else {
		        		  vm.loadGroups(criteria, resolve);
		        	  }
		
		          }
		          else { 
		        	  resolve( vm.querySearch(criteria) );
			          refreshDebounce();
		          }
	        });//$q
      }
      
      return pendingSearch;
    }
    
    function refreshDebounce() {
      lastSearch = 0;
      pendingSearch = null;
      cancelSearch = angular.noop;
    }
    /**
     * Debounce if querying faster than 300ms
     */
    function debounceSearch() {
      var now = new Date().getMilliseconds();
      lastSearch = lastSearch || now;
      return false;//((now - lastSearch) < 300);
    }
    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(contact) {
        return (contact._lowername.indexOf(lowercaseQuery) != -1 
        		|| (angular.lowercase(contact.email).indexOf(lowercaseQuery) != -1)
        		|| contact.email.length == 0//show groups without filtering
        );
      };
    }
    
    function loadUsers(criteria, resolve){
    	if (criteria && criteria.length > 2) {
	    	cvicRequestService
	    	.requestJsonData(__env.apiUrl + '/common/users/ts?searchTerm=' + criteria, 'GET', successResponseData, failResponseData)
	    	.then(function(data) {			    		 
	    		 for(i = 0; i < data.length; i++) {
	    			 var user = data[i];
	    			 			 	
	    		     var userContact = cvicListService.contactFromUser(user);
	    		    
	    		     if ( vm.allContactsUids.indexOf(userContact.uid) == -1 ){
	    		    	 vm.allContacts.push(userContact);
	    		    	 vm.allContactsUids.push(userContact.uid);
	    		     }
		         }
	    		 
	    		 resolve( vm.querySearch(criteria) );
	             refreshDebounce();
	    	}); //cvicRequestService
    	}
    	else {
    		 resolve( vm.querySearch(criteria) );
             refreshDebounce();
    	}
    }
    
    function loadGroups(criteria, resolve) { 
    	if (vm.groupsAreLoaded) {
    		loadUsers(criteria, resolve);
    	}
    	else {
	    	cvicRequestService
		    	.requestJsonData(__env.apiUrl + ApiEndPoints.GroupController.myGroups, 'GET', successResponseData, failResponseData)
		    	.then(function(data) {
		    		  if (data && data.length > 0) {	
			    		  for(i = 0; i < data.length; i++) {
			    			  var group = data[i];
			    			  var groupContact = cvicListService.contactFromGroup(group);
	
			    		      if ( vm.allContactsUids.indexOf(groupContact.uid) == -1 ){
			    			  		vm.allContacts.push(groupContact);
			    			  		vm.allContactsUids.push(groupContact.uid);
				    		  }
			    		  }
		    		  }	    		  
		    		  vm.groupsAreLoaded = true;
		    		  
		    		  loadUsers(criteria, resolve);
		    	}); 
    	}
    }
    
    function failResponseData(response) {
        return {};
    }

    function successResponseData(response) {
    	return response.data.elements;
    }
     
  }
})();
angular.module('angular-jwt.interceptor', [])
  .provider('jwtInterceptor', function() {

    this.urlParam;
    this.authHeader;
    this.authPrefix;
    this.whiteListedDomains;
    this.tokenGetter;

    var config = this;

    this.$get = function($q, $injector, $rootScope, urlUtils, jwtOptions) {

      var options = angular.extend({}, jwtOptions.getConfig(), config);

      function isSafe (url) {
        if (!urlUtils.isSameOrigin(url) && !options.whiteListedDomains.length) {
          throw new Error('As of v0.1.0, requests to domains other than the application\'s origin must be white listed. Use jwtOptionsProvider.config({ whiteListedDomains: [<domain>] }); to whitelist.')
        }
        var hostname = urlUtils.urlResolve(url).hostname.toLowerCase();
        for (var i = 0; i < options.whiteListedDomains.length; i++) {
          var domain = options.whiteListedDomains[i];
          var regexp = domain instanceof RegExp ? domain : new RegExp(domain, 'i');
          if (hostname.match(regexp)) {
            return true;
          }
        }

        if (urlUtils.isSameOrigin(url)) {
          return true;
        }

        return false;
      }

      return {
        request: function (request) {
          if (request.skipAuthorization || !isSafe(request.url)) {
            return request;
          }

          if (options.urlParam) {
            request.params = request.params || {};
            // Already has the token in the url itself
            if (request.params[options.urlParam]) {
              return request;
            }
          } else {
            request.headers = request.headers || {};
            // Already has an Authorization header
            if (request.headers[options.authHeader]) {
              return request;
            }
          }

          var tokenPromise = $q.when($injector.invoke(options.tokenGetter, this, {
            options: request
          }));

          return tokenPromise.then(function(token) {
            if (token) {
              if (options.urlParam) {
                request.params[options.urlParam] = token;
              } else {
                request.headers[options.authHeader] = options.authPrefix + token;
              }
            }
            return request;
          });
        },
        responseError: function (response) {
          // handle the case where the user is not authenticated
          if (response.status === 401) {
            $rootScope.$broadcast('unauthenticated', response);
          }
          return $q.reject(response);
        }
      };
    }
  });

 /**
  * The content from this file was directly lifted from Angular. It is
  * unfortunately not a public API, so the best we can do is copy it.
  *
  * Angular References:
  *   https://github.com/angular/angular.js/issues/3299
  *   https://github.com/angular/angular.js/blob/d077966ff1ac18262f4615ff1a533db24d4432a7/src/ng/urlUtils.js
  */

 angular.module('angular-jwt.interceptor')
  .service('urlUtils', function () {

    // NOTE:  The usage of window and document instead of $window and $document here is
    // deliberate.  This service depends on the specific behavior of anchor nodes created by the
    // browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
    // cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
    // doesn't know about mocked locations and resolves URLs to the real document - which is
    // exactly the behavior needed here.  There is little value is mocking these out for this
    // service.
    var urlParsingNode = document.createElement("a");
    var originUrl = urlResolve(window.location.href);

    /**
     *
     * Implementation Notes for non-IE browsers
     * ----------------------------------------
     * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
     * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
     * URL will be resolved into an absolute URL in the context of the application document.
     * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
     * properties are all populated to reflect the normalized URL.  This approach has wide
     * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
     * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
     *
     * Implementation Notes for IE
     * ---------------------------
     * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
     * browsers.  However, the parsed components will not be set if the URL assigned did not specify
     * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
     * work around that by performing the parsing in a 2nd step by taking a previously normalized
     * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
     * properties such as protocol, hostname, port, etc.
     *
     * References:
     *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
     *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
     *   http://url.spec.whatwg.org/#urlutils
     *   https://github.com/angular/angular.js/pull/2902
     *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
     *
     * @kind function
     * @param {string} url The URL to be parsed.
     * @description Normalizes and parses a URL.
     * @returns {object} Returns the normalized URL as a dictionary.
     *
     *   | member name   | Description    |
     *   |---------------|----------------|
     *   | href          | A normalized version of the provided URL if it was not an absolute URL |
     *   | protocol      | The protocol including the trailing colon                              |
     *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
     *   | search        | The search params, minus the question mark                             |
     *   | hash          | The hash string, minus the hash symbol
     *   | hostname      | The hostname
     *   | port          | The port, without ":"
     *   | pathname      | The pathname, beginning with "/"
     *
     */
    function urlResolve(url) {
      var href = url;

      // Normalize before parse.  Refer Implementation Notes on why this is
      // done in two steps on IE.
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/')
          ? urlParsingNode.pathname
          : '/' + urlParsingNode.pathname
      };
    }

    /**
     * Parse a request URL and determine whether this is a same-origin request as the application document.
     *
     * @param {string|object} requestUrl The url of the request as a string that will be resolved
     * or a parsed URL object.
     * @returns {boolean} Whether the request is for the same origin as the application document.
     */
    function urlIsSameOrigin(requestUrl) {
      var parsed = (angular.isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
      return (parsed.protocol === originUrl.protocol &&
              parsed.host === originUrl.host);
    }

    return {
      urlResolve: urlResolve,
      isSameOrigin: urlIsSameOrigin
    };

  });

angular.module('angular-jwt.options', [])
  .provider('jwtOptions', function() {
    var globalConfig = {};
    this.config = function(value) {
      globalConfig = value;
    };
    this.$get = function() {

      var options = {
        urlParam: null,
        authHeader: 'Authorization',
        authPrefix: 'Bearer ',
        whiteListedDomains: [],
        tokenGetter: function() {
          return null;
        },
        loginPath: '/',
        unauthenticatedRedirectPath: '/',
        unauthenticatedRedirector: ['$location', function($location) {
          $location.path(this.unauthenticatedRedirectPath);
        }]
      };

      function JwtOptions() {
        var config = this.config = angular.extend({}, options, globalConfig);
      }

      JwtOptions.prototype.getConfig = function() {
        return this.config;
      };

      return new JwtOptions();
    }
  });

 angular.module('angular-jwt.jwt', [])
  .service('jwtHelper', function($window) {

    this.urlBase64Decode = function(str) {
      var output = str.replace(/-/g, '+').replace(/_/g, '/');
      switch (output.length % 4) {
        case 0: { break; }
        case 2: { output += '=='; break; }
        case 3: { output += '='; break; }
        default: {
          throw 'Illegal base64url string!';
        }
      }
      return $window.decodeURIComponent(escape($window.atob(output))); //polyfill https://github.com/davidchambers/Base64.js
    };


    this.decodeToken = function(token) {
      var parts = token.split('.');

      if (parts.length !== 3) {
        throw new Error('JWT must have 3 parts');
      }

      var decoded = this.urlBase64Decode(parts[1]);
      if (!decoded) {
        throw new Error('Cannot decode the token');
      }

      return angular.fromJson(decoded);
    };

    this.getTokenExpirationDate = function(token) {
      var decoded = this.decodeToken(token);

      if(typeof decoded.exp === "undefined") {
        return null;
      }

      var d = new Date(0); // The 0 here is the key, which sets the date to the epoch
      d.setUTCSeconds(decoded.exp);

      return d;
    };

    this.isTokenExpired = function(token, offsetSeconds) {
      var d = this.getTokenExpirationDate(token);
      offsetSeconds = offsetSeconds || 0;
      if (d === null) {
        return false;
      }

      // Token expired?
      return !(d.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)));
    };
  });

angular.module('angular-jwt.authManager', [])
  .provider('authManager', function () {

    this.$get = function ($rootScope, $injector, $location, jwtHelper, jwtInterceptor, jwtOptions) {

      var config = jwtOptions.getConfig();

      function invokeToken(tokenGetter) {
        var token = null;
        if (Array.isArray(tokenGetter)) {
          token = $injector.invoke(tokenGetter, this, {options: null});
        } else {
          token = tokenGetter();
        }
        return token;
      }

      function invokeRedirector(redirector) {
        if (Array.isArray(redirector) || angular.isFunction(redirector)) {
          return $injector.invoke(redirector, config, {});
        } else {
          throw new Error('unauthenticatedRedirector must be a function');
        }
      }

      function isAuthenticated() {
        var token = invokeToken(config.tokenGetter);
        if (token) {
          return !jwtHelper.isTokenExpired(token);
        }
      }

      $rootScope.isAuthenticated = false;

      function authenticate() {
        $rootScope.isAuthenticated = true;
      }

      function unauthenticate() {
        $rootScope.isAuthenticated = false;
      }

      function checkAuthOnRefresh() {
        $rootScope.$on('$locationChangeStart', function () {
          var token = invokeToken(config.tokenGetter);
          if (token) {
            if (!jwtHelper.isTokenExpired(token)) {
              authenticate();
            } else {
              $rootScope.$broadcast('tokenHasExpired', token);
            }
          }
        });
      }

      function redirectWhenUnauthenticated() {
        $rootScope.$on('unauthenticated', function () {
          invokeRedirector(config.unauthenticatedRedirector);
          unauthenticate();
        });
      }

      function verifyRoute(event, next) {
        if (!next) {
          return false;
        }

        var routeData = (next.$$route) ? next.$$route : next.data;

        if (routeData && routeData.requiresLogin === true) {
          var token = invokeToken(config.tokenGetter);
          if (!token || jwtHelper.isTokenExpired(token)) {
            event.preventDefault();
            invokeRedirector(config.unauthenticatedRedirector);
          }
        }
      }

      var eventName = ($injector.has('$state')) ? '$stateChangeStart' : '$routeChangeStart';
      $rootScope.$on(eventName, verifyRoute);

      return {
        authenticate: authenticate,
        unauthenticate: unauthenticate,
        getToken: function(){ return invokeToken(config.tokenGetter); },
        redirect: function() { return invokeRedirector(config.unauthenticatedRedirector); },
        checkAuthOnRefresh: checkAuthOnRefresh,
        redirectWhenUnauthenticated: redirectWhenUnauthenticated,
        isAuthenticated: isAuthenticated
      }
    }
  });

(function ()
{
    'use strict';

    angular.module('app.eventsconferences')
        .controller('ErrorDialogController', ErrorDialogController);

    /** @ngInject */
    function ErrorDialogController($scope, $mdDialog, errorType)
    {
        var vm = this;


        $scope.closeDialog = closeDialog;
        $scope.error = errorType;

        //////////

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepBackTranslate : scope.stepBackTranslate,
                stepForwardTranslate: scope.stepForwardTranslate,
                stepSubmitTranslate: scope.stepSubmitTranslate,
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepBackTranslate : '=?',
                stepForwardTranslate: '=?',
                stepSubmitTranslate: '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepBackTranslate : '=?',
                stepForwardTranslate: '=?',
                stepSubmitTranslate: '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {

	'use strict';

	angular
		.module('app.trash', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

		$stateProvider.state('app.trash', {
			url			: '/trash',
			views		: {
						'content@app': {
							templateUrl	: 'app/main/trash/trash.html',
							controller	: 'TrashController as vm'
						}
			},
			bodyClass	: 'trash'
		});

		$translatePartialLoaderProvider.addPart('app/main/trash');

		msNavigationServiceProvider.saveItem('trash', {
			title		: 'TRASH.TITLE',
			state 		: 'app.trash',
			weight		: 1,
			icon		: 'icon-trash'
		});
	}

})();
(function () {

	'use strict';

	angular
		.module('app.trash')
		.controller('TrashController', TrashController);

	/** @ngInject */
	function TrashController($scope, cvicTrashService, cvicImageService, $mdDialog, cvicDateService, cvicEventService, cvicRequestService, __env) {

		var vm = this;

        // Data
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.myEventsSize = 0;

        $scope.cvicDateService = cvicDateService;

        cvicTrashService.fnLoad().then( function success() {
        	$scope.cvicTrashService = cvicTrashService;
	        $scope.cvicImageService = cvicImageService;
	        vm.strSearchTerm = cvicTrashService.strTerm;
        } );

        cvicRequestService.requestJsonData(__env.apiUrl + '/my_events', 'GET', successResponseData, failResponseData)
        .then(function(data) {
            if(!angular.equals(data, {})) {
                vm.myEventsSize = data.total;
            }
        });

        function failResponseData(response) {
            return {};
        }

        function successResponseData(response) {
             return response.data;
        }

        $scope.fnDisplayDate = function(intDate) {
            //return cvicDateService.formatDate( new Date(intDate) );
            return new Date(intDate);
        };

        $scope.fnChangePage = function (intNewPage) {

            if ( intNewPage + 1 <= cvicTrashService.fnGetPages() && intNewPage > -1 ) {
                cvicTrashService.fnLoadPage(intNewPage);
            }

        };

        $scope.fnNextPage = function () {

            var intNewPage = cvicTrashService.intCurrentPage + 1;

            if ( intNewPage + 1 <= cvicTrashService.fnGetPages()  ) {
                cvicTrashService.fnLoadPage(intNewPage);
            }

        };

        $scope.fnPreviousPage = function () {

            var intNewPage = cvicTrashService.intCurrentPage - 1;

            if ( intNewPage > -1 ) {
                cvicTrashService.fnLoadPage(intNewPage);
            }

        };

        $scope.fnExecuteSearch = function () {
        	var strTerm = vm.strSearchTerm;

            cvicTrashService.fnSearch(strTerm);
        };

        $scope.fnRestore = function (objItem) {

        	var objConfirmDialog = cvicTrashService.fnGetConfirmRestoreDialog();
        	$mdDialog.show(objConfirmDialog).then( function agree() {

                if(cvicEventService.checkEventLimits(vm.myEventsSize)) {
        		
            		cvicTrashService.fnRestore(objItem).then(function success(data) {

            			cvicTrashService.fnLoad();

            		});
                }

        	} );

        };

        $scope.fnDelete = function (objItem) {
        	var objConfirmDialog = cvicTrashService.fnGetConfirmDeleteDialog();
        	$mdDialog.show(objConfirmDialog).then( function agree() {
        		
        		cvicTrashService.fnDelete(objItem).then( function success() {

        			cvicTrashService.fnLoad();

        		} );

        	} );
        };
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.spaces')
        .controller('SpacesController', SpacesController);

    /** @ngInject */
    function SpacesController( 
    		$state, 
    		$mdDialog, 
    		$document, 
    		$rootScope,
    		cvicSpaceService,
    		cvicRequestService, 
    		cvicFormService, 
    		cvicListService,
            cvicJWTService,
            uuid, 
    		accesstypes,
    		__env,
            $scope)
    { 
        var vm = this;
        vm.mySpaces = {};
        vm.upcomingSpaces = {};
        vm.userUid = cvicJWTService.currentUserId();
        vm.spaceLimit = cvicJWTService.maxSpacesLimit();
        //vm.publicSpaces = {};

        vm.accessTypes = accesstypes.data;
        vm.addSpace = addSpace;

        $scope.fnExecuteSearch = fnExecuteSearch;

        init();
        
        //////////
        function init()
        {
        	//initMySpaces()
            cvicRequestService
            	.requestJsonData(__env.apiUrl + '/my_spaces', 'GET', successResponseData, failResponseData)
            	.then(function(data) {
	                vm.mySpaces = {};
                    vm.mySpaces['title'] = 'MyLearningSpaces';
                    vm.mySpaces['rows'] = [];
	
	                if(!angular.equals(data, {})) {
	                    vm.mySpaces['rows'] = data;
	                }
            });
            
            //initUpcomingSpaces
            cvicRequestService
        	.requestJsonData(__env.apiUrl + '/upcoming_spaces', 'GET', successResponseData, failResponseData)
        	.then(function(data) {
                vm.upcomingSpaces = {};
                vm.upcomingSpaces['title'] = 'IParticipateInLearningSpaces';
                vm.upcomingSpaces['rows'] = [];

                if(!angular.equals(data, {})) {
                    vm.upcomingSpaces['rows'] = data;
                }
        	});
        }
                
        function failResponseData(response) {
            return {};
        }

        function successResponseData(response) {
             return cvicListService.rows(response.data.elements, cvicListService.spaceRow);
        }
        
        function successSimpleResponseData(response) {
        	return response.data;
        }   
        
        /**
         * Add space
         *
         * @param e
         */
        function addSpace(e)
        {	
        	//var loadOptionalData = (vm.accessTypes.length == 0);

            if(vm.mySpaces['rows'].length < vm.spaceLimit) {
                cvicRequestService
                    .requestJsonData(__env.apiUrl + '/s/templ', 'GET', successSimpleResponseData, failResponseData)
                    .then(function(data) {
                        // if (loadOptionalData) {
                        //   vm.accessTypes = data.accessTypes;
                        // }
                        data.uid = uuid.v4();
                        data.owner.uid = vm.userUid;
                        data.userAudience[0].user.uid = data.owner.uid;
                        data.accessType = 'open';

                        showSpaceFormDialog('add', data, e);
                });   
            } else {
                cvicFormService.showErrorDialog('SPACE_LIMIT');
            }
        	 
        }
 
        /**
         * Show space add/edit form dialog
         *
         * @param type
         * @param space
         * @param e
         */
        function showSpaceFormDialog(type, space, e)
        {
            var dialogData = {
                type         	: type,
                space			: space,
                accessTypes		: vm.accessTypes
            };

            $mdDialog.show({
                controller         : 'SpaceFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/spaces/dialogs/space-form/space-form-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: false,
                locals             : {
                    dialogData: dialogData
                }
            }).then(function (response)
            {
            	cvicFormService.handleDmDialogResponse(response, handleAddSpace, handleEditSpace, handleRemoveSpace);

            });
        }
        
        function handleAddSpace(response) {
        	vm.mySpaces['rows'].unshift(cvicListService.spaceRow(response.space));
        }

        function handleEditSpace(response) {
            vm.mySpaces['rows'].unshift(cvicListService.spaceRow(response.space));
        }

        function handleRemoveSpace(response) {}

        function fnExecuteSearch() {
            var strTerm = vm.strSearch;

            if (strTerm != null && strTerm.length >= 3) {
            	$rootScope.cvicSearchService.fnExecuteSearch(strTerm, $rootScope.cvicSearchService.enumSearchType.Spaces).then(function success(objResultSet) {

                    $state.go('app.pages_search');

                });
            }
            
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.spacedetails',
            [
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
        	.state('app.spacedetails', {
	            url      : '/spacedetails/:uid',
                parent   : 'app.spaces',
	            views    : {
	                'content@app': {
	                    templateUrl: 'app/main/spacedetails/spacedetails.html',
	                    controller : 'SpacesDetailsController as vm'
	                }
	            },
	            resolve : { 
                    accesstypes: function (msApi)
                    {
                        return msApi.resolve('accesstypes@get');
                    },
                    eventtypes: function (msApi)
                    {
                        return msApi.resolve('eventtypes@get');
                    },
                    conferencetypes: function (msApi) {
                        return msApi.resolve('conferencetypes@get');
                    }
	            },
	            bodyClass: 'dashboard-project'
        });

        $translatePartialLoaderProvider.addPart('app/main/spacedetails');
 
        // Api 
        msApiProvider.register('accesstypes', ['app/data/accesstypes/space_event.json']); 
        msApiProvider.register('eventtypes', ['app/data/event/types.json']);
        msApiProvider.register('conferencetypes', ['app/data/conference/types.json']);
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.spacedetails')
        .controller('SpacesDetailsController', SpacesDetailsController);

    /** @ngInject */
    function SpacesDetailsController(
    		$rootScope,
    		$scope,
            $state,
    		$stateParams,
            $translate, 
            $mdDialog, 
            $document,
            $window, 
    		cvicSpaceService,
    		cvicRequestService, 
    		cvicFormService, 
    		cvicListService, 
    		cvicJWTService,
    		cvicMessageService,
            cvicAudienceService,
    		cvicDocumentService,
            cvicEventService,
            cvicImageService,
            accesstypes,
            eventtypes, 
            conferencetypes,  
            uuid,
    		__env,
            ApiEndPoints)
    // , DashboardData, Folders, Labels, $state, msApi, $mdMedia, msUtils,
	// Contacts, User, Documents
    {
        var vm = this;
        vm.currentUserId = cvicJWTService.currentUserId();
        
        // Data
        vm.uid = $stateParams.uid;
        vm.space = {}; 
        vm.bgImage = 'assets/images/dummy/classroom.jpg';
        vm.events = {}; 
        vm.files = [];
        vm.accessTypes = accesstypes.data;
        vm.eventTypes = cvicEventService.filterVisibleTypes(eventtypes.data);
        vm.conferenceTypes = conferencetypes.data;
        vm.eventsLimit = cvicJWTService.maxEventsLimit();
        vm.myEventsSize = 0;

        vm.audienceUpdateUrl = __env.apiUrl + ApiEndPoints.UserAudienceController.spaceAudienceAction;
        vm.showButtons = {
            showAccept: false,
            showJoin: false,
            showLeave: false,
            showReject: false,
            showRequest: false
        };
        vm.showAudienceTabs = false;
    
        vm.cvicSpaceService = cvicSpaceService;
        
        // Data
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.selectedAccount = '';
        vm.audience = [];
        
        // cvic-messages service
        vm.openThread = cvicMessageService.openThread;
        vm.closeThread = cvicMessageService.closeThread;
        vm.currentThread = cvicMessageService.currentThread;
        vm.currentFilter = {
            type  : 'space',
            filter: vm.uid
        };

        vm.rejectEntityAudience = rejectEntityAudience;
        vm.acceptEntityAudience = acceptEntityAudience;
        vm.showComposeMessageBtn = true;
        vm.composeDialog = function(ev){ 
        	cvicMessageService.composeDialog(ev, vm, { spaceUid: vm.uid });
        };
        
        vm.canReply = function(thread) {
        	return cvicMessageService.canReply(thread);
        }; 

        vm.replyDialog = function(ev){
        	if ( vm.currentThread() ){
        		if ( !cvicJWTService.isOwner(vm.currentThread().entity) ) {
	        		var rpTo = [];
	        		rpTo.push(vm.currentThread().entity.owner); 
		        	var dialogData = {
		        			message: vm.currentThread().entity,
		                    rpTo: rpTo,
		                    spaceUid: vm.uid
		        	};
		        	cvicMessageService.composeDialog(ev, vm, dialogData);
        		}
        	}
        };  
        vm.printMail = function(thread){
        	cvicMessageService.printMail(thread);
        };
        
        // Documents
        vm.cvicDocumentService = cvicDocumentService;
        $scope.uploadNewDocument = function (event) {
        	vm.cvicDocumentService.addDocument(event, true);
        };
        
        // Data
        vm.user = [];
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'name';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';

        // administration
        vm.showSpaceEditFormDialog = showSpaceEditFormDialog;
        vm.rejectEvent = rejectEvent;
        vm.acceptEvent = joinEvent;
        vm.requestEvent = requestEvent;
        vm.showEventFormDialog = showEventFormDialog;

        vm.deleteSpace = deleteSpace;
        
        vm.container = function(){
        	return vm.space;
        };
        
        vm.updateContainer = function(space){
        	vm.space = space;
        };

        vm.refreshContainer = function() {
           return cvicRequestService
                .requestJsonData(__env.apiUrl + ApiEndPoints.SpaceController.getSpace + vm.uid, 'GET', successResponseData, function (response) { $state.go('app.spaces');})
                .then(function(data) {
                	vm.setVMContainerAndAUdience(data);
                });
        };
        
        vm.setVMContainerAndAUdience = function(data){
        	vm.space = data;
            vm.audience = cvicListService.audience(vm.space.userAudience, vm.space.groupAudience);
        };

        vm.localChildren = [];

        $scope.avatar = function getUserAvatar( user ) {
            var img = user['coverImage'];

            if( img === null || user['coverImage']['uid'] === null ) {
                return 'assets/images/avatars/profile.jpg';
            }

            return cvicImageService.fnGetResizedImageUrl( 72, 72, user['coverImage']['uid'] );
        }
                
        init();

        /**
		 * Initialize
		 */
        function init()
        {
        	// space details, audience
            vm.chipSettings = cvicRequestService
            	.requestJsonData(__env.apiUrl + ApiEndPoints.SpaceController.getSpace + vm.uid, 'GET', successResponseData, function (response) { $state.go('app.spaces');})
            	.then(function(data) {
            		vm.setVMContainerAndAUdience(data);
            		
            		vm.allowEditSpace = allowEditSpace();
                    vm.allowDeleteSpace = allowDeleteSpace();

            		// documents canManage space check
                    vm.repo = vm.cvicDocumentService.repo(__env.apiUrl + ApiEndPoints.SpaceController.spaceDocument, vm);
                    vm.cvicDocumentService.selectRepo(vm.repo[0], true);// initDocuments
            		
                    var eventPicture = data.coverImage;
                    if(eventPicture != null) {
                        vm.bgImage = 'url("' + __env.apiUrl + ApiEndPoints.ImageController.getImage + eventPicture['uid'] + '.jpg");';

                        document.getElementById("space-background-img").setAttribute("style", "background-image:" +  vm.bgImage);
                    }

                    var settings = {};
                    settings.vm = vm;                    
                    settings.url = ApiEndPoints.SpaceController.updateSpace;
                    settings.showDelete = vm.cvicDocumentService.canManageContainer();

            		settings.audience = angular.copy(vm.audience);

                    $rootScope.userDataRequest().then( function( userInfo ) {
                    	var userAudience = vm.space.userAudience.map( function(ua){return ua.user.uid} );
                		var data = userInfo.children.filter( function( c ) { return userAudience.includes( c.uid ); } );
                		vm.localChildren = data;
                		return data;
                    });

                    initShowButtons();

                    return settings;
            	});

            initMyEvents();
            initMessages();
        	initEvents();
            initEventTemplate();
        }
        
        function allowEditSpace() {
            return vm.cvicSpaceService.allowEditSpace(vm.space);
        }

        function allowDeleteSpace() {
            return vm.cvicSpaceService.allowDeleteSpace(vm.space);
        }
                
    	// messages
        function initMessages()
        {
        	// space messages
        	cvicRequestService
        	.requestJsonData(__env.apiUrl + ApiEndPoints.SpaceController.spaceMessage + vm.uid, 'GET', successResponseData, failResponseData)
        	.then(function(data) { 
        		 vm.threads = cvicListService.rows(data.elements, cvicListService.messageRow);

                 // Hide the loading screen
                 vm.loadingThreads = false;
                 
                 // Open the thread if needed
                 if ( $stateParams.threadId )
                 {
                     for ( var i = 0; i < vm.threads.length; i++ )
                     {
                         if ( vm.threads[i].id === $stateParams.threadId )
                         {
                             vm.openThread(vm, vm.threads[i]);
                             break;
                         }
                     }
                 }
        	});
        }
    	
    	// events
        function initEvents()
        {
        	// space events
        	cvicRequestService
        	.requestJsonData(__env.apiUrl + ApiEndPoints.SpaceController.spaceEventConference + vm.uid, 'GET', successResponseData, failResponseData)
        	.then(function(data) { 
        		 vm.events.rows = cvicListService.rows(data.elements, cvicListService.eventRow);
        	});
        }

        function initMyEvents() {
            cvicRequestService.requestJsonData(__env.apiUrl + '/my_events', 'GET', successResponseData, failResponseData)
            .then(function(data) {
                if(!angular.equals(data, [])) {
                    vm.myEventsSize = data.total;
                }
            });
        }

        function initEventTemplate() {
            var url = __env.apiUrl + ApiEndPoints.EventController.eventTemplate;

            cvicRequestService.requestJsonData( url, 'GET', successResponseData, function(response) {return {};}).then(function(data) {
                vm.eventTemplate = data;
            });
        }

        function resetShowButtons() {
            vm.showButtons = {
                showAccept: false,
                showJoin: false,
                showLeave: false,
                showReject: false,
                showRequest: false
            };
        }

        function initShowButtons() {
            var accessType = vm.space.accessType;

            // check if parent the current user is parent of one of the audience users.
            $rootScope.userDataRequest().then( function( userInfo ) {
            	var isParentView = userInfo.children.filter( function( c ) {
        			return vm.space.userAudience.map( function(ua){return ua.user.uid} ).includes( c.uid ); 
        		} ).length > 0;
        		
        		vm.showAudienceTabs = vm.showAudienceTabs || isParentView;
        		
        		vm.showComposeMessageBtn = !isParentView;
        		
        		return;
            });

            if(cvicJWTService.isOwner(vm.space)) {
                vm.showAudienceTabs = true;
                return;
            }
 
            var userAudience = cvicJWTService.currentUserAudience(vm.space);
            vm.showAudienceTabs = false;

            if(userAudience && (userAudience.lastAction === 'Invite')) {
                vm.showButtons.showReject = true;
                vm.showButtons.showAccept = true;

                return;
            }

            if(userAudience && userAudience.lastAction === 'Accept') {
                vm.showButtons.showLeave = true;
                vm.showAudienceTabs = true;

                return;
            }

            if(accessType === 'open') {
                vm.showButtons.showJoin = true;

                return;
            }

            if(accessType === 'request') {
                if(!userAudience || (userAudience && (userAudience.lastAction != 'Request'))) {
                    vm.showButtons.showRequest = true;
                }

                return;
            }

        }

        function deleteSpace() {
            var confirmDialog = $mdDialog.confirm()
                        .title( $translate.instant( 'SPACE.CONFIRM_DIALOG.DELETE.TITLE' ) )
                        .htmlContent( $translate.instant( 'SPACE.CONFIRM_DIALOG.DELETE.TEXT' ) )
                        .ok( $translate.instant('SPACE.CONFIRM_DIALOG.DELETE.OK') )
                        .cancel( $translate.instant('SPACE.CONFIRM_DIALOG.DELETE.CANCEL') );

            $mdDialog.show(confirmDialog).then(function agree() {
                cvicRequestService.requestJsonData( 
                    __env.apiUrl + ApiEndPoints.SpaceController.delete, 
                    'POST', 
                    function() {
                         $state.go('app.spaces');
                    },
                    function() {
                        console.log("Failed");
                    }, 
                    JSON.stringify(vm.space)
                );
            });
        }

        function showSpaceEditFormDialog()
        {
            var dialogData = {
                type            : 'edit',
                space           : angular.copy(vm.space),
                accessTypes     : vm.accessTypes
            };

            $mdDialog.show({
                controller         : 'SpaceFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/spaces/dialogs/space-form/space-form-dialog.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false,
                locals             : {
                    dialogData: dialogData
                }
            }).then(function (response)
            {
                cvicFormService.handleDmDialogResponse(response, handleAddSpace, handleEditSpace, handleRemoveSpace);
            });
        }

        
        function handleAddSpace(response) {
            vm.space = response.space;
        }

        function handleEditSpace(response) {
            vm.setVMContainerAndAUdience( response.space );
            if(vm.space.coverImage != null) {
                var strNewUrl = __env.apiUrl + ApiEndPoints.ImageController.getImage + vm.space.coverImage.uid + '.jpg';
                vm.bgImage = "background-image: url(" + strNewUrl + ")";
            }
            else {
                vm.bgImage = 'background-image: url("assets/images/dummy/classroom.jpg")';
            }

            // $window.location.reload();
        }

        function handleRemoveSpace(response) {}

        function showEventFormDialog(e) {
            if(cvicEventService.checkEventLimits(vm.myEventsSize)) {

                var now = moment(new Date());

                var settings = {
                    type         : 'add',
                    calendarEvent: false,
                    start        : now,
                    end          : undefined,
                    accessTypes  : vm.accessTypes,
                    eventTypes   : vm.eventTypes,
                    conferenceTypes: vm.conferenceTypes,
                    targetEvent  : e,
                    handleAddEvent: handleAddEvent,
                    handleEditEvent: function(response) {},
                    handleRemoveEvent: function(response) {}
                };

                cvicFormService.showEventFormDialog(settings);
            }
        }

        function handleAddEvent(response) {
            var event = angular.copy(vm.eventTemplate);
            event.uid = uuid.v4();
            event.owner.uid = vm.currentUserId;
            event.userAudience[0].user.uid = event.owner.uid;
            event.container = vm.space;

            cvicListService.calendarEventToEvent(response.calendarEvent, event);

            if(!angular.equals(event, {})) {
                cvicRequestService.requestJsonData(
                    __env.apiUrl + ApiEndPoints.EventController.newEvent,
                    'POST',
                    function(response) {
                        vm.events.rows.push(cvicListService.eventRow(response.data, false));
                    },
                    function(response){
                        var errorMessage = (response.status == 401) ? "CALENDAR.ERRORS.LIMITS_ERROR": "CALENDAR.ERRORS.SUBMIT_ERROR";

                        cvicFormService.showEventRequestError(errorMessage);
                    },
                    event
                );
            }
        }


        function failResponseData(response) {
            return [];
        }

        function successResponseData(response) {
        	 return response.data;
        }

        function handleAudienceUpdateResponse(response) {
        	vm.refreshContainer().then( function() {
        		resetShowButtons();
        		initShowButtons();
                $rootScope.cvicSchedule.upcomingEventsRequest();
    		});
        }

        function joinEvent() {
            var confirmDialog = $mdDialog.confirm()
                        .title( $translate.instant( 'SPACE.CONFIRM_DIALOG.JOIN_SPACE.TITLE' ) )
                        .htmlContent( $translate.instant( 'SPACE.CONFIRM_DIALOG.JOIN_SPACE.TEXT' ) )
                        .ok( $translate.instant('SPACE.CONFIRM_DIALOG.JOIN_SPACE.OK') )
                        .cancel( $translate.instant('SPACE.CONFIRM_DIALOG.JOIN_SPACE.CANCEL') );

            $mdDialog.show(confirmDialog).then(function agree() {

                cvicAudienceService.updateUserAudience(vm.space, vm.audienceUpdateUrl, 'Accept').then(function(response) {
                    if(response.status === 200) {
                        handleAudienceUpdateResponse(response);
                    } else {
                        // TODO
                    }
                });
            });
        }

        function rejectEvent() {
            var confirmDialog = $mdDialog.confirm()
                        .title( $translate.instant( 'SPACE.CONFIRM_DIALOG.REJECT_SPACE.TITLE' ) )
                        .htmlContent( $translate.instant( 'SPACE.CONFIRM_DIALOG.REJECT_SPACE.TEXT' ) )
                        .ok( $translate.instant('SPACE.CONFIRM_DIALOG.REJECT_SPACE.OK') )
                        .cancel( $translate.instant('SPACE.CONFIRM_DIALOG.REJECT_SPACE.CANCEL') );

            $mdDialog.show(confirmDialog).then(function agree() {

                cvicAudienceService.updateUserAudience(vm.space, vm.audienceUpdateUrl, 'Reject').then(function(response) {
                    if(response.status === 200) {

                        handleAudienceUpdateResponse(response);
                    } else {
                        // TODO
                    }
                });
            });
        }

        function requestEvent() {
            var confirmDialog = $mdDialog.confirm()
                        .title( $translate.instant( 'SPACE.CONFIRM_DIALOG.REQUEST_SPACE.TITLE' ) )
                        .htmlContent( $translate.instant( 'SPACE.CONFIRM_DIALOG.REQUEST_SPACE.TEXT' ) )
                        .ok( $translate.instant('SPACE.CONFIRM_DIALOG.REQUEST_SPACE.OK') )
                        .cancel( $translate.instant('SPACE.CONFIRM_DIALOG.REQUEST_SPACE.CANCEL') );

            $mdDialog.show(confirmDialog).then(function agree() {

                cvicAudienceService.updateUserAudience(vm.space, vm.audienceUpdateUrl, 'Request').then(function(response) {
                    if(response.status === 200) {
                        handleAudienceUpdateResponse(response);
                    } else {
                        // TODO
                    }
                });
            });
        }

        function handleAudienceUpdateResponseByMessage(response, thread) {
            for(var i = 0; i < vm.threads.length; ++i) {
                if(thread.uid == vm.threads[i].uid) {
                    vm.threads[i]["Accept"] = false;
                    vm.threads[i]["Reject"] = false;
                }
            }

            if(vm.currentThread()) {
                vm.currentThread()["Accept"] = false;
                vm.currentThread()["Reject"] = false;
            }
        }

        function acceptEntityAudience(entity, userId, event, messageUid, thread) {
            if ( event ) {
                event.stopPropagation();
            }

            cvicAudienceService.updateUserAudience(entity, vm.audienceUpdateUrl + "/" + messageUid + "/" + userId, 'Accept').then(function(response) {
                if(response.status === 200) {
                    handleAudienceUpdateResponseByMessage(response, thread);
                } else {
                    // TODO
                }
            });
        }

        function rejectEntityAudience(entity, userId, event, messageUid, thread) {
            if ( event ) {
                event.stopPropagation();
            }

            cvicAudienceService.updateUserAudience(entity, vm.audienceUpdateUrl + "/" + messageUid + "/" + userId, 'Reject').then(function(response) {
                if(response.status === 200) {

                    handleAudienceUpdateResponseByMessage(response, thread);
                } else {
                    // TODO
                }
            });
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.search', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_search', {
            url      : '/search',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/search/search.html',
                    controller : 'SearchController as vm'
                }
            },
            bodyClass: 'search'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/search');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.search')
        .controller('SearchController', SearchController);

    /** @ngInject */
    function SearchController(
    		$scope, 
    		$state, 
    		$timeout, 
    		$rootScope, 
    		cvicListService, 
    		cvicImageService, 
    		cvicDateService,
    		cvicProfileService)
    {

        /**
         * It is unclear how the user got here, he definetely should not be here so we redirec thim back to the beginning
         */

        $scope.cvicSearchService = $rootScope.cvicSearchService;
        if ( !$scope.cvicSearchService.fnHasData() ) {
            $state.go('app.dashboard');
        }

        var vm = this; 
        vm.strUid = null;

        // Data
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.strSearchTerm = $scope.cvicSearchService.strSearchTerm;
    	$scope.cvicSearchService.fnSetSelectorMode(false);
        $scope.cvicImageService = cvicImageService;
        
        vm.viewSideNav = false;
         
        $scope.fnDisplayDate = function(intDate) {
            return cvicDateService.formatDate( new Date(intDate) );
        };

        $scope.fnChangePage = function (intNewPage) {
        	$scope.cvicSearchService.fnChangePage(intNewPage);
        };

        $scope.fnNextPage = function () {
        	$scope.cvicSearchService.fnNextPage();
        };

        $scope.fnPreviousPage = function () {
        	$scope.cvicSearchService.fnPreviousPage();
        };

        $scope.fnExecuteSearch = function () {

            var strTerm = vm.strSearchTerm;
         	vm.viewSideNav = false;
         	vm.strUid = null;
            
            if (strTerm != null && strTerm != undefined) {
                $scope.cvicSearchService.fnModifyTerm(strTerm);
            }

        };

        $scope.fnChangeSearchType = function () {
        	$scope.cvicSearchService.fnModifyEntityType();
        };

        $scope.fnGoToItem = function (objItem) {
        	
        	vm.strUid = objItem.uid;
         	vm.cvicDocumentService = $scope.cvicSearchService.cvicDocumentService(vm);

         	 var strClass = objItem['@class'];
             
             switch(strClass) {
                 case $scope.cvicSearchService.enumObjectType.Space:
                     $state.go('app.spacedetails', {uid: vm.strUid});
                     break;
                 case $scope.cvicSearchService.enumObjectType.Event:
                     $state.go('app.eventdetails', {uid: vm.strUid});
                     break;
                 case $scope.cvicSearchService.enumObjectType.Message:
                     $state.go('app.mail.threads.thread', {threadId: vm.strUid, filter: 'inbox'});
                     break;
                 case $scope.cvicSearchService.enumObjectType.Document:
                     $scope.toggleDocumentDetails(objItem);
                     break;
                 case $scope.cvicSearchService.enumObjectType.User:
                	 cvicProfileService.profile(vm.strUid);
                     break;
                 default:
                     break;
             }

        };
        
        $scope.toggleDocumentDetails = function(objItem){
        	vm.cvicDocumentService.select(cvicListService.documentRow(objItem));
            vm.viewSideNav = true;
            $timeout(function () {
            	vm.cvicDocumentService.toggleSidenav('details-sidenav');
            }, 100);            
        };       

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.profile')
        .controller( 'ProfileController', ProfileController )
        .directive('contactList', function( cvicImageService, cvicProfileService, cvicJWTService, $translate ) {
        	return {
        		restrict: 'E',
        		scope: {
        	    	collection: '=collection',
        	    	label: '=label'
        		},
        		link: function (scope, element, attrs) {
                    scope.cvicImageService = cvicImageService;
                    scope.cvicProfileService = cvicProfileService;
                    scope.cvicJWTService = cvicJWTService;
                    $translate( attrs.label ).then(function (translatedValue) {
                    	scope.trans_label = translatedValue;
                    });
                },
        		templateUrl: 'app/main/profile/contact-list.html'
        	};
        })
        .filter('to_trusted', ['$sce', function($sce){
            return function(text) {
                return $sce.trustAsHtml(text);
            };
        }]);

    /** @ngInject */
    function ProfileController(
    	$q,
        $scope, 
        $rootScope,
        $location,
        $state,
        cvicProfileService, 
        cvicImageService, 
        cvicDateService, 
        cvicJWTService, 
        cvicDocumentService,
        cvicMessageService,
        cvicListService,
        cvicRequestService,
        ApiEndPoints,
        uuid, 
        __env
    )
    {
        var vm = this;
        //Documents
        vm.cvicDocumentService = cvicDocumentService;
        $scope.uploadNewDocument = function (event) {
        	vm.cvicDocumentService.addDocument(event, true);
        };
        vm.container = function(){
        	return $scope.cvicProfileService.objAboutResult;
        };
        vm.updateContainer = function(user){
        	$scope.cvicProfileService.objAboutResult = user;
			$rootScope.userInformation = null;
        };
        
        vm.isParent = cvicJWTService.hasFeature( 'AddChild' );
        vm.addNewGroup = addNewGroup;
      
        $scope.varImgSrc = 'assets/images/avatars/profile.jpg';
        $scope.cvicImageService = cvicImageService;
        $scope.cvicProfileService = cvicProfileService;
        $scope.cvicDateService = cvicDateService;
        $scope.bIsEditTitle = false;
        $scope.bIsEditDescription = false;
        $scope.bIsEditEmail = false;
        $scope.intSelectedTabIndex = 0;
        
        vm.upgrade = null;
        vm.upgrades = [];
        
        $scope.onUpgradeChanged = function() {
        	var form = document.querySelector( "#epay" + vm.upgrade + " > form" );
        	form.target = "_blank";
        	form.submit();
        }
        
        $q( function( resolve, reject ) {
        	cvicRequestService.requestJsonData(
				__env.apiUrl + '/upgrade/options', 'GET', 
				function( response ){ 
					vm.upgrades = response.data;
					return response;
				}, 
				function( response ){ return []; }
        	).then( function( data ) { resolve(); } );
    	});
        
        vm.bIsEditAllowed = false;
        vm.bIsEditEmailAllowed = false;
        vm.loading = true;
        vm.addRemoveUserToGroup = function (group, contact) {
        	$scope.cvicProfileService.addRemoveUserToGroup($scope.cvicProfileService, group, cvicListService.contactRow(contact));
        };
                
        $scope.cvicProfileService.fnLoad($state.params.userUid)
        .then(function success() {        	
        	if ( $scope.cvicProfileService.objAboutResult.coverImage != null ) {
                $scope.varImgSrc = cvicImageService.fnGetResizedImageUrl( 
                    cvicImageService.objCONSTANTS.PROFILE_HEIGHT, 
                    cvicImageService.objCONSTANTS.PROFILE_WIDTH, 
                    $scope.cvicProfileService.objAboutResult.coverImage.uid 
                ); 
            }
        	 
        	if (!$scope.cvicProfileService.objAboutResult.settings) {
        		$scope.cvicProfileService.objAboutResult.settings = {};
        	}
        	if (!$scope.cvicProfileService.objAboutResult.settings.email) {
        		$scope.cvicProfileService.objAboutResult.settings.email = $scope.cvicProfileService.objAboutResult.email;
        	}
        	
        	vm.loading = false;
        	
            vm.bIsEditAllowed = ($scope.cvicProfileService.objAboutResult.organization == null 
            						|| $scope.cvicProfileService.objAboutResult.organization.type != 'moodle'
            					 )
            					 && cvicJWTService.isCurrentUser($state.params.userUid);
            vm.bIsEditEmailAllowed = $scope.cvicProfileService.objAboutResult.organization != null 
										&& $scope.cvicProfileService.objAboutResult.organization.type == 'moodle'
										&& cvicJWTService.isCurrentUser($state.params.userUid);

            fnOpenGrades();
            
            fnLoadPortfolio();
        });
        
        $scope.fnAddImage = function (event) {

            if( event.target.files.length == 1 ) {

                var objFile = event.target.files[0];
                var objReader = new FileReader();
                //var objReader2 = new FileReader();
                var strMimeType = objFile.type;
                var strTitle = objFile.name;

                objReader.onload = function (e) {
                    $scope.varImgSrc = e.target.result;
                    $scope.$apply();

                    cvicImageService.getTemplate().then(function success(objImgTpl) {

                        objReader.onload = function (evt) {
                            var arrBytes = evt.target.result;
                            var strEncodedContent = cvicImageService.arrayBufferToBase64(arrBytes);

                            objImgTpl.title = strTitle;
                            objImgTpl.mimeType = strMimeType;
                            objImgTpl.content = strEncodedContent;
                            objImgTpl.owner.uid = cvicJWTService.currentUserId();
                            objImgTpl.uid = uuid.v4();

                            $scope.cvicProfileService.objAboutResult.coverImage = objImgTpl;
                            $scope.cvicProfileService.fnSave();
                        };

                        objReader.readAsArrayBuffer(objFile);

                    });
                };

                objReader.readAsDataURL(objFile);
            }
            
        };

        $scope.fnEditTitle = function () {
            $scope.bIsEditTitle = true;
        };

        $scope.fnEditDescription = function () {
            $scope.bIsEditDescription = true;
        };
        
        $scope.fnEditEmail = function () {
            $scope.bIsEditEmail = true;
        };
        
        $scope.fnSave = function () {
            $scope.bIsEditTitle = false;
            $scope.bIsEditDescription = false;
            $scope.bIsEditEmail = false;
            $scope.cvicProfileService.fnSave();
        };

        $scope.fnResetPass = function () {
        	$state.go( 'app.pages_auth_reset-password' );
        };

        $scope.fnIsCourseEmpty = function (objCourse) {

            if ( 
            		(typeof objCourse.grades === 'undefined' || objCourse.grades == null || objCourse.grades.length == 0) 
            		&&
            		(typeof objCourse.gradeitems === 'undefined' || objCourse.gradeitems == null || objCourse.gradeitems.length == 0)
            ) {
                return true;
            }

            if ( objCourse.grades ) {
                for ( var i = 0; i < objCourse.grades.length; i++ ) {
                    var objGrade = objCourse.grades[i];
                    if ( objGrade.grade != null ) {
                        return false;
                    }
                }            	
            }
            
            if ( objCourse.gradeitems ) {
                for ( var i = 0; i < objCourse.gradeitems.length; i++ ) {
                    var objGrade = objCourse.gradeitems[i];
                    if ( objGrade.gradeformatted != null ) {
                        return false;
                    }
                }            	            	
            }

            return true;
        };

        $scope.fnGetNotEmptyLength = function (objSpace) {

            if ( typeof objSpace.grades.items === 'undefined' || objSpace.grades.items == null || objSpace.grades.items.length == 0 ) {
                return 0;
            }

            var intCounter = 0;

            for ( var i = 0; i < objSpace.grades.items.length; i++ ) {
                var objCourse = objSpace.grades.items[i];
                if ( !$scope.fnIsCourseEmpty(objCourse)  ) {
                    intCounter++;
                }
            }

            return intCounter;

        };

        $scope.fnSpaceClick = function (objSpace) {
            $state.go('app.spacedetails', {
                uid: objSpace.uid
            });
        };
        
        function fnLoadPortfolio() {
        	 vm.repo = vm.cvicDocumentService.repo(__env.apiUrl + ApiEndPoints.ProfileController.portfolio, vm);
             vm.cvicDocumentService.selectRepo(vm.repo[0], true);//initDocuments             
        }

        function fnOpenGrades() {
            var intOpenGrades = $location.search().openGrades;

            if ( typeof intOpenGrades !== 'undefined' ) {
                $scope.intSelectedTabIndex = intOpenGrades;
            }
        };
        
        function addNewGroup() { 
            if ( vm.newGroupName === undefined || vm.newGroupName == null || vm.newGroupName.trim().length == 0 ) {
                return;
            } 
            
            $scope.cvicProfileService.addNewGroup(vm.newGroupName)
            	.then(function(data) {
	                if(!angular.equals(data, {})) {;	
	                	$scope.cvicProfileService.groups.push(data);		
	                	$scope.cvicProfileService.groupsUsers[data.uid] = [];
	                	$scope.cvicProfileService.objGroupsUsersMap[data.uid] = {};
		                
	                	$scope.cvicProfileService.addRemoveUserToGroup($scope.cvicProfileService, data, cvicListService.contactRow($scope.cvicProfileService.objAboutResult));
	
		            } else {
		                // TODO
		            }
            	});
            

            vm.newGroupName = '';
        }

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.mail')
        .controller('MailController', MailController);

    /** @ngInject */
    function MailController(
    		$scope, 
    		$rootScope, 
    		$document, 
    		$mdDialog, 
    		$mdMedia, 
    		$mdSidenav, 
    		$state, 
    		cvicRequestService, 
    		cvicListService,
    		cvicMessageService,
    		cvicJWTService,
            cvicAudienceService,
    		Folders, 
            Labels, 
            __env,
            ApiEndPoints,
            $sce)
    {
        var vm = this;
                 
        vm.openThread = cvicMessageService.openThread;
        vm.closeThread = cvicMessageService.closeThread;
        vm.currentThread = cvicMessageService.currentThread;
        vm.deleteMsg = cvicMessageService.deleteMsg;
        vm.markAs = cvicMessageService.markAs;
        vm.rejectEntityAudience = rejectEntityAudience;
        vm.acceptEntityAudience = acceptEntityAudience;
        vm.fnGetMessage = cvicMessageService.fnGetMessage;
        
        
        // Data
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.selectedAccount = 'creapond';

        vm.folders = Folders.data;
        vm.labels = Labels.data;
        vm.loadingThreads = true;

        vm.currentFilter = {
            type  : $state.params.type,
            filter: $state.params.filter
        };
        vm.selectedThreads = [];

        vm.views = {
            classic: 'app/main/mail/views/classic/classic-view.html',
            outlook: 'app/main/mail/views/outlook/outlook-view.html'
        };
        vm.defaultView = 'classic';
        vm.currentView = 'classic';

        // Methods
        vm.loadFolder = loadFolder;
        vm.loadLabel = loadLabel;
        vm.isFolderActive = isFolderActive;
        vm.isLabelActive = isLabelActive;

        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;
        
        vm.deleteThread = deleteThread;

        vm.getLabel = getLabel;
        vm.getLabelColor = getLabelColor;
        vm.getLabelTitle = getLabelTitle;
        vm.toggleLabel = toggleLabel;
        vm.isLabelExist = isLabelExist;

         vm.changeView = changeView;

        vm.composeDialog = function(ev){ 
        	cvicMessageService.composeDialog(ev, vm, { rpTo:  [] });
         };
        vm.replyDialog = function(ev){
        	if ( vm.currentThread() ){
        		if ( vm.currentThread().entity.owner.uid != cvicJWTService.currentUserId() ) {
	        		var rpTo = [];
	        		rpTo.push(vm.currentThread().entity.owner); 
		        	var dialogData = {
		        			message: vm.currentThread().entity,
		                    rpTo: rpTo
		        	};
		        	cvicMessageService.composeDialog(ev, vm, dialogData);
        		}
        	}
        };
        vm.canReply = function(thread) {
        	return cvicMessageService.canReply(thread);
        };       
        vm.forwardDialog = function(ev){
        	if ( vm.currentThread() ){
	        	var dialogData = {
	        			message: vm.currentThread().entity,
	                    fwTo:  true
	        	};
	        	cvicMessageService.composeDialog(ev, vm, dialogData);
        	}
        };
        vm.printMail = function(thread){
        	cvicMessageService.printMail(thread);
        };

        vm.toggleSidenav = toggleSidenav;

        
        init();

        //////////
        function failResponseData(response) {
        	//console.log("failResponseData: " + JSON.stringify(response.data));
            return [];
        }

        function successResponseData(response) { 
        	 //console.log("successResponseData: " + JSON.stringify(response.data));
             return cvicListService.rows(response.data.elements, cvicListService.messageRow);
        }
         
        /**
         * Initialize
         */
        function init()
        {
            // Figure out the api name
            var apiName = __env.apiUrl + '/m' + ($state.params.type || '/') + $state.params.filter;

            // Request the mails         
            cvicRequestService
         	.requestJsonData(apiName, 'GET', successResponseData, failResponseData)
         	.then(
                // Success
                function (response)
                {  
                    // Load new threads
                    vm.threads = response;

                    // Hide the loading screen
                    vm.loadingThreads = false;

                    // Open the thread if needed
                    if ( $state.params.threadId )
                    {
                        for ( var i = 0; i < vm.threads.length; i++ )
                        {
                            if ( vm.threads[i].id === $state.params.threadId )
                            {
                                vm.openThread(vm, vm.threads[i]);
                                break;
                            }
                        }
                    }
                }
            );
        }

        // Watch screen size to change view modes
        $scope.$watch(function ()
        {
            return $mdMedia('xs');
        }, function (current, old)
        {
            if ( angular.equals(current, old) )
            {
                return;
            }

            if ( current )
            {
                vm.currentView = 'classic';
            }
        });

        $scope.$watch(function ()
        {
            return $mdMedia('gt-xs');
        }, function (current, old)
        {
            if ( angular.equals(current, old) )
            {
                return;
            }

            if ( current )
            {
                if ( vm.defaultView === 'outlook' )
                {
                    vm.currentView = 'outlook';
                }
            }
        });

        /**
         * Load folder
         *
         * @param name
         */
        function loadFolder(name)
        {         
            // If we are already in the selected folder and
            // there is an open thread just close it
            if ( vm.isFolderActive(name) )
            {
                // Close the current thread if open
                if ( vm.currentThread() )
                {
                    vm.closeThread(vm);
                }

                //if ( name != 'important' && name != 'starred' ) {
                //	return;
                //}
            }

            // Show loader
            $rootScope.loadingProgress = true;

            // Update the state without reloading the controller
            $state.go('app.mail.threads', {
                type  : null,
                filter: name
            }, {notify: false});

            // Build the API name
            var apiName = __env.apiUrl + '/m/' + name;
                        
            // Make the call
            cvicRequestService
         	.requestJsonData(apiName, 'GET', successResponseData, failResponseData)
         	.then(
                // Success
                function (response)
                {                  	
                    // Load new threads
                    vm.threads = response;

                    // Set the current filter
                    vm.currentFilter = {
                        type  : null,
                        filter: name
                    };

                    // Close the current thread if open
                    if ( vm.currentThread() )
                    {
                        vm.closeThread(vm);
                    }

                    vm.deselectThreads();
                    
                    // Hide loader
                    $rootScope.loadingProgress = false;
                }
            );
        }

        /**
         * Load label
         *
         * @param name
         */
        function loadLabel(name)
        {
            // Update the state without reloading the controller
            $state.go('app.mail.threads', {
                type  : 'label',
                filter: name
            }, {notify: false});

            // If we are already in the selected folder and
            // there is an open thread just close it
            if ( vm.isLabelActive(name) )
            {
                // Close the current thread if open
                if ( vm.currentThread() )
                {
                    vm.closeThread(vm);
                }

                return;
            }

            // Show loader
            $rootScope.loadingProgress = true;

            // Build the API name 
            var apiName = __env.apiUrl + '/mlabel/' + name;

            // Make the call
            cvicRequestService
         	.requestJsonData(apiName, 'GET', successResponseData, failResponseData)
         	.then(
                // Success
                function (response)
                {  
                    // Load new threads
                    vm.threads = response;

                 // Set the current filter
                    vm.currentFilter = {
                        type  : 'label',
                        filter: name
                    };

                    // Close the current thread if open
                    if ( vm.currentThread() )
                    {
                        vm.closeThread(vm);
                    }

                    // Hide loader
                    $rootScope.loadingProgress = false;
                }
            );
        }

        /**
         * Is the folder with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isFolderActive(name)
        {
            return (vm.currentFilter.type === null && vm.currentFilter.filter === name);
        }

        /**
         * Is the label with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isLabelActive(name)
        {
            return (vm.currentFilter.type === 'label' && vm.currentFilter.filter === name);
        }

      

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread)
        {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            if ( vm.selectedThreads.indexOf(thread) > -1 )
            {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            }
            else
            {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value)
        {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for ( var i = 0; i < vm.threads.length; i++ )
            {
                if ( angular.isUndefined(key) && angular.isUndefined(value) )
                {
                    vm.selectedThreads.push(vm.threads[i]);
                    continue;
                }

                if ( angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value )
                {
                    vm.selectedThreads.push(vm.threads[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads()
        {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads()
        {
            if ( vm.selectedThreads.length > 0 )
            {
                vm.deselectThreads();
            }
            else
            {
                vm.selectThreads();
            }
        }
        
        function deleteThread(thread,event){
        	 // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if ( event )
            {
                event.stopPropagation();
            }            

        	var delThreads = [];

            // If the thread provided, do the changes on that
            // particular thread
            if ( thread )
            { 
            	//thread[key] = value;
            	delThreads.push(thread);
            	vm.deleteMsg(delThreads, vm);
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if ( vm.currentThread() )
            {
                //vm.currentThread()[key] = value;
            	delThreads.push(vm.currentThread());
            	vm.deleteMsg(delThreads, vm);
                return;
            }

            // Otherwise do the status update on selected threads
            for ( var x = 0; x < vm.selectedThreads.length; x++ )
            {
                //vm.selectedThreads[x][key] = value;
            	delThreads.push(vm.selectedThreads[x]);
            }
        	vm.deleteMsg(delThreads, vm);
        }
        
        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event)
        {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if ( event )
            {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if ( thread )
            { 
            	//thread[key] = value;
            	vm.markAs(key, value, thread);
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if ( vm.currentThread() )
            {
                //vm.currentThread()[key] = value;
            	vm.markAs(key, value, vm.currentThread());
                return;
            }

            // Otherwise do the status update on selected threads
            for ( var x = 0; x < vm.selectedThreads.length; x++ )
            {
                //vm.selectedThreads[x][key] = value;
            	vm.markAs(key, value, vm.selectedThreads[x]);
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event)
        {        	
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if ( event )
            {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if ( thread )
            {
                if ( typeof(thread[key]) !== 'boolean' )
                {
                    return;
                }

                //thread[key] = !thread[key];
                vm.markAs(key, !thread[key], thread);
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if ( vm.currentThread() )
            {
                if ( typeof(vm.currentThread()[key]) !== 'boolean' )
                {
                    return;
                }

                //vm.currentThread()[key] = !vm.currentThread()[key];
                vm.markAs(key, !vm.currentThread()[key], vm.currentThread());
                return;
            }

            // Otherwise do the status update on selected threads
            for ( var x = 0; x < vm.selectedThreads.length; x++ )
            {
                if ( typeof(vm.selectedThreads[x][key]) !== 'boolean' )
                {
                    continue;
                }

                //vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
                vm.markAs(key, !vm.selectedThreads[x][key], vm.selectedThreads[x]);
            }
        }

        /**
         * Get label object content
         *
         * @param id
         * @returns {*}
         */
        function getLabel(id)
        {
            for ( var i = 0; i < vm.labels.length; i++ )
            {
                if ( vm.labels[i].id === id )
                {
                    return vm.labels[i];
                }
            }
        }

        /**
         * Get label color from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelColor(id)
        {
            return vm.getLabel(id).color;
        }

        /**
         * Get label title from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelTitle(id)
        {
            return vm.getLabel(id).title;
        }

        /**
         * Toggle label
         *
         * @param label
         */
        function toggleLabel(label)
        {
        	//TODO DB store
        	
            // Toggle label on the currently open thread
            if ( vm.currentThread() )
            {
                if ( vm.currentThread().labels.indexOf(label.id) > -1 )
                {
                    vm.currentThread().labels.splice(vm.currentThread().labels.indexOf(label.id), 1);
                }
                else
                {
                    vm.currentThread().labels.push(label.id);
                }

                return;
            }

            // Toggle labels on selected threads
            // Toggle action will be determined by the first thread from the selection.
            if ( vm.selectedThreads.length > 0 )
            {
                // Decide if we are going to remove or add labels
                var removeLabels = (vm.selectedThreads[0].labels.indexOf(label.id) > -1);

                for ( var i = 0; i < vm.selectedThreads.length; i++ )
                {
                    if ( !removeLabels )
                    {
                        vm.selectedThreads[i].labels.push(label.id);
                        continue;
                    }

                    if ( vm.selectedThreads[i].labels.indexOf(label.id) > -1 )
                    {
                        vm.selectedThreads[i].labels.splice(vm.selectedThreads[i].labels.indexOf(label.id), 1);
                    }
                }
            }
        }

        /**
         * Is label exist?
         *
         * @param label
         * @returns {boolean}
         */
        function isLabelExist(label)
        {
            if ( vm.currentThread() && vm.currentThread().labels )
            {
                return (vm.currentThread().labels.indexOf(label.id) > -1);
            }
        }

        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view)
        {
            if ( vm.views[view] )
            {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }
 
        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        function constructAudienceUpdateUrl(entity) {
            var url = undefined;

            if(entity['@class'] === 'com.tetracom.cvic.model.space.Space') {
                url = __env.apiUrl + ApiEndPoints.UserAudienceController.spaceAudienceAction;
            } else if(entity['@class'] === 'com.tetracom.cvic.model.event.Event') {
                url = __env.apiUrl + ApiEndPoints.UserAudienceController.eventAudienceAction;
            }

            return url;
        }

        function handleAudienceUpdateResponse(response, thread) {
            for(var i = 0; i < vm.threads.length; ++i) {
                if(thread.uid == vm.threads[i].uid) {
                    vm.threads[i]["Accept"] = false;
                    vm.threads[i]["Reject"] = false;
                }
            }

            if(vm.currentThread()) {
                vm.currentThread()["Accept"] = false;
                vm.currentThread()["Reject"] = false;
            }
        }

        function acceptEntityAudience(entity, userId, event, messageUid, thread) {
            if ( event ) {
                event.stopPropagation();
            }

            var url = constructAudienceUpdateUrl(entity);
            if(url == undefined) {
                // TODO show notification
                return;
            }

            cvicAudienceService.updateUserAudience(entity, url + "/" + messageUid + "/" + userId, 'Accept').then(function(response) {
                if(response.status === 200) {
                    handleAudienceUpdateResponse(response, thread);
                } else {
                    // TODO
                }
            });
        }

        function rejectEntityAudience(entity, userId, event, messageUid, thread) {
            if ( event ) {
                event.stopPropagation();
            }

            var url = constructAudienceUpdateUrl(entity);
            if(url == undefined) {
                // TODO show notification
                return;
            }

            cvicAudienceService.updateUserAudience(entity, url + "/" + messageUid + "/" + userId, 'Reject').then(function(response) {
                if(response.status === 200) {

                    handleAudienceUpdateResponse(response, thread);
                } else {
                    // TODO
                }
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.file-manager')
        .controller('FileManagerController', FileManagerController);

    /** @ngInject */
    function FileManagerController(
            $scope,
            $document,
            $rootScope,
    		cvicRequestService, 
    		cvicListService, 
    		cvicDocumentService,
    		cvicJWTService,
    		__env,
            cvicImageService,
            uuid,
            $state)
    {
        var vm = this;

        $scope.fnExecuteSearch = fnExecuteSearch;

        // Data 
        vm.currentView = 'list';
        
        //cvicDocumentService
        vm.cvicDocumentService = cvicDocumentService;
        
        //cvicJWTService
        vm.cvicJWTService = cvicJWTService;

        // Methods
        $scope.executeUpload = executeUpload;
 
        vm.toggleView = toggleView;
        
        init();

        //////////
        function init(){       
        	vm.repo = vm.cvicDocumentService.repo(__env.apiUrl + '/filemanager/', null);
        	vm.cvicDocumentService.selectRepo(vm.repo[0], true);//initDocuments
        }

        function executeUpload(event) {
        	vm.cvicDocumentService.addDocument(event, false);
        }

        /**
         * Toggle view
         */
        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'grid' : 'list';
        }

        function fnExecuteSearch() {
            var strTerm = vm.strSearch;

            if (strTerm != null && strTerm.length >= 3) {
            	$rootScope.cvicSearchService.fnExecuteSearch(strTerm, $rootScope.cvicSearchService.enumSearchType.Documents).then(function success(objResultSet) {

                    $state.go('app.pages_search');

                });
            }
            
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.eventsconferences')
        .controller('EventsConferencesController', EventsConferencesController);

    /** @ngInject */
    function EventsConferencesController(
        $scope, 
        $rootScope, 
        $interval, 
        $filter, 
        $mdDialog, 
        $document, 
        $translate, 
        cvicRequestService, 
        cvicFormService, 
        cvicListService, 
        cvicDateService, 
        cvicJWTService, 
        cvicEventService,
        accesstypes, 
        eventtypes, 
        conferencetypes, 
        uuid, 
        __env,
        ApiEndPoints,
        $state
        )
    {
        var vm = this;
        vm.accessTypes = accesstypes.data;
        vm.eventTypes = cvicEventService.filterVisibleTypes(eventtypes.data);
        vm.conferenceTypes = conferencetypes.data;
        vm.eventTemplate = initEventTemplate();
        vm.currentUserId = cvicJWTService.currentUserId();
        vm.isParent = cvicJWTService.hasFeature( 'AddChild' );
        
        $scope.fnExecuteSearch = fnExecuteSearch;

        initMyEvents();
        initUpcomingEvents();

        vm.events = [[]];
        vm.myEvents = {};
        vm.upcomingEvents = {};

        initCalendar();

        vm.calendarUiConfig = {
            calendar: {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                eventClick        : eventDetail,
                selectable        : true,
                selectHelper      : true,
                select            : select
            }
        };

        setCalendarDayNames();

        $rootScope.$on('$translateChangeSuccess', function(event, current, previous) {
            setCalendarDayNames();
        });

        vm.addEvent = addEvent;
        vm.next = next;
        vm.prev = prev;

        function failResponseData(response) {
            return {};
        }

        function successResponseData(response) {
            return response.data;
        }

        function successResultSetData(response) {
            return response.data.elements;
        }

        function setCalendarDayNames() {
            vm.calendarUiConfig.calendar.dayNames = [
                $translate.instant("CALENDAR.DAY_NAMES.FULL.SUNDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.FULL.MONDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.FULL.TUESDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.FULL.WEDNESDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.FULL.THURSDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.FULL.FRIDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.FULL.SATURDAY")
            ];
                
            vm.calendarUiConfig.calendar.dayNamesShort = [
                $translate.instant("CALENDAR.DAY_NAMES.SHORT.SUNDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.SHORT.MONDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.SHORT.TUESDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.SHORT.WEDNESDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.SHORT.THURSDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.SHORT.FRIDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.SHORT.SATURDAY")
            ];
        }

        function initEventTemplate() {
            var url = __env.apiUrl + ApiEndPoints.EventController.eventTemplate;

            cvicRequestService.requestJsonData( url, 'GET', successResponseData, function(response) {return {};}).then(function(data) {
                vm.eventTemplate = data;
            });
        }

        function initMyEvents() {
            cvicRequestService.requestJsonData(__env.apiUrl + '/my_events', 'GET', successResultSetData, failResponseData)
            .then(function(data) {
                if(!angular.equals(data, {})) {
                    vm.myEvents['title'] = 'MyEventsAndConferences';
                    vm.myEvents['rows'] = eventsRows(data, false);
                }
            });
        }

        function initUpcomingEvents() {
            cvicRequestService.requestJsonData( __env.apiUrl + '/upcoming_events', 'GET', successResultSetData, failResponseData)
            .then(function(data) {
                if(!angular.equals(data, {})) {
                    vm.upcomingEvents['title'] = 'IncomingEventsAndConferences';
                    vm.upcomingEvents['rows'] = eventsRows(data, false);
                }
            });
        }

        

        function initCalendar() {
            cvicRequestService.requestJsonData( __env.apiUrl + ApiEndPoints.EventController.getCalendarEvents, 'GET', successResultSetData, failResponseData).then(function(data) {
                if(!angular.equals(data, {})) {

                    $rootScope.userDataRequest().then( function( userInfo ){
                        return userInfo.children.map( function(c){return c.uid} ); 
                    } ).then( function( children ) {
                        for(i = 0; i < data.length; ++i) {
                            var event = data[i];

                            var calendarEvent = cvicListService.calendarEvent(event);

                            if ( event.userAudience.map( function(ua){return ua.user.uid} ).filter( function(uid){ return children.indexOf( uid ) >= 0} ).length > 0 ) {
                                calendarEvent.className = 'calchild';
                            } else if ( event.container == null ) {
                                calendarEvent.className = 'attending';  
                            }
                            
                            vm.events[0].push(calendarEvent);
                        }
                    } );
                }
            });
        }

        function eventsRows(events, publicEventButtons) {
            var rows = [];

            for(i = 0; i < events.length; i++) {
                rows.push(cvicListService.eventRow(events[i], publicEventButtons));
            }

            return rows;
        }

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Show event detail
         *
         * @param calendarEvent
         * @param e
         */
        function eventDetail(calendarEvent, e)
        {
            showEventDetailDialog(calendarEvent, e);
        }

        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        function select(start, end, e)
        {
            if(cvicEventService.checkEventLimits(vm.myEvents['rows'].length)) {
                showEventFormDialog('add', false, start, end, e);
            }
        }

        /**
         * Add event
         *
         * @param e
         */
        function addEvent(e)
        {
            if(cvicEventService.checkEventLimits(vm.myEvents['rows'].length)) {

                var start = moment(new Date());

                showEventFormDialog('add', false, start, undefined, e);
            }
        }

        /**
         * Show event detail dialog
         * @param calendarEvent
         * @param e
         */
        function showEventDetailDialog(calendarEvent, e)
        {
            cvicFormService.showEventDetailDialog(calendarEvent, showEventFormDialog, e);
        }


        function handleAddCalendarEvent(response) {
            var event = angular.copy(vm.eventTemplate);
            event.uid = uuid.v4();
            event.owner.uid = vm.currentUserId;
            event.userAudience[0].user.uid = event.owner.uid;

            var newCalendarEvent = response.calendarEvent;
            cvicListService.calendarEventToEvent(newCalendarEvent, event);

            cvicRequestService.requestJsonData(
                __env.apiUrl + ApiEndPoints.EventController.newEvent,
                'POST',
                function(response) {
                    newCalendarEvent.baseObj = response.data;
                    newCalendarEvent.className = 'attending';
                    vm.events[0].push(newCalendarEvent);

                    var rowEvent = cvicListService.eventRow(newCalendarEvent.baseObj, false);
                    vm.myEvents['rows'].unshift(rowEvent);
                    vm.upcomingEvents['rows'].unshift(rowEvent);
                    $rootScope.cvicSchedule.upcomingEventsRequest();
                },
                function(response){
                    var errorMessage = (response.status == 401) ? "CALENDAR.ERRORS.LIMITS_ERROR": "CALENDAR.ERRORS.SUBMIT_ERROR";
                    
                    cvicFormService.showEventRequestError(errorMessage);
                },
                event
            );
        }

        function handleEditCalendarEvent(response) {
            for ( var i = 0; i < vm.events[0].length; i++ ) {
                // Update
                if ( vm.events[0][i].id === response.calendarEvent.id ) {

                    cvicListService.calendarEventToEvent(response.calendarEvent, vm.events[0][i].baseObj);

                    cvicRequestService.requestJsonData( 
                        __env.apiUrl + ApiEndPoints.EventController.updateEvent, 
                        'POST', 
                        function (response) {
                            var calendarEvent = cvicListService.calendarEvent(response.data);
                            vm.events[0][i] = calendarEvent;

                            var rowEvent = cvicListService.eventRow(calendarEvent.baseObj, false);
                            var foundEvent = false;

                            for(var j = 0; j < vm.myEvents['rows'].length; ++j) {
                                if(vm.myEvents['rows'][j].uid === rowEvent.uid) {
                                    vm.myEvents['rows'][j] = rowEvent;

                                    foundEvent = true;

                                    break;
                                }
                            }

                            for(var j = 0; j < vm.upcomingEvents['rows'].length; ++j) {
                                if(vm.upcomingEvents['rows'][j].uid === rowEvent.uid) {
                                    vm.upcomingEvents['rows'][j] = rowEvent;

                                    foundEvent = true;

                                    break;
                                }
                            }

                            if(response.data.startDate >= (new Date()).getTime() && !foundEvent) {
                                vm.myEvents['rows'].unshift(rowEvent);
                                vm.upcomingEvents['rows'].unshift(rowEvent);
                            }

                            $rootScope.cvicSchedule.upcomingEventsRequest();
                        }, 
                        function (response) {
                            var errorMessage = (response.status == 401) ? "CALENDAR.ERRORS.LIMITS_ERROR": "CALENDAR.ERRORS.EDIT_ERROR";

                            cvicFormService.showEventRequestError(errorMessage);
                        }, 
                        JSON.stringify(vm.events[0][i].baseObj));

                    return;
                }
            }
        }

        function handleRemoveCalendarEvent(response) {
            for ( var j = 0; j < vm.events[0].length; j++ ) {
                // Update
                if ( vm.events[0][j].id === response.calendarEvent.id ) {
                    var removedEvent = vm.events[0][j];

                    cvicRequestService.requestJsonData( 
                        __env.apiUrl + '/remove_event', 
                        'POST', 
                        function() {
                             vm.events[0].splice(j, 1);

                             for(var i = 0; i < vm.myEvents['rows'].length; ++i) {
                                if(vm.myEvents['rows'][i].uid === removedEvent.baseObj.uid) {
                                    vm.myEvents['rows'].splice(i, 1);

                                    break;
                                }
                            }

                            for(var i = 0; i < vm.upcomingEvents['rows'].length; ++i) {
                                if(vm.upcomingEvents['rows'][i].uid === removedEvent.baseObj.uid) {
                                    vm.upcomingEvents['rows'].splice(i, 1);

                                    break;
                                }
                            }
                            
                            $rootScope.cvicSchedule.upcomingEventsRequest();

                        },
                        function() {
                            cvicFormService.showEventRequestError("CALENDAR.ERRORS.DELETE_ERROR");
                        }, 
                        JSON.stringify(removedEvent.baseObj)
                    );

                    return;
                }
            }
                         
        }

        /**
         * Show event add/edit form dialog
         *
         * @param type
         * @param calendarEvent
         * @param start
         * @param end
         * @param e
         */
        function showEventFormDialog(type, calendarEvent, start, end, e) {
            var settings = {
                type         : type,
                calendarEvent: calendarEvent,
                start        : start,
                end          : end,
                accessTypes  : vm.accessTypes,
                eventTypes   : vm.eventTypes,
                conferenceTypes: vm.conferenceTypes,
                targetEvent  : e,
                handleAddEvent: handleAddCalendarEvent,
                handleEditEvent: handleEditCalendarEvent,
                handleRemoveEvent: handleRemoveCalendarEvent
            };

            cvicFormService.showEventFormDialog(settings);
        }

        function fnExecuteSearch() {
            var strTerm = vm.strSearch;

            if ( strTerm != null && strTerm.length >= 3 ) {
            	$rootScope.cvicSearchService.fnExecuteSearch(strTerm, $rootScope.cvicSearchService.enumSearchType.Events).then(function success(objResultSet) {

                    $state.go('app.pages_search');

                });
            }

            
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.eventdetails',
            [
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.eventdetails', {
            url      : '/eventdetails/:uid',
            parent   : 'app.eventsconferences',
            resolve : {
            	accesstypes: function (msApi)
                {
                    return msApi.resolve('accesstypes@get');
                },
                eventtypes: function (msApi)
                {
                    return msApi.resolve('eventtypes@get');
                },
                conferencetypes: function (msApi) {
                    return msApi.resolve('conferencetypes@get');
                }
            },
            views    : {
                'content@app': {
                    templateUrl: 'app/main/eventdetails/eventdetails.html',
                    controller : 'EventDetailsController as vm'
                }
            },
            bodyClass: 'dashboard-project'
        });

        //msApi
        msApiProvider.register('accesstypes', ['app/data/accesstypes/space_event.json']); 
        msApiProvider.register('eventtypes', ['app/data/event/types.json']);
        msApiProvider.register('conferencetypes', ['app/data/conference/types.json']);
         
        $translatePartialLoaderProvider.addPart('app/main/eventdetails');

        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.eventdetails')
        .controller('EventDetailsController', EventDetailsController);

    /** @ngInject */
    function EventDetailsController(
    		$rootScope,
    		$scope, 
    		$state,
            $mdDialog, 
            $document, 
    		$stateParams, 
            $filter, 
            $translate, 
            $window,
    		cvicRequestService, 
    		cvicFormService, 
    		cvicListService,
    		cvicMessageService,
    		cvicDocumentService,
    		cvicJWTService,
            cvicAudienceService,
            cvicEventService,
            cvicImageService,
    		accesstypes,
    		eventtypes,
    		conferencetypes,
    		__env,
            ApiEndPoints,
            uuid,
            $location)
    {
        var vm = this;
        var now = Date.now();
        vm.currentUserId = cvicJWTService.currentUserId();

        vm.accessTypes = accesstypes.data;
        vm.eventTypes = cvicEventService.filterVisibleTypes(eventtypes.data);
        vm.conferenceTypes = conferencetypes.data;
        vm.isPasswordEditDisabled = true;
        vm.audienceUpdateUrl = __env.apiUrl + ApiEndPoints.UserAudienceController.eventAudienceAction;

        // Data
        vm.uid = $stateParams.uid;
        vm.event = {};

        //Show data jsons
        vm.showButtons = {
            showAccept: false,
            showJoin: false,
            showLeave: false,
            showReject: false,
            showRequest: false
        };
        vm.showAudienceTabs = false;
        
        // Data
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.selectedAccount = '';
        vm.audience = [];
        
        //cvic-messages service
        vm.showComposeMessageBtn = true;
        vm.openThread = cvicMessageService.openThread;
        vm.closeThread = cvicMessageService.closeThread;
        vm.currentThread = cvicMessageService.currentThread;
        vm.currentFilter = {
            type  : 'event',
            filter: vm.uid
        };

        vm.rejectEntityAudience = rejectEntityAudience;
        vm.acceptEntityAudience = acceptEntityAudience;

        vm.openSpace = openSpace;
        
        vm.composeDialog = function(ev){ 
        	cvicMessageService.composeDialog(ev, vm, { eventUid: vm.uid });
        };

        vm.canReply = function(thread) {
        	return cvicMessageService.canReply(thread);
        }; 

        vm.replyDialog = function(ev){
        	if ( vm.currentThread() ){
        		if ( vm.currentThread().entity.owner.uid != cvicJWTService.currentUserId() ) {
	        		var rpTo = [];
	        		rpTo.push(vm.currentThread().entity.owner); 
		        	var dialogData = {
		        			message: vm.currentThread().entity,
		                    rpTo: rpTo,
		                    eventUid: vm.uid
		        	};
		        	cvicMessageService.composeDialog(ev, vm, dialogData);
        		}
        	}
        };
        
        vm.printMail = function(thread){
        	cvicMessageService.printMail(thread);
        };
        
        //Documents
        vm.cvicDocumentService = cvicDocumentService;
        $scope.uploadNewDocument = function (event) {
        	vm.cvicDocumentService.addDocument(event, true);
        };

        // Data
        vm.user = [];
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'name';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';
        vm.myEventsSize = 0;

        // methods
        vm.showEditEventFormDialog = showEditEventFormDialog;
        vm.rejectEvent = rejectEvent;
        vm.acceptEvent = joinEvent;
        vm.requestEvent = requestEvent;
        vm.openConfLink = openConfLink;

        vm.copyEvent = copyEvent;
        vm.deleteEvent = deleteEvent;
        
        vm.container = function(){
        	return vm.event;
        };
        
        vm.updateContainer = function(event){
        	vm.event = event;
        };

        vm.refreshContainer = function() {
           return cvicRequestService
                .requestJsonData(__env.apiUrl + ApiEndPoints.EventController.eventGet + vm.uid, 'GET', successResponseData, function (response) { $state.go('app.eventsconferences');})
                .then(function(data) { 
                    vm.setVMContainerAndAUdience( data );
                });
        };
        
        vm.setVMContainerAndAUdience = function(data){
        	 vm.event = data;
             vm.audience = cvicListService.audience(vm.event.userAudience, vm.event.groupAudience);
        };

        init();

        fnOpenAlert();

        
        $scope.avatar = function getUserAvatar( user ) {
            var img = user['coverImage'];

            if( img === null || user['coverImage']['uid'] === null ) {
                return 'assets/images/avatars/profile.jpg';
            }

            return cvicImageService.fnGetResizedImageUrl( 72, 72, user['coverImage']['uid'] );
        }

        vm.localChildren = [];
        
        /**
         * Initialize
         */
        function init()
        {
            //event details, audience
            vm.chipSettings = cvicRequestService
                .requestJsonData(__env.apiUrl + ApiEndPoints.EventController.eventGet + vm.uid, 'GET', successResponseData, function (response) { $state.go('app.eventsconferences');})
                .then(function(data) { 
                    vm.setVMContainerAndAUdience( data );
                    
                    //documents canManage event check
                    vm.repo = vm.cvicDocumentService.repo(__env.apiUrl + ApiEndPoints.EventController.eventDocument, vm);
                    vm.cvicDocumentService.selectRepo(vm.repo[0], true);//initDocuments
                    
                    var userAudience = cvicJWTService.currentUserAudience(vm.event);
                  
                    if( cvicEventService.hasEventExpired(vm.event, now)){
                        vm.expired = true;                      
                    }else{
                        vm.expired = false;
                    }

                    if(vm.event.recording!=null && userAudience){
                        vm.showRecording = true;
                        vm.card = cvicListService.recordingRow(vm.event.recording);
                    }else{
                        vm.showRecording = false;
                    }

                    vm.allowEditEvent = allowEditEvent();
                    vm.allowDeleteEvent = allowDeleteEvent();
                    
                    vm.showExternalLink = false;
                    if (vm.event.externalLink){
                        vm.showExternalLink = true;
                    }

                    vm.monthTransKey = "CALENDAR.MONTHS." + $filter('date')(vm.event.startDate, "MMM");

                    var eventPicture = data.coverImage;                    
                    if( eventPicture != null ) {
                        vm.bgImage = "url(" + __env.apiUrl + ApiEndPoints.ImageController.getImage + eventPicture['uid'] + '.jpg);';

                        document.getElementById("event-background-img").setAttribute("style", "background-image:" +  vm.bgImage);
                    } else if (vm.event.endDate < now) {
                        vm.bgImage = 'url(assets/images/backgrounds/header-bg.png);';

                        document.getElementById("event-background-img").setAttribute("style", "background-image:" +  vm.bgImage);
                    }

                    var settings = {};
                    settings.vm = vm;
                    settings.url = ApiEndPoints.EventController.updateEvent;
                    settings.showDelete = vm.cvicDocumentService.canManageContainer();
 
                    if( vm.event.settings != undefined && vm.event.settings.joinPassword == undefined &&  vm.event.settings.adminPassword == undefined) {
                        cvicRequestService.requestJsonData(__env.apiUrl + ApiEndPoints.EventController.conferencePasswords, 'GET', function(response) {
                            var data = response.data;
                            
                        }, function(response) {
                            vm.joinPassword = undefined;
                            vm.adminPassword = undefined;
                        });
                    }

                    $rootScope.userDataRequest().then( function( userInfo ) {
                    	var userAudience = vm.event.userAudience.map( function(ua){return ua.user.uid} );
                		var data = userInfo.children.filter( function( c ) { return userAudience.includes( c.uid ); } );
                		vm.localChildren = data;
                		return data;
                    });
                    
                    initShowButtons();
                    return settings;

                });

            initMessages();
            initMyEventsSize();
        }
        
        //messages
        function initMessages()
        {
        
            //event messages
            cvicRequestService
            .requestJsonData(__env.apiUrl + ApiEndPoints.EventController.eventMessage + vm.uid, 'GET', successResponseData, failResponseData)
            .then(function(data) { 
                vm.threads = cvicListService.rows(data.elements, cvicListService.messageRow);
                
                // Hide the loading screen
                vm.loadingThreads = false;
                 
                // Open the thread if needed
                if ( $state.params.threadId )
                {
                    for ( var i = 0; i < vm.threads.length; i++ )
                    {
                        if ( vm.threads[i].id === $state.params.threadId )
                        {
                            vm.openThread(vm, vm.threads[i]);
                            break;
                        }
                    }
                }
            });
        }


        function initMyEventsSize() {
            cvicRequestService.requestJsonData(__env.apiUrl + '/my_events', 'GET', successResponseData, failResponseData)
            .then(function(data) {
                if(!angular.equals(data, [])) {
                    vm.myEventsSize = data.total;
                }
            });
        }

        function resetShowButtons() {
            vm.showButtons = {
                showAccept: false,
                showJoin: false,
                showLeave: false,
                showReject: false,
                showRequest: false
            };
        }

        function initShowButtons() { 
            var accessType = vm.event.accessType;

            // check if parent the current user is parent of one of the audience users.
            $rootScope.userDataRequest().then( function( userInfo ) {
            	var isParentView = userInfo.children.filter( function( c ) {
        			return vm.event.userAudience.map( function(ua){return ua.user.uid} ).includes( c.uid ); 
        		} ).length > 0;
        		
        		vm.showAudienceTabs = vm.showAudienceTabs || isParentView;
        		
        		vm.showComposeMessageBtn = !isParentView;
        		
        		return;
            });
            
            if(vm.currentUserId === vm.event.owner.uid) {
                vm.showAudienceTabs = true;
                return;
            }

            var userAudience = cvicJWTService.currentUserAudience(vm.event);
            vm.showAudienceTabs = false;

            if(userAudience && (userAudience.lastAction === 'Invite')) {
                vm.showButtons.showReject = true;
                vm.showButtons.showAccept = true;

                return;
            }

            if(userAudience && userAudience.lastAction === 'Accept') {
                vm.showButtons.showLeave = true;
                vm.showAudienceTabs = true;

                return;
            }

            if(accessType === 'open') {
                vm.showButtons.showJoin = true;

                return;
            }

            if(accessType === 'request') {
                if(!userAudience || (userAudience && (userAudience.lastAction != 'Request'))) {
                    vm.showButtons.showRequest = true;
                }

                return;
            }
        }
        
        function failResponseData(response) {
            return [];
        }

        function successResponseData(response) {
             return response.data;
        }

        function saveChange(changedEvent) { 

            cvicRequestService.requestJsonData( 
                __env.apiUrl + ApiEndPoints.EventController.updateEvent, 
                'POST', 
                function (response) {
                    vm.setVMContainerAndAUdience( response.data );
                    
                    if(vm.event != null && vm.event.coverImage != null && !cvicEventService.hasEventExpired(vm.event, now)) {
                        var strImgUrl = __env.apiUrl + ApiEndPoints.ImageController.getImage + vm.event.coverImage.uid + '.jpg';
                        vm.bgImage = "background-image: url(" + strImgUrl + ");";
                    }
                    else if (!cvicEventService.hasEventExpired(vm.event, now)){
                        vm.bgImage = 'background-image: url(assets/images/dummy/children.jpeg);';   
                    } 
                    if ( cvicEventService.hasEventExpired(vm.event, now)){
                        vm.bgImage = 'background-image: url(assets/images/dummy/expired.png);';  
                    } 
                    
                    $rootScope.cvicSchedule.upcomingEventsRequest();                   

                },
                function (response) {
                    var errorMessage = (response.status == 401) ? "CALENDAR.ERRORS.LIMITS_ERROR": "CALENDAR.ERRORS.SUBMIT_ERROR";

                    cvicFormService.showEventRequestError(errorMessage);
                }, 
                changedEvent
            );
        }

        function deleteEvent() {
            var confirmDialog = $mdDialog.confirm()
                        .title( $translate.instant( 'EVENT.CONFIRM_DIALOG.DELETE.TITLE' ) )
                        .htmlContent( $translate.instant( 'EVENT.CONFIRM_DIALOG.DELETE.TEXT' ) )
                        .ok( $translate.instant('EVENT.CONFIRM_DIALOG.DELETE.OK') )
                        .cancel( $translate.instant('EVENT.CONFIRM_DIALOG.DELETE.CANCEL') );

            $mdDialog.show(confirmDialog).then(function agree() {

                cvicRequestService.requestJsonData( 
                    __env.apiUrl + ApiEndPoints.EventController.deleteEvent, 
                    'POST', 
                    function() {
                        $rootScope.cvicSchedule.upcomingEventsRequest();
                        $state.go('app.eventsconferences');
                    },
                    function() {
                        console.log("Failed");
                    }, 
                    JSON.stringify(vm.event)
                );
            });
        }

        function allowEditEvent() {
            return cvicEventService.allowEditEvent(vm.event,now);
        }

        function allowDeleteEvent() {
            return cvicEventService.allowDeleteEvent(vm.event);
        }
 
        function showEditEventFormDialog() {
            var calendarEvent = cvicListService.calendarEvent(vm.event);

            var settings = {
                type         : 'edit',
                calendarEvent: calendarEvent,
                start        : false,
                end          : false,
                accessTypes  : vm.accessTypes,
                eventTypes   : vm.eventTypes,
                conferenceTypes: vm.conferenceTypes,
                targetEvent  : null,
                handleAddEvent: handleAddCalendarEvent,
                handleEditEvent: handleEditCalendarEvent,
                handleRemoveEvent: handleRemoveCalendarEvent
            };

            cvicFormService.showEventFormDialog(settings);
        }

        function copyEvent() {
            if(cvicEventService.checkEventLimits(vm.myEventsSize)) {

                var eventCopy = angular.copy(vm.event);

                eventCopy.uid = uuid.v4();
                eventCopy.title = $translate.instant('EVENT.CONFIRM_DIALOG.COPY.EVENT_NAME') + eventCopy.title;
                eventCopy.inserted = null;
                eventCopy.updated = null;
                eventCopy.deleted = null;
                
                eventCopy.documents = [];

                var documents = vm.cvicDocumentService.filesTmp;

                for(var i = 0; i < documents.length; ++i) {
                    eventCopy.documents.push(documents[i].entity);
                }

                var confirmDialog = $mdDialog.confirm()
                            .title( $translate.instant( 'EVENT.CONFIRM_DIALOG.COPY.TITLE' ) )
                            .htmlContent( $translate.instant( 'EVENT.CONFIRM_DIALOG.COPY.TEXT' ) )
                            .ok( $translate.instant('EVENT.CONFIRM_DIALOG.COPY.OK') )
                            .cancel( $translate.instant('EVENT.CONFIRM_DIALOG.COPY.CANCEL') );

                $mdDialog.show(confirmDialog).then(function agree() {
                    var calendarEvent = cvicListService.calendarEvent(eventCopy);

                    var settings = {
                        type         : 'edit',
                        calendarEvent: calendarEvent,
                        start        : false,
                        end          : false,
                        accessTypes  : vm.accessTypes,
                        eventTypes   : vm.eventTypes,
                        conferenceTypes: vm.conferenceTypes,
                        targetEvent  : null,
                        handleAddEvent: handleAddCalendarEvent,
                        handleEditEvent: function(response1) {
                            cvicListService.calendarEventToEvent(response1.calendarEvent, eventCopy);

                            cvicRequestService.requestJsonData( 
                                    __env.apiUrl + ApiEndPoints.EventController.updateEvent, 
                                    'POST', 
                                    function(response) {
                                        $state.go('app.eventdetails', {uid: response.data.uid});
                                    },
                                    function(response) {
                                        console.log("Failed");
                                    }, 
                                    JSON.stringify(eventCopy)
                                );
                        },
                        handleRemoveEvent: handleRemoveCalendarEvent
                    };

                    cvicFormService.showEventFormDialog(settings);
                });
            }
        }

        function handleAddCalendarEvent(response) {}

        function handleEditCalendarEvent(response) {
            var changedEvent = angular.copy(vm.event);

            cvicListService.calendarEventToEvent(response.calendarEvent, changedEvent);

            saveChange(changedEvent);
        }

        function handleRemoveCalendarEvent(response) {}

        function handleAudienceUpdateResponse(response) { 
        	vm.refreshContainer().then( function() {
        		resetShowButtons();
                initShowButtons();
                $rootScope.cvicSchedule.upcomingEventsRequest();
    		});
        }

        function joinEvent() {
            var confirmDialog = $mdDialog.confirm()
                        .title( $translate.instant( 'EVENT.CONFIRM_DIALOG.JOIN_EVENT.TITLE' ) )
                        .htmlContent( $translate.instant( 'EVENT.CONFIRM_DIALOG.JOIN_EVENT.TEXT' ) )
                        .ok( $translate.instant('EVENT.CONFIRM_DIALOG.JOIN_EVENT.OK') )
                        .cancel( $translate.instant('EVENT.CONFIRM_DIALOG.JOIN_EVENT.CANCEL') );

            $mdDialog.show(confirmDialog).then(function agree() {

                cvicAudienceService.updateUserAudience(vm.event, vm.audienceUpdateUrl, 'Accept').then(function(response) {
                    if(response.status === 200) {
                        handleAudienceUpdateResponse(response);
                    } else {
                        // TODO
                    }
                });
            });
        }

        function rejectEvent() {
            var confirmDialog = $mdDialog.confirm()
                        .title( $translate.instant( 'EVENT.CONFIRM_DIALOG.REJECT_EVENT.TITLE' ) )
                        .htmlContent( $translate.instant( 'EVENT.CONFIRM_DIALOG.REJECT_EVENT.TEXT' ) )
                        .ok( $translate.instant('EVENT.CONFIRM_DIALOG.REJECT_EVENT.OK') )
                        .cancel( $translate.instant('EVENT.CONFIRM_DIALOG.REJECT_EVENT.CANCEL') );

            $mdDialog.show(confirmDialog).then(function agree() {
                cvicAudienceService.updateUserAudience(vm.event, vm.audienceUpdateUrl, 'Reject').then(function(response) {
                    if(response.status === 200) {openSpace

                        vm.showExternalLink = false;

                        handleAudienceUpdateResponse(response);
                    } else {
                        // TODO
                    }
                });
            });
        }

        function requestEvent() {
            var confirmDialog = $mdDialog.confirm()
                        .title( $translate.instant( 'EVENT.CONFIRM_DIALOG.REQUEST_EVENT.TITLE' ) )
                        .htmlContent( $translate.instant( 'EVENT.CONFIRM_DIALOG.REQUEST_EVENT.TEXT' ) )
                        .ok( $translate.instant('EVENT.CONFIRM_DIALOG.REQUEST_EVENT.OK') )
                        .cancel( $translate.instant('EVENT.CONFIRM_DIALOG.REQUEST_EVENT.CANCEL') );

            $mdDialog.show(confirmDialog).then(function agree() {

                cvicAudienceService.updateUserAudience(vm.event, vm.audienceUpdateUrl, 'Request').then(function(response) {
                    if(response.status === 200) {
                        handleAudienceUpdateResponse(response);
                    } else {
                        // TODO
                    }
                });
            });
        }


        function handleAudienceUpdateResponseByMessage(response, thread) {
            for(var i = 0; i < vm.threads.length; ++i) {
                if(thread.uid == vm.threads[i].uid) {
                    vm.threads[i]["Accept"] = false;
                    vm.threads[i]["Reject"] = false;
                }
            }

            if(vm.currentThread()) {
                vm.currentThread()["Accept"] = false;
                vm.currentThread()["Reject"] = false;
            }
        }

        function acceptEntityAudience(entity, userId, event, messageUid, thread) {
            if ( event ) {
                event.stopPropagation();
            }

            cvicAudienceService.updateUserAudience(entity, vm.audienceUpdateUrl + "/" + messageUid + "/" + userId, 'Accept').then(function(response) {
                if(response.status === 200) {
                    handleAudienceUpdateResponseByMessage(response, thread);
                } else {
                    // TODO
                }
            });
        }

        function rejectEntityAudience(entity, userId, event, messageUid, thread) {
            if ( event ) {
                event.stopPropagation();
            }

            cvicAudienceService.updateUserAudience(entity, vm.audienceUpdateUrl + "/" + messageUid + "/" + userId, 'Reject').then(function(response) {
                if(response.status === 200) {

                    handleAudienceUpdateResponseByMessage(response, thread);
                } else {
                    // TODO
                }
            });
        }

        function openConfLink(){
            $window.open(vm.event.externalLink);
        }

        function fnOpenAlert() {
            var strMessageId = $location.search().msg;

            if ( typeof strMessageId !== 'undefined' ) {

               var objAlert = $mdDialog.alert()
                .title( $translate.instant( 'EVENT.ALERT.TITLE' ) )
                .htmlContent( $translate.instant( 'EVENT.ALERT.' + strMessageId.toUpperCase() ) )
                .ok( $translate.instant( 'EVENT.ALERT.OK' ) );

                $mdDialog.show(objAlert); 
            }
        }

        function openSpace( evt ) {
            $state.go('app.spacedetails', {uid: evt.container.uid });        	
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard',
            [
                // 3rd Party Dependencies
                //'nv.d3',
                //'datatables'
                'ui.calendar'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.dashboard', {
            url      : '/dashboard',
            resolve : {
                accesstypes: function (msApi)
                {
                    return msApi.resolve('accesstypes@get');
                },
                eventtypes: function (msApi)
                {
                    return msApi.resolve('eventtypes@get');
                },
                conferencetypes: function (msApi) {
                    return msApi.resolve('conferencetypes@get');
                }
            },
            views    : {
                'content@app': {
                    templateUrl: 'app/main/dashboard/dashboard.html',
                    controller : 'DashboardController as vm'
                }
            },
            bodyClass: 'dashboard-server'
        });

        //msApi
        msApiProvider.register('accesstypes', ['app/data/accesstypes/space_event.json']); 
        msApiProvider.register('eventtypes', ['app/data/event/types.json']);
        msApiProvider.register('conferencetypes', ['app/data/conference/types.json']);

        msNavigationServiceProvider.saveItem('dashboard', {
            title: 'Dashboard',
            state: 'app.dashboard',
            weight: 1,
            icon: 'icon-tile-four'
        });

        $translatePartialLoaderProvider.addPart('app/main/dashboard');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController(
        $scope,
        $rootScope, 
        $interval, 
        $filter, 
        $mdDialog, 
        $document,
        $window,
        $state,
        $translate,
        accesstypes, 
        eventtypes, 
        conferencetypes, 
        cvicRequestService, 
        cvicDateService,
        cvicFormService, 
        cvicEventService,
        cvicListService,
        cvicJWTService,
        cvicProfileService,
        ApiEndPoints, 
        uuid,
        __env
        )
    {
        var vm = this;

        vm.cvicProfileService = cvicProfileService;
        
        $scope.fnExecuteSearch = fnExecuteSearch;
        $scope.viewStatistics = viewStatistics;
        $scope.gotoGrades = gotoGrades;  
        $scope.gotoSpaces = gotoSpaces;
        $scope.gotoEvents = gotoEvents;
        
        vm.accessTypes = accesstypes.data;
        vm.myEventsSize = 0;
        vm.eventTypes = cvicEventService.filterVisibleTypes(eventtypes.data);
        vm.conferenceTypes = conferencetypes.data;
        vm.currentUserId = cvicJWTService.currentUserId();
        vm.eventTemplate = initEventTemplate();

        // Data
        vm.gradesWidget = {};
        vm.spacesWidget = {};
        vm.eventsWidget = {};
        vm.recordsWidget  = {};
        vm.messagesWidget = {};
        vm.events = [[]]; 

        // Methods
        vm.openConfLink = openConfLink;
        vm.showExternalLink = showExternalLink;
        vm.addEvent = addEvent;
        vm.next = next;
        vm.prev = prev;

        vm.isParent = cvicJWTService.hasFeature( 'AddChild' );
        vm.hasGrades = false;

        vm.hasChild = false;

        vm.calendarUiConfig = {
            calendar: {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                eventClick        : eventDetail,
                selectable        : true,
                selectHelper      : true,
                select            : select
            }
        };

        setCalendarDayNames();

        init();

        $rootScope.$on('$translateChangeSuccess', function(event, current, previous) {
            setCalendarDayNames();
        });

        function init() {
            var url = __env.apiUrl + ApiEndPoints.DashboardController.widgets;

            cvicRequestService.requestJsonData( url, 'GET', successResponseData, failResponseData).then(function(data) {
                for(var i = 0; i < data.length; ++i) {
                    var widget = data[i];

                    switch(widget.widget) {
                    	case 'grades' :
                    		vm.gradesWidget = widget.counts;
                    		vm.hasGrades = widget.counts.all > 0; 
                    		break;
                        case 'spaces':
                            vm.spacesWidget = widget.counts;
                            break;
                        case 'events':
                            vm.eventsWidget = widget.counts;
                            break;
                        case 'records':
                            vm.recordsWidget = widget.counts;
                            break
                        case 'messages':
                            vm.messagesWidget = widget.counts;
                            break;
                        default:
                            continue;
                    }

                }
            });
            
            $rootScope.userDataRequest().then( function( userInfo ) {
            	vm.hasChild = userInfo.children.length > 0;        		
        		return;
            });

            
            initCalendar(); 
        }

        function initEventTemplate() {
            var url = __env.apiUrl + ApiEndPoints.EventController.eventTemplate;

            cvicRequestService.requestJsonData( url, 'GET', successResponseData, failResponseJson).then(function(data) {
                vm.eventTemplate = data;
            });
        }

        function initCalendar() {
            cvicRequestService.requestJsonData( __env.apiUrl + ApiEndPoints.EventController.getCalendarEvents, 'GET', successResultSetData, failResponseJson).then(function(data) {
                if(!angular.equals(data, {})) {

                    $rootScope.userDataRequest().then( function( userInfo ){
                        return userInfo.children.map( function(c){return c.uid} ); 
                    } ).then( function( children ) {

                        for(i = 0; i < data.length; ++i) {
                            var event = data[i];
                            var calendarEvent = cvicListService.calendarEvent(event);

                            if ( event.userAudience.map( function(ua){return ua.user.uid} ).filter( function(uid){ return children.indexOf( uid ) >= 0} ).length > 0 ) {
                                calendarEvent.className = 'calchild';
                            } else if ( event.container == null ) {
                                calendarEvent.className = 'attending';  
                            }
                            
                            vm.events[0].push(calendarEvent);
                        }
                    } );

                    vm.myEventsSize = vm.events[0].filter( function( ev ) { return (ev.baseObj.owner.uid == cvicJWTService.currentUserId()); } ).length;
                }
            });
        }

        function setCalendarDayNames() {
            vm.calendarUiConfig.calendar.dayNames = [
                $translate.instant("CALENDAR.DAY_NAMES.FULL.SUNDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.FULL.MONDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.FULL.TUESDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.FULL.WEDNESDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.FULL.THURSDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.FULL.FRIDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.FULL.SATURDAY")
            ];
                
            vm.calendarUiConfig.calendar.dayNamesShort = [
                $translate.instant("CALENDAR.DAY_NAMES.SHORT.SUNDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.SHORT.MONDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.SHORT.TUESDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.SHORT.WEDNESDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.SHORT.THURSDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.SHORT.FRIDAY"),
                $translate.instant("CALENDAR.DAY_NAMES.SHORT.SATURDAY")
            ];
        }

        function openConfLink(event){
            $window.open(event.externalLink);
        }

        function showExternalLink(event) {
            if(event.externalLink) {
                return true;
            }

            return false;
        }

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Show event detail
         *
         * @param calendarEvent
         * @param e
         */
        function eventDetail(calendarEvent, e) {
            cvicFormService.showEventDetailDialog(calendarEvent, showEventFormDialog, e);
        }

        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        function select(start, end, e)
        {
            if(cvicEventService.checkEventLimits(vm.myEventsSize)) {
                showEventFormDialog('add', false, start, end, e);
            }
        }

        /**
         * Add event
         *
         * @param e
         */
        function addEvent(e)
        {
            if(cvicEventService.checkEventLimits(vm.myEventsSize)) {
                var start = moment(new Date());

                showEventFormDialog('add', false, start, undefined, e);
            }
        }

        /**
         * Show event add/edit form dialog
         *
         * @param type
         * @param calendarEvent
         * @param start
         * @param end
         * @param e
         */
        function showEventFormDialog(type, calendarEvent, start, end, e) {
            var settings = {
                type         : type,
                calendarEvent: calendarEvent,
                start        : start,
                end          : end,
                accessTypes  : vm.accessTypes,
                eventTypes   : vm.eventTypes,
                conferenceTypes: vm.conferenceTypes,
                targetEvent  : e,
                handleAddEvent: handleAddCalendarEvent,
                handleEditEvent: handleEditCalendarEvent,
                handleRemoveEvent: handleRemoveCalendarEvent
            };

            cvicFormService.showEventFormDialog(settings);
        }

        function handleAddCalendarEvent(response) {
            var event = angular.copy(vm.eventTemplate);

            event.uid = uuid.v4();
            event.owner.uid = vm.currentUserId;
            event.userAudience[0].user.uid = event.owner.uid;

            var newCalendarEvent = response.calendarEvent;
            cvicListService.calendarEventToEvent(newCalendarEvent, event);

            cvicRequestService.requestJsonData(
                __env.apiUrl + ApiEndPoints.EventController.newEvent,
                'POST',
                function(response) {
                    newCalendarEvent.baseObj = response.data;
                    newCalendarEvent.className = 'attending';
                    vm.events[0].push(newCalendarEvent);
                    $rootScope.cvicSchedule.upcomingEventsRequest();

                },
                function(response){
                    var errorMessage = (response.status == 401) ? "CALENDAR.ERRORS.LIMITS_ERROR": "CALENDAR.ERRORS.SUBMIT_ERROR";
                    
                    cvicFormService.showEventRequestError(errorMessage);
                },
                event
            );
        }

        function handleEditCalendarEvent(response) {
            for ( var i = 0; i < vm.events[0].length; i++ ) {
                // Update
                if ( vm.events[0][i].id === response.calendarEvent.id ) {

                    cvicListService.calendarEventToEvent(response.calendarEvent, vm.events[0][i].baseObj);

                    cvicRequestService.requestJsonData( 
                        __env.apiUrl + ApiEndPoints.EventController.updateEvent, 
                        'POST', 
                        function (response) {
                            var calendarEvent = cvicListService.calendarEvent(response.data);
                            vm.events[0][i] = calendarEvent;
                            $rootScope.cvicSchedule.upcomingEventsRequest();
                        }, 
                        function (response) {
                            var errorMessage = (response.status == 401) ? "CALENDAR.ERRORS.LIMITS_ERROR": "CALENDAR.ERRORS.EDIT_ERROR";

                            cvicFormService.showEventRequestError(errorMessage);
                        }, 
                        JSON.stringify(vm.events[0][i].baseObj));

                    return;
                }
            }
        }

        function handleRemoveCalendarEvent() {}

        function successResponseData(response) {
            return response.data;
        }

        function successResultSetData(response) {
            return response.data.elements;
        }

        function failResponseData(response) {
            return [];
        }

        function failResponseJson(response) {
            return {};
        }

        function viewStatistics(state, type) {
            $state.go(state, {type:type});
        }

        function gotoGrades() {
        	$state.go( 'app.profile', {openGrades: 1} );
        }
        
        function fnExecuteSearch() {
            var strTerm = vm.strSearch;

            if ( strTerm != null && strTerm.length >= 3 ) {

            	$rootScope.cvicSearchService.fnExecuteSearch( strTerm, $rootScope.cvicSearchService.enumSearchType.Mixed ).then(function success(objResultSet) {
                    $state.go('app.pages_search');
                });

            }
        }
        
        function gotoSpaces() {
        	$rootScope.cvicSearchService.fnExecuteSearch( "", $rootScope.cvicSearchService.enumSearchType.Spaces )
	            .then( function success(objResultSet) {
	                $state.go('app.pages_search');
	            });
        }
        
        function gotoEvents() {
        	$rootScope.cvicSearchService.fnExecuteSearch( "", $rootScope.cvicSearchService.enumSearchType.Events )
	            .then( function success(objResultSet) {
	                $state.go('app.pages_search');
	            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts',
            [
                // 3rd Party Dependencies
                'xeditable',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.contacts', {
            url    : '/contacts',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/contacts/contacts.html',
                    controller : 'ContactsController as vm'
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/contacts');

        // Navigation
        msNavigationServiceProvider.saveItem('contacts', {
            title : 'Contacts',
            icon  : 'icon-account-box',
            state : 'app.contacts',
            weight: 1
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts')
        .controller('ContactsController', ContactsController);

    /** @ngInject */
    function ContactsController(
    		$scope, 
    		$rootScope, 
    		$state, 
    		$filter, 
    		$mdSidenav, 
    		$translate,	
    		$timeout, 
    		cvicJWTService, 
    		cvicRequestService, 
    		cvicListService, 
    		cvicAudienceService, 
    		cvicMessageService,
    		cvicProfileService,
    		$mdDialog, 
    		$document,
    		ApiEndPoints,
    		uuid,
    		$q,
    		__env)
    {

        var vm = this;

        // Data
        vm.contacts = [];
        vm.user = {};
        
        vm.groups = [];
        vm.groupsVirtual = [];
        vm.groupsSystem = [];

        vm.groupsUsers = {};
        vm.objGroupsUsersMap = {};
        vm.loading = true;
        
        $scope.showGroupTitleEdit = false;
        $scope.fnExecuteSearch = fnExecuteSearch;
 
        vm.frequentContacts = [];
        vm.classmates = [];
 
        vm.listType = 'frequent';
        vm.listOrder = 'name';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';
        vm.groupTitle = '';

        // Methods
        vm.filterChange = filterChange;
        vm.toggleSelectContact = toggleSelectContact;
        vm.deselectContacts = deselectContacts;
        vm.selectAllContacts = selectAllContacts;
        vm.addNewGroup = addNewGroup;
        vm.deleteGroup = deleteGroup;
        vm.toggleSidenav = toggleSidenav;
        vm.sendMessageToContact = sendMessageToContact;
        vm.sendMessageToContacts = sendMessageToContacts;
        vm.showRemoveUsersFromGroupIcon = showRemoveUsersFromGroupIcon;
        vm.addRemoveUserToGroup = addRemoveUserToGroup;
        vm.addRemoveUsersFromGroup = addRemoveUsersFromGroup;
        vm.exists = exists;
        vm.editGroup = editGroup;
        vm.showGroupEditTitleForm = function() {
            vm.groupTitle = vm.listType.title;

            $scope.showGroupTitleEdit = true;
        };
        vm.hideGroupEditTitleForm = function() {
            $scope.showGroupTitleEdit = false;
        };
        
        
        vm.cvicProfileService = cvicProfileService;
              
        //contacts data table options
        vm.dtOptions = {
                dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth : false,
                iDisplayLength:  10,
                responsive: true,
                paging: true,
                language: {
                    "emptyTable":     $translate.instant("CONTACTS.DATA_TABLE.EMPTY_TABLE"),
                    "info":           $translate.instant("CONTACTS.DATA_TABLE.INFO"),
                    "infoEmpty":      $translate.instant("CONTACTS.DATA_TABLE.INFO_EMPTY"),
                    "infoFiltered":   $translate.instant("CONTACTS.DATA_TABLE.INFO_FILTERED"),
                    "infoPostFix":    "",
                    "lengthMenu":     $translate.instant("CONTACTS.DATA_TABLE.LENGTH_MENU"),
                    "processing":     $translate.instant("CONTACTS.DATA_TABLE.PROCESSING"),
                    "search":         $translate.instant("CONTACTS.DATA_TABLE.SEARCH"),
                    "zeroRecords":    $translate.instant("CONTACTS.DATA_TABLE.ZERO_RECORDS"),
                    "paginate": {
                        "first":      $translate.instant("CONTACTS.DATA_TABLE.PAGINATE.FIRST"),
                        "last":       $translate.instant("CONTACTS.DATA_TABLE.PAGINATE.LAST"),
                        "next":       $translate.instant("CONTACTS.DATA_TABLE.PAGINATE.NEXT"),
                        "previous":   $translate.instant("CONTACTS.DATA_TABLE.PAGINATE.PREVIOUS")
                    },
                    "aria": {
                        "sortAscending":  "",
                        "sortDescending": ""
                    }
                }
            };

        init();

        function init() {
        	$q.all( [ 
        	         vm.cvicProfileService.loadGroups(vm, null),
        	         loadFrequentContacts(),
        	         getUserInformation(),               
        	         vm.cvicProfileService.loadGroupTempl(vm.cvicProfileService, null)
        	 ]).then(function success() {    	             	 
        		 setContacts(vm.listType);
        		 
        		 initPaging();
        		 
	        	 vm.loading = false; 
	        	 
    	         loadParticipantGroups(ApiEndPoints.UserController.participantTo);
    	         loadParticipantGroups(ApiEndPoints.UserController.participantWithMe);
    	         loadParticipantGroups(ApiEndPoints.UserController.participantInMy);
        	 });
        }
        
        function initPaging(){ 
        	if (vm.contacts.length > vm.dtOptions.iDisplayLength) { 
            	angular.element(document.querySelector('#contactsTable_length')).show();
            	angular.element(document.querySelector('#contactsTable_paginate')).show();
        	}
        	else {
            	angular.element(document.querySelector('#contactsTable_length')).hide();
            	angular.element(document.querySelector('#contactsTable_paginate')).hide();
        	}
        }
         
       function setContacts(type){
        	vm.listType = type;
        	if ( angular.isObject(type) ) { 
	            	vm.contacts = vm.groupsUsers[type.uid];
            } 
        	else { 
            	vm.contacts = vm.frequentContacts; 
            }
        }

        function failResponseData(response) {
            return [];
        }

        function failResponseDataAsJson(response) {
            return {};
        }

        function successResponseData(response) {
             return response.data;
        }
        
        function successResultSetData(response) {
            return response.data.elements;
        }

        function loadAllContacts() {
        	return $q(function(resolve, reject) {
	            cvicRequestService
	            .requestJsonData(__env.apiUrl + '/common/user/contacts/all', 'GET', successResultSetData, failResponseData)
	            .then(function(data) {
	                for(var i = 0; i < data.length; ++i) {
	                    vm.allContacts.push(cvicListService.contactRow(data[i]));
	                }                     
	                resolve();
	            });
        	});
        }

        function loadFrequentContacts() {
        	return $q(function(resolve, reject) {
	            cvicRequestService
	            .requestJsonData(__env.apiUrl + ApiEndPoints.UserController.getMostFrequentContacts + cvicJWTService.currentUserId(), 'GET', successResultSetData, failResponseData)
	            .then(function(data) {
	                for(var i = 0; i < data.length; ++i) {
	                    vm.frequentContacts.push(cvicListService.contactRow(data[i]));
	                } 
	                
	                resolve();
	            });
        	});
        }
        
        function loadParticipantGroups(url) {
        	return $q(function(resolve, reject) {
	            cvicRequestService
	            .requestJsonData(__env.apiUrl + url, 'GET', successResponseData, failResponseData)
	            .then( function(data) { 
	            	if (data.elements && data.elements.length > 0 ) {
		            	
		            	var group = {};
		            	group.uid = uuid.v4();
		            	group.isSystem = true;
		            	group.viewGroupLabel = true;
		            	switch(url) {
			                case ApiEndPoints.UserController.participantTo:
			                	group.seq = 2;
			                	group.title = 'CONTACTS.PARTICIPANT_TO';
			                    break;
			                case ApiEndPoints.UserController.participantWithMe:
			                	group.seq = 3;
			                	group.title = 'CONTACTS.PARTICIPANT_WITH_ME';
			                    break;
			                case ApiEndPoints.UserController.participantInMy:
			                	group.seq = 4;
			                	group.title = 'CONTACTS.PARTICIPANT_IN_MY';
				                    break;
			            }
		            	group.users = data.elements;
		            	
		            	//alert( url + " --> " + JSON.stringify(group));
		            	
	                	vm.cvicProfileService.formatGroupData(vm,group);
	            	}
	            	resolve();
	            });
        	});
        } 
        
        function getUserInformation() 
        {
        	return $q(function(resolve, reject) {
        		
        		$rootScope.userDataRequest()
				.then( function( user ) {
					vm.user = user;
					
	                vm.userAvatar = null;
	                if(user.coverImage) {
	                    vm.userAvatar = __env.apiUrl + '/common/i/' + user.coverImage.uid + '.jpg';
	                } else {
	                    vm.userAvatar = 'assets/images/avatars/profile.jpg';
	                }
	
	                resolve();
								
				});        		
        	});
        }

        function exists(contact) {
            for(var i = 0; i < vm.selectedContacts.length; ++i) {
                if(contact.id === vm.selectedContacts[i].id) {
                    return true;
                }
            }

            return false;
        }

        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {
        	$q(function(resolve, reject) {
            	vm.loading = true; 
            	
            	vm.listType = type; 
 	            
 	            vm.selectedContacts = [];
 	            
 	            vm.hideGroupEditTitleForm();
 	                        		                        	
	            $timeout(function() { 
	            	setContacts(vm.listType);	 	            
	            	resolve(); 
	            }, 5);
	           
        	}).then(function(){	      		
        		initPaging(); 			
        		vm.loading = false;  
        	});

        }

        /**
         * Toggle selected status of the contact
         *
         * @param contact
         * @param event
         */
        function toggleSelectContact(contact, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            if ( vm.selectedContacts.indexOf(contact) > -1 )
            {
                vm.selectedContacts.splice(vm.selectedContacts.indexOf(contact), 1);
            }
            else
            {
                vm.selectedContacts.push(contact);
            }
        }

        /**
         * Deselect contacts
         */
        function deselectContacts()
        {
            vm.selectedContacts = [];
        }

        /**
         * Sselect all contacts
         */
        function selectAllContacts()
        {
            vm.selectedContacts = vm.contacts;
        }

        function sendMessageToContact(ev, contact) {
            var contacts = [];
            contacts.push(contact);
            sendMessageToContacts(ev, contacts);
        }

        function sendMessageToContacts(ev, contacts){ 
            var sdTo = [];

            for(var i = 0; i < contacts.length; ++i) {
                var userContact = {
                    uid: contacts[i].id,    
                    name: contacts[i].name,
                    email: contacts[i].email,
                    image: contacts[i].avatar
                };

                sdTo.push(userContact);
            }

            cvicMessageService.composeDialog(ev, vm, { sdTo:  sdTo });
        };

        function addRemoveUserToGroup(group, contact) {
            vm.cvicProfileService.addRemoveUserToGroup(vm,group, contact);
        }

        function showRemoveUsersFromGroupIcon(group, contacts) {
            var showRemoveFunction = true;

            for(var i = 0; i < contacts.length; ++i) {

                if(!vm.objGroupsUsersMap[group.uid][contacts[i].entity.uid]) {
                    showRemoveFunction = false;

                    break;
                }
            }

            return showRemoveFunction;
        }

        function addRemoveUsersFromGroup(group, contacts) {
            var useAddFunction = !showRemoveUsersFromGroupIcon(group, contacts);

            if(useAddFunction) {
                addUsersToGroup(group, contacts);
            } else {
                removeUsersFromGroup(group, contacts);
            }
        }

        function removeUsersFromGroup(group, contacts) {
            for(var i = 0; i < vm.groups.length; ++i) {
                var newGroup = vm.groups[i];

                if(newGroup.uid === group.uid) {
                    var removedUsers = [];

                    for(var k = 0; k < contacts.length; ++k) {
                        var userAlreadyRemoved = true;

                        for(var j = 0;  j < newGroup.users.length; ++j) {
                            if(newGroup.users[j].uid === contacts[k].id) {
                                userAlreadyRemoved = false;
                                break;
                            }
                        }

                        if(!userAlreadyRemoved) {
                            newGroup.users.splice(j, 1);
                            removedUsers.push(contacts[k].id);
                            vm.objGroupsUsersMap[group.uid][contacts[k].entity.uid] = false;
                        }
                    }
                    
                    cvicRequestService
                    .requestJsonData(__env.apiUrl + ApiEndPoints.GroupController.detachUsers, 'POST', successResponseData, failResponseDataAsJson, newGroup)
                    .then(function(data) {
                        if(!angular.equals(data, {})) {
                            vm.groups[i] = data; 

                            var groupUsers = vm.groupsUsers[group.uid].filter(function( el ) {
                                return removedUsers.indexOf( el.id ) < 0;
                            });

                            vm.groupsUsers[group.uid] = groupUsers;

                            if(vm.listType.title === group.title) {
                                filterChange(group);
                            }
                        } else {
                            // TODO
                        }
                    }); 

                    break;
                }
            }
        }

        function addUsersToGroup(group, contacts) {
            for(var i = 0; i < vm.groups.length; ++i) {
                var newGroup = vm.groups[i];

                if(newGroup.uid === group.uid) {
                    var addedUsers = [];

                    for(var k = 0; k < contacts.length; ++k) {
                        var userAlreadyAdded = false;

                        for(var j = 0;  j < newGroup.users.length; ++j) {
                            if(newGroup.users[j].uid === contacts[k].id) {
                                userAlreadyAdded = true;
                                break;
                            }
                        }

                        if(!userAlreadyAdded) {
                            newGroup.users.push(contacts[k].entity);
                            addedUsers.push(contacts[k]);
                            vm.objGroupsUsersMap[group.uid][contacts[k].entity.uid] = true;
                        }
                    }
                    
                    cvicRequestService
                    .requestJsonData(__env.apiUrl + ApiEndPoints.GroupController.save, 'POST', successResponseData, failResponseDataAsJson, newGroup)
                    .then(function(data) {
                        if(!angular.equals(data, {})) {
                            vm.groups[i] = data;

                            var groupUsers = vm.groupsUsers[group.uid];
                            groupUsers.push.apply(groupUsers, addedUsers);

                            vm.groupsUsers[group.uid] = groupUsers;
                        } else {
                            // TODO
                        }
                    }); 

                    break;
                }
            }
        }

        /**
         *
         */
        function addNewGroup() {
        	if ( vm.newGroupName === undefined || vm.newGroupName == null || vm.newGroupName.trim().length == 0 ) {
                return;
            } 
            
            vm.cvicProfileService.addNewGroup(vm.newGroupName)
            	.then(function(data) {
	                if(!angular.equals(data, {})) {;	
		                vm.groups.push(data);
		
		                vm.groupsUsers[data.uid] = [];
		                vm.objGroupsUsersMap[data.uid] = {};
	
		            } else {
		                // TODO
		            }
            	});
            

            vm.newGroupName = '';
        }

        /**
         * Delete Group
         */
        function deleteGroup(ev)
        {
            var group = vm.listType;

            var confirm = $mdDialog.confirm()
                .title($filter('translate')('CONTACTS.CONFIRM_GROUP_DELETE_DIALOG_TITLE'))
                .htmlContent('<b>' + group.title + '</b>' + $filter('translate')('CONTACTS.CONFIRM_GROUP_DELETE_DIALOG_TEXT'))
                .ariaLabel('delete group')
                .targetEvent(ev)
                .ok($filter('translate')('CONTACTS.CONFIRM_GROUP_DELETE_DIALOG_OK'))
                .cancel($filter('translate')('CONTACTS.CONFIRM_GROUP_DELETE_DIALOG_CANCEL'));

            $mdDialog.show(confirm).then(function ()
            {
                cvicRequestService
                .requestJsonData(__env.apiUrl + ApiEndPoints.GroupController.deleteGroup, 'POST', function(response) {
                    vm.groups.splice(vm.groups.indexOf(group), 1);

                    filterChange('frequent');
                }, function(response) {
                
                }, group)
                .then(function() {
                    
                });
            });

        }

        function editGroup() {
            vm.hideGroupEditTitleForm();

            if(vm.groupTitle && vm.groupTitle.length > 0) {
                var editedGroup = angular.copy(vm.listType);
                editedGroup.title  = vm.groupTitle;

                cvicRequestService
                .requestJsonData(__env.apiUrl + ApiEndPoints.GroupController.save, 'POST', successResponseData, failResponseDataAsJson, editedGroup)
                .then(function(group) {
                    if(!angular.equals(group, {})) {;

                        for(var i = 0; i < vm.groups.length; ++i) {
                            if(group.uid === vm.groups[i].uid) {
                                vm.groups[i] = group;
                                vm.listType = group;
                            }
                        }
                    } else {
                        // TODO
                    }
                });
            }
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        } 

        function fnExecuteSearch() {
            var strTerm = vm.search;

            if ( strTerm != null && strTerm.length >= 1 ) {
                $rootScope.cvicSearchService.fnExecuteSearch(strTerm, $rootScope.cvicSearchService.enumSearchType.Users).then(function success(objResultSet) {

                    $state.go('app.pages_search');

                });
            }   
        }

    }

})();
/**
 * @license AngularJS v1.5.11
 * (c) 2010-2017 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* global shallowCopy: true */

/**
 * Creates a shallow copy of an object, an array or a primitive.
 *
 * Assumes that there are no proto properties for objects.
 */
function shallowCopy(src, dst) {
  if (isArray(src)) {
    dst = dst || [];

    for (var i = 0, ii = src.length; i < ii; i++) {
      dst[i] = src[i];
    }
  } else if (isObject(src)) {
    dst = dst || {};

    for (var key in src) {
      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
        dst[key] = src[key];
      }
    }
  }

  return dst || src;
}

/* global shallowCopy: false */

// There are necessary for `shallowCopy()` (included via `src/shallowCopy.js`).
// They are initialized inside the `$RouteProvider`, to ensure `window.angular` is available.
var isArray;
var isObject;

/**
 * @ngdoc module
 * @name ngRoute
 * @description
 *
 * # ngRoute
 *
 * The `ngRoute` module provides routing and deeplinking services and directives for angular apps.
 *
 * ## Example
 * See {@link ngRoute.$route#example $route} for an example of configuring and using `ngRoute`.
 *
 *
 * <div doc-module-components="ngRoute"></div>
 */
 /* global -ngRouteModule */
var ngRouteModule = angular.module('ngRoute', ['ng']).
                        provider('$route', $RouteProvider),
    $routeMinErr = angular.$$minErr('ngRoute');

/**
 * @ngdoc provider
 * @name $routeProvider
 * @this
 *
 * @description
 *
 * Used for configuring routes.
 *
 * ## Example
 * See {@link ngRoute.$route#example $route} for an example of configuring and using `ngRoute`.
 *
 * ## Dependencies
 * Requires the {@link ngRoute `ngRoute`} module to be installed.
 */
function $RouteProvider() {
  isArray = angular.isArray;
  isObject = angular.isObject;

  function inherit(parent, extra) {
    return angular.extend(Object.create(parent), extra);
  }

  var routes = {};

  /**
   * @ngdoc method
   * @name $routeProvider#when
   *
   * @param {string} path Route path (matched against `$location.path`). If `$location.path`
   *    contains redundant trailing slash or is missing one, the route will still match and the
   *    `$location.path` will be updated to add or drop the trailing slash to exactly match the
   *    route definition.
   *
   *    * `path` can contain named groups starting with a colon: e.g. `:name`. All characters up
   *        to the next slash are matched and stored in `$routeParams` under the given `name`
   *        when the route matches.
   *    * `path` can contain named groups starting with a colon and ending with a star:
   *        e.g.`:name*`. All characters are eagerly stored in `$routeParams` under the given `name`
   *        when the route matches.
   *    * `path` can contain optional named groups with a question mark: e.g.`:name?`.
   *
   *    For example, routes like `/color/:color/largecode/:largecode*\/edit` will match
   *    `/color/brown/largecode/code/with/slashes/edit` and extract:
   *
   *    * `color: brown`
   *    * `largecode: code/with/slashes`.
   *
   *
   * @param {Object} route Mapping information to be assigned to `$route.current` on route
   *    match.
   *
   *    Object properties:
   *
   *    - `controller` – `{(string|function()=}` – Controller fn that should be associated with
   *      newly created scope or the name of a {@link angular.Module#controller registered
   *      controller} if passed as a string.
   *    - `controllerAs` – `{string=}` – An identifier name for a reference to the controller.
   *      If present, the controller will be published to scope under the `controllerAs` name.
   *    - `template` – `{string=|function()=}` – html template as a string or a function that
   *      returns an html template as a string which should be used by {@link
   *      ngRoute.directive:ngView ngView} or {@link ng.directive:ngInclude ngInclude} directives.
   *      This property takes precedence over `templateUrl`.
   *
   *      If `template` is a function, it will be called with the following parameters:
   *
   *      - `{Array.<Object>}` - route parameters extracted from the current
   *        `$location.path()` by applying the current route
   *
   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
   *      template that should be used by {@link ngRoute.directive:ngView ngView}.
   *
   *      If `templateUrl` is a function, it will be called with the following parameters:
   *
   *      - `{Array.<Object>}` - route parameters extracted from the current
   *        `$location.path()` by applying the current route
   *
   *    - `resolve` - `{Object.<string, function>=}` - An optional map of dependencies which should
   *      be injected into the controller. If any of these dependencies are promises, the router
   *      will wait for them all to be resolved or one to be rejected before the controller is
   *      instantiated.
   *      If all the promises are resolved successfully, the values of the resolved promises are
   *      injected and {@link ngRoute.$route#$routeChangeSuccess $routeChangeSuccess} event is
   *      fired. If any of the promises are rejected the
   *      {@link ngRoute.$route#$routeChangeError $routeChangeError} event is fired.
   *      For easier access to the resolved dependencies from the template, the `resolve` map will
   *      be available on the scope of the route, under `$resolve` (by default) or a custom name
   *      specified by the `resolveAs` property (see below). This can be particularly useful, when
   *      working with {@link angular.Module#component components} as route templates.<br />
   *      <div class="alert alert-warning">
   *        **Note:** If your scope already contains a property with this name, it will be hidden
   *        or overwritten. Make sure, you specify an appropriate name for this property, that
   *        does not collide with other properties on the scope.
   *      </div>
   *      The map object is:
   *
   *      - `key` – `{string}`: a name of a dependency to be injected into the controller.
   *      - `factory` - `{string|function}`: If `string` then it is an alias for a service.
   *        Otherwise if function, then it is {@link auto.$injector#invoke injected}
   *        and the return value is treated as the dependency. If the result is a promise, it is
   *        resolved before its value is injected into the controller. Be aware that
   *        `ngRoute.$routeParams` will still refer to the previous route within these resolve
   *        functions.  Use `$route.current.params` to access the new route parameters, instead.
   *
   *    - `resolveAs` - `{string=}` - The name under which the `resolve` map will be available on
   *      the scope of the route. If omitted, defaults to `$resolve`.
   *
   *    - `redirectTo` – `{(string|function())=}` – value to update
   *      {@link ng.$location $location} path with and trigger route redirection.
   *
   *      If `redirectTo` is a function, it will be called with the following parameters:
   *
   *      - `{Object.<string>}` - route parameters extracted from the current
   *        `$location.path()` by applying the current route templateUrl.
   *      - `{string}` - current `$location.path()`
   *      - `{Object}` - current `$location.search()`
   *
   *      The custom `redirectTo` function is expected to return a string which will be used
   *      to update `$location.path()` and `$location.search()`.
   *
   *    - `[reloadOnSearch=true]` - `{boolean=}` - reload route when only `$location.search()`
   *      or `$location.hash()` changes.
   *
   *      If the option is set to `false` and url in the browser changes, then
   *      `$routeUpdate` event is broadcasted on the root scope.
   *
   *    - `[caseInsensitiveMatch=false]` - `{boolean=}` - match routes without being case sensitive
   *
   *      If the option is set to `true`, then the particular route can be matched without being
   *      case sensitive
   *
   * @returns {Object} self
   *
   * @description
   * Adds a new route definition to the `$route` service.
   */
  this.when = function(path, route) {
    //copy original route object to preserve params inherited from proto chain
    var routeCopy = shallowCopy(route);
    if (angular.isUndefined(routeCopy.reloadOnSearch)) {
      routeCopy.reloadOnSearch = true;
    }
    if (angular.isUndefined(routeCopy.caseInsensitiveMatch)) {
      routeCopy.caseInsensitiveMatch = this.caseInsensitiveMatch;
    }
    routes[path] = angular.extend(
      routeCopy,
      path && pathRegExp(path, routeCopy)
    );

    // create redirection for trailing slashes
    if (path) {
      var redirectPath = (path[path.length - 1] === '/')
            ? path.substr(0, path.length - 1)
            : path + '/';

      routes[redirectPath] = angular.extend(
        {redirectTo: path},
        pathRegExp(redirectPath, routeCopy)
      );
    }

    return this;
  };

  /**
   * @ngdoc property
   * @name $routeProvider#caseInsensitiveMatch
   * @description
   *
   * A boolean property indicating if routes defined
   * using this provider should be matched using a case insensitive
   * algorithm. Defaults to `false`.
   */
  this.caseInsensitiveMatch = false;

   /**
    * @param path {string} path
    * @param opts {Object} options
    * @return {?Object}
    *
    * @description
    * Normalizes the given path, returning a regular expression
    * and the original path.
    *
    * Inspired by pathRexp in visionmedia/express/lib/utils.js.
    */
  function pathRegExp(path, opts) {
    var insensitive = opts.caseInsensitiveMatch,
        ret = {
          originalPath: path,
          regexp: path
        },
        keys = ret.keys = [];

    path = path
      .replace(/([().])/g, '\\$1')
      .replace(/(\/)?:(\w+)(\*\?|[?*])?/g, function(_, slash, key, option) {
        var optional = (option === '?' || option === '*?') ? '?' : null;
        var star = (option === '*' || option === '*?') ? '*' : null;
        keys.push({ name: key, optional: !!optional });
        slash = slash || '';
        return ''
          + (optional ? '' : slash)
          + '(?:'
          + (optional ? slash : '')
          + (star && '(.+?)' || '([^/]+)')
          + (optional || '')
          + ')'
          + (optional || '');
      })
      .replace(/([/$*])/g, '\\$1');

    ret.regexp = new RegExp('^' + path + '$', insensitive ? 'i' : '');
    return ret;
  }

  /**
   * @ngdoc method
   * @name $routeProvider#otherwise
   *
   * @description
   * Sets route definition that will be used on route change when no other route definition
   * is matched.
   *
   * @param {Object|string} params Mapping information to be assigned to `$route.current`.
   * If called with a string, the value maps to `redirectTo`.
   * @returns {Object} self
   */
  this.otherwise = function(params) {
    if (typeof params === 'string') {
      params = {redirectTo: params};
    }
    this.when(null, params);
    return this;
  };


  this.$get = ['$rootScope',
               '$location',
               '$routeParams',
               '$q',
               '$injector',
               '$templateRequest',
               '$sce',
      function($rootScope, $location, $routeParams, $q, $injector, $templateRequest, $sce) {

    /**
     * @ngdoc service
     * @name $route
     * @requires $location
     * @requires $routeParams
     *
     * @property {Object} current Reference to the current route definition.
     * The route definition contains:
     *
     *   - `controller`: The controller constructor as defined in the route definition.
     *   - `locals`: A map of locals which is used by {@link ng.$controller $controller} service for
     *     controller instantiation. The `locals` contain
     *     the resolved values of the `resolve` map. Additionally the `locals` also contain:
     *
     *     - `$scope` - The current route scope.
     *     - `$template` - The current route template HTML.
     *
     *     The `locals` will be assigned to the route scope's `$resolve` property. You can override
     *     the property name, using `resolveAs` in the route definition. See
     *     {@link ngRoute.$routeProvider $routeProvider} for more info.
     *
     * @property {Object} routes Object with all route configuration Objects as its properties.
     *
     * @description
     * `$route` is used for deep-linking URLs to controllers and views (HTML partials).
     * It watches `$location.url()` and tries to map the path to an existing route definition.
     *
     * Requires the {@link ngRoute `ngRoute`} module to be installed.
     *
     * You can define routes through {@link ngRoute.$routeProvider $routeProvider}'s API.
     *
     * The `$route` service is typically used in conjunction with the
     * {@link ngRoute.directive:ngView `ngView`} directive and the
     * {@link ngRoute.$routeParams `$routeParams`} service.
     *
     * @example
     * This example shows how changing the URL hash causes the `$route` to match a route against the
     * URL, and the `ngView` pulls in the partial.
     *
     * <example name="$route-service" module="ngRouteExample"
     *          deps="angular-route.js" fixBase="true">
     *   <file name="index.html">
     *     <div ng-controller="MainController">
     *       Choose:
     *       <a href="Book/Moby">Moby</a> |
     *       <a href="Book/Moby/ch/1">Moby: Ch1</a> |
     *       <a href="Book/Gatsby">Gatsby</a> |
     *       <a href="Book/Gatsby/ch/4?key=value">Gatsby: Ch4</a> |
     *       <a href="Book/Scarlet">Scarlet Letter</a><br/>
     *
     *       <div ng-view></div>
     *
     *       <hr />
     *
     *       <pre>$location.path() = {{$location.path()}}</pre>
     *       <pre>$route.current.templateUrl = {{$route.current.templateUrl}}</pre>
     *       <pre>$route.current.params = {{$route.current.params}}</pre>
     *       <pre>$route.current.scope.name = {{$route.current.scope.name}}</pre>
     *       <pre>$routeParams = {{$routeParams}}</pre>
     *     </div>
     *   </file>
     *
     *   <file name="book.html">
     *     controller: {{name}}<br />
     *     Book Id: {{params.bookId}}<br />
     *   </file>
     *
     *   <file name="chapter.html">
     *     controller: {{name}}<br />
     *     Book Id: {{params.bookId}}<br />
     *     Chapter Id: {{params.chapterId}}
     *   </file>
     *
     *   <file name="script.js">
     *     angular.module('ngRouteExample', ['ngRoute'])
     *
     *      .controller('MainController', function($scope, $route, $routeParams, $location) {
     *          $scope.$route = $route;
     *          $scope.$location = $location;
     *          $scope.$routeParams = $routeParams;
     *      })
     *
     *      .controller('BookController', function($scope, $routeParams) {
     *          $scope.name = 'BookController';
     *          $scope.params = $routeParams;
     *      })
     *
     *      .controller('ChapterController', function($scope, $routeParams) {
     *          $scope.name = 'ChapterController';
     *          $scope.params = $routeParams;
     *      })
     *
     *     .config(function($routeProvider, $locationProvider) {
     *       $routeProvider
     *        .when('/Book/:bookId', {
     *         templateUrl: 'book.html',
     *         controller: 'BookController',
     *         resolve: {
     *           // I will cause a 1 second delay
     *           delay: function($q, $timeout) {
     *             var delay = $q.defer();
     *             $timeout(delay.resolve, 1000);
     *             return delay.promise;
     *           }
     *         }
     *       })
     *       .when('/Book/:bookId/ch/:chapterId', {
     *         templateUrl: 'chapter.html',
     *         controller: 'ChapterController'
     *       });
     *
     *       // configure html5 to get links working on jsfiddle
     *       $locationProvider.html5Mode(true);
     *     });
     *
     *   </file>
     *
     *   <file name="protractor.js" type="protractor">
     *     it('should load and compile correct template', function() {
     *       element(by.linkText('Moby: Ch1')).click();
     *       var content = element(by.css('[ng-view]')).getText();
     *       expect(content).toMatch(/controller: ChapterController/);
     *       expect(content).toMatch(/Book Id: Moby/);
     *       expect(content).toMatch(/Chapter Id: 1/);
     *
     *       element(by.partialLinkText('Scarlet')).click();
     *
     *       content = element(by.css('[ng-view]')).getText();
     *       expect(content).toMatch(/controller: BookController/);
     *       expect(content).toMatch(/Book Id: Scarlet/);
     *     });
     *   </file>
     * </example>
     */

    /**
     * @ngdoc event
     * @name $route#$routeChangeStart
     * @eventType broadcast on root scope
     * @description
     * Broadcasted before a route change. At this  point the route services starts
     * resolving all of the dependencies needed for the route change to occur.
     * Typically this involves fetching the view template as well as any dependencies
     * defined in `resolve` route property. Once  all of the dependencies are resolved
     * `$routeChangeSuccess` is fired.
     *
     * The route change (and the `$location` change that triggered it) can be prevented
     * by calling `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on}
     * for more details about event object.
     *
     * @param {Object} angularEvent Synthetic event object.
     * @param {Route} next Future route information.
     * @param {Route} current Current route information.
     */

    /**
     * @ngdoc event
     * @name $route#$routeChangeSuccess
     * @eventType broadcast on root scope
     * @description
     * Broadcasted after a route change has happened successfully.
     * The `resolve` dependencies are now available in the `current.locals` property.
     *
     * {@link ngRoute.directive:ngView ngView} listens for the directive
     * to instantiate the controller and render the view.
     *
     * @param {Object} angularEvent Synthetic event object.
     * @param {Route} current Current route information.
     * @param {Route|Undefined} previous Previous route information, or undefined if current is
     * first route entered.
     */

    /**
     * @ngdoc event
     * @name $route#$routeChangeError
     * @eventType broadcast on root scope
     * @description
     * Broadcasted if any of the resolve promises are rejected.
     *
     * @param {Object} angularEvent Synthetic event object
     * @param {Route} current Current route information.
     * @param {Route} previous Previous route information.
     * @param {Route} rejection Rejection of the promise. Usually the error of the failed promise.
     */

    /**
     * @ngdoc event
     * @name $route#$routeUpdate
     * @eventType broadcast on root scope
     * @description
     * The `reloadOnSearch` property has been set to false, and we are reusing the same
     * instance of the Controller.
     *
     * @param {Object} angularEvent Synthetic event object
     * @param {Route} current Current/previous route information.
     */

    var forceReload = false,
        preparedRoute,
        preparedRouteIsUpdateOnly,
        $route = {
          routes: routes,

          /**
           * @ngdoc method
           * @name $route#reload
           *
           * @description
           * Causes `$route` service to reload the current route even if
           * {@link ng.$location $location} hasn't changed.
           *
           * As a result of that, {@link ngRoute.directive:ngView ngView}
           * creates new scope and reinstantiates the controller.
           */
          reload: function() {
            forceReload = true;

            var fakeLocationEvent = {
              defaultPrevented: false,
              preventDefault: function fakePreventDefault() {
                this.defaultPrevented = true;
                forceReload = false;
              }
            };

            $rootScope.$evalAsync(function() {
              prepareRoute(fakeLocationEvent);
              if (!fakeLocationEvent.defaultPrevented) commitRoute();
            });
          },

          /**
           * @ngdoc method
           * @name $route#updateParams
           *
           * @description
           * Causes `$route` service to update the current URL, replacing
           * current route parameters with those specified in `newParams`.
           * Provided property names that match the route's path segment
           * definitions will be interpolated into the location's path, while
           * remaining properties will be treated as query params.
           *
           * @param {!Object<string, string>} newParams mapping of URL parameter names to values
           */
          updateParams: function(newParams) {
            if (this.current && this.current.$$route) {
              newParams = angular.extend({}, this.current.params, newParams);
              $location.path(interpolate(this.current.$$route.originalPath, newParams));
              // interpolate modifies newParams, only query params are left
              $location.search(newParams);
            } else {
              throw $routeMinErr('norout', 'Tried updating route when with no current route');
            }
          }
        };

    $rootScope.$on('$locationChangeStart', prepareRoute);
    $rootScope.$on('$locationChangeSuccess', commitRoute);

    return $route;

    /////////////////////////////////////////////////////

    /**
     * @param on {string} current url
     * @param route {Object} route regexp to match the url against
     * @return {?Object}
     *
     * @description
     * Check if the route matches the current url.
     *
     * Inspired by match in
     * visionmedia/express/lib/router/router.js.
     */
    function switchRouteMatcher(on, route) {
      var keys = route.keys,
          params = {};

      if (!route.regexp) return null;

      var m = route.regexp.exec(on);
      if (!m) return null;

      for (var i = 1, len = m.length; i < len; ++i) {
        var key = keys[i - 1];

        var val = m[i];

        if (key && val) {
          params[key.name] = val;
        }
      }
      return params;
    }

    function prepareRoute($locationEvent) {
      var lastRoute = $route.current;

      preparedRoute = parseRoute();
      preparedRouteIsUpdateOnly = preparedRoute && lastRoute && preparedRoute.$$route === lastRoute.$$route
          && angular.equals(preparedRoute.pathParams, lastRoute.pathParams)
          && !preparedRoute.reloadOnSearch && !forceReload;

      if (!preparedRouteIsUpdateOnly && (lastRoute || preparedRoute)) {
        if ($rootScope.$broadcast('$routeChangeStart', preparedRoute, lastRoute).defaultPrevented) {
          if ($locationEvent) {
            $locationEvent.preventDefault();
          }
        }
      }
    }

    function commitRoute() {
      var lastRoute = $route.current;
      var nextRoute = preparedRoute;

      if (preparedRouteIsUpdateOnly) {
        lastRoute.params = nextRoute.params;
        angular.copy(lastRoute.params, $routeParams);
        $rootScope.$broadcast('$routeUpdate', lastRoute);
      } else if (nextRoute || lastRoute) {
        forceReload = false;
        $route.current = nextRoute;
        if (nextRoute) {
          if (nextRoute.redirectTo) {
            if (angular.isString(nextRoute.redirectTo)) {
              $location.path(interpolate(nextRoute.redirectTo, nextRoute.params)).search(nextRoute.params)
                       .replace();
            } else {
              $location.url(nextRoute.redirectTo(nextRoute.pathParams, $location.path(), $location.search()))
                       .replace();
            }
          }
        }

        $q.when(nextRoute).
          then(resolveLocals).
          then(function(locals) {
            // after route change
            if (nextRoute === $route.current) {
              if (nextRoute) {
                nextRoute.locals = locals;
                angular.copy(nextRoute.params, $routeParams);
              }
              $rootScope.$broadcast('$routeChangeSuccess', nextRoute, lastRoute);
            }
          }, function(error) {
            if (nextRoute === $route.current) {
              $rootScope.$broadcast('$routeChangeError', nextRoute, lastRoute, error);
            }
          });
      }
    }

    function resolveLocals(route) {
      if (route) {
        var locals = angular.extend({}, route.resolve);
        angular.forEach(locals, function(value, key) {
          locals[key] = angular.isString(value) ?
              $injector.get(value) :
              $injector.invoke(value, null, null, key);
        });
        var template = getTemplateFor(route);
        if (angular.isDefined(template)) {
          locals['$template'] = template;
        }
        return $q.all(locals);
      }
    }


    function getTemplateFor(route) {
      var template, templateUrl;
      if (angular.isDefined(template = route.template)) {
        if (angular.isFunction(template)) {
          template = template(route.params);
        }
      } else if (angular.isDefined(templateUrl = route.templateUrl)) {
        if (angular.isFunction(templateUrl)) {
          templateUrl = templateUrl(route.params);
        }
        if (angular.isDefined(templateUrl)) {
          route.loadedTemplateUrl = $sce.valueOf(templateUrl);
          template = $templateRequest(templateUrl);
        }
      }
      return template;
    }


    /**
     * @returns {Object} the current active route, by matching it against the URL
     */
    function parseRoute() {
      // Match a route
      var params, match;
      angular.forEach(routes, function(route, path) {
        if (!match && (params = switchRouteMatcher($location.path(), route))) {
          match = inherit(route, {
            params: angular.extend({}, $location.search(), params),
            pathParams: params});
          match.$$route = route;
        }
      });
      // No route matched; fallback to "otherwise" route
      return match || routes[null] && inherit(routes[null], {params: {}, pathParams:{}});
    }

    /**
     * @returns {string} interpolation of the redirect path with the parameters
     */
    function interpolate(string, params) {
      var result = [];
      angular.forEach((string || '').split(':'), function(segment, i) {
        if (i === 0) {
          result.push(segment);
        } else {
          var segmentMatch = segment.match(/(\w+)(?:[?*])?(.*)/);
          var key = segmentMatch[1];
          result.push(params[key]);
          result.push(segmentMatch[2] || '');
          delete params[key];
        }
      });
      return result.join('');
    }
  }];
}

ngRouteModule.provider('$routeParams', $RouteParamsProvider);


/**
 * @ngdoc service
 * @name $routeParams
 * @requires $route
 * @this
 *
 * @description
 * The `$routeParams` service allows you to retrieve the current set of route parameters.
 *
 * Requires the {@link ngRoute `ngRoute`} module to be installed.
 *
 * The route parameters are a combination of {@link ng.$location `$location`}'s
 * {@link ng.$location#search `search()`} and {@link ng.$location#path `path()`}.
 * The `path` parameters are extracted when the {@link ngRoute.$route `$route`} path is matched.
 *
 * In case of parameter name collision, `path` params take precedence over `search` params.
 *
 * The service guarantees that the identity of the `$routeParams` object will remain unchanged
 * (but its properties will likely change) even when a route change occurs.
 *
 * Note that the `$routeParams` are only updated *after* a route change completes successfully.
 * This means that you cannot rely on `$routeParams` being correct in route resolve functions.
 * Instead you can use `$route.current.params` to access the new route's parameters.
 *
 * @example
 * ```js
 *  // Given:
 *  // URL: http://server.com/index.html#/Chapter/1/Section/2?search=moby
 *  // Route: /Chapter/:chapterId/Section/:sectionId
 *  //
 *  // Then
 *  $routeParams ==> {chapterId:'1', sectionId:'2', search:'moby'}
 * ```
 */
function $RouteParamsProvider() {
  this.$get = function() { return {}; };
}

ngRouteModule.directive('ngView', ngViewFactory);
ngRouteModule.directive('ngView', ngViewFillContentFactory);


/**
 * @ngdoc directive
 * @name ngView
 * @restrict ECA
 *
 * @description
 * # Overview
 * `ngView` is a directive that complements the {@link ngRoute.$route $route} service by
 * including the rendered template of the current route into the main layout (`index.html`) file.
 * Every time the current route changes, the included view changes with it according to the
 * configuration of the `$route` service.
 *
 * Requires the {@link ngRoute `ngRoute`} module to be installed.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM |
 * | {@link ng.$animate#leave leave}  | when the old element is removed from to the DOM  |
 *
 * The enter and leave animation occur concurrently.
 *
 * @knownIssue If `ngView` is contained in an asynchronously loaded template (e.g. in another
 *             directive's templateUrl or in a template loaded using `ngInclude`), then you need to
 *             make sure that `$route` is instantiated in time to capture the initial
 *             `$locationChangeStart` event and load the appropriate view. One way to achieve this
 *             is to have it as a dependency in a `.run` block:
 *             `myModule.run(['$route', function() {}]);`
 *
 * @scope
 * @priority 400
 * @param {string=} onload Expression to evaluate whenever the view updates.
 *
 * @param {string=} autoscroll Whether `ngView` should call {@link ng.$anchorScroll
 *                  $anchorScroll} to scroll the viewport after the view is updated.
 *
 *                  - If the attribute is not set, disable scrolling.
 *                  - If the attribute is set without value, enable scrolling.
 *                  - Otherwise enable scrolling only if the `autoscroll` attribute value evaluated
 *                    as an expression yields a truthy value.
 * @example
    <example name="ngView-directive" module="ngViewExample"
             deps="angular-route.js;angular-animate.js"
             animations="true" fixBase="true">
      <file name="index.html">
        <div ng-controller="MainCtrl as main">
          Choose:
          <a href="Book/Moby">Moby</a> |
          <a href="Book/Moby/ch/1">Moby: Ch1</a> |
          <a href="Book/Gatsby">Gatsby</a> |
          <a href="Book/Gatsby/ch/4?key=value">Gatsby: Ch4</a> |
          <a href="Book/Scarlet">Scarlet Letter</a><br/>

          <div class="view-animate-container">
            <div ng-view class="view-animate"></div>
          </div>
          <hr />

          <pre>$location.path() = {{main.$location.path()}}</pre>
          <pre>$route.current.templateUrl = {{main.$route.current.templateUrl}}</pre>
          <pre>$route.current.params = {{main.$route.current.params}}</pre>
          <pre>$routeParams = {{main.$routeParams}}</pre>
        </div>
      </file>

      <file name="book.html">
        <div>
          controller: {{book.name}}<br />
          Book Id: {{book.params.bookId}}<br />
        </div>
      </file>

      <file name="chapter.html">
        <div>
          controller: {{chapter.name}}<br />
          Book Id: {{chapter.params.bookId}}<br />
          Chapter Id: {{chapter.params.chapterId}}
        </div>
      </file>

      <file name="animations.css">
        .view-animate-container {
          position:relative;
          height:100px!important;
          background:white;
          border:1px solid black;
          height:40px;
          overflow:hidden;
        }

        .view-animate {
          padding:10px;
        }

        .view-animate.ng-enter, .view-animate.ng-leave {
          transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 1.5s;

          display:block;
          width:100%;
          border-left:1px solid black;

          position:absolute;
          top:0;
          left:0;
          right:0;
          bottom:0;
          padding:10px;
        }

        .view-animate.ng-enter {
          left:100%;
        }
        .view-animate.ng-enter.ng-enter-active {
          left:0;
        }
        .view-animate.ng-leave.ng-leave-active {
          left:-100%;
        }
      </file>

      <file name="script.js">
        angular.module('ngViewExample', ['ngRoute', 'ngAnimate'])
          .config(['$routeProvider', '$locationProvider',
            function($routeProvider, $locationProvider) {
              $routeProvider
                .when('/Book/:bookId', {
                  templateUrl: 'book.html',
                  controller: 'BookCtrl',
                  controllerAs: 'book'
                })
                .when('/Book/:bookId/ch/:chapterId', {
                  templateUrl: 'chapter.html',
                  controller: 'ChapterCtrl',
                  controllerAs: 'chapter'
                });

              $locationProvider.html5Mode(true);
          }])
          .controller('MainCtrl', ['$route', '$routeParams', '$location',
            function MainCtrl($route, $routeParams, $location) {
              this.$route = $route;
              this.$location = $location;
              this.$routeParams = $routeParams;
          }])
          .controller('BookCtrl', ['$routeParams', function BookCtrl($routeParams) {
            this.name = 'BookCtrl';
            this.params = $routeParams;
          }])
          .controller('ChapterCtrl', ['$routeParams', function ChapterCtrl($routeParams) {
            this.name = 'ChapterCtrl';
            this.params = $routeParams;
          }]);

      </file>

      <file name="protractor.js" type="protractor">
        it('should load and compile correct template', function() {
          element(by.linkText('Moby: Ch1')).click();
          var content = element(by.css('[ng-view]')).getText();
          expect(content).toMatch(/controller: ChapterCtrl/);
          expect(content).toMatch(/Book Id: Moby/);
          expect(content).toMatch(/Chapter Id: 1/);

          element(by.partialLinkText('Scarlet')).click();

          content = element(by.css('[ng-view]')).getText();
          expect(content).toMatch(/controller: BookCtrl/);
          expect(content).toMatch(/Book Id: Scarlet/);
        });
      </file>
    </example>
 */


/**
 * @ngdoc event
 * @name ngView#$viewContentLoaded
 * @eventType emit on the current ngView scope
 * @description
 * Emitted every time the ngView content is reloaded.
 */
ngViewFactory.$inject = ['$route', '$anchorScroll', '$animate'];
function ngViewFactory($route, $anchorScroll, $animate) {
  return {
    restrict: 'ECA',
    terminal: true,
    priority: 400,
    transclude: 'element',
    link: function(scope, $element, attr, ctrl, $transclude) {
        var currentScope,
            currentElement,
            previousLeaveAnimation,
            autoScrollExp = attr.autoscroll,
            onloadExp = attr.onload || '';

        scope.$on('$routeChangeSuccess', update);
        update();

        function cleanupLastView() {
          if (previousLeaveAnimation) {
            $animate.cancel(previousLeaveAnimation);
            previousLeaveAnimation = null;
          }

          if (currentScope) {
            currentScope.$destroy();
            currentScope = null;
          }
          if (currentElement) {
            previousLeaveAnimation = $animate.leave(currentElement);
            previousLeaveAnimation.done(function(response) {
              if (response !== false) previousLeaveAnimation = null;
            });
            currentElement = null;
          }
        }

        function update() {
          var locals = $route.current && $route.current.locals,
              template = locals && locals.$template;

          if (angular.isDefined(template)) {
            var newScope = scope.$new();
            var current = $route.current;

            // Note: This will also link all children of ng-view that were contained in the original
            // html. If that content contains controllers, ... they could pollute/change the scope.
            // However, using ng-view on an element with additional content does not make sense...
            // Note: We can't remove them in the cloneAttchFn of $transclude as that
            // function is called before linking the content, which would apply child
            // directives to non existing elements.
            var clone = $transclude(newScope, function(clone) {
              $animate.enter(clone, null, currentElement || $element).done(function onNgViewEnter(response) {
                if (response !== false && angular.isDefined(autoScrollExp)
                  && (!autoScrollExp || scope.$eval(autoScrollExp))) {
                  $anchorScroll();
                }
              });
              cleanupLastView();
            });

            currentElement = clone;
            currentScope = current.scope = newScope;
            currentScope.$emit('$viewContentLoaded');
            currentScope.$eval(onloadExp);
          } else {
            cleanupLastView();
          }
        }
    }
  };
}

// This directive is called during the $transclude call of the first `ngView` directive.
// It will replace and compile the content of the element with the loaded template.
// We need this directive so that the element content is already filled when
// the link function of another directive on the same element as ngView
// is called.
ngViewFillContentFactory.$inject = ['$compile', '$controller', '$route'];
function ngViewFillContentFactory($compile, $controller, $route) {
  return {
    restrict: 'ECA',
    priority: -400,
    link: function(scope, $element) {
      var current = $route.current,
          locals = current.locals;

      $element.html(locals.$template);

      var link = $compile($element.contents());

      if (current.controller) {
        locals.$scope = scope;
        var controller = $controller(current.controller, locals);
        if (current.controllerAs) {
          scope[current.controllerAs] = controller;
        }
        $element.data('$ngControllerController', controller);
        $element.children().data('$ngControllerController', controller);
      }
      scope[current.resolveAs || '$resolve'] = locals;

      link(scope);
    }
  };
}


})(window, window.angular);
// Create all modules and define dependencies to make sure they exist
// and are loaded in the correct order to satisfy dependency injection
// before all nested files are concatenated by Grunt

// Modules
angular.module('angular-jwt',
    [
        'angular-jwt.options',
        'angular-jwt.interceptor',
        'angular-jwt.jwt',
        'angular-jwt.authManager'
    ]);

//    angular-uuid created by Ivan Hayes @munkychop
//    MIT License - http://opensource.org/licenses/mit-license.php
//    --------------------------------------------------------------
//    This is an AngularJS wrapper for the original node-uuid library
//    written by Robert Kieffer – https://github.com/broofa/node-uuid
//    MIT License - http://opensource.org/licenses/mit-license.php
//    The wrapped node-uuid library is at version 1.4.7

function AngularUUID () {
  'use strict';

  angular.module('angular-uuid',[]).factory('uuid', ['$window', nodeUUID]);

  function nodeUUID ($window) {
    // Unique ID creation requires a high quality random # generator.  We feature
    // detect to determine the best RNG source, normalizing to a function that
    // returns 128-bits of randomness, since that's what's usually required
    var _rng, _mathRNG, _whatwgRNG;

    // Allow for MSIE11 msCrypto
    var _crypto = $window.crypto || $window.msCrypto;

    if (!_rng && _crypto && _crypto.getRandomValues) {
      // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
      //
      // Moderately fast, high quality
      try {
        var _rnds8 = new Uint8Array(16);
        _whatwgRNG = _rng = function whatwgRNG() {
          _crypto.getRandomValues(_rnds8);
          return _rnds8;
        };
        _rng();
      } catch(e) {}
    }

    if (!_rng) {
      // Math.random()-based (RNG)
      //
      // If all else fails, use Math.random().  It's fast, but is of unspecified
      // quality.
      var  _rnds = new Array(16);
      _mathRNG = _rng = function() {
        for (var i = 0, r; i < 16; i++) {
          if ((i & 0x03) === 0) { r = Math.random() * 0x100000000; }
          _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }

        return _rnds;
      };
      if ('undefined' !== typeof console && console.warn) {
        console.warn('[SECURITY] node-uuid: crypto not usable, falling back to insecure Math.random()');
      }
    }

    // Buffer class to use
    var BufferClass = ('function' === typeof Buffer) ? Buffer : Array;

    // Maps for number <-> hex string conversion
    var _byteToHex = [];
    var _hexToByte = {};
    for (var i = 0; i < 256; i++) {
      _byteToHex[i] = (i + 0x100).toString(16).substr(1);
      _hexToByte[_byteToHex[i]] = i;
    }

    // **`parse()` - Parse a UUID into it's component bytes**
    function parse(s, buf, offset) {
      var i = (buf && offset) || 0, ii = 0;

      buf = buf || [];
      s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
        if (ii < 16) { // Don't overflow!
          buf[i + ii++] = _hexToByte[oct];
        }
      });

      // Zero out remaining bytes if string was short
      while (ii < 16) {
        buf[i + ii++] = 0;
      }

      return buf;
    }

    // **`unparse()` - Convert UUID byte array (ala parse()) into a string**
    function unparse(buf, offset) {
      var i = offset || 0, bth = _byteToHex;
      return  bth[buf[i++]] + bth[buf[i++]] +
              bth[buf[i++]] + bth[buf[i++]] + '-' +
              bth[buf[i++]] + bth[buf[i++]] + '-' +
              bth[buf[i++]] + bth[buf[i++]] + '-' +
              bth[buf[i++]] + bth[buf[i++]] + '-' +
              bth[buf[i++]] + bth[buf[i++]] +
              bth[buf[i++]] + bth[buf[i++]] +
              bth[buf[i++]] + bth[buf[i++]];
    }

    // **`v1()` - Generate time-based UUID**
    //
    // Inspired by https://github.com/LiosK/UUID.js
    // and http://docs.python.org/library/uuid.html

    // random #'s we need to init node and clockseq
    var _seedBytes = _rng();

    // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
    var _nodeId = [
      _seedBytes[0] | 0x01,
      _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
    ];

    // Per 4.2.2, randomize (14 bit) clockseq
    var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

    // Previous uuid creation time
    var _lastMSecs = 0, _lastNSecs = 0;

    // See https://github.com/broofa/node-uuid for API details
    function v1(options, buf, offset) {
      var i = buf && offset || 0;
      var b = buf || [];

      options = options || {};

      var clockseq = (options.clockseq != null) ? options.clockseq : _clockseq;

      // UUID timestamps are 100 nano-second units since the Gregorian epoch,
      // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
      // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
      // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
      var msecs = (options.msecs != null) ? options.msecs : new Date().getTime();

      // Per 4.2.1.2, use count of uuid's generated during the current clock
      // cycle to simulate higher resolution clock
      var nsecs = (options.nsecs != null) ? options.nsecs : _lastNSecs + 1;

      // Time since last uuid creation (in msecs)
      var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

      // Per 4.2.1.2, Bump clockseq on clock regression
      if (dt < 0 && options.clockseq == null) {
        clockseq = clockseq + 1 & 0x3fff;
      }

      // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
      // time interval
      if ((dt < 0 || msecs > _lastMSecs) && options.nsecs == null) {
        nsecs = 0;
      }

      // Per 4.2.1.2 Throw error if too many uuids are requested
      if (nsecs >= 10000) {
        throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
      }

      _lastMSecs = msecs;
      _lastNSecs = nsecs;
      _clockseq = clockseq;

      // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
      msecs += 12219292800000;

      // `time_low`
      var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
      b[i++] = tl >>> 24 & 0xff;
      b[i++] = tl >>> 16 & 0xff;
      b[i++] = tl >>> 8 & 0xff;
      b[i++] = tl & 0xff;

      // `time_mid`
      var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
      b[i++] = tmh >>> 8 & 0xff;
      b[i++] = tmh & 0xff;

      // `time_high_and_version`
      b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
      b[i++] = tmh >>> 16 & 0xff;

      // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
      b[i++] = clockseq >>> 8 | 0x80;

      // `clock_seq_low`
      b[i++] = clockseq & 0xff;

      // `node`
      var node = options.node || _nodeId;
      for (var n = 0; n < 6; n++) {
        b[i + n] = node[n];
      }

      return buf ? buf : unparse(b);
    }

    // **`v4()` - Generate random UUID**

    // See https://github.com/broofa/node-uuid for API details
    function v4(options, buf, offset) {
      // Deprecated - 'format' argument, as supported in v1.2
      var i = buf && offset || 0;

      if (typeof(options) === 'string') {
        buf = (options === 'binary') ? new BufferClass(16) : null;
        options = null;
      }
      options = options || {};

      var rnds = options.random || (options.rng || _rng)();

      // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
      rnds[6] = (rnds[6] & 0x0f) | 0x40;
      rnds[8] = (rnds[8] & 0x3f) | 0x80;

      // Copy bytes to buffer, if provided
      if (buf) {
        for (var ii = 0; ii < 16; ii++) {
          buf[i + ii] = rnds[ii];
        }
      }

      return buf || unparse(rnds);
    }

    // Export public API
    var uuid = v4;
    uuid.v1 = v1;
    uuid.v4 = v4;
    uuid.parse = parse;
    uuid.unparse = unparse;
    uuid.BufferClass = BufferClass;
    uuid._rng = _rng;
    uuid._mathRNG = _mathRNG;
    uuid._whatwgRNG = _whatwgRNG;

    return uuid;
  }
}

// check for Module/AMD support, otherwise call the uuid function to setup the angular module.
if (typeof module !== 'undefined' && module.exports) {
  module.exports = new AngularUUID();

} else if (typeof define !== 'undefined' && define.amd) {
  // AMD. Register as an anonymous module.
  define (function() {
    return new AngularUUID();
  });
  
} else {
  AngularUUID();
}
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function () {
	'use strict';

	angular
		.module('app.core')
		.service('cvicTrashService', cvicTrashService);
            
    /** @ngInject */
	function cvicTrashService($rootScope,ApiEndPoints, __env, $mdDialog, $http, $translate, cvicRequestService) {

				var that = this;

				this.objResultSet = null;
				this.intCurrentPage = null;
				this.strTerm = null;

				var objPRIVATE_CONSTANTS = {
					LIST_URL				: __env.apiUrl + ApiEndPoints.TrashController.list,
					DELETE_SPACE_URL		: __env.apiUrl + ApiEndPoints.SpaceController.delete,
					DELETE_EVENT_URL		: __env.apiUrl + ApiEndPoints.EventController.deleteEvent,
					DELETE_DOCUMENT_URL		: __env.apiUrl + ApiEndPoints.DocumentController.delete,
					DELETE_MESSAGE_URL 		: __env.apiUrl + ApiEndPoints.MessagesController.delete,
					UNDELETE_SPACE_URL 		: __env.apiUrl + ApiEndPoints.SpaceController.undelete,
					UNDELETE_EVENT_URL 		: __env.apiUrl + ApiEndPoints.EventController.undelete,
					UNDELETE_DOCUMENT_URL	: __env.apiUrl + ApiEndPoints.DocumentController.undelete,
					UNDELETE_MESSAGE_URL	: __env.apiUrl + ApiEndPoints.MessagesController.undelete,
					PAGE_SIZE	: 10
				};

				var objPRIVATE_ENTITY_TYPES = {
                    SPACE 		: 'com.tetracom.cvic.model.space.Space',
                    EVENT 		: 'com.tetracom.cvic.model.event.Event',
                    MESSAGE 	: 'com.tetracom.cvic.model.message.Message',
                    DOCUMENT 	: 'com.tetracom.cvic.model.doc.Document',
                    USER 		: 'com.tetracom.cvic.model.user.User'
				};

				this.fnLoad = function () {
					this.intCurrentPage = 0;
					this.strTerm = null;
					this.objResultSet = null;
					return fnExecuteRequest();
				};

				this.fnLoadPage = function (intPage) {
					this.intCurrentPage = intPage;
					return fnExecuteRequest();
				};

				this.fnSearch = function (strTerm) {
					this.strTerm = strTerm;
					this.intCurrentPage = 0;
					return fnExecuteRequest();
				};

				this.fnGetStartPosition = function () {
					if( !fnHasData() ) {
						return 0;
					}

                    var intExpected = ( this.intCurrentPage * this.objResultSet.pageSize + 1 );

                    if ( intExpected > this.objResultSet.total ) {
                        return this.objResultSet.total;
                    }

                    return intExpected;
                };

                this.fnGetEndPosition = function () {
                	if( !fnHasData() ) {
                		return 0;
                	}

                    var intExpected = ( (this.intCurrentPage + 1) * this.objResultSet.pageSize );

                    if ( intExpected > this.objResultSet.total ) {
                        return this.objResultSet.total;
                    }

                    return intExpected;
                };

                this.fnGetPages = function () {
                	if ( !fnHasData() ) {
                		return 0;
                	}

                    return Math.ceil( this.objResultSet.total / this.objResultSet.pageSize );
                };

                this.fnGetPagesForRepeat = function () {
                    return new Array(this.fnGetPages());
                };

                this.fnShowPage = function (intIndex) {
                    if( intIndex == this.intCurrentPage || 
                        intIndex + 1 == this.intCurrentPage || 
                        intIndex - 1 == this.intCurrentPage || 
                        intIndex + 2 == this.intCurrentPage ||
                        intIndex - 2 == this.intCurrentPage ) {
                        return true;
                    }

                    return false;
                };

                this.fnIsSpace = function(objEntity) {
                	return objEntity['@class'] == objPRIVATE_ENTITY_TYPES.SPACE;
                };

                this.fnIsEvent = function(objEntity) {
                	return objEntity['@class'] == objPRIVATE_ENTITY_TYPES.EVENT;
                };

                this.fnIsMessage = function(objEntity) {
                	return objEntity['@class'] == objPRIVATE_ENTITY_TYPES.MESSAGE;
                };

                this.fnIsDocument = function(objEntity) {
                	return objEntity['@class'] == objPRIVATE_ENTITY_TYPES.DOCUMENT;
                };

                this.fnIsUser = function(objEntity) {
                	return objEntity['@class'] == objPRIVATE_ENTITY_TYPES.USER;
                };

                this.fnGetConfirmRestoreDialog = function () {

                	return $mdDialog.confirm()
                		.title( $translate.instant( 'TRASH.CONFIRM.RESTORE.TITLE' ) )
                		.htmlContent( $translate.instant( 'TRASH.CONFIRM.RESTORE.TEXT' ) )
                		.ok( $translate.instant('TRASH.CONFIRM.RESTORE.OK') )
                		.cancel( $translate.instant('TRASH.CONFIRM.RESTORE.CANCEL') );

                };

                this.fnGetConfirmDeleteDialog = function () {

                	return $mdDialog.confirm()
                		.title( $translate.instant( 'TRASH.CONFIRM.DELETE.TITLE' ) )
                		.htmlContent( $translate.instant( 'TRASH.CONFIRM.DELETE.TEXT' ) )
                		.ok( $translate.instant('TRASH.CONFIRM.DELETE.OK') )
                		.cancel( $translate.instant('TRASH.CONFIRM.DELETE.CANCEL') );

                };

                this.fnRestore = function (objEntity) {

                	var strUrl;

                	switch( objEntity['@class'] ) {
                		case objPRIVATE_ENTITY_TYPES.SPACE:
                			strUrl = objPRIVATE_CONSTANTS.UNDELETE_SPACE_URL;
                			break;
                		case objPRIVATE_ENTITY_TYPES.EVENT:
                			strUrl = objPRIVATE_CONSTANTS.UNDELETE_EVENT_URL;
                			break;
                		case objPRIVATE_ENTITY_TYPES.MESSAGE:
                			strUrl = objPRIVATE_CONSTANTS.UNDELETE_MESSAGE_URL;
                			break;
                		case objPRIVATE_ENTITY_TYPES.DOCUMENT:
                			strUrl = objPRIVATE_CONSTANTS.UNDELETE_DOCUMENT_URL;
                			break;
                		default: 
                			throw { msg: 'There is no implementation for undelete' };
                	}

                	return cvicRequestService.fnPostJsonData( strUrl, objEntity ).
                			then(function(){
                				if (objEntity['@class'] == objPRIVATE_ENTITY_TYPES.EVENT ){
                					$rootScope.cvicSchedule.upcomingEventsRequest();
                				}
                			});
                };

                this.fnDelete = function (objEntity) {
                	var strUrl;

                	switch( objEntity['@class'] ) {
                		case objPRIVATE_ENTITY_TYPES.SPACE:
	                		strUrl = objPRIVATE_CONSTANTS.DELETE_SPACE_URL;
	                		break;
	                	case objPRIVATE_ENTITY_TYPES.EVENT:
	                		strUrl = objPRIVATE_CONSTANTS.DELETE_EVENT_URL;
	                		break;
	                	case objPRIVATE_ENTITY_TYPES.MESSAGE:
	                		strUrl = objPRIVATE_CONSTANTS.DELETE_MESSAGE_URL;
	                		break;
	                	case objPRIVATE_ENTITY_TYPES.DOCUMENT:
	                		strUrl = objPRIVATE_CONSTANTS.DELETE_DOCUMENT_URL;
	                		break;
	                	default:
	                		throw { msg: 'There is no implementation for delete' };
                	}

                	return cvicRequestService.fnPostJsonData( strUrl, objEntity );
                };

				var fnExecuteRequest = function () {

					var objPostData = {};
					objPostData.currentPage = that.intCurrentPage;
					objPostData.pageSize = objPRIVATE_CONSTANTS.PAGE_SIZE;

					if ( that.strTerm != null ) {
						objPostData.searchTerm = that.strTerm;
					}

                    return cvicRequestService.fnPostJsonData( objPRIVATE_CONSTANTS.LIST_URL, objPostData ).then(
                        function success(response) {

                            that.objResultSet = response.data;

                            return response.data;

                        }, function fail(response) {

                            //TODO error handling
                            return response.data;

                        });

				};

				var fnHasData = function () {
					return (that.objResultSet != null);
				};
			
			} 

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('cvicSpaceService', cvicSpaceService);

    /** @ngInject */
    function cvicSpaceService(cvicJWTService)
    {
	    var service = { 
            allowEditSpace: allowEditSpace,
            allowDeleteSpace: allowDeleteSpace
	    };

        return service;
        
        function allowEditSpace(space) {  
            return ( cvicJWTService.isOwner(space) || cvicJWTService.canManage(space) ) 
            		&& (!space.organization || space.organization.type != 'moodle'); 
        }
        
        function allowDeleteSpace(space) {
            return ( cvicJWTService.isOwner(space) || cvicJWTService.canManage(space) ) 
            		&& (!space.organization || space.organization.type != 'moodle');
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
		.service('cvicSearchService', cvicSearchService);

    /** @ngInject */
	function cvicSearchService(ApiEndPoints, __env, cvicRequestService,cvicDocumentService) {

                var that = this;

                var objPRIVATE_CONSTANTS = {
                    SPACE_SEARCH    : __env.apiUrl + ApiEndPoints.DashboardController.search,
                    EVENT_SEARCH    : __env.apiUrl + ApiEndPoints.DashboardController.search,
                    MIXED_SEARCH    : __env.apiUrl + ApiEndPoints.DashboardController.search,
                    DOCUMENT_SEARCH : __env.apiUrl + ApiEndPoints.DashboardController.search,
                    PAGE_SIZE       : 10
                };

                
                this.enumObjectType = {
                    Space	: 'com.tetracom.cvic.model.space.Space',
                    Event	: 'com.tetracom.cvic.model.event.Event',
                    Message	: 'com.tetracom.cvic.model.message.Message',
                    Document: 'com.tetracom.cvic.model.doc.Document',
                    User	: 'com.tetracom.cvic.model.user.User'
                };

                this.enumSearchType = {
                    Mixed    : 'MIXED',
                    Spaces   : 'SPACES',
                    Events   : 'EVENTS',
                    Messages : 'MESSAGES',
                    Documents: 'DOCUMENTS',
                    Users	 : 'USERS'
                };
            
                this.objResultSet = null;
                this.intCurrentPage = null;
                this.strSearchTerm = null;
                this.enumType = null;
                this.selectorMode = false;
                this.selected = [];
                this.requestExecuted = false;
                this.searchVm = null;
                this.loading = false;
                //this.enumEntityType = null;

                this.fnExecuteSearch = function (strTerm, enumType) {
                    var strUrl = fnBuildRoute(enumType);
                    this.intCurrentPage = 0;
                    this.strSearchTerm = strTerm;
                    this.enumType = enumType;
                    //this.enumEntityType = null;

                    return fnExecuteRequest(strUrl);
                };
                
                this.cvicDocumentService = function(vm){
                	this.searchVm = vm;
                	return cvicDocumentService;
                };
                
                this.fnModifySearchType = function (enumType) {
                	 var strUrl = fnBuildRoute(enumType);
                     this.intCurrentPage = 0;
                     this.strSearchTerm = "";
                     this.enumType = enumType;
                     this.objResultSet = null;
                     this.selected = [];
                     this.requestExecuted = false;
                     //this.enumEntityType = null;
                };
                
                this.fnSetSelectorMode = function (selectorMode) {
                	this.selectorMode = selectorMode;
                };

                this.fnChangePage = function (intNewPage) {
                	if ( intNewPage + 1 <= this.fnGetPages() && intNewPage > -1 ) {
	                    var strUrl = fnBuildRoute(this.enumType);
	                    this.intCurrentPage = intNewPage;
	
	                    return fnExecuteRequest(strUrl);
                	}
                };
                
                this.fnNextPage = function () {

                    var intNewPage = this.intCurrentPage + 1;

                    if ( intNewPage + 1 <= this.fnGetPages()  ) {
                    	this.fnChangePage(intNewPage);
                    }

                };

                this.fnPreviousPage = function () {

                    var intNewPage = this.intCurrentPage - 1;

                    if ( intNewPage > -1 ) {
                    	this.fnChangePage(intNewPage);
                    }

                };

                this.fnModifyTerm = function (strNewTerm) {
                    var strUrl = fnBuildRoute(this.enumType);
                    this.strSearchTerm = strNewTerm;
                    this.intCurrentPage = 0;
                    //this.enumEntityType = null;
                    
                    return fnExecuteRequest(strUrl);
                };

                this.fnModifyEntityType = function () {
                    var strUrl = fnBuildRoute(this.enumType);
                    this.intCurrentPage = 0;

                    return fnExecuteRequest(strUrl);
                };

                this.fnGetStartPosition = function () {
                	if (this.objResultSet == null) return 0;
                		
                    var intExpected = ( this.intCurrentPage * this.objResultSet.pageSize + 1 );

                    if ( intExpected > this.objResultSet.total ) {
                        return this.objResultSet.total;
                    }

                    return intExpected;
                };

                this.fnGetEndPosition = function () {
                	if (this.objResultSet == null) return 0;
                	
                    var intExpected = ( (this.intCurrentPage + 1) * this.objResultSet.pageSize );

                    if ( intExpected > this.objResultSet.total ) {
                        return this.objResultSet.total;
                    }

                    return intExpected;
                };

                this.fnHasData = function () {
                    return ( this.objResultSet != null );
                };

                this.fnGetPages = function () {
                	if (this.objResultSet == null) return 0;
                	
                    return Math.ceil( this.objResultSet.total / this.objResultSet.pageSize );
                };

                this.fnGetPagesForRepeat = function () {
                    return new Array(this.fnGetPages());
                };

                this.fnShowPage = function (intIndex) {
                    if( intIndex == this.intCurrentPage || 
                        intIndex + 1 == this.intCurrentPage || 
                        intIndex - 1 == this.intCurrentPage || 
                        intIndex + 2 == this.intCurrentPage ||
                        intIndex - 2 == this.intCurrentPage ) {
                        return true;
                    }

                    return false;
                };

                var fnBuildRoute = function (enumType) {
                    var strUrl;

                    switch(enumType) {
                        case that.enumSearchType.Spaces:
                            strUrl = objPRIVATE_CONSTANTS.SPACE_SEARCH;
                            break;
                        case that.enumSearchType.Events:
                            strUrl = objPRIVATE_CONSTANTS.EVENT_SEARCH;
                            break;
                        case that.enumSearchType.Mixed:
                        case that.enumSearchType.Messages:
                        case that.enumSearchType.Users:
                            strUrl = objPRIVATE_CONSTANTS.MIXED_SEARCH;
                            break;
                        case that.enumSearchType.Documents:
                            strUrl = objPRIVATE_CONSTANTS.DOCUMENT_SEARCH;
                            break;
                        default:
                            throw new {'error':"Not implemented route"};
                    }

                    return strUrl;
                };
                
                this.selectedItems = function(){
                	return this.selected;
                };
                
                this.setSelected = function(selected){
                	this.selected = selected;
                };
                
                this.isSelected = function(item){
                	for ( i = 0; i < this.selected.length; i++ ){
                		if ( item.uid == this.selected[i].uid){
                			return true;
                		}
                	}
                    return false;
                };

                this.toggleSelected = function(item, event){
                    if ( event ) {
                        event.stopPropagation();
                    }
                    
                    var isSelected = false;
                    for ( i = 0; i < this.selected.length; i++ ){
                		if ( item.uid == this.selected[i].uid){
                			isSelected = true;
                			this.selected.splice(this.selected.indexOf(this.selected[i]), 1);
                		}
                	}

                    if ( !isSelected ) {
                    	this.selected.push(item);
                    }
                };
                
                this.editListElement = function(newElement){  
                	for ( i = 0; i < this.objResultSet.elements.length; i++ ){
                		if (this.objResultSet.elements[i].uid == newElement.uid) {
                			this.objResultSet.elements[i] = newElement;
                		}
                	}
                };
                
                this.deleteListElement = function(element){
                	this.searchVm.viewSideNav = false;
                	this.objResultSet.elements.splice(this.objResultSet.elements.indexOf(element), 1);
                };
                
                this.resultElement= function(){
                	return this.objResultSet.elements;
                };

                var fnExecuteRequest = function(strUrl) {

                    var objPostData = {};
                    objPostData.searchTerm = that.strSearchTerm;
                    objPostData.pageSize = objPRIVATE_CONSTANTS.PAGE_SIZE;
                    objPostData.currentPage = that.intCurrentPage;
                	objPostData.selectorMode = that.selectorMode;
                    objPostData.entityType = that.enumType;
                     
                    if (objPostData.searchTerm == null 
                    		&& that.selectorMode ) {
                    	objPostData.myItems = true;
                    } 
                    that.loading = true;
                                         
                    return cvicRequestService.fnPostJsonData( strUrl, objPostData )
                    .then( function success(response) {

                        that.objResultSet = response.data;
                        that.requestExecuted = true;
                        that.loading = false;
                         
                        if ( that.objResultSet && that.objResultSet.elements && !that.selectorMode ){
	                        if ( that.enumType == that.enumSearchType.Documents
	                        		|| that.enumType == that.enumSearchType.Mixed
	                        ) {  
	                        	that.cvicDocumentService().searchInit(that);
	                        }
                    	}
                        
                        return response.data;

                    }, function fail(response) {

                    	that.requestExecuted = true;
                    	that.loading = false;
                        //TODO add error handling
                        return response.data;

                    });

                };
                

        } 
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('cvicSchedule', cvicSchedule);

    /** @ngInject */
    function cvicSchedule(cvicRequestService, __env)
    {
        this.upcomingEvents = []

        this.upcomingEventsRequest = function() { 
        	var service = this;
        	
        	return cvicRequestService.requestJsonData( __env.apiUrl + '/upcoming_events', 'GET', successResultSetData, failResponseJson)
		            .then(function(data) {
		                if(!angular.equals(data, {})) {
		                	service.upcomingEvents = data;
		                }
		            });
        };
        
        function successResultSetData(response) {
            return response.data.elements;
        } 

        function failResponseJson(response) {
            return {};
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('cvicRequestService', cvicRequestService);

    /** @ngInject */
    function cvicRequestService($http, $rootScope)
    {
        var service = {
            requestJsonData             : requestJsonData,
            requestHtmlData             : requestHtmlData,
            requestDocumentContent      : requestDocumentContent,
            requestExternalContent		: requestExternalContent,
            fnGetJsonData               : fnGetJsonData,
            fnPostJsonData              : fnPostJsonData
        };

        return service;

        function requestJsonData(reqPath, httpMethod, successFunc, failFunc, data) {
            var dataRequest = {
                method: httpMethod,
                url: reqPath,
                params: { 'foobar': new Date().getTime() },
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                }
            };

            if ( data ){
                dataRequest.data = data;
            } 

            return $http(dataRequest).then(function success(response) {
                if ( typeof successFunc === 'undefined' ) {
                    return response;
                }
                else {
                    return successFunc(response);
                }
            }, function fail(response) {
                if ( typeof failFunc === 'undefined' ) {
                    return response;
                }
                else {
                    return failFunc(response);
                }
            }); 
        } 
        
        function requestHtmlData(reqPath, httpMethod, sucessFunc, failFunc, data) {
            var dataRequest = {
                method: httpMethod,
                url: reqPath,
                params: { 'foobar': new Date().getTime() },
                headers: {
                    'Content-Type': 'application/html; charset=utf-8'
                }
            };

            if ( data ){
                dataRequest.data = data;
            } 

            return $http(dataRequest).then(function success(response) {
            	if (sucessFunc && sucessFunc != null ) {
            		return sucessFunc(response);
            	}
            	
                return response;
            }, function fail(response) {
            	if (failFunc && failFunc != null ) {
            		return failFunc(response);
            	}
            	
                return response;
            }); 
        } 
        
        function requestDocumentContent(reqPath) {
            return $http({
                method: 'GET',
                url: reqPath,
                params: { 'foobar': new Date().getTime() },
                responseType : 'arraybuffer'
            })            
            .success(function (data, status, headers) { 
            	var header = headers();
            	downloadResult(data, status, header);
             })
            .error(function (data) { console.log(data);});
        }
        
        function requestExternalContent(reqPath,customHeaders) { 
        	$rootScope.loadingExternalContentProgress = true;
        	return $http({
                method: 'GET',//'JSONP',
                url: reqPath,
                params: { 'foobar': new Date().getTime() },
                responseType : 'arraybuffer'
            })          
            .success(function (data, status, headers) { 
            	var header = headers();  
            	if (customHeaders) {
            		angular.extend(header, customHeaders);
            	} 
            	downloadResult(data, status, header);
            	$rootScope.loadingExternalContentProgress = false;
             })
            .error(function (data, status, headers) { 
            	$rootScope.loadingExternalContentProgress = false; 
            });
        }
        
        function downloadResult(data, status, headers) {    
            var filename = headers['filename'];
            var contentType = headers['content-type'];  
     
            var linkElement = document.createElement('a');
            try {
                var blob = new Blob([data], { type: contentType });

                if (navigator.appVersion.toString().indexOf('.NET') > 0) {
                    window.navigator.msSaveBlob(blob, filename);
                } else  {
                    var url = window.URL.createObjectURL(blob);
     
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", filename);
         
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                }
            } catch (ex) {
                console.log(ex);
            }
        }

        function fnGetJsonData(strUrl, objData, successFunc, failFunc) {
            var strHttpMethod = 'GET';

            return requestJsonData(strUrl, strHttpMethod, successFunc, failFunc, objData);
        }

        function fnPostJsonData(strUrl, objData, successFunc, failFunc) {
            var strHttpMethod = 'POST';

            return requestJsonData(strUrl, strHttpMethod, successFunc, failFunc, objData);
        }
    }

})();
(function () {

	'use strict';

	angular
		.module('app.core')
		.service('cvicProfileService', cvicProfileService);

		/** @ngInject */
		function cvicProfileService( 
				$q,
				$state,
				$rootScope,
				$mdDialog,
	    		$document, 
	    		uuid,
	    		cvicRequestService,
	    		cvicJWTService,
	    		cvicMessageService,
	    		cvicAudienceService,
	    		cvicListService,
	    		cvicDateService,
	    		ApiEndPoints, 
	    		__env ) {

			var that = this;

			var objPRIVATE_CONSTANTS_URLS = {
				ABOUT_URL			: __env.apiUrl + ApiEndPoints.UserController.getUserInformation,
				GRADES_URL			: __env.apiUrl + ApiEndPoints.ProfileController.grades,
				FREQUENT_URL		: __env.apiUrl + ApiEndPoints.UserController.getMostFrequentContacts,
				OTHER_PARENTS_URL	: __env.apiUrl + ApiEndPoints.ParentController.getOtherParents,
				EDIT_URL			: __env.apiUrl + ApiEndPoints.ProfileController.edit,
				RESET_PASS_URL		: __env.apiUrl + ApiEndPoints.ProfileController.resetPassword
			};

			this.objAboutResult = null;
			this.objGradesResult = null;
			this.objFrequentResult = null;
			this.objChildrenResult = null;
			this.objParentResult = null;
			this.isCurrentParentOf = false;
			this.isCurrent = false;
			this.groupTempl = {};
			this.groups = [];
			this.groupsSystem = [];
			this.groupsVirtual = [];
			this.groupsUsers = {};
			this.objGroupsUsersMap = {};
			
			this.profile = function(userUid){ 
				if ( userUid === undefined || userUid == null || userUid == "") {
					userUid = cvicJWTService.currentUserId();
				}
				$state.go('app.profile', {userUid  : userUid }, {notify: true});
			};

			this.fnLoad = function (userUid) {
				var service = this;
				service.objAboutResult = null;
				service.objGradesResult = null;
				service.objFrequentResult = null;
				service.objChildrenResult = null;
				service.objParentResult = null;
				service.isCurrentParentOf = false;
				
				if ( userUid === undefined || userUid == null || userUid == "") {
					userUid = cvicJWTService.currentUserId();
				}
				
				service.isCurrent = cvicJWTService.isCurrentUser(userUid);
								
				return $q(function(resolve, reject) {
							$rootScope.userDataRequest()
								.then( function( userInfo ) {
									service.isCurrentParentOf = 
											userInfo.children.filter( 
													function( c ) { return (c.uid == userUid); 
											} ).length > 0;
																						
									resolve(service.isCurrentParentOf);		
												
								});
						})
						.then(function () { 
							return $q.all( [ fnRequestAbout(service, userUid), 
							                 fnRequestGrades(service, userUid), 
							                 fnRequestFrequent(service, userUid), 
							                 fnChildrenList(service, userUid), 
							                 fnParentList(service, userUid),
							                 service.loadGroupTempl(service, userUid),
							                 service.loadGroups(service, userUid )] ); 
						});
			};
			 
			this.fnSave = function () {
				var service = this;
				
				cvicRequestService.fnPostJsonData( objPRIVATE_CONSTANTS_URLS.EDIT_URL, this.objAboutResult )
					.then(function success(response) {
						service.objAboutResult = response.data;
						$rootScope.userInformation = null;
	                }, function fail(response) {
	                   //TODO fail alert dlg
	                });
			};

			this.fnResetPassword = function () {
				return cvicRequestService.fnGetJsonData( objPRIVATE_CONSTANTS_URLS.RESET_PASS_URL );
			};
			
		     
	        this.sendMessageUser = function (event, user){
	        	var imageUrl = null;

	        	if(user.coverImage) {
	        		imageUrl = __env.apiUrl + '/common/i/' + user.coverImage.uid + '.jpg';
	        	} else {
	        		imageUrl = 'assets/images/avatars/profile.jpg';
	        	}
	        	
	            var sdTo = [];
	            var userContact = {
	                    uid: user.uid,    
	                    name: user.title,
	                    email: user.email,
	                    image: imageUrl
	                };

	            sdTo.push(userContact);

	            cvicMessageService.composeDialog(event, null, { sdTo:  sdTo });
	        };
	         	        
	        this.addRemoveUserToGroup = function(vmContainer, group, contact) {
	            if(vmContainer.objGroupsUsersMap[group.uid][contact.uid]) {
	                this.removeUserFromGroup(vmContainer, group, contact);
	            } else {
	                this.addUserToGroup(vmContainer,group, contact);
	            }
	        };

	        this.removeUserFromGroup = function(vmContainer, group, contact) {
	            for(var i = 0; i < vmContainer.groups.length; ++i) {
	                var newGroup = vmContainer.groups[i];

	                if(newGroup.uid === group.uid) {
	                    for(var j = 0;  j < newGroup.users.length; ++j) {
	                        if(newGroup.users[j].uid === contact.id) {
	                            newGroup.users.splice(j, 1);

	                            break;
	                        }
	                    }
	                     
	                    if(j <= newGroup.users.length) { 
	                        vmContainer.objGroupsUsersMap[group.uid][contact.uid] = false;

	                        cvicRequestService
	                        .requestJsonData(__env.apiUrl + ApiEndPoints.GroupController.detachUsers, 'POST', 
	                        		function (response) { return response.data; }, 
	                        		function (response) {  return {}; }, 
	                        		newGroup)
	                        .then(function(data) {
	                            if(!angular.equals(data, {})) {
	                                vmContainer.groups[i] = data;

	                                var groupUsers = vmContainer.groupsUsers[group.uid];
	                                
	                                for(var k = 0; k < groupUsers.length; ++k) {
	                                    if(groupUsers[k].id == contact.id) {
	                                        groupUsers.splice(k, 1);

	                                        break;
	                                    }
	                                }

	                                vmContainer.groupsUsers[group.uid] = groupUsers;

	                            } else {
	                                // TODO
	                            }
	                        }); 
	                    }

	                    break;
	                }
	            }    
	        };

	        this.addUserToGroup = function(vmContainer, group, contact) {
	            for(var i = 0; i < vmContainer.groups.length; ++i) {
	                var newGroup = vmContainer.groups[i];

	                if(newGroup.uid === group.uid) {
	                    for(var j = 0;  j < newGroup.users.length; ++j) {
	                        if(newGroup.users[j].uid === contact.id) {
	                            return;
	                        }
	                    }

	                    newGroup.users.push(contact.entity);
	                    vmContainer.objGroupsUsersMap[group.uid][contact.entity.uid] = true;
	                    
	                    cvicRequestService
	                    .requestJsonData(__env.apiUrl + ApiEndPoints.GroupController.save, 'POST', 
	                    		function (response) { return response.data; },
	                    		function (response) {  return {}; }, 
	                    		newGroup)
	                    .then(function(data) {
	                        if(!angular.equals(data, {})) {
	                            vmContainer.groups[i] = data;

	                            var groupUsers = vmContainer.groupsUsers[group.uid];
	                            groupUsers.push(contact);

	                            vmContainer.groupsUsers[group.uid] = groupUsers;

	                        } else {
	                            // TODO
	                        }
	                    }); 

	                    break;
	                }
	            }
	        };
	          
	        this.addNewGroup = function(newGroupName){
	        	var group = angular.copy(this.groupTempl);
	            group.uid = uuid.v4();
	            group.title = newGroupName;
	            group.owner.uid = cvicJWTService.currentUserId();

	            return cvicRequestService
			            .requestJsonData(__env.apiUrl + ApiEndPoints.GroupController.create, 'POST', 
			            		function (response) { return response.data; }, 
			            		function (response) { return {}; }, 
			            		group);
	        };

			var fnGetGradesObject = function (objRawResponse) {

				if ( objRawResponse == null ) {
					return {};
				}

				var objResult = {};

				for(var i = 0; i < objRawResponse.length; i++) {
					var objGrade = objRawResponse[i];

					if ( typeof objResult[ objGrade.user.uid ] !== 'undefined' ) {
						objResult[ objGrade.user.uid ].push( objGrade );
					}
					else {
						objResult[ objGrade.user.uid ] = new Array();
						objResult[ objGrade.user.uid ].push( objGrade );
					}

				}

				return objResult;
			}; 
			
			this.loadGroupTempl = function (service, userUid) {				
				return $q(function(resolve, reject) {
					if (userUid == null || !cvicJWTService.isCurrentUser(userUid) ) {	
			            cvicAudienceService.groupAudienceTempl().then(function(group) {
			            	service.groupTempl = group;
			            	resolve(service.groupTempl);	
			            });
					}
					else {
						resolve(service.groupTempl);
					}
				});
	        };
	        
	        this.loadGroups = function (vmContainer, userUid) { 
	        	var service = this;
	        	return $q(function(resolve, reject) {
	        		if (userUid == null || !cvicJWTService.isCurrentUser(userUid) ) {	
		        		cvicRequestService
		                .requestJsonData(__env.apiUrl + ApiEndPoints.GroupController.myGroups, 'GET', 
		                		function (response) { return response.data.elements; }, 
		                		function (response) { return [];}
		                 )
		                .then(function(data) {
		                      if (data) {    
		                          for(i = 0; i < data.length; i++) {
		                            if(data[i].organization) {
		                                data[i].isSystem = true;
		                            } else {
		                                data[i].isSystem = false;
		                            }
		                            data[i].viewGroupLabel = true;
		                            service.formatGroupData(vmContainer, data[i], true);
		                          }
		                      }
		                      
		                      resolve(vmContainer.groups);
		                });
	        		}
	        		else {
	        			resolve(vmContainer.groups);
	        		}
	        	});
	        };
	        
	        this.formatGroupData = function(vmContainer, group, isUserGroup) {
	        	if ( isUserGroup ) {
	        		if ( group.isSystem ){
	        			vmContainer.groupsSystem.push(group);
	        		}
	        		else {
	        			vmContainer.groups.push(group);
	        		}
	        	} else {
	        		vmContainer.groupsVirtual.push(group);
	        	}
	        	
	        	vmContainer.objGroupsUsersMap[group.uid] = {};

	            var groupUserRows = [];
	            for(var i = 0; i < group.users.length; ++i) {
	                groupUserRows.push(cvicListService.contactRow(group.users[i]));
	                vmContainer.objGroupsUsersMap[group.uid][group.users[i].uid] = true;
	            }

	            vmContainer.groupsUsers[group.uid] = groupUserRows;        		
	        };
			
			var fnRequestAbout = function (service, userUid ) {
				return $q(function(resolve, reject) {
					cvicRequestService.fnGetJsonData( objPRIVATE_CONSTANTS_URLS.ABOUT_URL + userUid  )
					.then( function success(response) {
						service.objAboutResult = response.data;
						//alert("profile upd: " + cvicDateService.formatDate(new Date(service.objAboutResult.updated)) );
						resolve(service.objAboutResult);
					} );
				});
			};

			var fnRequestGrades = function (service, userUid) {
				return $q(function(resolve, reject) {
					if ( cvicJWTService.isCurrentUser(userUid) || service.isCurrentParentOf ) {					
						cvicRequestService.fnGetJsonData( objPRIVATE_CONSTANTS_URLS.GRADES_URL + userUid)
						.then( function success(response) {
							service.objGradesResult = fnGetGradesObject(response.data);
							resolve(service.objGradesResult);
						} );
					}
					else {
						resolve(service.objGradesResult);
					}
				});
			};
			
			var fnRequestFrequent = function (service, userUid ) {
				return $q(function(resolve, reject) {
					if ( cvicJWTService.isCurrentUser(userUid) || service.isCurrentParentOf ) {	
					   cvicRequestService.fnGetJsonData( objPRIVATE_CONSTANTS_URLS.FREQUENT_URL + userUid )
					    .then( 
	    					function unwrap( response ){ 
	    						try {
	    							return { data: response.data.elements };
	    						} catch (error){
	    							return { data: [] };
	    						}
	    					} 
	    				).then( function success(response) {						
	    					service.objFrequentResult = response.data;
	    					resolve(service.objFrequentResult);
						} );
					}
					else {
						resolve(service.objFrequentResult);
					}
				});
			};
			
			var fnParentList = function (service, userUid) { 
				return $q(function(resolve, reject) { 
					if ( (cvicJWTService.isCurrentUser(userUid) || service.isCurrentParentOf) ) {
						cvicRequestService.fnGetJsonData( objPRIVATE_CONSTANTS_URLS.OTHER_PARENTS_URL + userUid )
						.then( 
								function unwrap( response ){ 
									try {
		    							return { data: response.data.elements };
		    						} catch (error){
		    							return { data: [] };
		    						}
								} 
							)
						.then( function success(response) {
							service.objParentResult = response.data.filter( 
															function( c ) { return (c.uid != cvicJWTService.currentUserId()); 
														} ); 
							resolve(service.objParentResult);
						} );
					}
					else {
						resolve(service.objParentResult);
					}
				});
			};

			var fnChildrenList = function (service, userUid) { 
				return $q(function(resolve, reject) {
					if ( cvicJWTService.isCurrentUser(userUid)) {
						$rootScope.userDataRequest()
						.then( function( userInfo ) {
							try {
								if ( userInfo.children.length > 0 ) {
									return { data: userInfo.children };
								} else {
									return { data: [] };
								}
							} catch (error){
    							return { data: [] };
    						}
						} )
						.then( function success(response) {
							service.objChildrenResult = response.data;
							resolve(service.objChildrenResult);
						} );
					}
					else {
						resolve(service.objChildrenResult);
					}
				});
			};
			
			this.orderChild = function( event ) {
		       	 var service = this;	
		       	 $mdDialog.show({
	                 controller         : 'OrderChildController',
	                 controllerAs       : 'vm',
	                 templateUrl        : 'app/main/profile/dialogs/order-child/order-child.html',
	                 parent             : angular.element($document.body),
	                 targetEvent        : event,
	                 clickOutsideToClose: false 
	             })
	             .then(function () { 	            	 
	            	 
	             });
		    };
		}

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('cvicOptionsData', cvicOptionsData);

    /** @ngInject */
    function cvicOptionsData($q, cvicRequestService, ApiEndPoints, __env)
    {
        this.schools = [];

        this.schoolsRequest = function() { 
        	var service = this;
        	
        	if ( service.schools && service.schools.length > 0 ) {
        		return $q( function( resolve, reject ) { resolve( service.schools ); });
        	}  else {
        		return cvicRequestService.requestJsonData(
                        __env.apiUrl + '/common/orgs', 
                        'GET', 
                        function (response) {
                        	service.schools = response.data; 
                        	return service.schools;
                        },
                        function (response) {
                        	service.schools = [];
                        	return service.schools;
                        }
                    );        		
        	}
        };
        
        this.filter = function(orgType){
        	return this.schools.filter(function(org) {
        		return org.type == orgType;
        	});
        };
        
        this.getOrganizations = function(searchText, $scope) {
            $scope.removeErrors();

            var schoolsMatch = [];

            for(var i = 0; i <  $scope.organizations.length; ++i) {
                var school = $scope.organizations[i];

                if(school.title.toLowerCase().indexOf(searchText.toLowerCase()) !== -1) {
                    schoolsMatch.push(school);
                }
            }

            return schoolsMatch;
        };

        this.organizationErrorCheck = function(searchText, form, $scope) {
            var organization = $scope.vm.form.organization;

            if(!searchText || searchText.length == 0) {
                form.organization.$setValidity("real_orgranization", true);

                return;
            }

            if(!organization || !organization.uid) {
            	form.organization.$setValidity("real_orgranization", false);
            } else {
            	form.organization.$setValidity("real_orgranization", true);
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('cvicMessageService', cvicMessageService);

    /** @ngInject */
    function cvicMessageService($state, 
    		$mdDialog, 
    		$document, 
    		cvicListService, 
    		cvicRequestService, 
    		cvicJWTService, 
            __env,
            $sce)
    {	
    	this.currentThreadTmp = null;
        
        this.markAs = markAs;
        
        /**
         * Close thread
         */        	
        this.closeThread = function(vm) { 
        	if ( this.currentThreadTmp !== undefined && this.currentThreadTmp != null  ) {
	        	this.currentThreadTmp = null;	        
	        	close(vm);
        	}
        };//closeThread    
    	
        this.currentThread =  function (){
        	return this.currentThreadTmp;
		};//currentThread;
        
        /**
         * Open thread
         *
         * @param thread
         */
        this.openThread = function(vm, thread){
            // Assign thread as the current thread
            this.currentThreadTmp = thread;           
            
            if (!this.currentThreadTmp.read) {
            	markAs('read', true, this.currentThreadTmp);
            }
            
            if (vm.currentFilter.type == 'space' || vm.currentFilter.type == 'event' || vm.currentFilter.type == 'message' ) {
            	$state.go('app.mail.threads.thread', {threadId: thread.id}, 
            			{notify: false, location: false});
            }
            else { 
            	// Update the state without reloading the controller
            	$state.go('app.mail.threads.thread', {threadId: thread.id}, {notify: false});
            }
        };//openThread       

        this.canReply = function( thread ){
        	return thread.entity.owner.uid != cvicJWTService.currentUserId() 
        };
        
        this.deleteMsg = function(threads, vm) { 
        	var service = this;
        	
        	var vmThreads = vm.threads;
	    	var delThreadsUids = [];
	    	for ( i = 0; i < threads.length; i++ ){
	    		delThreadsUids.push(threads[i].uid);
	    	}
	    	
	    	cvicRequestService
	     	.requestJsonData(__env.apiUrl + '/m/delete', 'POST', successResponseData, failResponseData, delThreadsUids)
	     	.then(function(data) { //data: not deleted messages     			
	     			var newVmThreads = []; 
	     			for ( i = 0; i < vmThreads.length; i++ ){
	     				var uid = vmThreads[i].uid;
	     				if ( delThreadsUids.indexOf(uid) == -1 || data.indexOf(uid) > -1 ) {
	     					newVmThreads.push(vmThreads[i]);
	     				}
	     			} 
	     			
	     			if ( newVmThreads.length < vmThreads.length ){
	     				vm.threads = newVmThreads;
	     				vm.deselectThreads();
		     			if (threads.length == 1 && vm.currentThread() !== undefined && vm.currentThread() != null  ) {
		     				service.closeThread(vm);
		            	}
	     			}
	         });
        };
        
        this.printMail = function( thread ){
        	  var docHead = document.head.outerHTML;
        	  var printContents = angular.element(document.querySelector(".thread-detail")).html();
        	  var winAttr = "location=yes, statusbar=no, menubar=no, titlebar=no, toolbar=no,dependent=no, width=865, height=600, resizable=yes, screenX=200, screenY=200, personalbar=no, scrollbars=yes";

        	  var newWin = window.open("", "_blank", winAttr);
        	  var writeDoc = newWin.document;
        	  writeDoc.open();
        	  writeDoc.write('<!doctype html><html>' + docHead + '<body onLoad="window.print()" style="margin:30px;">' + printContents + '</body></html>');
        	  writeDoc.close();
        	  newWin.focus();
        };        

        /**
         * Open compose dialog
         *
         * @param ev
         * @param vm
         * @param dialogData : {
          		message: null,
                spaceUid: null,//space uid
                eventUid: null,//event uid
                rpTo:  [],//user audience
                fwTo:  false
           }
         */

        this.composeDialog = function(ev, vm, dialogData)
        {        
        	//alert(JSON.stringify(dialogData));        	
        	var queryParams = "";
        	if ( !(dialogData.spaceUid === undefined || dialogData.spaceUid == null)) { 
        		queryParams = "?spaceUid=" + dialogData.spaceUid;
        	}
        	if ( !(dialogData.eventUid === undefined || dialogData.eventUid == null)) { 
        		queryParams = "?eventUid=" + dialogData.eventUid;
        	}
        	        	
        	cvicRequestService
         	.requestJsonData(__env.apiUrl + '/m/templ' + queryParams, 'GET', successResponseData, failResponseData)
         	.then(function(templMessage) {
         		//alert("templ: " + JSON.stringify(data));         		
         		if ( !(dialogData.message === undefined || dialogData.message == null)) {  
         			templMessage.title = templMessage.subject = dialogData.message.title;
         			templMessage.description = templMessage.body = dialogData.message.description;
            	}
         		
         		dialogData.message = templMessage;
         		 
                $mdDialog.show({
                    controller         : 'ComposeDialogController',
                    controllerAs       : 'vm',
                    locals             : {dialogData: dialogData},
                    templateUrl        : 'app/main/mail/dialogs/compose/compose-dialog.html',
                    parent             : angular.element($document.body),
                    targetEvent        : ev,
                    clickOutsideToClose: false
                }).then(function (response)
                {
                	//alert(JSON.stringify(response.userAudience));                	
                	if (vm != null
                			&& vm.currentFilter 
                			&& (vm.currentFilter.type == 'space' || vm.currentFilter.type == 'event' || vm.currentFilter.filter == 'sent')) {
                			vm.threads.unshift(cvicListService.messageRow(response));
                	}
                });
         	});
        	
        	
        };
           		                 
        function failResponseData(response) {
        	 return {};
        } 
        
        function successResponseData(response) {
        	 return response.data;
        }
        
        function markAs( markAsKey, markValue, thread){ 
        	var message = thread.entity;  	
        	cvicRequestService
    	     	.requestJsonData(__env.apiUrl + '/m/' + markAsKey + '/' + markValue + "/" + message.uid, 'GET', successResponseData, failResponseData, {})
    	     	.then(function(data) { 	
    	     		if(!angular.equals(data, {})) {
        	        	// Set the read status on the thread
        	            thread[markAsKey] = markValue; 
        	            thread.entity = data;
    		        }
    	         });
        }//readMark 
        
        function close(vm){
        	if (vm.currentFilter.type == 'space' || vm.currentFilter.type == 'event' ) {
	            	// Update the state without reloading the controller
	            $state.go('app.mail.threads', {
	                type  : vm.currentFilter.type,
	                filter: vm.currentFilter.filter
	            }, {notify: false, location: false});
            }
            else { 
	            // Update the state without reloading the controller
	            $state.go('app.mail.threads', {
	                type  : vm.currentFilter.type,
	                filter: vm.currentFilter.filter
	            }, {notify: false});
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('cvicListService', cvicListService);

    /** @ngInject */
    function cvicListService(
    		$rootScope,
    		$filter, 
    		cvicDateService, 
    		cvicFileService,
    		cvicImageService,
    		cvicJWTService, 
    		__env 
    		)
    {
	      var service = {
	        		rows			: 	rows,
	        		eventRow		: 	eventRow,
	        		spaceRow 		: 	spaceRow,
	        		messageRow		:	messageRow,
	        		documentRow		:	documentRow,
	        		folderRow		:   folderRow,
	        		userRow			:	userRow,
	        		groupRow		:	groupRow,
	        		audience		: 	audience,
	        		userAudienceRow :   userAudienceRow,
	        		calendarEvent   :   calendarEvent,
	        		calendarEventToEvent: calendarEventToEvent,
	        		contactRow		: 	contactRow,
	        		contactFromUser : 	contactFromUser,
	        		contactFromGroup: 	contactFromGroup,
	        		recordingRow	:   recordingRow
	      };

          return service;

	      function rows(items,rowFunc ) {
	       	 	var rows = [];
	
	       	 	if( typeof items === 'undefined' || items === null ){
	       	 		return rows;
	       	 	}
	            for(i = 0; i < items.length; i++) { 
	                rows.push(rowFunc(items[i]));
	            }
	
	            return rows;
	      }
	      
	      function setRowSystem(row, item){
	    	  	row.entity = item;
	    	  	row.uid = row.entity.uid; 
	    	  	row.id = row.uid;
	      }
	      
	      function eventRow(event, publicEventButtons ) {
	    	  //TODO publicEventButtons = event is public || currentUser is in event audience
	    	  var row = {};
          	  setRowSystem(row, event);
	    	  
	    	  row.uid = event.uid;
              row.title = event.title;
              row.text = event.description;
 
              row.subtitle = cvicDateService.formatDate(new Date(event.startDate));

              row.media = {};
              row.media.image = {};
              row.media.image.alt = "";

              var eventPicture = event.coverImage;
              if(eventPicture != null) {
                  //row.media.image.src = __env.apiUrl + '/common/i/' + eventPicture['uid'] + '.jpg';
                  row.media.image.src = cvicImageService.fnGetResizedImageUrl( 
                  	cvicImageService.objCONSTANTS.EVENT_LIST_WIDTH, 
                  	cvicImageService.objCONSTANTS.EVENT_LIST_HEIGHT, 
                  	eventPicture['uid'] 
                  );
              } else {
                  row.media.image.src = 'assets/images/dummy/children.jpeg';
              }

              if(publicEventButtons) {
                  row.button1 = 'Attend';
                  row.button2 = 'Leave';
              } else {
                  if(event.settings != null) {
                      if(event.settings.virtual != null) {
                          row.button1 = event.settings.virtual;
                      }

                      if(event.settings.physical != null) {
                          row.button2 = event.settings.physical;
                      }
                  }
              }
              
              return row; 
	      }


	      function recordingRow(recording) {
      		  var row = {};
      	  	  setRowSystem(row, recording);

      	  	  row.uid = recording.uid;
      	  	  row.title = recording.title;
      	  	  row.text = $filter("date")(recording.inserted, "dd-MM-yyyy HH:mm");
      	  	  row.subtitle = $filter("date")(recording.inserted, "dd-MM-yyyy HH:mm");
      	  	  row.cta = "play";
      	  	  row.url = recording.playbackUrl;

      	  	  row.media = {};
      	  	  row.media.image = {};
      	  	  row.media.image.alt = "";
      	  	  row.media.playback = recording.playbackUrl;

      	  	  var recordingPicture = recording.image;
      	  	  if(recordingPicture != null) {
                  row.media.image.src = __env.apiUrl + '/common/i/' + recordingPicture['uid'] + '.jpg';
              } else {
                  row.media.image.src = 'assets/images/dummy/children.jpeg';
              }

              return row;
	      }
        
	      function spaceRow(space){
	    	  	var row = {};
            	setRowSystem(row, space);
	
	            row.uid = space.uid;
	            row.title = space.title;
	            row.subtitle = ( space.organization != null ? space.organization.title : "");
	            row.text = space.description;
	            //userAudience,accessType
	
	            row.media = {};
	            row.media.image = {};
	            row.media.image.alt = "";
	
	            var spacePicture = space.coverImage;
	            if(spacePicture != null) {
	           	 	//row.media.image.src = __env.apiUrl + '/common/i/' + spacePicture.uid + '.jpg';
	           	 	row.media.image.src = cvicImageService.fnGetResizedImageUrl( 
	                  	cvicImageService.objCONSTANTS.SPACE_LIST_WIDTH, 
	                  	cvicImageService.objCONSTANTS.SPACE_LIST_HEIGHT, 
	                  	spacePicture['uid'] 
                  	);
	            } else {
	                row.media.image.src = 'assets/images/dummy/classroom.jpg';
	            }
	            
	            return row;
	      }
       
	      function messageRow(message){
	      	   var row = {};
	      	   setRowSystem(row, message);
	      	   	      	  
	           row.uid = message.uid;

	           var fromUser = {};
	           for(var i = 0; i < message.userAudience.length; ++i) {
	           		if(message.userAudience[i].dateRequested) {
	           			fromUser = message.userAudience[i].user;
	           			break;
	           		}
	           }

	           if(angular.equals(fromUser, {})) {
	           		fromUser = message.owner;
	           }

	           row.from = {};
	           row.from.name = fromUser.title + " <" + fromUser.email + ">";
	           row.from.uid = fromUser.uid;
	           row.from.email = fromUser.email;
	           var ownerPicture = fromUser.coverImage;
	           if(ownerPicture != null) {
	        	   row.from.avatar = __env.apiUrl + '/common/i/' + ownerPicture.uid + '.jpg';
	           }

	           row["Accept"] = false;
               row["Reject"] = false;

	           if(message.actions.length > 0) {
	           		for(var j = 0; j < message.actions.length; ++j) {
                        row[message.actions[j]] = true;
                    }
	           }
	           
	           row.subject = $("<div>").html(message.title).text();
	           row.message = $("<div>").html(message.description).text();
	           
	           row.time = ( message.inserted != null 
	        		   			? cvicDateService.formatDate(new Date(message.inserted))
	        		   			: cvicDateService.formatDate(new Date()) );
	           
	           var userAudience;
	           row.to = [];
	           row.listTo = [];
	           for (var i = 0; i < message.userAudience.length; i++) {
	        	   if (message.userAudience[i].user.uid == cvicJWTService.currentUserId()) {
	        		   userAudience = message.userAudience[i];
	        	   }
	        	   if (message.userAudience[i].dateInvited != null ) {
	    	           var to = {
		        			   name: message.userAudience[i].user.title,
		        			   email: message.userAudience[i].user.email 
		        		   };
	    	           
	        		   var ownerPicture = message.userAudience[i].user.coverImage;
	    	           if(ownerPicture != null) {
	    	        	   to.avatar = __env.apiUrl + '/common/i/' + ownerPicture.uid + '.jpg';
	    	        	   to.image = __env.apiUrl + '/common/i/' + ownerPicture.uid + '.jpg';
	    	           }
	        		   
	        		   row.to.push(to); 
		        	   row.listTo.push(message.userAudience[i].user.title);
	        	   }
	           }
	           if (typeof message.container !== "undefined" && message.container != null) {
	        	   row.to.push({
        			   name: message.container.title 
        		   });
	        	   row.listTo.push(message.container.title);
	           }
	           row.read = userAudience && userAudience.dateAccepted != null; 	           
	           row.starred = userAudience && userAudience.settings && userAudience.settings.starred == true; 
	           row.important = userAudience && userAudience.settings && userAudience.settings.important == true;
	           row.hasAttachments = false;  
	           if (userAudience && userAudience.settings && userAudience.settings.labels) {
	        	   row.labels = userAudience.settings.labels;
	           }
	           
	           return row;
	      }
       
	      function documentRow(document){
	    	   var row = {};
           	   setRowSystem(row, document);
           	   	      	  
	           row.name = document.title;
	           row.description = document.description;
	           row.type = document.simpleType; 
	           row.icontype = cvicImageService.iconType(document.simpleType);	        	            
	           row.owner = document.owner.uid;
	           row.size = cvicFileService.formatFileSize(document.size); 
	           row.modified = cvicDateService.formatDate(new Date(document.updated));
	           if(document.settings && !angular.equals(document.settings, {}) && document.settings.tags) {
	        	   row.tags = document.settings.tags;
	           }
	         
	           row.repo = document.repository;
	           var coverImage = document.coverImage;
	           if(coverImage != null) {
	        	   row.preview = __env.apiUrl + '/common/i/' + coverImage.uid + '.jpg';
	           }
	           
	           return row;
	      }
	      
	      function folderRow(folder){
	    	   var row = {};
           	   setRowSystem(row, folder);
	      	  
	           row.name = folder.title; 
	           row.owner = folder.owner.uid; 
	           row.type = "folder";
	           
	           return row;
	      }
	      
	      function audience(users, groups){
	    	  var rows = [];
	    		
	    	  //date_requested timestamp 
	    	  //date_invited timestamp
	    	  //date_accepted timestamp 
	    	  //date_rejected timestamp 
	    	  if( typeof users === 'undefined' || users === null ){	 
	    	  } else {
	    		  //console.log(JSON.stringify(users));
		          for(i = 0; i < users.length; i++) { 
		        	  	rows.push(userAudienceRow(users[i]));
		          }
		          //console.log(JSON.stringify(rows));
	    	  }
	          
	    	  if( typeof groups === 'undefined' || groups === null ){	 
	    	  } else {
	    		//console.log(JSON.stringify(groups));
		    	for(i = 0; i < groups.length; i++) { 	    		
	                rows.push(groupRow(groups[i]));
		    	}
		    	//console.log(JSON.stringify(rows));
	    	  }
	
	          return rows;
	      }
	      
	      function userAudienceRow(userAudience){
	    	  	var row = userRow(userAudience.user);		            	
	      	  	if (userAudience.dateRequested != null) {
	      	  		row.dateRequested = cvicDateService.formatDate(new Date(userAudience.dateRequested));
	      	  	}
	      	  	if (userAudience.dateInvited != null) {
	      	  		row.dateInvited = cvicDateService.formatDate(new Date(userAudience.dateInvited));
	      	  	}
	      	  	if (userAudience.dateAccepted != null) {
	      	  		row.dateAccepted = cvicDateService.formatDate(new Date(userAudience.dateAccepted));
	      	  	}
	      	  	if (userAudience.dateRejected != null) {
	      	  		row.dateRejected = cvicDateService.formatDate(new Date(userAudience.dateRejected));
	      	  	}

	      	  	row.baseObj = userAudience;  
	      	  	
	      	  	return row;
	      }
      
	      function userRow(user){
	    	  	var row = {};
	    	  	setRowSystem(row, user);
	      
	    	  	row.name = user.title;
	    	  	row.email = user.email;
	    	  	row.company = ( user.organization != null ? user.organization.title : "");
	    	  	row.description = user.description;
	    	  	row.type = "user";
	    	  
	    	  	row.avatar = "";
	            var userPicture = user.coverImage;
	            if(userPicture != null) {
	       	 		row.avatar = __env.apiUrl + '/common/i/' + userPicture.uid + '.jpg';
	            } else {
	            	row.avatar = "assets/images/avatars/profile.jpg";
	            }
	    	  
	            return row;
	      }
	      
	      function groupRow(group){
	    	  var row = {};
	    	  setRowSystem(row, group);
		      
	    	  row.name = group.title; 
	    	  row.description = group.description;
	    	  row.type = "group";
	    	  
	    	  return row;
		  }

		  function contactFromGroup(group) {
		  	var contact = {
		        uid: group.uid,		
		        name: group.title,
		        email: '(' + group.users.length + ')',
		        image: 'assets/images/avatars/group.svg.png',
		        size: group.users.length,
		        isGroup: true
			};
			 contact._lowername = contact.name.toLowerCase();

			 return contact;
		  }

		  function contactFromUser(user) {
	  	  	 var contact = {
		          uid: user.uid,		
		          name: user.title,
		          email: user.email,
		          contact_info: "<" + user.email + ">" + (user.organization != null && user.organization.title.length > 0 ? ", " + user.organization.title : ""),
		          size: 1,
		          isGroup: false
		     };
		     if (user.coverImage != null ) {
		    	 contact.image =  __env.apiUrl + '/common/i/' + user.coverImage.uid + '.jpg';
		     }
		     contact._lowername = contact.name.toLowerCase();

	  	  	return contact;

		  }

		  function calendarEvent(event) {
            var calendarEvent = {};

            calendarEvent.id = i;
            calendarEvent.title = event.title;
            calendarEvent.description = event.description;

            calendarEvent.start = moment(new Date(event.startDate));

            if(event.endDate != null) {
                calendarEvent.end = moment(new Date(event.endDate));
            } else {
                calendarEvent.end = null;
            }

            calendarEvent.accessType = event.accessType;
            calendarEvent.eventType = event.eventType;

            var settings = event.settings;
            if(settings != null && !angular.equals(settings, {})) {
                if(settings['address'] != null) {
                    calendarEvent.address = settings['address'];
                }

                if(settings['place'] != null) {
                    calendarEvent.place = settings['place'];
                }

                if(settings['summary'] != null) {
                    calendarEvent.summary = settings['summary'];
                    calendarEvent.joinMessage = settings['summary'];
                }

                if(settings['conference'] != null) {
                    calendarEvent.conference = settings['conference'];
                }
            }

            if(calendarEvent.eventType === 'conference' || calendarEvent.eventType === 'consultation') {
                if(settings['conferenceType'] != null) {
                    calendarEvent.conferenceType = settings['conferenceType'];
                }

                if(settings['adminPassword'] != null) {
                    calendarEvent.adminPassword = settings['adminPassword'];
                }

                if(settings['joinPassword'] != null) {
                    calendarEvent.joinPassword = settings['joinPassword'];
                }

                if(settings['sharesAudio'] != null) {
                    calendarEvent.sharesAudio = settings['sharesAudio'];
                }

                if(settings['sharesVideo'] != null) {
                    calendarEvent.sharesVideo = settings['sharesVideo'];
                }

                if(settings['automaticAudio'] != null) {
                    calendarEvent.automaticAudio = settings['automaticAudio'];
                }

                if(settings['automaticVideo'] != null) {
                    calendarEvent.automaticVideo = settings['automaticVideo'];
                }
                
            }

            event['@class'] = "com.tetracom.cvic.model.event.Event";

            calendarEvent.coverImage = event.coverImage;

            calendarEvent.baseObj = event;

            return calendarEvent;
        }

        function calendarEventToEvent(calendarEvent, event) {
            event.title = calendarEvent.title;
            event.description = calendarEvent.description;
            event.startDate = calendarEvent.start;
            event.endDate = calendarEvent.end;
            event.accessType = calendarEvent.accessType;
            event.eventType = calendarEvent.eventType;

            if(event.settings == null) {
            	event.settings = {};
            }

            if(calendarEvent.address != undefined) {
                event.settings.address = calendarEvent.address;
            }

            if( calendarEvent.place != undefined) {
                 event.settings.place = calendarEvent.place;
            }

            if(calendarEvent.summary != undefined) {
                 event.settings.summary = calendarEvent.summary;
                 event.settings.joinMessage = calendarEvent.summary;
            }

            if(calendarEvent.conference != undefined) {
                 event.settings.conference = calendarEvent.conference;
            }

            if(calendarEvent.conferenceType != undefined) {
                event.settings.conferenceType = calendarEvent.conferenceType;
            }

            if(calendarEvent.joinMessage != undefined) {
                event.settings.joinMessage = calendarEvent.joinMessage;
            }

            if(calendarEvent.adminPassword != undefined) {
                event.settings.adminPassword = calendarEvent.adminPassword;
            }

            if(calendarEvent.joinPassword != undefined) {
                event.settings.joinPassword = calendarEvent.joinPassword;
            }

            if(calendarEvent.sharesAudio != undefined) {
                event.settings.sharesAudio = calendarEvent.sharesAudio;
            }

            if(calendarEvent.sharesVideo != undefined) {
                event.settings.sharesVideo = calendarEvent.sharesVideo;
            }
            
            if(calendarEvent.automaticAudio != undefined) {
                event.settings.automaticAudio = calendarEvent.automaticAudio;
            }

            if(calendarEvent.automaticVideo != undefined) {
                event.settings.automaticVideo = calendarEvent.automaticVideo;
            }

            event.coverImage = calendarEvent.coverImage;
            
        }

        function contactRow(contact) {
        	var row = {};
	    	setRowSystem(row, contact);
	    	  
        	var imageUrl = null;

        	if(contact.coverImage) {
        		imageUrl = __env.apiUrl + '/common/i/' + contact.coverImage.uid + '.jpg';
        	} else {
        		imageUrl = 'assets/images/avatars/profile.jpg';
        	}

        	row.name = contact.title;
        	row.avatar = imageUrl;
        	row.email = contact.email;

            if(contact.isSystem) {
            	row.isSystem = true;
            } else {
            	row.isSystem = false;
            }

            return row;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('cvicJWTService', cvicJWTService);

    /** @ngInject */
    function cvicJWTService(jwtHelper)
    {
        var service = {
        		alertTokenJson			 :		alertTokenJson,
        		currentUserId			 : 		currentUserId,
        		isCurrentUser			 :  	isCurrentUser,	
        		currentUserOrgName 		 : 		currentUserOrgName,
        		currentUserOrgUid 		 : 		currentUserOrgUid,
        		currentUserOrgType		 :		currentUserOrgType,
        		currentUserIsFromMoodle		 :		currentUserIsFromMoodle,
        		currentUserIsFromExternalSchool : currentUserIsFromExternalSchool,
        		canAccessExternalRepos	 :		canAccessExternalRepos,
        		canDelete				 :		canDelete,
        		canManage				 :		canManage,
        		externalOrganizations	 :		externalOrganizations,
                jwt                      :      jwt, 
        		isOwner					 :		isOwner,
        		isOwnerOfContainer		 :		isOwnerOfContainer,
                maxConferenceDuration    :      maxConferenceDuration,
                maxLimitedFileStorage	 : 		maxLimitedFileStorage,
                maxSpacesLimit           :      maxSpacesLimit,
                maxEventDuration         :      maxEventDuration,
                maxLimitedFileUploadSize :		maxLimitedFileUploadSize,
                currentUserAudience		 :      currentUserAudience,
                maxConferenceParticipants:      maxConferenceParticipants,
                hasFeature				 :		hasFeature,
                maxEventsLimit           :      maxEventsLimit
        };

        return service;

        function hasFeature( f ) {
        	return decodeToken()[f] !== undefined;
        }
        
        function currentUserId() {
             return decodeToken()['user_id'];
        }
        
        function isCurrentUser(userId){
        	return currentUserId() == userId;
        }

        function maxSpacesLimit() {
            return  decodeToken()['LimitedLearningSpaces_max'];
        }

        function maxEventDuration() {
            return decodeToken()['LimitedEventDurationInMinutes_max'];
        }

        function maxEventsLimit() {
            return decodeToken()['LimitedEvents_max'];
        }
        
        function maxLimitedFileUploadSize() {
            return decodeToken().LimitedFileUploadSize_max*1048576;
        }
        
        function maxLimitedFileStorage() { 
        	return decodeToken().LimitedFileStorage_max*1048576;
        }
        
        function currentUserOrgName() {
            return decodeToken()['user_org_name'];
        }
        
        function currentUserOrgUid() {
            return decodeToken()['user_org_uid'];
        }
        
        function currentUserOrgType() {
            return decodeToken()['user_org_type'];
        }
        
        function currentUserIsFromMoodle(){
        	return currentUserOrgType() != undefined 
        			&& currentUserOrgType() != null
        			&& currentUserOrgType() == 'moodle';
        }
        
        function currentUserIsFromExternalSchool(){
        	return currentUserOrgType() != undefined 
        			&& currentUserOrgType() != null
        			&& currentUserOrgType() == 'external';
        }
        
        function canAccessExternalRepos(){
        	return decodeToken().AccessExternalRepos;
        }

        function maxConferenceDuration() {
            return decodeToken()['LimitedConferenceByDuration_max'];
        }

        function maxConferenceParticipants() {
            return decodeToken()['LimitedConferenceByParticipants_max'];
        }
        
        function isOwner(item){ 
        	return item.owner.uid == currentUserId() 
        			//user portfolio
        			|| item.uid == currentUserId();
        }
        
        function isOwnerOfContainer(item){
        	return item.container != null 
        			&& ( item.container.owner.uid == currentUserId()
        					//user portfolio
        					|| item.container.uid == currentUserId()
        			);
        }
        
        function canManage(item){
        	 if ( item.userAudience !== undefined && item.userAudience != null ) {
	        	 for (var i = 0; i < item.userAudience.length; i++) {
		        	   if (item.userAudience[i].user.uid == currentUserId()) {
		        		   return item.userAudience[i].canManage;
		        	   }
	        	 }
        	 }
        	 
        	 return false;
        }
                
        function canDelete(item, container){        	
        	return (isOwner(item)
        			 || (container != null && (isOwner(container) || canManage(container) ) ));
        }
        
        function externalOrganizations(){
    		var externalOrgsArr = [];
    		 
        	if (typeof decodeToken()['external_orgs'] !== "undefined") {
        		var externalOrgs = decodeToken()['external_orgs'];
        		 
        		for (var i = 0; i < externalOrgs.length; i++) {
        			var org = externalOrgs[i].split("|");
        			externalOrgsArr.push({
        				uid: org[0],
        				title: org[1]	
        			});
        		}
        	}
        	 
    		return externalOrgsArr;
        } 
        
        function alertTokenJson(){            
        	alert(JSON.stringify(decodeToken()));
        }
        
        function jwt(){
        	return localStorage.getItem('id_token');
        }
        
        function decodeToken(){
        	return jwtHelper.decodeToken(jwt());
        }
                
        function currentUserAudience(audienceItem){
        	var userAudience = null;
        	
        	if ( audienceItem.userAudience !== undefined && audienceItem.userAudience != null ) {
	            for(var i = 0; i < audienceItem.userAudience.length; ++i) {
	                if(audienceItem.userAudience[i].user.uid == currentUserId()) {
	                    userAudience = audienceItem.userAudience[i];
	                    break;
	                }
	            }
        	}
            
            return userAudience;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('cvicImageService', cvicImageService);
    
     
    /** @ngInject */
    function cvicImageService(ApiEndPoints, __env, cvicRequestService) {


            this.objCONSTANTS = {

                EVENT_LIST_WIDTH            : 372,
                EVENT_LIST_HEIGHT           : 126,
                SPACE_LIST_WIDTH            : 372,
                SPACE_LIST_HEIGHT           : 126,
                PROFILE_HEIGHT              : 96,
                PROFILE_WIDTH               : 96,
                PROFILE_FREQUENT_HEIGHT     : 81,
                PROFILE_FREQUENT_WIDTH      : 81

            };

            /**
             * Gets the template from the API
             */
            this.getTemplate = function () {

                var strUrl = __env.apiUrl + ApiEndPoints.ImageController.getTemplate;

                return cvicRequestService.fnGetJsonData( strUrl ).then( function success(response) { 
                    return response.data; 
                }, function fail(response) { 
                    //TODO add some kind of error handling?
                    return response.data;
                } );

            }; 

            this.arrayBufferToBase64 = function(buffer) {
                var binary = '';
                var bytes = new Uint8Array(buffer);
                var len = bytes.byteLength;

                for (var i = 0; i < len; i += 1) {
                  binary += String.fromCharCode(bytes[i]);
                }
                return window.btoa(binary);
            };

            this.fnGetResizedImageUrl = function (intWidth, intHeight, strUid) {
                var strBase = __env.apiUrl + ApiEndPoints.ImageController.getImage;

                var strResult = strBase + intWidth + '/' + intHeight + '/' + strUid + '.jpg';

                return strResult;
            };

            this.iconType = function (fileSimpleType) {
 	           if (fileSimpleType == "image"){
 	        	   return "file-image-box";
 	           }
 	           if (fileSimpleType == "video"){
 	        	   return "video";
 	           }
 	           if (fileSimpleType == "audio"){
 	        	   return "music-box";
 	           }
 	           if (fileSimpleType == "html"){
 	        	   return "language-html5";
 	           }
 	           if (fileSimpleType == "xml"){
 	        	   return "file-xml";
 	           }
 	           if (fileSimpleType == "text"){
 	        	   return "file-document-box";
 	           }
 	           if (fileSimpleType == "zip"){
 	        	   return "zip-box";
 	           }
 	           if (fileSimpleType == "pdf"){
 	        	   return "file-pdf-box";
 	           }
 	           if (fileSimpleType == "spreadsheet"){
 	        	   return "file-spreadsheet";
 	           }
 	           if (fileSimpleType == "document"){
 	        	   return "document";
 	           }
 	           if (fileSimpleType == "presentation"){
 	        	   return "presentation";
 	           }
 	           if (fileSimpleType == 'flash') {
 	        	   return "video";
 	           }

 	           return "file-outline";
            };

        } 

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('cvicFormService', cvicFormService);

    /** @ngInject */
    function cvicFormService($document, $mdDialog)
    {
        var service = {
        		handleDmDialogResponse: handleDmDialogResponse,
                showEventRequestError: showEventRequestError,
                showEventFormDialog: showEventFormDialog,
                showEventDetailDialog: showEventDetailDialog,
                showErrorDialog: showErrorDialog
        };

        return service;

        function handleDmDialogResponse(response, handleAdd, handleEdit, handleRemove) {
            switch ( response.type ) {
                case 'add':
                    // Add new
                	handleAdd(response);

                    break;

                case 'edit':
                    // Edit
                	handleEdit(response);

                    break;

                case 'remove':
                    // Remove
                	handleRemove(response);

                    break;
            }
        }

        function showEventRequestError(errorType) {
            $mdDialog.show({
                controller         : 'EventCalendarErrorController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/eventsconferences/dialogs/event-submit-error/event-submit-error.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false,
                locals             : {
                    errorType: errorType
                }
            });
        }

        function showErrorDialog(errorType) {
            $mdDialog.show({
                controller         : 'ErrorDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/core/errors/error-message/error-message.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
                locals             : {
                    errorType: errorType
                }
            });
        }

        function showEventFormDialog(settings) {

            var dialogData = {
                type         : settings.type,
                calendarEvent: settings.calendarEvent,
                start        : settings.start,
                end          : settings.end,
                accessTypes  : settings.accessTypes,
                eventTypes   : settings.eventTypes,
                conferenceTypes: settings.conferenceTypes
            };

            $mdDialog.show({
                controller         : 'EventFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/eventsconferences/dialogs/event-form/event-form-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : settings.targetEvent,
                clickOutsideToClose: false,
                locals             : {
                    dialogData: dialogData
                }
            }).then(function (response)
            {
                handleDmDialogResponse(response, settings.handleAddEvent, settings.handleEditEvent, settings.handleRemoveEvent);
            });
        }

        function showEventDetailDialog(calendarEvent, showEventFormDialog, e)
        {
            $mdDialog.show({
                controller         : 'EventDetailDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/eventsconferences/dialogs/event-detail/event-detail-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    calendarEvent      : calendarEvent,
                    showEventFormDialog: showEventFormDialog,
                    event              : e
                }
            });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('cvicFileService', cvicFileService);

    /** @ngInject */
    function cvicFileService()
    {
	      var service = {
	    		  formatFileSize: 	formatFileSize
	      };

          return service;

         function formatFileSize(bytes) {  
              if ( bytes < 1024 )
              {
                 return parseFloat(bytes).toFixed(2) + ' B';
              }
              else if ( bytes >= 1024 && bytes < 1048576 )
              {
            	  return parseFloat(bytes / 1024).toFixed(2) + ' KB';
              }
              else if ( bytes >= 1048576 && bytes < 1073741824 )
              {
            	  return parseFloat(bytes / (1024 * 1024)).toFixed(2) + ' MB';
              }
              else
              {
            	  return parseFloat(bytes / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
              }
              
              return (bytes / 1024).toFixed(2) + ' KB';
              
          };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('cvicEventService', cvicEventService);

    /** @ngInject */
    function cvicEventService(cvicJWTService, cvicFormService)
    {
	    var service = {
	    	filterVisibleTypes: filterVisibleTypes,
            hasEventExpired: hasEventExpired,
            allowEditEvent: allowEditEvent,
            allowDeleteEvent: allowDeleteEvent,
            checkEventLimits: checkEventLimits
	    };

        return service;

        function filterVisibleTypes(eventTypes) {
        	return eventTypes.filter(function(eventType) {
        		return eventType.show;
        	});
        }

        function hasEventExpired(event, now) {
        	if (now) {
        		return event.endDate < now;
        	} 
        	else {
        		return event.endDate < Date.now();
        	}
        }
        
        function allowEditEvent(event, now) {     
            return (cvicJWTService.isOwner(event) || cvicJWTService.canManage(event)) 
            		&& (!event.organization || event.organization.type != 'moodle' ); 
        }
        
        function allowDeleteEvent(event) {
            return (cvicJWTService.isOwner(event) || cvicJWTService.canManage(event)) 
            			&& (!event.organization || event.organization.type != 'moodle' );
        }

        function checkEventLimits(eventsSize) {
            var  eventsLimit = cvicJWTService.maxEventsLimit();

            if(eventsSize < eventsLimit) {
                return true;
            } else {
                cvicFormService.showErrorDialog('EVENT_LIMIT');

                return false;
            }
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('cvicDocumentService', cvicDocumentService);

    //https://stackoverflow.com/questions/18614695/sort-or-rearrange-rows-of-a-table-in-angularjs-drag-and-drop
    
    /** @ngInject */
    function cvicDocumentService(
    		$q,
    		$rootScope,
    		$state, 
    		$translate,
    		$mdSidenav,
    		$mdDialog,
    		$document,
    		$window,
    		uuid, 
    		cvicFileService,
    		cvicImageService,
    		cvicListService, 
    		cvicRequestService,
    		cvicDateService,
            cvicEventService,
    		cvicJWTService,
    		__env,
            ApiEndPoints
            )
    {	 
    	this.currentRepo = null;
    	this.containerVm = null; 
    	this.initPathUrl = null;
    	this.lastPathUrl = null;
    	this.pathTmp = []; 
    	this.selectedTmp = null; 
    	this.selectedPlayerTmp = null;
    	this.foldersTmp = [];
    	this.filesTmp = []; 
    	this.folderCache = [];
    	this.repoLinkPrefix;
        this.mixedReposList = false;
        this.sortableOptions = {sort : false};  
        this.newOrder = false;
        this.externalService = null;
        this.loading = false;
        this.newPageLoading = false;
        this.fileAndFolderVMLimit = 50;
        this.fileAndFolderShortVMLimit = 30;
                
        this.diskSpace = 0;
        this.trashDiskSpace = 0;

        this.newPaging = function(){
        	var service = this;
        	
        	return {
        		pageSize		: 10,
        		currentPage		: 0,
        		total			: 0,
        		pages			: function () {
                	if (this.total == null) return 0;
                	
                    return Math.ceil( this.total / this.pageSize );
                },
        		startPosition	: function(){
        			if (this.total == 0) return 0;
            		
                    var pos = this.currentPage * this.pageSize + 1;

                    if ( pos > this.total ) {
                        return this.total;
                    }

                    return pos;
        		},
        		endPosition		: function(){
        			if (this.total == 0) return 0;
                	
                    var pos = (this.currentPage + 1) * this.pageSize;

                    if ( pos > this.total ) {
                        return this.total;
                    }

                    return pos;
        		},
        		previousPage	: function(){
        			 var newPage = this.currentPage - 1;

                     if ( newPage > -1 ) {
                     	this.changePage(newPage);
                     }
        		},
        		nextPage		: function(){
        			var newPage = this.currentPage + 1;

                    if ( newPage + 1 <= this.pages()  ) {
                    	this.changePage(newPage);
                    }
        		},
        		pagesNumbersArray 	: function(){
        			return new Array(this.pages())
        		},
        		showPage 		: function(index){
        			
        			if( index == this.currentPage 
        				|| (index > this.currentPage && index - this.currentPage <= 3 ) 
        				|| (index < this.currentPage && this.currentPage - index <= 3 )  ) {
                        return true;
                    }

                    return false;
        		},
        		changePage 		: function(index){ 
        			if ( index + 1 <= this.pages() && index > -1 ) { 
	                    var loadPath = service.lastPathUrl;
	                    if (loadPath.indexOf("currentPage") < 0 ) {
	                    	loadPath = loadPath + "?pageSize=" + this.pageSize + "&currentPage=" + index;
	                    }
	                    else {
	                    	loadPath = loadPath.replace("currentPage=" + this.currentPage, "currentPage=" + index);
	                    }
	                    this.currentPage = index;
	                    service.newPageLoading = true;
	                    service.loadFromCache(loadPath);
                	}
        		}       		
        	};
        };//newPaging 
        this.paging = this.newPaging();
        
        /**
         * repo
         * { 
            "name": "local or orgUid",
            "label": local or org name
            "readOnly": false,
            "visible":
        }
         */        	
        this.repo = function(repoLinkPrefix, containerVm) {  
        	this.repoLinkPrefix = repoLinkPrefix;
        	this.containerVm = containerVm; 
        	this.externalService = null;
        	
        	this.mixedReposList = (containerVm != null);
        	        	
            if ( this.canReorderFiles()) { 
            	 var service = this;	
            	 this.sortableOptions =  {  handle       : '.handle',
					  		                forceFallback : true,
					  		                ghostClass    : 'item-placeholder',
					  		                fallbackClass : 'item-ghost',
					  		                fallbackOnBody: true,
					  		                sort          : true,
					  		                onSort        : function () {
					  		                	service.newOrder = true;
						  		            }
					  		             };
          	}  
        	 
            //map repo to org
        	var userRepos = [];
        	//local repo
        	userRepos.push({
        		name: "local", 
        		label: $translate.instant("FM.REPOS.local"),
        		readOnly: false,
        		visible: true
        	});
        	
        	if ( cvicJWTService.currentUserIsFromMoodle()){
        		userRepos.push({
            		name: cvicJWTService.currentUserOrgUid(),
            		label: cvicJWTService.currentUserOrgName(),
            		readOnly: true,
            		visible: true        		
            	});
        	}
        	
        	//external  
        	if (cvicJWTService.canAccessExternalRepos()) {
        		var externalOrgs = cvicJWTService.externalOrganizations().sort( function( a, b ) { 
            		if (a.title < b.title) { return -1; }
            		if (a.title > b.title) { return 1; }
            		return 0; 
            	} );
            	 
        		for (var i = 0; i < externalOrgs.length; i++) {
        			userRepos.push({
                		name: externalOrgs[i].uid,
                		label: externalOrgs[i].title,
                		readOnly: true,
                		visible: true          		
                	});
        		}
        	} 
        	
        	this.initOccupiedDiskSpaceData();
    		
        	return userRepos;
        };//repo  
        
        this.searchInit = function(externalService) { 
        	this.mixedReposList = true;
        	this.filesTmp = []; 
        	this.externalService = externalService;
        	for ( i = 0; i < this.externalService.resultElement().length; i++ ){
 				if (this.isDocument(this.externalService.resultElement()[i])){
 					this.filesTmp.push(cvicListService.documentRow(this.externalService.resultElement()[i]));
 				}
 			}
        	this.initOccupiedDiskSpaceData();
        };
        
        this.initOccupiedDiskSpaceData = function() {
        	var currentUserId = cvicJWTService.currentUserId();
        	var service = this;
        	
        	cvicRequestService
            .requestJsonData(__env.apiUrl + ApiEndPoints.UserController.userAggregationData + currentUserId, 'GET', successResponseData, failObjectResponseData)
            .then(function(data) { 
            	service.diskSpace = data.diskSpace;
            	service.trashDiskSpace = data.trashDiskSpace;
            });        	
        };
        
        this.selectRepo = function( repo, clean ) { 
        	this.currentRepo = repo;
        	this.externalService = null;
        	this.paging = this.newPaging();
        	
        	this.initPathUrl = this.repoLinkPrefix + (this.mixedReposList ? "" : repo.name ); 
        	if ( this.initPathUrl.lastIndexOf("/") != this.initPathUrl.length - 1 && this.itemContainer() != null) {
        		this.initPathUrl += "/";
        	}
        	this.initPathUrl += (this.itemContainer() != null ? this.itemContainer().uid : "")
        						+ "?pageSize=" + this.paging.pageSize + "&currentPage=" + this.paging.currentPage;
        	
        	this.lastPathUrl = null;
        	this.pathTmp = []; 
        	this.selectedTmp = null;
        	this.cleanSelectedPlayer();
        	 
        	this.foldersTmp = [];
        	this.filesTmp = [];  
        	
        	if ( clean ) {
        		this.folderCache = [];
        	}  
        	
        	this.loadFromCache(this.initPathUrl);
        };
        
        this.isMixedReposList =  function() {
        	return this.mixedReposList;
        };
        
        this.itemContainer =  function() {
        	return (this.containerVm != null ? this.containerVm.container() : null);
        };
        
        this.setItemContainer =  function( container ) {
        	if ( this.containerVm != null ) {
        		this.containerVm.updateContainer(container);
        	}
        };
        
        this.folders = function() { 
        	return this.foldersTmp;
        };
                
        this.pushFile = function(uploadingFile, onTop){
        	if (onTop) {
        		this.filesTmp.unshift(uploadingFile);
        	} else {
        		this.filesTmp.push(uploadingFile);
        	}
        	return this.filesTmp;
        }
        
        this.path = function(){ 
        	return this.pathTmp;
        };
        
        this.selected = function(){ 
        	return this.selectedTmp;
        }; 
        
        this.selectedFolder = function(){ 
        	return this.pathTmp.length > 0 ? this.pathTmp[this.pathTmp.length - 1].entity : null;
        }; 
        
        this.selectedPlayer = function(){ 
        	return this.selectedPlayerTmp;
        }; 
        
        this.cleanSelectedPlayer = function(){ 
        	this.selectedPlayerTmp = null;
        	try {
        		angular.element(document.querySelector('#player')).html("");
        	} catch (e){}
        }; 
        
        this.loadFromServer = function(loadPath){       	 
        	var service = this;
        	if (this.initPathUrl == null) {
        		this.initPathUrl = loadPath;
        	} 
        	this.loading = true;
        	        	
        	cvicRequestService
            .requestJsonData(loadPath, 'GET', successResponseData, failResponseData)
            .then(function(data) { 
            	var pagingNew = service.newPaging();
            	if (typeof data.files !== "undefined") {
            		service.filesTmp = cvicListService.rows(data.files.elements, cvicListService.documentRow);
            		pagingNew.total = data.files.total;
            		pagingNew.currentPage = service.paging.currentPage;
            		
            		service.paging.total = pagingNew.total;
            	}
            	if (typeof data.elements !== "undefined") {
            		service.filesTmp = cvicListService.rows(data.elements, cvicListService.documentRow); 
            	}
            	if (typeof data.folders !== "undefined") {
            		service.foldersTmp = cvicListService.rows(data.folders.elements, cvicListService.folderRow);
            	}

            	service.folderCache.push({
       			  	path: loadPath,
       			  	files: service.filesTmp,
       			  	folders: service.foldersTmp,
       			  	paging: pagingNew 
       		  	});
            	
            	service.loading = false;
            	service.newPageLoading = false;
            });
        }; 
        
        this.loadFromCache = function(loadPath){         	
	        this.foldersTmp = []; 
	    	this.filesTmp = [];
	    	this.lastPathUrl = loadPath;
	    	 
	    	var loadFromServer = true;
	    	this.loading = true;
	    	for (var i = 0; i < this.folderCache.length; i++) {
	    		if (this.folderCache[i].path == loadPath) {
	    			loadFromServer = false;
	    			this.foldersTmp = this.folderCache[i].folders;
	    	    	this.filesTmp = this.folderCache[i].files;
	    	    	
	    	    	var pagingNew = this.newPaging();
	    	    	pagingNew.total = this.folderCache[i].paging.total;
            		pagingNew.currentPage = this.folderCache[i].paging.currentPage;	    	    	
	    	    	this.paging = pagingNew;
	    	    	
	    			break;
	    		}
	    	}
	    	
	    	if (loadFromServer) {
	    		this.loadFromServer(loadPath);
	    	}
	    	else {
	    		this.loading = false;
	    		this.newPageLoading = false;
	    	}
        };
        
        this.cleanPathFromCache = function(loadPath){   
        	var newFolderCache = []; 
        	
 			for ( i = 0; i < this.folderCache.length; i++ ){ 
 				if ( this.folderCache[i].path != loadPath ) {
 					newFolderCache.push(this.folderCache[i]);
 				}
 			} 
 			
 			if ( newFolderCache.length < this.folderCache.length ){ 
            	this.folderCache = newFolderCache;
 			}
        };
        
        /**
         * Select an item
         *
         * @param item
         */
        this.select = function(folderOrFile,tryToDownload) {
        	if (folderOrFile.type == "folder") {
        		this.selectedTmp = null; 
        		this.paging = this.newPaging();

            	this.cleanSelectedPlayer();
        		
            	this.refreshPath( folderOrFile );
            	        		        		
            	this.loadFromCache( this.repoLinkPrefix 
            						+ (this.mixedReposList ? "" : this.currentRepo.name + "/" )
            						+ folderOrFile.uid
            						+ (this.itemContainer() != null ? "/" + this.itemContainer().uid : "")
            						+ "?pageSize=" + this.paging.pageSize + "&currentPage=" + this.paging.currentPage);
        	}
        	else {
        		this.selectedTmp = folderOrFile;
            	this.cleanSelectedPlayer();
             
            	if (tryToDownload !== undefined && this.canDownloadDocument(this.selectedTmp.entity)) {
            		this.download(this.selectedTmp);
            	}
        	}
        };
        
        this.home = function(){
        	this.selectedTmp = null; 
        	this.cleanSelectedPlayer();
        	this.pathTmp = [];
    		this.paging = this.newPaging();
        	this.loadFromCache(this.initPathUrl);
        };
        
        this.refreshPath = function( folder ) { 
        	var pathTmpClone = angular.copy(this.pathTmp);
        	this.pathTmp = []; 
        	 
        	var notInPath = true;
        	for (var i = 0; i < pathTmpClone.length; i++) {
        		
        		this.pathTmp.push(pathTmpClone[i]);
        		
        		if (pathTmpClone[i].uid == folder.uid ) {
        			notInPath = false;
        			break;
        		}
        	}

        	if (notInPath) {
        		this.pathTmp.push(folder);
        	}
        };
         
        this.open = function( item ) {
        	$window.open( item.entity.playOptions, '_blank' );
        }
        
        this.play = function(item, container, event) {             
            var service = this;
         	var player;
         	
            if ( item.entity.playOptions == 'inline') {            	
            	service.selectedPlayerTmp = "loading";
            	
            	cvicRequestService
                .requestHtmlData(__env.apiUrl + ApiEndPoints.DownloadController.play + item.uid, 'GET' )
                .then(function(response) {
                	angular.element(document.querySelector('#player')).html(response.data); 
                	service.selectedPlayerTmp = "loaded";
                });
            } 
            else {
	         	$mdDialog.show({
	                 controller         : 'PlayDocumentDialogController',
	                 controllerAs       : 'vm',
	                 templateUrl        : 'app/main/file-manager/dialogs/play-docm-dialog/play-docm-dialog.html',
	                 parent             : angular.element($document.body),
	                 targetEvent        : event,
	                 clickOutsideToClose: true,
		             fullscreen: true,
	                 locals             : {
	                     dialogData: {document: angular.copy(item.entity)}
	                 }
	             })
	             .then(function () { });
        	}
        };
        
        this.noFreeDiskSpaceAlert = function(event){
        	var alert = $mdDialog.alert({
    	        title: $translate.instant("NEW_FILE_ALERT.FREE_DISK_SPACE") + " " + cvicFileService.formatFileSize(this.freeDiskSpace()),
    	        htmlContent: $translate.instant("NEW_FILE_ALERT.NO_FREE_DISK_SPACE"),
    	        ok: $translate.instant("NEW_FILE_ALERT.CLOSE"),
    	        clickOutsideToClose: true
	      });

	      $mdDialog.show( alert ).finally(function() { alert = undefined;});
        };
                
        this.noFreeDiskSpace = function(){
        	return (this.freeDiskSpace() < 0 );
        };
        
        this.freeDiskSpace = function(){
        	return (cvicJWTService.maxLimitedFileStorage() - this.diskSpace );
        };
        
        this.addDocument = function( event, onTop ) {
        	var service = this;
        	var domFileInput = event.target;

            if (service.canAddDocument() && domFileInput.files.length == 1 ) {
                var objFile = event.target.files[0];
               
                var objFileReader = new FileReader();
                var fileSize = objFile.size;
                var strTitle = objFile.name;
                var strMimeType = objFile.type;
               
                objFileReader.onloadend = function (e) {
                    var arrBytes = e.target.result;
                    var strEncodedBytes = cvicImageService.arrayBufferToBase64(arrBytes); 

                    service.getTemplate().then(function success(objTpl) {
                    	if (cvicJWTService.maxLimitedFileUploadSize() < fileSize ) {
                    		 var alert = $mdDialog.alert({
	                    	        title: $translate.instant("NEW_FILE_ALERT.EXCEED_FILE_UPLOAD_SIZE"),
	                    	        htmlContent: strTitle + " - " + cvicFileService.formatFileSize(fileSize) 
	                    	        			+ "<br/>" + $translate.instant("NEW_FILE_ALERT.EXCEED_FILE_UPLOAD_SIZE_TEXT")
	                    	        			+ " " + cvicFileService.formatFileSize(cvicJWTService.maxLimitedFileUploadSize()) ,
	                    	        ok: $translate.instant("NEW_FILE_ALERT.CLOSE"),
	                    	        clickOutsideToClose: true
                    		 });
                    		 
                    		 $mdDialog.show( alert ).finally(function() { alert = undefined;});
                    	} 
                    	else if (cvicJWTService.maxLimitedFileStorage() - (service.diskSpace + fileSize ) < 0 ) {
                    		  var alert = $mdDialog.alert({
	                    	        title: $translate.instant("NEW_FILE_ALERT.FREE_DISK_SPACE") + " " + cvicFileService.formatFileSize(service.freeDiskSpace()),
	                    	        htmlContent: strTitle + " - " + cvicFileService.formatFileSize(fileSize) + "<br/>" + $translate.instant("NEW_FILE_ALERT.EXCEED_FREE_DISK_SPACE"),
	                    	        ok: $translate.instant("NEW_FILE_ALERT.CLOSE"),
	                    	        clickOutsideToClose: true
                    	      });
                    		  
                    	      $mdDialog.show( alert ).finally(function() { alert = undefined;});
                    	}
                    	else {
	                        objTpl.uid = uuid.v4();
	                        objTpl.title = strTitle;
	                        objTpl.mimeType = strMimeType;
	                        objTpl.content = strEncodedBytes;
	                        objTpl.owner.uid = cvicJWTService.currentUserId();
	                        objTpl.repository = 'local';
	                        objTpl.parentFolder = service.selectedFolder(); 
	                        objTpl.size = fileSize;
	                        if ( service.itemContainer() != null ) {
		                        if ( service.isSpaceContainer(service.itemContainer())) {
		                        	objTpl.spaces.push(service.itemContainer());
		                        }
		                        else if ( service.isEventContainer(service.itemContainer())) {
		                        	objTpl.events.push(service.itemContainer());
		                        }
		                        else if ( service.isUserContainer(service.itemContainer()) ){
		                        	objTpl.portfolioUser = service.itemContainer();
		                        }
                    		}
	                        service.upload(objTpl, onTop).then(function success(objNewDoc) {
	                            domFileInput.value = '';
	                        });
                    	}
                    });                    
                }

                objFileReader.readAsArrayBuffer(objFile);                
            }
        };
        
        this.chooseDocuments = function( event ) {
        	 var service = this;	
        	 if (service.itemContainer() != null && service.canAddDocument() ) { 
        		 $mdDialog.show({
	                 controller         : 'ChooseDocumentDialogController',
	                 controllerAs       : 'vm',
	                 templateUrl        : 'app/main/file-manager/dialogs/choose-docm-dialog/choose-docm-dialog.html',
	                 parent             : angular.element($document.body),
	                 targetEvent        : event,
	                 clickOutsideToClose: false,
		             fullscreen: true,
	                 locals             : {
	                     dialogData: {container: angular.copy(service.itemContainer())}
	                 } 
	             })
	             .then(function (documents) { 	            	 
	            	 if (documents.length > 0){
		            	 service.storeContainerFiles(documents, false);
	             	 }
	             });
        	 }
        };
        
        this.storeContainerFiles = function(documents, detachFiles){
        	 var service = this;
        	         	  		
        	 //old files & new files: merge and check for dupl
 			 var newFilesTmp = angular.copy(service.filesTmp); 
 			 var uids = [];
 			 for ( i = 0; i < newFilesTmp.length; i++ ){
 				uids.push(newFilesTmp[i].entity.uid);
 			 }
 			 
 			 var isForPortfolio = (service.itemContainer() != null 
									&& service.isUserContainer(service.itemContainer()));
 			 var notSuitableForPortfolioDocs = [];
 			 for ( i = 0; i < documents.length; i++ ){
 				if (isForPortfolio && !service.isSuitableForPortfolio ) {
 					notSuitableForPortfolioDocs.push(documents[i]);
 	        	} 
 				else  if ( uids.indexOf(documents[i].uid) == -1 ) {
 	 				newFilesTmp.push(cvicListService.documentRow(documents[i])); 
 				}
        	 } 
 			 
 			 if ( notSuitableForPortfolioDocs.length > 0) {
 				var alert = $mdDialog.alert({
 	    	        //title: $translate.instant("NOT_FOR_PORTFOLIO.TITLE"),
 	    	        htmlContent: $translate.instant("NOT_FOR_PORTFOLIO.TEXT"),
 	    	        ok: $translate.instant("NOT_FOR_PORTFOLIO.CLOSE"),
 	    	        clickOutsideToClose: true
 				});

 				$mdDialog.show( alert ).finally(function() { alert = undefined;});
 			 }

 			 //construct container "update" link
        	 var url = null;
        	 if (service.itemContainer() != null && service.isSpaceContainer(service.itemContainer())) {
        		if ( detachFiles ){
        			url = ApiEndPoints.SpaceController.detachFiles;
        		} else {
     		 		url = ApiEndPoints.SpaceController.updateSpace;
        		}
             }
             else if (service.itemContainer() != null && service.isEventContainer(service.itemContainer())) {
            	 if ( detachFiles ){
            		 url = ApiEndPoints.EventController.detachFiles;
            	 } else {
                	 url = ApiEndPoints.EventController.updateEvent;             		 
            	 }                    	
             }
             else if (service.itemContainer() != null && service.isUserContainer(service.itemContainer())) {
            	 if ( detachFiles ){
            		 url = ApiEndPoints.ProfileController.detachFiles;
            	 } else {
                	 url = ApiEndPoints.ProfileController.edit;             		 
            	 }                    	
             }
        	          	 
        	 if ( url != null ){
        		 //set container files
	        	 service.itemContainer().documents = []; 
		       	 for ( i = 0; i < newFilesTmp.length; i++ ){ 
		       		service.itemContainer().documents.push(newFilesTmp[i].entity); 
		       	 }
		       	 		       	 		       	 
		       	 cvicRequestService.fnPostJsonData(__env.apiUrl + url, service.itemContainer())
		       	 .then(function success(response) {
		       		 	if (!angular.equals(response.data, {})) {
			       		 	service.cleanSelectedPlayer();
			       		 	service.cleanPathFromCache(service.lastPathUrl); 
			       		 	
			       		 	service.setItemContainer( response.data );
			       		 	service.filesTmp = newFilesTmp;
			       		 	service.newOrder = false;
		       		 	}
		       		 	
		       		 	service.itemContainer().documents = [];
		            }, function fail(response) {
		                //TODO add error handling
		       		 	service.itemContainer().documents = [];
		            });
        	 }
        };

        this.deleteDocument = function(item, container, event){
        	if ( item == null ) return;
        	 
        	var service = this;
        	var docDeletePath = __env.apiUrl + ApiEndPoints.DocumentController.delete; 
        	var isInTrash = (item.entity.deleted != null);
        	
        	if ( docDeletePath && this.canDeleteDocument(item, container) ) {
        		var confirm = $mdDialog.confirm()
				                .title($translate.instant("FM.DELETE.DOCM.SURE"))
				                .htmlContent('<b>"' + item.name + '"</b> ' + $translate.instant("FM.DELETE.DOCM.WILL"))
				                .ariaLabel($translate.instant("FM.DELETE.DOCM.LABEL"))
				                .targetEvent(event)
				                .ok($translate.instant("FM.DELETE.OK")) 
				                .cancel($translate.instant("FM.DELETE.CANCEL"));
        		
        		$mdDialog.show(confirm).then(function (){ 
		        	cvicRequestService
		            .requestJsonData(docDeletePath, 'POST', successResponseData, failResponseData, item.entity)
		            .then(function(data) {             	
		            	service.selectedTmp = null;
		            	service.cleanSelectedPlayer();
		            	
		            	if ( service.externalService != null ) {
		            		service.externalService.deleteListElement(item.entity);
		            	}
		            	service.removeFilesTmpListItem(item); 
		            	if ( isInTrash ){
		            		service.decrOccupiedDiskSpace(item.entity.size);
		            		service.decrTrashDiscSpace(item.entity.size);
		            	}
		            	else {
		            		service.incrTrushDiscSpace(item.entity.size);
		            	}
		            });
        	    });
        	}
        };
                
        this.editDocument = function(item, event){ 
        	var service = this;
        	var currentDocmSize = item.entity.size;
        	
        	$mdDialog.show({
                controller         : 'EditDocumentFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/file-manager/dialogs/edit-docm-dialog/edit-docm-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : event,
                clickOutsideToClose: false,
                locals             : {
                    dialogData: {document: angular.copy(item.entity),
                    			 freeDiskSpace: service.freeDiskSpace()	
                    			}
                }
            }).then(function (document)
            {
                service.decrOccupiedDiskSpace(currentDocmSize); 
            	service.incrOccupiedDiskSpace(document.size);
            	
            	if ( service.externalService != null ) {
            		service.externalService.editListElement(document);
            	}
            
            	service.refreshFilesTmpList(document);
            });
        };

        this.detachDocument = function (item, container, event) {
             if ( this.canManageContainer() ) {
             	var service = this;
             	
                var confirm = $mdDialog.confirm()
                                .title($translate.instant("FM.DETACH.DOCM.SURE"))
                                .htmlContent('<b>"' + item.name + '"</b> ' + 
                                		$translate.instant("FM.DETACH.DOCM.WILL"))
                                .ariaLabel($translate.instant("FM.DETACH.DOCM.LABEL"))
                                .targetEvent(event)
                                .ok($translate.instant("FM.DETACH.OK")) 
                                .cancel($translate.instant("FM.DETACH.CANCEL"));

                $mdDialog.show(confirm).then(function () {
                	 service.removeFilesTmpListItem(item);                	
                	 service.storeContainerFiles([], true);
                });
            }

        }; 
        
        this.refreshFilesTmpList = function(document){
        	var service = this;
        	
        	for ( i = 0; i < service.filesTmp.length; i++ ){
 				var uid = service.filesTmp[i].uid;
 				if ( uid == document.uid ) {
 					service.filesTmp[i] = cvicListService.documentRow(document);
 					if (service.selected() && service.selected().uid == document.uid) {
 						service.selectedTmp = service.filesTmp[i];
 					}
	            	service.cleanSelectedPlayer();
     				service.cleanPathFromCache(service.lastPathUrl);
 					break;
 				}
 			} 
        };	
        
        this.removeFilesTmpListItem = function(item){	
        	 var service = this;
        	
        	 var newFilesTmp = []; 
         	
 			 for ( i = 0; i < service.filesTmp.length; i++ ){
 				var uid = service.filesTmp[i].uid;
 				if ( uid != item.uid ) {
 					newFilesTmp.push(service.filesTmp[i]);
 				}
 			 } 
 			
 			 if ( newFilesTmp.length < service.filesTmp.length ){
 				service.filesTmp = newFilesTmp;
 				service.cleanPathFromCache(service.lastPathUrl);
 			 }	
        };

        this.addFolder = function(e){	 
        	var service = this;

        	$mdDialog.show({
                controller         : 'NewFolderFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/file-manager/dialogs/new-folder-form-dialog/new-folder-form-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : event,
                clickOutsideToClose: false,
                locals             : {
                    dialogData: {
                    	space: (service.isSpaceContainer(service.itemContainer()) ? service.itemContainer() : null ),
                    	parentFolder: service.selectedFolder()
                    }
                }
            }).then(function (folder)
            {
            	service.foldersTmp.unshift(cvicListService.folderRow(folder));	
 				service.cleanPathFromCache(service.lastPathUrl);
            });
        };
        
        this.deleteFolder = function(item, event){ 
        	var service = this;
        	var folderDeletePath = __env.apiUrl + ApiEndPoints.FolderController.deleteFolder; 
        	
        	if ( folderDeletePath && this.canManageFolder(item)) {
        		var confirm = $mdDialog.confirm()
				                .title($translate.instant("FM.DELETE.FOLDER.SURE"))
				                .htmlContent('<b>"' + item.name + '"</b> ' + $translate.instant("FM.DELETE.FOLDER.WILL"))
				                .ariaLabel($translate.instant("FM.DELETE.FOLDER.LABEL"))
				                .targetEvent(event)
				                .ok($translate.instant("FM.DELETE.OK")) 
				                .cancel($translate.instant("FM.DELETE.CANCEL"));
        		$mdDialog.show(confirm).then(function (){
		        	cvicRequestService
		            .requestJsonData(folderDeletePath, 'POST', successResponseData, failResponseData, item.entity)
		            .then(function(data) {      	
		            	service.selectedTmp = null;
		            	service.cleanSelectedPlayer();     	
		            	var newFoldersTmp = []; 
		            	
		     			for ( i = 0; i < service.foldersTmp.length; i++ ){
		     				var uid = service.foldersTmp[i].uid;
		     				if ( uid != item.uid ) {
		     					newFoldersTmp.push(service.foldersTmp[i]);
		     				}
		     			} 
		     			
		     			if ( newFoldersTmp.length < service.foldersTmp.length ){
		     				service.foldersTmp = newFoldersTmp;
		     				service.cleanPathFromCache(service.lastPathUrl);
		     			}
		            });
        		});
        	}
        };
        
        this.renameFolder = function(item, event){ 
        	var service = this;
        	
        	$mdDialog.show({
                controller         : 'RenameFolderFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/file-manager/dialogs/rename-form-dialog/rename-form-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : event,
                clickOutsideToClose: false,
                locals             : {
                    dialogData: {folder: angular.copy(item.entity)}
                }
            }).then(function (folder)
            {
            	for ( i = 0; i < service.foldersTmp.length; i++ ){
     				var uid = service.foldersTmp[i].uid;
     				if ( uid == folder.uid ) {
     					service.foldersTmp[i] = cvicListService.folderRow(folder);
     					break;
     				}
     			} 
            });
        };
                    
        this.size = function(item){
        	if ( item == null ) return "-";
        	
        	return ( item.size !== undefined && item.size != null && item.size != "" 
        			? cvicFileService.formatFileSize(item.size)
        			: "-");
        };
        
        this.formatBytes = function(bytes){        	
        	return cvicFileService.formatFileSize(bytes);
        };

        this.hasEventContainerExpired = function() {
            var container = this.itemContainer();

            if( container && this.isEventContainer(container)) {
                return cvicEventService.hasEventExpired(container);
            }
            
            return false;
        }
                
        this.download = function(item){ 

        	if ( item == null ) return; 
        	
        	cvicRequestService.requestDocumentContent(this.downloadPath(item));
        };
        
        this.downloadPath = function(item){
        	if ( item == null ) return "";
        	return __env.apiUrl + ApiEndPoints.DocumentController.download + item.entity.uid; 
        };
        
        this.canAddToPortfolio = function(docm) { 
        	return ( this.externalService == null
        				&& this.itemContainer() == null 
        				&& this.isSuitableForPortfolio(docm));
        };
        
        this.isSuitableForPortfolio = function(docm) { 
        	return (docm.repo == 'local' 
				&& !docm.entity.portfolioUser 
				&& cvicJWTService.isOwner(docm.entity));
        };
        
        this.addToPortfolio = function(file, $event){  
        	var service = this;
        	
        	$rootScope.userDataRequest().then( function( userInfo ) {
        		file.entity.portfolioUser = userInfo;
        		cvicRequestService
	         		.requestJsonData(__env.apiUrl + ApiEndPoints.DocumentController.update, 'POST', successResponseData, failResponseData, file.entity)
	         		.then(function(document) {
	         			if (!angular.equals(document, {})) {
	         				service.refreshFilesTmpList(document);
	         			}
	         		});
        	});
        };
        
        this.canDeleteDocument = function(docm, container) {
            if(this.hasEventContainerExpired()) {
                return false;
            }

        	return (docm.repo == 'local' && cvicJWTService.canDelete(docm.entity, container));
        };
        
        this.canDownloadDocument = function(docm ){
        	return docm.allowDirectDownloadRepo;
        }; 
        
        this.canAddDocument = function(){     
        	return (this.currentRepo != null && this.currentRepo.name == 'local')
        			|| (this.itemContainer() != null 
        					&& this.canManageContainer()
        					&& ( this.isSpaceContainer() || this.isUserContainer() || !this.hasEventContainerExpired())
        				);
        };
        
        this.canEditDocument = function(docm ){
            return (docm.repo == 'local' && cvicJWTService.isOwner(docm.entity))
					|| (docm.repo == 'local' 
						&& this.itemContainer() != null 
						&& this.canManageContainer()
						&& ( this.isSpaceContainer() || this.isUserContainer() || !this.hasEventContainerExpired())
						);
        };
        
        this.canAddFolder = function(){
        	return this.currentRepo != null && this.currentRepo.name == 'local' && this.itemContainer() == null;
        };
        
        this.canManageFolder = function(folder){
        	return this.currentRepo != null && this.currentRepo.name == 'local'
    				&& ( ( this.itemContainer() == null 
    						&& (cvicJWTService.isOwner(folder.entity) 
    								|| cvicJWTService.isOwnerOfContainer(folder.entity) )) 
    						|| this.canManageContainer());
        };
        
        this.canManageContainer = function(){

            if ( typeof this.itemContainer() === 'undefined' 
            	|| this.itemContainer() == null 
            	|| this.hasEventContainerExpired()) {
                return false;
            }
            
        	return (cvicJWTService.isOwner(this.itemContainer()) || cvicJWTService.canManage(this.itemContainer()))
		        	/**
		        	 * GRZ-4957 Добавяне на материали към синхронизирано УП и Събитие – в момента те са read-only
		        			//&& (this.isUserContainer(this.itemContainer()) || !this.itemContainer().organization);
		        	 */
					&& ( this.isSpaceContainer() || this.isUserContainer() || !this.hasEventContainerExpired());
        };
        
        this.isSpaceContainer = function(container){
        	return container != null && container["@class"].indexOf('.Space') != -1
        };
        
        this.isEventContainer = function(container){
        	return container != null && container["@class"].indexOf('.Event') != -1
        };
        
        this.isUserContainer = function(container){
        	return container != null && container["@class"].indexOf('.User') != -1
        };
        
        this.isDocument = function(item){ 
        	return item != null && item["@class"].indexOf('.Document') != -1
        };
        
        this.isDocumentsArea = function(){
        	return this.itemContainer() == null;
        };
        
        this.canReorderFiles = function(){
        	return ( this.isEventContainer(this.itemContainer()) 
        				|| this.isSpaceContainer(this.itemContainer()) 
        				|| this.isUserContainer(this.itemContainer()) )
        			&& this.canManageContainer();
        			//|| (this.isSpaceContainer(this.itemContainer()) && this.itemContainer().organization);
        };
         
        /**
         * Toggle details
         *
         * @param item
         */
        this.toggleDetails = function(item) {
        	this.select(item);
        	if (item.type != "folder") { 
        		toggleSidenav('details-sidenav');
        	}
        };

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        this.toggleSidenav = toggleSidenav;         	
        	
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
    	      
        function failResponseData(response) {
        	 $state.go('app.file-manager');
        } 
        
        function successResponseData(response) {
        	 return response.data;
        }

        this.getTemplate = function () {

            var strUrl = __env.apiUrl + ApiEndPoints.DocumentController.getTemplate;

            return cvicRequestService.fnGetJsonData(strUrl).then(function success(response) {
                return response.data;
            }, function fail(response) {
                //TODO add error handling
                return response.data;
            });

        };

        this.upload = function (objFilledTpl, onTop) {
        	var service = this;
            var strUrl = __env.apiUrl + ApiEndPoints.DocumentController.upload;
            
            if (cvicJWTService.maxLimitedFileStorage() - (service.diskSpace + objFilledTpl.size ) < 0 ) {
        		return false;
        	}
            else { 
            	$rootScope.loadingExternalContentProgress = true;
	            return cvicRequestService.fnPostJsonData( strUrl, objFilledTpl ).then(function success(response) { 
	            	service.pushFile(cvicListService.documentRow( response.data), onTop);
	                service.cleanPathFromCache(service.lastPathUrl);
	                service.incrOccupiedDiskSpace(objFilledTpl.size); 
	                $rootScope.loadingExternalContentProgress = false;
	                return response.data;                
	            }, function fail(response) {
	            	$rootScope.loadingExternalContentProgress = false;
	                return response.data;
	            });
            }
        };  
        
        this.incrOccupiedDiskSpace = function(amount){
        	this.diskSpace = this.diskSpace + amount;
        };
        
        this.decrOccupiedDiskSpace = function(amount){
        	this.diskSpace = this.diskSpace - amount;
        };
        
        this.incrTrushDiscSpace = function(amount){
        	this.trashDiskSpace = this.trashDiskSpace + amount;
        };
        
        this.decrTrashDiscSpace = function(amount){
        	this.trashDiskSpace = this.trashDiskSpace - amount;
        };
        
        this.preventDefault = function (event) {
        	event.preventDefault();
        	event.stopPropagation();
        };
        
        function failObjectResponseData(response) {
            return {};
        }  
               
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('cvicDateService', cvicDateService);

    /** @ngInject */
    function cvicDateService($translate)
    {
  	      var service = {
  	    		  	formatDate		      : 	formatDate,
                fnGetDateObject     :   fnGetDateObject,
                fnGetFormat         :   fnGetFormat,
                fnGetOnlyDateFormat :   fnGetOnlyDateFormat
  	      };

          return service;

          function formatDate(date) {
              var monthNames = [
                  "January", "February", "March",
                  "April", "May", "June", "July",
                  "August", "September", "October",
                  "November", "December"
              ];

              var day = date.getDate();
              var monthIndex = date.getMonth();
              var year = date.getFullYear();

              return day + ' ' + monthNames[monthIndex] + ' ' + year + ' - ' + date.getHours() + ":" + date.getMinutes();
          };

          function fnGetDateObject(intDate) {
              return new Date(intDate);
          };

          function fnGetFormat() {

              if ( $translate.use() == 'en' ) {
                return 'M/d/yyyy HH:mm';
              }
              else {
                return 'dd.MM.yyyy HH:mm';
              }
              
          };

          function fnGetOnlyDateFormat() {
              if ( $translate.use() == 'en' ) {
                return 'M/d/yyyy ';
              }
              else {
                return 'dd.MM.yyyy';
              }
          }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('cvicAudienceService', cvicAudienceService);

    /** @ngInject */
    function cvicAudienceService(
            cvicRequestService, 
            cvicJWTService,
            ApiEndPoints,
            __env)
    {
        var service = {
        		getUserAudience: getUserAudience,
                userAudienceTempl: userAudienceTempl,
        		getGroupAudience: getGroupAudience,
                groupAudienceTempl: groupAudienceTempl,
                updateUserAudience: updateUserAudience,
                createAudienceMap: createAudienceMap,
                createAudienceChipMap: createAudienceChipMap,
                canManageAudience: canManageAudience
        };

        return service;

        function failResponseData(response) {
            return {};
        }

        function successResponseData(response) {
             return response.data;
        }

        function canManageAudience(container) {
            return (cvicJWTService.isOwner(container) || cvicJWTService.canManage(container)) 
            		&& (!container.organization || container.organization.type != 'moodle');
        }

        function createAudienceMap(audienceEntity) {
            var audienceMap = {};

            for(var i = 0; i < audienceEntity.userAudience.length; i++) {
               var userAudience = audienceEntity.userAudience[i];
               
               audienceMap[userAudience.user.uid] = userAudience;
           }

           return audienceMap;
        }

        function createAudienceChipMap(audience) {
            var uidMap = {};

            for(var i = 0; i < audience.length; i++) {
               var currAudience = audience[i];
               
               uidMap[currAudience.uid] = currAudience;
           }

           return uidMap;
        }

        function getUserAudience( audience, audienceTempl, existingAudience){
            var checkAudience = existingAudience != null && existingAudience != undefined;

        	var itemUserAudience = [];     
        	for (var i = 0; i < audience.length; i++) {        		
        		if (isUserAudience(audience[i])) {

                    if(checkAudience && existingAudience[audience[i].uid] ) {
                        itemUserAudience.push(existingAudience[audience[i].uid]);
                        
                        continue;
                    }

		        	var newAudience = jQuery.extend(true, {}, audienceTempl);
		        	newAudience.user.uid = audience[i].uid;
		        	newAudience.dateInvited = new Date();
                    newAudience.dateAccepted = null;
                    newAudience.dateRejected = null;
                    newAudience.dateRequested = null;
		            newAudience.canManage = false;
		            newAudience.canManage = false;
		        	newAudience.lastAction = 'Invite'; 
		        		
		        	itemUserAudience.push(newAudience);
        		}
        	}
        	
        	return itemUserAudience;
        }//getUserAudience
        
        function isUserAudience(contact) {           
        	return !contact.isGroup;
        }//createFilterForUserAudience()

        function userAudienceTempl() {
            return cvicRequestService
                    .requestJsonData(__env.apiUrl + '/user/audience/templ', 'GET', successResponseData, failResponseData)
                    .then(function(item) { 
                        return item;
                    }
                );
        }//userAudienceTempl
        
        function getGroupAudience( audience, audienceTempl){

        	var itemGroupAudience = [];
			for (var i = 0; i < audience.length; i++) {				
				if (isGroupAudience(audience[i])) {

					var newAudience = jQuery.extend(true, {}, audienceTempl);
					newAudience.uid = audience[i].uid;
				
					itemGroupAudience.push(newAudience);
				}
			}
			 			
			return itemGroupAudience;
        }//getGroupAudience
        
        function isGroupAudience(contact) {    
            return contact.isGroup;
        }//isGroupAudience()

        function groupAudienceTempl(){
            return cvicRequestService
                    .requestJsonData(__env.apiUrl + ApiEndPoints.GroupController.groupTempl, 'GET', successResponseData, failResponseData)
                    .then(function(item) { 
                        return item;
                    }
                );
        }//groupAudienceTempl

        function updateUserAudience(auEntity, reqUrl, audienceAction) {
             var data = {
                entity:  auEntity,
                audienceAction: audienceAction
            };

            return cvicRequestService.requestJsonData(
                reqUrl, 
                'POST', 
                function(response) {
                    return {
                        userAudience: response.data,
                        status: response.status
                    };
                }, function(response) {
                    return {
                        status: response.status
                    };
                },
                data
            );
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController(
    		 $scope,
        $rootScope, 
        $q, 
        $state, 
        $timeout, 
        $mdSidenav, 
        $translate, 
        $mdToast,
        msNavigationService, 
        cvicRequestService, 
        cvicProfileService,
        cvicMessageService,
        ApiEndPoints, 
        __env)
    {

        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        }; 
        
        $scope.cvicProfileService = cvicProfileService;

        vm.bodyEl = angular.element('body');
        vm.userAvatar = 'assets/images/avatars/profile.jpg';
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            bg: {
                'title'         : 'Bulgarian',
                'translation'   : 'TOOLBAR.BULGARIAN',
                'code'          : 'bg',
                'flag'          : 'bg'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.inboxClick=inboxClick;
        vm.helpClick=helpClick;
        vm.sendMailToAdmin=sendMailToAdmin;
        //////////

        init();

        function getUserName(userInformation) {
            return userInformation['title'];
        }

        function getUserAvatar(userInformation) {
            var img = userInformation['coverImage'];

            if( img === null || userInformation['coverImage']['uid'] === null ) {
                return 'assets/images/avatars/profile.jpg';
            }

            return __env.apiUrl + ApiEndPoints.ImageController.getImage + userInformation['coverImage']['uid'] + '.jpg';
        }

        /**
         * Initialize
         */
        function init() {
            $rootScope.userDataRequest().then(function(userInfo) {
            	
                /**
                 * Get username
                 */
                vm.userName = getUserName(userInfo);

                vm.userAvatar = getUserAvatar(userInfo);

                vm.objUserInfo = userInfo;

                var strPrefferedLanguage = vm.objUserInfo.settings.language;

                if ( strPrefferedLanguage != null ) {
                    vm.selectedLanguage = vm.languages[strPrefferedLanguage];
                    $translate.use( vm.selectedLanguage.code );
                }
            });

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            localStorage.removeItem("id_token");

            $state.go('app.pages_auth_login-v2');
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            /* Comment this toast for now
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }
            */
            // Change the language
            $translate.use(lang.code);

            vm.objUserInfo.settings.language = vm.selectedLanguage.code;

            var strUrl = __env.apiUrl + ApiEndPoints.ProfileController.edit;

            cvicRequestService.requestJsonData(
                    strUrl,
                    'POST',
                    function success(response) {
                    	vm.objUserInfo = response.data;
                        return;
                    },
                    function fail(response) {
                        return response;
                    },
                    vm.objUserInfo
                );
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }
        
        function inboxClick(){         	
        	$state.go('app.mail.threads', {
                type  : null,
                filter: "system"
            });
        }
        
        $rootScope.adminDataRequest = function() {
        	if ( $rootScope.adminDataInformation ) {
        		return $q(function( resolve, reject ) { resolve( $rootScope.adminDataInformation ); });
        	}  else {
        		return  cvicRequestService.requestJsonData(
        				__env.apiUrl + ApiEndPoints.UserController.getAdminContact,
		                    'GET', 
		    	            function (response) {
		    	        		$rootScope.adminDataInformation = response.data;
		    	        		return response.data;
		    	            }, 
		    	            function (response) {
		    	                return response.data;
		    	            }
		    	        );        		
        	}
        };
        
        function sendMailToAdmin(ev){
        	
        	$rootScope.adminDataRequest().then( function( user ) {
        		var sndTo = [];	            
	            var userContact = { uid: user.uid,                        
					                title: user.title,                    
					                email: user.email
					                };    
	            sndTo.push(userContact);  

	            cvicMessageService
	            	.composeDialog(ev, null, { sndTo:  sndTo });
        	});
        	
        }
        
        function helpClick(){
        	var customHeaders = {filename: 'cvic_manual.pdf'};
        	cvicRequestService.requestExternalContent(ApiEndPoints.Help, customHeaders);
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(
    		msApi, 
    		$scope, 
    		$rootScope,
    		cvicRequestService, 
    		cvicSchedule,
    		__env)
    {
        var vm = this; 
        

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };
        
        $rootScope.cvicSchedule = cvicSchedule;
        $rootScope.cvicSchedule.upcomingEventsRequest();

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );
        
        vm.showExternalLink =  function(event) {
            if(event.externalLink) {
                return true;
            }

            return false;
        };


        // Methods

        function successResultSetData(response) {
            return response.data.elements;
        } 

        function failResponseJson(response) {
            return {};
        }
        //////////
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [
            //Tetracom General Implementations 
            'app.tetracom.general',

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick Panel
            'app.quick-panel',

            //Auth Login
            'app.auth.login-v2',

            //Auth register
            'app.auth.register-v2',

            //Forgotten password
            'app.pages.auth.forgot-password',

            //Change password
            'app.pages.auth.reset-password',

            //Dashboard
            'app.dashboard',

            //Events statistics
            'app.eventstatistics',

            //Spaces statistics
            'app.spacestatistics',

            //Messages statistics
            'app.messagestatistics',

            //Recordings statistics
            'app.recordingstatistics',

            //Learningspaces
            'app.spaces',
            
            //Learningspace details
            'app.spacedetails',

            //Events and Conferences
            'app.eventsconferences',

            //Event details
            'app.eventdetails',
            
            //Documents
            'app.file-manager',
            
            //Messages
            'app.mail',

            //Contacts
            'app.contacts',
            
            'app.audiencechips',

            'app.add-audience',
            
            // Json Web Token
            'angular-jwt',
            'vcRecaptcha',
            'ngMaterial',
            'ngRoute',
            'angular-uuid',
            'app.search',
            'app.trash',
            'app.profile',
            'ui.validate'
        ]);
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/navigation');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, $window, cvicRequestService, cvicJWTService, ApiEndPoints, __env)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        $scope.redirectToMoodle = function() {
            $window.open(vm.organization.syncData.baseUrl, '_blank');
        }
        
        $scope.redirectToSchool = function() {
            $window.open(vm.school.syncData.baseUrl, '_blank');
        }

        init();

        function init() { 
            cvicRequestService.requestJsonData(
	            		__env.apiUrl + ApiEndPoints.UserController.getUserInformation + cvicJWTService.currentUserId(), 
	                    'GET', 
	                    function (response) {
	                        return response.data;
	                    }, 
	                    function (response) {
	                        return {};
	                    }
                    ).then(function (userInfo) {
                if(!angular.equals({}, userInfo)) {

                    if(userInfo.organization && userInfo.organization.type == 'moodle') {
                        vm.organization = userInfo.organization;
                    }
                    else if (userInfo.organization && userInfo.organization.type == 'external') {
                    	vm.school = userInfo.organization;
                    }
                }
            });
        }

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, jwtHelper, cvicJWTService, __env)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (e, toState, toParams, fromState, fromParams)
        {
            $rootScope.loadingProgress = true;

            var stateWithLogin = __env["permittedStatesWithoutToken"][toState.name];
            var jwt = localStorage.getItem('id_token');

            if ( jwt !== null && toState.name == 'app.pages_auth_login-v2' ) {
            	// FIXME: if we have a token and we go to login page - forward to dashboard.
            	// The fix is for the deployed android application version.
                e.preventDefault();
                $state.go( 'app.dashboard' );
            } else if (stateWithLogin == undefined && (jwt === null || jwtHelper.isTokenExpired(jwt))) {
                e.preventDefault();

                localStorage.removeItem('id_token');

                // remeber the prev requested state in order to redirect after login.
                $rootScope.toState = toState;
                $rootScope.toParmas = toParams;
                
                $state.go('app.pages_auth_login-v2');
            } else if ( jwt !== null && cvicJWTService.hasFeature( 'one_time_password' ) && toState.name !== 'app.pages_auth_reset-password' ) {
            	e.preventDefault();
            	$state.go( 'app.pages_auth_reset-password' );
            }
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/auth/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController($q, fuseTheming, $rootScope, cvicRequestService, cvicSearchService, cvicJWTService, ApiEndPoints, __env)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        $rootScope.userDataRequest = function() {
        	if ( $rootScope.userInformation ) {
        		return $q(function( resolve, reject ) { resolve( $rootScope.userInformation ); });
        	}  else {
        		return  cvicRequestService.requestJsonData(
		    				__env.apiUrl + ApiEndPoints.UserController.getUserInformation + cvicJWTService.currentUserId(), 
		                    'GET', 
		    	            function (response) {
		    	        		$rootScope.userInformation = response.data;
		    	        		return response.data;
		    	            }, 
		    	            function (response) {
		    	                return response.data;
		    	            }
		    	        );        		
        	}
        };
        
        $rootScope.cvicSearchService = cvicSearchService;
    }
})();
(function ()
{
    'use strict';

    angular
        .module( 'fuse' )
        .config( config )
        .run( run );

    /** @ngInject */
    function config($translateProvider, $httpProvider, jwtOptionsProvider, __env)
    {
        // Put your common app configurations here

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('bg');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        jwtOptionsProvider.config({
            tokenGetter: [function() {
                return localStorage.getItem('id_token');
            }],
            whiteListedDomains: __env.whitelistedDomains
        });

        $httpProvider.interceptors.push('jwtInterceptor');
        
        //AnalyticsProvider.setAccount('UA-105419128-1');
    }

    run.$inject = ['$rootScope', '$location', '$window'];

    function run($rootScope, $location, $window) {
        // initialise google analytics
        $window.ga('create', 'UA-105419128-1', 'auto');
 
        // track pageview on state change
        $rootScope.$on('$stateChangeSuccess', function (event) {
            $window.ga('send', 'pageview', $location.path());
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();
(function ()
{
    'use strict';

    angular.module("fuse")
	.constant("__env", {
	"apiUrl": "https://join.classbg.online",
	"whitelistedDomains": [
		"join.classbg.online"
	],
	"permittedStatesWithoutToken": {
		"app.pages_auth_login-v2": true,
		"app.pages_auth_register-v2": true,
		"app.pages_auth_forgot-password": true
	}
});
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab \nng-if=\"false\"><md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab ng-if=\"false\"><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/dashboard/dashboard.html","<div id=\"calendar\" class=\"page-layout simple tabbed\"><div class=\"header dark\"><div class=\"header-content\" \nlayout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\" \ntranslate=\"Dashboard\">Calendar</span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search dark-search\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input key-press-action=\"fnExecuteSearch()\" key-press-code=\"13\" \nclass=\"search-input\" ng-model=\"vm.strSearch\" type=\"text\" placeholder=\"Search..\" translate \ntranslate-attr-placeholder=\"Search\" flex></div></div></div></div><md-button class=\"add-event-button md-fab md-warn\" \nng-click=\"vm.addEvent($event)\" aria-label=\"Add event\" translate translate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon\n md-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content\"><div id=\"widgets\"><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\" ng-if=\"vm.hasGrades || vm.isParent\"><ms-widget-front class=\"white-bg\"><div \nng-if=\"vm.isParent && vm.hasChild\" ng-click=\"gotoGrades()\" class=\"pt-32 pb-32 pointer-cursor\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"green-600-fg font-size-72 line-height-72\">{{vm.gradesWidget.recent}}</div><div\n class=\"h3 secondary-text font-weight-500\">{{\"DASHBOARD_WIDGET.GRADES.RECENT\" | translate}}</div></div><div \nng-if=\"vm.isParent && !vm.hasChild\" class=\"pt-32 pb-32 pointer-cursor\" layout=\"column\" layout-align=\"center center\">\n<div class=\"green-600-fg font-size-72 line-height-72\"><button class=\"md-fab md-button md-primary md-hue-3\" \nng-click=\"vm.cvicProfileService.orderChild($event)\" aria-label=\"{{DASHBOARD_WIDGET.GRADES.CHILD | translate}}\" \nstyle=\"margin-bottom:10px\"><md-icon md-font-icon=\"icon-account-plus\" class=\"s32\" style=\"color: greenyellow\"></button>\n</div><div class=\"h3 secondary-text font-weight-500\">{{\"DASHBOARD_WIDGET.GRADES.CHILD\" | translate}}</div></div><div \nng-if=\"vm.isParent && vm.hasChild\" class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"height: 52px\"><div class=\"layout-row\"><span ng-click=\"gotoGrades()\" \nclass=\"h4 secondary-text text-truncate pointer-cursor\">{{\"DASHBOARD_WIDGET.GRADES.ALL\" | translate}}: </span><span \nng-click=\"gotoGrades()\" class=\"h4 ml-8 pointer-cursor\">{{vm.gradesWidget.all}}</span></div><button \nclass=\"md-fab md-button md-primary md-hue-3\" ng-click=\"vm.cvicProfileService.orderChild($event)\" \naria-label=\"{{DASHBOARD_WIDGET.GRADES.CHILD | translate}}\" style=\"line-height:30px; width: 30px; height: 30px\"><md-icon\n md-font-icon=\"icon-account-plus\" class=\"s18\" style=\"color: greenyellow\"></button></div></ms-widget-front></ms-widget>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div ng-click=\"viewStatistics(\'app.spacestatistics\', \'activity\')\" class=\"pt-32 pb-32 pointer-cursor\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">\n{{vm.spacesWidget.my_spaces_activities}}</div><div class=\"h3 secondary-text font-weight-500\">\n{{\'DASHBOARD_WIDGET.SPACES.ACTIVITIES\' | translate}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"height: 52px\"><div class=\"layout-row\"><span ng-show=\"false\" \nng-click=\"viewStatistics(\'app.spacestatistics\', \'my_spaces\')\" class=\"h4 secondary-text text-truncate pointer-cursor\">\n{{\"DASHBOARD_WIDGET.SPACES.MY\" | translate}}:</span> <span ng-show=\"false\" \nng-click=\"viewStatistics(\'app.spacestatistics\', \'my_spaces\')\" class=\"h4 ml-8 pointer-cursor\" style=\"margin-right:15px\">\n{{vm.spacesWidget.my_spaces}}</span> <span ng-click=\"viewStatistics(\'app.spacestatistics\', \'comments\')\" \nclass=\"h4 secondary-text text-truncate pointer-cursor\">{{\"DASHBOARD_WIDGET.SPACES.COMMENTS\" | translate}}:</span> <span\n ng-click=\"viewStatistics(\'app.spacestatistics\', \'comments\')\" class=\"h4 ml-8 pointer-cursor\">\n{{vm.spacesWidget.comments}}</span></div><button class=\"md-fab md-button md-primary md-hue-3\" ng-click=\"gotoSpaces()\" \naria-label=\"{{DASHBOARD_WIDGET.SPACES.CATALOG | translate}}\" style=\"line-height:30px; width: 30px; height: 30px\">\n<md-icon md-font-icon=\"icon-bank\" class=\"s18\" style=\"color: greenyellow\"></button></div></ms-widget-front></ms-widget>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div ng-click=\"viewStatistics(\'app.eventstatistics\', \'activity\')\" class=\"pt-32 pb-32 pointer-cursor\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">\n{{vm.eventsWidget.my_events_activities}}</div><div class=\"h3 secondary-text font-weight-500\">\n{{\"DASHBOARD_WIDGET.EVENTS.ACTIVITIES\" | translate}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"height: 52px\"><div class=\"layout-row\"><span ng-show=\"false\" \nng-click=\"viewStatistics(\'app.eventstatistics\', \'my_events\')\" class=\"h4 secondary-text text-truncate pointer-cursor\">\n{{\"DASHBOARD_WIDGET.EVENTS.MY\" | translate}}:</span> <span ng-show=\"false\" \nng-click=\"viewStatistics(\'app.eventstatistics\', \'my_events\')\" class=\"h4 ml-8 pointer-cursor\" style=\"margin-right:15px\">\n{{vm.eventsWidget.my_events}}</span> <span ng-click=\"viewStatistics(\'app.eventstatistics\', \'comments\')\" \nclass=\"h4 secondary-text text-truncate pointer-cursor\">{{\"DASHBOARD_WIDGET.EVENTS.COMMENTS\" | translate}}:</span> <span\n ng-click=\"viewStatistics(\'app.eventstatistics\', \'comments\')\" class=\"h4 ml-8 pointer-cursor\">\n{{vm.eventsWidget.comments}}</span></div><button class=\"md-fab md-button md-primary md-hue-3\" ng-click=\"gotoEvents()\" \naria-label=\"{{DASHBOARD_WIDGET.EVENTS.CATALOG | translate}}\" style=\"line-height:30px; width: 30px; height: 30px\">\n<md-icon md-font-icon=\"icon-bank\" class=\"s18\" style=\"color: greenyellow\"></button></div></ms-widget-front></ms-widget>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div ng-click=\"viewStatistics(\'app.recordingstatistics\', \'all\')\" class=\"pt-32 pb-32 pointer-cursor\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">\n{{vm.recordsWidget.all_recordings}}</div><div class=\"h3 secondary-text font-weight-500\">\n{{\"DASHBOARD_WIDGET.RECORDINGS.ALL\" | translate}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span ng-click=\"viewStatistics(\'app.recordingstatistics\', \'new\')\" \nclass=\"h4 secondary-text text-truncate pointer-cursor\">{{\"DASHBOARD_WIDGET.RECORDINGS.RECENT\" | translate}}:</span> \n<span ng-click=\"viewStatistics(\'app.recordingstatistics\', \'new\')\" class=\"h4 ml-8 pointer-cursor\" \nstyle=\"margin-right:15px\">{{vm.recordsWidget.recent_recordings}}</span> <span \nng-click=\"viewStatistics(\'app.recordingstatistics\', \'old\')\" class=\"h4 secondary-text text-truncate pointer-cursor\">\n{{\"DASHBOARD_WIDGET.RECORDINGS.OLD\" | translate}}:</span> <span \nng-click=\"viewStatistics(\'app.recordingstatistics\', \'old\')\" class=\"h4 ml-8 pointer-cursor\">\n{{vm.recordsWidget.old_recordings}}</span></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" ng-if=\"!(vm.hasGrades || vm.isParent)\"><ms-widget-front \nclass=\"white-bg\"><div ng-click=\"viewStatistics(\'app.messagestatistics\', \'all\')\" class=\"pt-32 pb-32 pointer-cursor\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">\n{{vm.messagesWidget.new_messages}}</div><div class=\"h3 secondary-text font-weight-500\">\n{{\"DASHBOARD_WIDGET.MESSAGES.NEW\" | translate}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span ng-click=\"viewStatistics(\'app.messagestatistics\', \'user\')\" \nclass=\"h4 secondary-text text-truncate pointer-cursor\">{{\"DASHBOARD_WIDGET.MESSAGES.ALL\" | translate}}:</span> <span \nng-click=\"viewStatistics(\'app.messagestatistics\', \'user\')\" class=\"h4 ml-8 pointer-cursor\" style=\"margin-right:15px\">\n{{vm.messagesWidget.user_messages}}</span> <span ng-click=\"viewStatistics(\'app.messagestatistics\', \'system\')\" \nclass=\"h4 secondary-text text-truncate pointer-cursor\">{{\"DASHBOARD_WIDGET.MESSAGES.SYSTEM\" | translate}}:</span> <span\n ng-click=\"viewStatistics(\'app.messagestatistics\', \'system\')\" class=\"h4 ml-8 pointer-cursor\">\n{{vm.messagesWidget.system_messages}}</span></div></ms-widget-front></ms-widget></div></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"100\" \nflex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"calendar-legend\" layout=\"column\" \nlayout-align=\"start start\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><div class=\"calendar-legend-element\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"my-events\"></div><div class=\"calendar-legend-text\" \ntranslate=\"CALENDAR.LEGEND.MY_EVENTS\">My events</div></div><div class=\"calendar-legend-element\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"space-events\"></div><div class=\"calendar-legend-text\" \ntranslate=\"CALENDAR.LEGEND.LEARNING_SPACE_EVENTS\">Space events</div></div><div ng-if=\"vm.isParent\" \nclass=\"calendar-legend-element\" layout=\"row\" layout-align=\"space-between center\"><div class=\"child-events\"></div><div \nclass=\"calendar-legend-text\" translate=\"CALENDAR.LEGEND.STUDENT_EVENTS\">Child events</div></div></div><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" \nng-model=\"vm.events\" calendar=\"main\"></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h1\">{{\"Schedule\" | translate}}</div></div><div \nclass=\"p-16\" layout=\"column\" ng-repeat=\"event in $root.cvicSchedule.upcomingEvents | orderBy: \'startDate\'\"><div \nng-controller=\"EventsScheduleController as evtSchCtrl\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/eventsconferences/views/schedule/list.html\'\"></div></div></ms-widget-front></ms-widget></div>\n</div></div>");
$templateCache.put("app/main/contacts/contacts.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg indigo-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" \ntranslate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span><span class=\"logo-text\" translate=\"CONTACTS.CONTACTS\">\nContacts</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label \nfor=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input \nid=\"search\" placeholder=\"Search for anyone\" key-press-action=\"fnExecuteSearch()\" key-press-code=\"13\" type=\"text\" \nng-model=\"vm.search\" translate translate-attr-placeholder=\"CONTACTS.SEARCH_FOR_ANYONE\"></md-input-container></div>\n</div><div ng-show=\"vm.selectedContacts.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedContacts =[]\">\n<md-button layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon>\n<span translate=\"CONTACTS.BACK\">Back</span></md-button></div><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div><span class=\"selected-contacts-count\"><span>{{vm.selectedContacts.length}}\n</span> <span translate=\"CONTACTS.SELECTED\">selected</span></span><md-menu class=\"select-menu\" \nng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"multi select toggle\" translate translate-attr-aria-label=\"CONTACTS.MULTI_SELECT_TOGGLE\"><md-icon \nmd-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.selectAllContacts()\" translate=\"CONTACTS.SELECT_ALL\">Select all</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deselectContacts()\" translate=\"CONTACTS.SELECT_NONE\">Select none</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"multi-select-actions\" ng-if=\"vm.groups.length > 0\"><md-menu><md-button \nclass=\"\" translate=\"CONTACTS.ACTIONS\" ng-click=\"$mdMenu.open($event)\">Actions</md-button><md-menu-content width=\"3\">\n<md-list-item ng-click=\"vm.sendMessageToContacts($event, vm.selectedContacts)\"><p class=\"pl-8\" \ntranslate=\"CONTACTS.WRITE_MESSAGE\" ng-style=\"{\'font-weight\':\'500\'}\">Write message</p></md-list-item><md-divider \nng-show=\"vm.groups.length > 0\"></md-divider><md-subheader class=\"md-no-sticky\" ng-show=\"vm.groups.length > 0\">\n{{\'CONTACTS.GROUPS\' | translate}}</md-subheader><md-list-item ng-repeat=\"group in vm.groups\" \nng-click=\"vm.addRemoveUsersFromGroup(group, vm.selectedContacts)\"><p class=\"pl-8\" ng-style=\"{\'font-weight\':\'500\'}\"><i \nng-if=\"vm.showRemoveUsersFromGroupIcon(group, vm.selectedContacts)\" class=\"icon-check\"></i> {{group.title}}</p>\n</md-list-item></md-menu-content></md-menu></div></div></div><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nlayout=\"column\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/contacts/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"main scrollable\" ms-scroll>\n<md-list class=\"contacts-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"list-title\" layout=\"row\" layout-align=\"start center\" \nng-hide=\"showGroupTitleEdit\"><span ng-if=\"vm.listType === \'all\'\" translate=\"CONTACTS.ALL_CONTACTS\">All contacts</span> \n<span ng-if=\"vm.listType === \'frequent\'\" translate=\"CONTACTS.FREQUENTLY_CONTACTED\">Frequnetly contacted</span> <span \nng-if=\"vm.listType.title\">{{vm.listType.title | translate}}</span> <span class=\"secondary-text contacts-count\" \nng-show=\"!vm.loading\">({{vm.contacts.length}})</span></div><div class=\"edit-group-form\" ng-show=\"vm.listType.title\" \nlayout=\"row\" layout-align=\"start center\"><form editable-from name=\"editGroupForm\" ng-show=\"showGroupTitleEdit\"><span \nclass=\"editable-controls\"><input required type=\"text\" class=\"editable-has-buttons editable-input\" \nng-model=\"vm.groupTitle\"> <span class=\"editable-buttons\"><button class=\"btn md-raised md-accent md-button btn-primary\" \ntype=\"submit\" title=\"Submit\" ng-click=\"vm.editGroup()\" aria-label=\"Submit\" translate=\"CONTACTS.SAVE\">Запази</button> \n<button class=\"btn md-raised md-accent md-button btn-primary\" type=\"button\" ng-click=\"vm.hideGroupEditTitleForm()\" \ntitle=\"Cancel\" aria-label=\"Cancel\" translate=\"CONTACTS.CANCEL\">Отказ</button></span></span></form><md-button \nclass=\"md-icon-button edit-group-button\" ng-click=\"vm.showGroupEditTitleForm()\" ng-if=\"!vm.listType.isSystem\" \nng-hide=\"showGroupTitleEdit\" aria-label=\"edit group name\" translate translate-attr-label=\"CONTACTS.EDIT_GROUP_NAME\">\n<md-icon md-font-icon=\"icon-pencil s18\"></md-icon></md-button><md-button class=\"md-icon-button edit-group-button\" \nng-click=\"vm.deleteGroup($event)\" ng-if=\"!vm.listType.isSystem\" ng-hide=\"showGroupTitleEdit\" aria-label=\"delete group\" \ntranslate translate-attr-label=\"CONTACTS.DELETE_GROUP\"><md-icon md-font-icon=\"icon-delete s18\"></md-icon></md-button>\n</div><div flex></div><md-button class=\"md-accent md-raised\" ng-show=\"vm.selectedContacts.length > 0\" \nng-click=\"vm.sendMessageToContacts($event, vm.selectedContacts)\" aria-label=\"Send message\" \ntranslate=\"CONTACTS.WRITE_MESSAGE\" translate-attr-aria-label=\"CONTACTS.WRITE_MESSAGE\">Send message</md-button></div>\n</md-subheader><div class=\"loading\" layout=\"column\" layout-align=\"center center\" ng-show=\"vm.loading\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div \ntranslate=\"CONTACTS.LOADING\">Loading...</div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex \nng-show=\"!vm.loading\"><table id=\"contactsTable\" class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"CONTACTS.NAME\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"CONTACTS.EMAIL\">Email</span></div></th><th><div class=\"table-header\"></div></th></tr>\n</thead><tbody class=\"\"><tr data-ng-repeat=\"contact in vm.contacts\" ng-class=\"{\'selected\': vm.isSelected(contact)}\" \nclass=\"contact-item\"><td class=\"name\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox \nng-checked=\"vm.exists(contact)\" ng-click=\"vm.toggleSelectContact(contact, $event)\" \naria-label=\"{{vm.exists(contact) ? \'Deselect\' : \'Select\'}}\" class=\"chbox\"></md-checkbox><img class=\"avatar\" \nng-if=\"contact.avatar\" alt=\"{{contact.name}}\" ng-src=\"{{contact.avatar}}\"><p class=\"text-truncate font-weight-600\">\n{{contact.name}}</p></div></td><td class=\"email\"><div layout=\"row\" layout-align=\"start center\"><p \nclass=\"text-truncate hide show-gt-sm\">{{contact.email}}</p></div></td><td class=\"opt\"><div class=\"actions\" \nlayout=\"row\" layout-align=\"end center\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"CONTACTS.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdMenu.open($event)\">\n</md-icon></md-button><md-menu-content width=\"3\" ms-scroll><md-list-item \nng-click=\"vm.sendMessageToContact($event, contact)\"><p class=\"pl-8\" translate=\"CONTACTS.WRITE_MESSAGE\" \nng-style=\"{\'font-weight\':\'500\'}\">Write message</p></md-list-item><md-list-item \nng-click=\"vm.cvicProfileService.profile(contact.id)\"><p class=\"pl-8\" translate=\"CONTACTS.PROFILE\" \nng-style=\"{\'font-weight\':\'500\'}\">Profile</p></md-list-item><md-divider ng-show=\"vm.groups.length > 0\"></md-divider>\n<md-subheader class=\"md-no-sticky\" ng-show=\"vm.groups.length > 0\">{{\'CONTACTS.GROUPS\' | translate}}</md-subheader>\n<md-list-item ng-repeat=\"group in vm.groups\" ng-click=\"vm.addRemoveUserToGroup(group, contact)\"><p class=\"pl-8\" \nng-style=\"{\'font-weight\':\'500\'}\"><i class=\"icon-check\" ng-if=\"vm.objGroupsUsersMap[group.uid][contact.entity.uid]\"></i>\n {{group.title}}</p></md-list-item></md-menu-content></md-menu></div></td></tr></tbody></table></div></md-list></div>\n</div></div>");
$templateCache.put("app/main/eventdetails/eventdetails.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-md=\"100\"><ms-widget-front id=\"event-background-img\" \nclass=\"p-16 white-fg details-background-img\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex>\n<div class=\"md-display-3 pb-8 details-background-img-text\">{{vm.event.title}}</div></div><div><img \nng-repeat=\"c in vm.localChildren\" title=\"{{c.title}}\" alt=\"{{c.title}}\" ng-src=\"{{ avatar( c ) }}\" \nclass=\"profile-image avatar big\" style=\"border: 4px solid rgba(255, 255, 255, .5)\"></div></ms-widget-front><md-button \nng-if=\"vm.allowEditEvent && !vm.expired\" class=\"add-event-button md-fab md-warn\" \nng-click=\"vm.showEditEventFormDialog()\" aria-label=\"\'Edit event\'\" translate translate-attr-aria-label=\"\'Edit event\'\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button ng-if=\"vm.allowEditEvent\" \nclass=\"copy-event-button md-fab md-warn\" ng-click=\"vm.copyEvent()\" aria-label=\"\'Edit event\'\" translate \ntranslate-attr-aria-label=\"\'Edit event\'\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon></md-button><md-button \nng-if=\"vm.allowDeleteEvent\" class=\"delete-event-button md-fab md-warn\" ng-click=\"vm.deleteEvent()\" \naria-label=\"\'Delete event\'\" translate translate-attr-aria-label=\"\'Delete event\'\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button></ms-widget><div class=\"content\" flex ms-scroll><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"tab container\"><md-tabs md-dynamic-height><md-tab><md-tab-label>{{\'Info\' | translate}}\n</md-tab-label><md-tab-body><div ng-include=\"\'app/main/info/event-info/event-info-tab.html\'\"></div></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.showAudienceTabs\"><md-tab-label>{{\'Messages\' | translate}}</md-tab-label><md-tab-body><div \nclass=\"event-messages-tab\"><div class=\"content thread-list\" \nng-include=\"\'app/main/mail/views/classic/classic-view.html\'\" ms-scroll flex></div></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.showAudienceTabs\"><md-tab-label>{{\'Documents\' | translate}}</md-tab-label><md-tab-body><div \nng-include=\"\'app/main/file-manager/views/mixed_repo_list.html\'\"></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.showAudienceTabs\"><md-tab-label>{{\'UsersAndGroups\' | translate}}</md-tab-label><md-tab-body><div \nng-include=\"\'app/main/audience/views/list/list-view.html\'\"></div></md-tab-body></md-tab></md-tabs></div>\n</ms-widget-front></ms-widget></div></div></div></div>");
$templateCache.put("app/main/eventsconferences/eventsconferences.html","<div id=\"calendar\" class=\"page-layout simple tabbed\"><div class=\"header orange-bg\"><div class=\"header-content\" \nlayout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\" \ntranslate=\"EventsAndConferences\">Calendar</span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\">\n<div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input key-press-action=\"fnExecuteSearch()\" key-press-code=\"13\" \nclass=\"search-input\" ng-model=\"vm.strSearch\" type=\"text\" placeholder=\"Search..\" translate \ntranslate-attr-placeholder=\"Search\" flex></div></div></div></div><md-button class=\"add-event-button md-fab md-warn\" \nng-click=\"vm.addEvent($event)\" aria-label=\"Add event\" translate translate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon\n md-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content\"><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"h1\">{{vm.myEvents.title | translate}}</span></div></div><div \nclass=\"event-container\"><ms-card ng-repeat=\"row in vm.myEvents.rows\" ui-sref=\"app.eventdetails({uid:row.uid})\" \ntemplate=\"\'app/core/directives/ms-card/templates/template-8/template-8.html\'\" ng-model=\"row\"></ms-card></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"h1\">{{vm.upcomingEvents.title | translate}}</span></div></div>\n<div class=\"event-container\"><ms-card ng-repeat=\"row in vm.upcomingEvents.rows\" \nui-sref=\"app.eventdetails({uid:row.uid})\" \ntemplate=\"\'app/core/directives/ms-card/templates/template-8/template-8.html\'\" ng-model=\"row\"></ms-card></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">\n{{\'Calendar\' | translate}}</div></div><div class=\"calendar-legend\" layout=\"column\" layout-align=\"start start\" \nlayout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><div class=\"calendar-legend-element\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"my-events\"></div><div class=\"calendar-legend-text\" \ntranslate=\"CALENDAR.LEGEND.MY_EVENTS\">My events</div></div><div class=\"calendar-legend-element\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"space-events\"></div><div class=\"calendar-legend-text\" \ntranslate=\"CALENDAR.LEGEND.LEARNING_SPACE_EVENTS\">Space events</div></div><div ng-if=\"vm.isParent\" \nclass=\"calendar-legend-element\" layout=\"row\" layout-align=\"space-between center\"><div class=\"child-events\"></div><div \nclass=\"calendar-legend-text\" translate=\"CALENDAR.LEGEND.STUDENT_EVENTS\">Child events</div></div></div><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" \nng-model=\"vm.events\" calendar=\"main\"></div></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/file-manager/file-manager.html","<div id=\"file-manager\" class=\"page-layout simple right-sidenav\" layout=\"row\"><md-sidenav class=\"main-sidenav\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/file-manager/sidenavs/main/main-sidenav.html\'\" ms-scroll \nms-sidenav-helper></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"header md-accent-bg lime-bg\"><div \nclass=\"header-content\" layout=\"column\" layout-align=\"space-between space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start center\"><div class=\"logo\" \nlayout=\"column\" layout-align=\"start space-between\"><div layout=\"column\" layout-align=\"start start\"><span \nclass=\"logo-text\" translate=\"FM.DOCUMENTS\">Documents</span></div><div id=\"diskSpaceData\" layout=\"column\" \nlayout-align=\"start start\"><div><span translate=\"FM.OCCUPIED_DISK_SPACE\">occupied disk space</span>:&nbsp;<b>\n{{ vm.cvicDocumentService.formatBytes( vm.cvicDocumentService.diskSpace )}}</b>&nbsp;(<b>\n{{ vm.cvicDocumentService.formatBytes( vm.cvicDocumentService.trashDiskSpace ) }}</b>&nbsp;<span \ntranslate=\"FM.TRASH_DISK_SPACE\">trash</span>) &nbsp;<span translate=\"FM.FREE_DISK_SPACE\">free disk space</span>:&nbsp;\n<b>{{vm.cvicDocumentService.formatBytes( vm.cvicDocumentService.freeDiskSpace())}}</b>.</div></div></div><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"><div class=\"right-side\" layout=\"row\"><div class=\"search\" flex \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input\n key-press-action=\"fnExecuteSearch()\" key-press-code=\"13\" class=\"search-input\" ng-model=\"vm.strSearch\" type=\"text\" \nplaceholder=\"Search..\" translate translate-attr-placeholder=\"FM.SEARCH\" flex></div></div></div></div><div \nclass=\"header-top\" layout=\"row\" layout-align=\"start end\"><div class=\"breadcrumb text-truncate\" layout=\"row\" \nlayout-align=\"start end\" ng-show=\"vm.cvicDocumentService.path().length > 0\" \nng-if=\"vm.cvicDocumentService.isDocumentsArea()\" ng-include=\"\'app/main/file-manager/views/location.html\'\"></div></div>\n</div><md-button class=\"add-file-button md-fab md-warn\" upload-file file-input-id=\"document-file-upload\" \naria-label=\"Add file\" translate translate-attr-aria-label=\"FM.ADD_FILE\" \nng-if=\"vm.cvicDocumentService.canAddDocument() && !vm.cvicDocumentService.noFreeDiskSpace()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><input \nng-if=\"vm.cvicDocumentService.canAddDocument() && !vm.cvicDocumentService.noFreeDiskSpace()\" type=\"file\" \nid=\"document-file-upload\" file-change fn-change-handler=\"executeUpload\" style=\"display:none\"><md-button \nclass=\"add-file-button md-fab md-warn\" ng-if=\"vm.cvicDocumentService.noFreeDiskSpace()\" \nng-click=\"vm.cvicDocumentService.noFreeDiskSpaceAlert()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n<md-content ng-if=\"vm.cvicDocumentService.isDocumentsArea()\" class=\"content\" flex ms-scroll><md-tabs md-dynamic-height>\n<md-tab ng-repeat=\"repository in vm.repo\" ng-if=\"repository.visible == true\" \nng-click=\"vm.cvicDocumentService.selectRepo(repository, false)\"><md-tab-label>{{ repository.label }}</md-tab-label>\n<md-tab-body><div ng-include=\"\'app/main/file-manager/views/list/list-view.html\'\"></div></md-tab-body></md-tab>\n</md-tabs></md-content></div><md-sidenav class=\"sidenav details-sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"details-sidenav\" \nng-if=\"vm.cvicDocumentService.isDocumentsArea() && vm.cvicDocumentService.selected()\" \nng-include=\"\'app/main/file-manager/sidenavs/details/details-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav>\n</div>");
$templateCache.put("app/main/mail/mail.html","<div id=\"mail\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg green-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/mail/sidenavs/main/main-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"space-between start\"><md-menu layout=\"row\" \nlayout-align=\"start center\" class=\"settings-menu small-menu\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"Settings\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.composeDialog($event)\"><div><md-icon \nmd-font-icon=\"icon-message-text-outline\" class=\"s16\"></md-icon><span class=\"title\" translate=\"MAIL.COMPOSE\">COMPOSE\n</span></div></md-button></md-menu-item><md-menu-item ng-repeat=\"folder in vm.folders\"><md-button \nng-click=\"vm.loadFolder(folder.name)\" ng-class=\"{\'selected\':vm.isFolderActive(folder.name)}\"><div><md-icon \nmd-font-icon=\"{{folder.icon}}\" class=\"s16\"></md-icon><span class=\"title\">\n{{\"MAIL.\" + folder.title | uppercase | translate}}</span></div></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><div class=\"search\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input \nclass=\"search-input\" ng-model=\"vm.search\" type=\"text\" placeholder=\"Search..\" translate \ntranslate-attr-placeholder=\"Search\" flex></div></div></div></div></div><div class=\"content-card\" \nng-class=\"vm.currentView\" layout=\"column\" flex ng-include=\"vm.views[vm.currentView]\"></div></div></div>");
$templateCache.put("app/main/profile/contact-list.html","<header class=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\">{{ trans_label }}\n</div></header><div class=\"content\"><div class=\"group\" ng-repeat=\"user in collection\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"start start\" \nng-if=\"!cvicJWTService.isCurrentUser(user.uid)\"><img ng-if=\"!user.coverImage\" src=\"assets/images/avatars/profile.jpg\" \nwidth=\"81\" height=\"81\" class=\"logo\"> <img ng-if=\"user.coverImage\" class=\"logo\" alt=\"{{user.title}}\" \nng-src=\"{{ cvicImageService.fnGetResizedImageUrl( cvicImageService.objCONSTANTS.PROFILE_FREQUENT_WIDTH, cvicImageService.objCONSTANTS.PROFILE_FREQUENT_HEIGHT, user.coverImage.uid ) }}\">\n<div class=\"name\" layout=\"row\" layout-align=\"start start\"><a ng-click=\"cvicProfileService.profile(user.uid)\">\n{{user.title}}</a></div></div></div></div>");
$templateCache.put("app/main/profile/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nid=\"profile-img\" class=\"profile-image avatar huge\" ng-src=\"{{varImgSrc}}\"><div class=\"name\">\n{{ cvicProfileService.objAboutResult.title }}</div></div><div class=\"actions\" layout-align=\"end center\" \nng-if=\"vm.bIsEditAllowed || vm.isParent || !cvicProfileService.isCurrent\"><md-button \nng-if=\"vm.isParent && vm.bIsEditAllowed\" ng-click=\"cvicProfileService.orderChild($event)\" class=\"md-accent md-raised\" \naria-label=\"Add student\" translate translate-attr-aria-label=\"ORDER_CHILD.BUTTON\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><span translate=\"ORDER_CHILD.BUTTON\">Add student</span></md-button><md-button \nng-if=\"!cvicProfileService.isCurrent\" \nng-click=\"cvicProfileService.sendMessageUser($event,cvicProfileService.objAboutResult)\" class=\"md-raised md-accent\" \naria-label=\"Send Message\" translate translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\"><md-icon \nmd-font-icon=\"icon-message\"></md-icon><span translate=\"PROFILE.SEND_MESSAGE\">Send a message</span></md-button><md-menu \nng-if=\"!cvicProfileService.isCurrent\"><md-button ng-click=\"$mdMenu.open($event)\" class=\"md-raised md-accent\" \naria-label=\"Add to group\" translate translate-attr-aria-label=\"PROFILE.ADD_TO_GROUP\"><md-icon \nmd-font-icon=\"icon-group\"></md-icon><span translate=\"PROFILE.ADD_TO_GROUP\">Add to group</span></md-button>\n<md-menu-content width=\"3\" ms-scroll><md-list-item class=\"new-group-form\" style=\"padding-top:10px;padding-bottom:10px\">\n<form editable-form name=\"newGroupForm\" onaftersave=\"vm.addNewGroup(vm.newGroupName)\"><span \nclass=\"editable-wrap editable-text ng-scope\"><span class=\"editable-controls\"><input type=\"text\" \nclass=\"editable-input ng-pristine ng-empty ng-invalid ng-invalid-required ng-touched\" placeholder=\"New group\" \ntranslate translate-attr-placeholder=\"PROFILE.NEW_GROUP\" ng-model=\"vm.newGroupName\" aria-invalid=\"true\" \nstyle=\"border: 1px solid rgba(0, 0, 0, 0.2); padding: 4px; font-size: 13px; width: 95%\"></span></span><div \nclass=\"buttons\" layout=\"row\" layout-align=\"end center\"><button type=\"submit\" \nclass=\"btn md-raised md-accent md-button btn-primary\" ng-disabled=\"editableForm.$waiting\">\n{{ \'CONTACTS.SAVE\' | translate }}</button></div></form></md-list-item><md-divider \nng-show=\"cvicProfileService.groups.length > 0\"></md-divider><md-subheader class=\"md-no-sticky\" \nng-show=\"cvicProfileService.groups.length > 0\">{{\"CONTACTS.GROUPS\" | translate}}</md-subheader><md-list-item \nng-repeat=\"group in cvicProfileService.groups\" \nng-click=\"vm.addRemoveUserToGroup(group, cvicProfileService.objAboutResult)\"><p class=\"pl-8\" \nng-style=\"{\'font-weight\':\'500\'}\"><i class=\"icon-check\" \nng-if=\"cvicProfileService.objGroupsUsersMap[group.uid][cvicProfileService.objAboutResult.uid]\"></i> {{group.title}}</p>\n</md-list-item></md-menu-content></md-menu><md-button ng-if=\"vm.bIsEditAllowed\" class=\"md-raised md-primary\" \naria-label=\"Change image\" translate=\"PROFILE.CHANGE_IMAGE\" ng-disabled=\"!vm.bIsEditAllowed\" \ntranslate-attr-aria-label=\"PROFILE.CHANGE_IMAGE\" upload-file file-input-id=\"profile-img-file\">Change Image</md-button>\n<input id=\"profile-img-file\" accept=\"image/x-png,image/gif,image/jpeg\" file-change fn-change-handler=\"fnAddImage\" \ntype=\"file\" style=\"visibility: hidden; position: absolute; width: 1px; height: 1px\"><md-button \nng-if=\"vm.bIsEditAllowed\" class=\"md-raised md-primary\" ng-click=\"fnResetPass()\" ng-disabled=\"!vm.bIsEditAllowed\" \ntranslate=\"PROFILE.RESET_PASS\" translate-attr-aria-label=\"PROFILE.RESET_PASS\">Reset Password</md-button></div></div>\n<div class=\"loading-profile\" layout=\"column\" layout-align=\"center center\" ng-show=\"vm.loading\"><md-progress-circular \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div translate=\"PROFILE.LOADING\">\nLoading...</div></div><div class=\"content\" flex ng-show=\"!vm.loading\"><md-tabs md-dynamic-height \nmd-selected=\"intSelectedTabIndex\" ng-if=\"cvicProfileService.isCurrent || cvicProfileService.isCurrentParentOf\"><md-tab>\n<md-tab-label><span translate=\"PROFILE.ABOUT_ME\">About</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-if=\"cvicProfileService.isCurrent\" ng-include=\"\'app/main/profile/tabs/about/about_me.html\'\"></md-content><md-content \nclass=\"about-tab\" ng-if=\"cvicProfileService.isCurrentParentOf\" \nng-include=\"\'app/main/profile/tabs/about/about_ch.html\'\"></md-content><md-content class=\"about-tab\" \nng-if=\"!cvicProfileService.isCurrent && !cvicProfileService.isCurrentParentOf\" \nng-include=\"\'app/main/profile/tabs/about/about.html\'\"></md-content></md-tab-body></md-tab><md-tab \nng-if=\"cvicProfileService.isCurrent || cvicProfileService.isCurrentParentOf\" \nng-repeat=\"(key, value) in cvicProfileService.objGradesResult\"><md-tab-label><span \nng-show=\"cvicProfileService.objAboutResult.uid != key || cvicProfileService.isCurrentParentOf\">\n{{ value[0].user.title }} - {{ \'PROFILE.GRADES\' | translate }}</span> <span \nng-show=\"cvicProfileService.objAboutResult.uid == key && cvicProfileService.isCurrent\">\n{{ \'PROFILE.MY_GRADES\' | translate }}</span></md-tab-label><md-tab-body><md-content class=\"grades-tab\" \nng-include=\"\'app/main/profile/tabs/grades/grades.html\'\"></md-content></md-tab-body></md-tab><md-tab \nng-if=\"cvicProfileService.isCurrent\"><md-tab-label><span translate=\"PROFILE.PORTFOLIO\">Portfolio</span></md-tab-label>\n<md-tab-body><div ng-include=\"\'app/main/file-manager/views/mixed_repo_list.html\'\"></div></md-tab-body></md-tab>\n</md-tabs><md-content class=\"about-tab\" ng-if=\"!cvicProfileService.isCurrent && !cvicProfileService.isCurrentParentOf\" \nng-include=\"\'app/main/profile/tabs/about/about.html\'\"></md-content></div></div>");
$templateCache.put("app/main/search/search.html","<div id=\"search\" layout=\"column\"><div class=\"header md-accent-bg {{cvicSearchService.selectorMode ? \'selector\' : \'\'}}\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"search\" layout=\"row\" layout-md=\"column\" layout-sm=\"column\" \nlayout-xs=\"column\" layout-align=\"space-between center\" layout-align-md=\"space-between start\" \nlayout-align-sm=\"space-between start\" layout-align-xs=\"space-between start\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input \nclass=\"search-input\" ng-model=\"vm.strSearchTerm\" key-press-action=\"fnExecuteSearch()\" key-press-code=\"13\" type=\"text\" \nplaceholder=\"Search..\" translate translate-attr-placeholder=\"SEARCH.SEARCH\" flex></div><div \nng-if=\"!cvicSearchService.selectorMode\" layout=\"row\" layout-align=\"end center\"><select \nng-model=\"cvicSearchService.enumType\" ng-change=\"fnChangeSearchType()\"><option \nvalue=\"{{ cvicSearchService.enumSearchType.Mixed }}\">{{ \'SEARCH.ALL\' | translate }}</option><option \nvalue=\"{{ cvicSearchService.enumSearchType.Spaces }}\">{{ \'SEARCH.SPACE\' | translate }}</option><option \nvalue=\"{{ cvicSearchService.enumSearchType.Events }}\">{{ \'SEARCH.EVENT\' | translate }}</option><option \nvalue=\"{{ cvicSearchService.enumSearchType.Documents }}\">{{ \'SEARCH.DOCUMENT\' | translate }}</option><option \nvalue=\"{{ cvicSearchService.enumSearchType.Messages }}\">{{ \'SEARCH.MESSAGE\' | translate }}</option><option \nvalue=\"{{ cvicSearchService.enumSearchType.Users }}\">{{ \'SEARCH.USER\' | translate }}</option></select></div></div>\n</div><div class=\"loading\" layout=\"column\" layout-align=\"center center\" ng-if=\"cvicSearchService.loading\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div \ntranslate=\"SEARCH.LOADING\">Loading...</div></div><div class=\"content right-sidenav\" layout=\"row\" \nng-if=\"!cvicSearchService.loading\"><md-content class=\"center scrollable\" ms-scroll flex layout=\"column\"><div \nng-if=\"cvicSearchService.requestExecuted\" class=\"result-info center\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\" layout-align-xs=\"start start\"><div><span \nng-if=\"cvicSearchService.enumType == cvicSearchService.enumSearchType.Mixed\" class=\"md-title\" translate=\"SEARCH.Mixed\">\n</span> <span ng-if=\"cvicSearchService.enumType == cvicSearchService.enumSearchType.Spaces\" class=\"md-title\" \ntranslate=\"SEARCH.LearningSpaces\"></span> <span \nng-if=\"cvicSearchService.enumType == cvicSearchService.enumSearchType.Events\" class=\"md-title\" \ntranslate=\"SEARCH.Events\"></span> <span \nng-if=\"cvicSearchService.enumType == cvicSearchService.enumSearchType.Documents\" class=\"md-title\" \ntranslate=\"SEARCH.Documents\"></span> <span \nng-if=\"cvicSearchService.enumType == cvicSearchService.enumSearchType.Messages\" class=\"md-title\" \ntranslate=\"SEARCH.Messages\"></span> <span ng-if=\"cvicSearchService.enumType == cvicSearchService.enumSearchType.Users\" \nclass=\"md-title\" translate=\"SEARCH.Users\"></span><br><span class=\"secondary-text\"><span>\n{{cvicSearchService.objResultSet.total}}</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div \nng-show=\"cvicSearchService.objResultSet.total > 0\" class=\"pager\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"secondary-text\"><span translate=\"SEARCH.RESULTS_DOT\">Results:</span> </span><span class=\"page-info\"><span>\n{{cvicSearchService.fnGetStartPosition()}}</span> <span>-</span> <span>{{cvicSearchService.fnGetEndPosition()}}</span> \n<span translate=\"SEARCH.OF\">of</span> <span>{{cvicSearchService.objResultSet.total}}</span></span><md-button \nng-show=\"cvicSearchService.fnGetPages() > 1\" ng-disabled=\"cvicSearchService.intCurrentPage == 0\" \nclass=\"md-icon-button\" aria-label=\"previous page\" ng-click=\"fnPreviousPage()\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button ng-show=\"cvicSearchService.fnGetPages() > 1\" \nng-disabled=\"(cvicSearchService.intCurrentPage + 1) == cvicSearchService.fnGetPages()\" class=\"md-icon-button\" \naria-label=\"next page\" ng-click=\"fnNextPage()\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><md-content class=\"results_content\"><div class=\"results\"><div \nng-if=\"cvicSearchService.enumType == cvicSearchService.enumSearchType.Mixed\n	            			|| cvicSearchService.enumType == cvicSearchService.enumSearchType.Messages\n	            			|| cvicSearchService.enumType == cvicSearchService.enumSearchType.Users\n	            \">\n<div class=\"result-item\" ng-class=\"{\'selected\' : vm.strUid == item.uid}\" \nng-repeat=\"item in cvicSearchService.objResultSet.elements\" md-ink-ripple ng-click=\"fnGoToItem(item)\"><div \nlayout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-show=\"cvicSearchService.selectorMode\" \nng-checked=\"cvicSearchService.isSelected(item)\" ng-click=\"cvicSearchService.toggleSelected(item, $event)\" \naria-label=\"{{cvicSearchService.isSelected(item) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><img class=\"avatar\" \nng-if=\"item.coverImage != null\" ng-src=\"{{cvicImageService.fnGetResizedImageUrl(40, 40, item.coverImage.uid)}}\"><div \nclass=\"avatar\" ng-if=\"item.coverImage == null\" ms-random-class=\"vm.colors\">{{item.title.charAt(0)}}</div><div \nclass=\"info\" flex layout=\"column\"><div class=\"name text-truncate\">{{item.title}}</div><div \nng-show=\"item[\'@class\'] != cvicSearchService.enumObjectType.Document\" class=\"subject secondary-text text-truncate\">\n{{item.description}}</div><div ng-show=\"item[\'@class\'] == cvicSearchService.enumObjectType.Document\" \nclass=\"subject secondary-text\" layout=\"row\" layout-align=\"start start\"><span class=\"text-truncate\" \nng-if=\"item.organization\">{{item.organization.title}} </span><span class=\"text-truncate\" ng-if=\"!item.organization\" \ntranslate=\"SEARCH.MY_COCUMENTS\">My documents </span><span class=\"text-truncate\" ng-if=\"item.parentFolder\">\n>> {{item.title}}</span></div><div \nng-if=\"item[\'@class\'] == cvicSearchService.enumObjectType.Document && item.settings && item.settings.tags\" \nlayout=\"row\" layout-align=\"start start\" class=\"labels\"><div class=\"label\" ng-repeat=\"tag in item.settings.tags\">{{tag}}\n</div></div></div><div layout=\"column\" layout-align=\"center end\"><div class=\"time secondary-text\"><i \nng-show=\"item[\'@class\'] == cvicSearchService.enumObjectType.Event\" class=\"icon s16 icon-calendar-blank\"></i> <i \nclass=\"smaller\" ng-show=\"item[\'@class\'] == cvicSearchService.enumObjectType.Event\">{{ \'SEARCH.EVENT\' | translate }}</i>\n <i ng-show=\"item[\'@class\'] == cvicSearchService.enumObjectType.Space\" class=\"icon s16 icon-bulletin-board\"></i> <i \nclass=\"smaller\" ng-show=\"item[\'@class\'] == cvicSearchService.enumObjectType.Space\">{{ \'SEARCH.SPACE\' | translate }}</i>\n <i ng-show=\"item[\'@class\'] == cvicSearchService.enumObjectType.Message\" class=\"icon s16 icon-email\"></i> <i \nclass=\"smaller\" ng-show=\"item[\'@class\'] == cvicSearchService.enumObjectType.Message\">{{ \'SEARCH.MESSAGE\' | translate }}\n</i> <i ng-show=\"item[\'@class\'] == cvicSearchService.enumObjectType.Document\" class=\"icon s16 icon-folder\"></i> <i \nclass=\"smaller\" ng-show=\"item[\'@class\'] == cvicSearchService.enumObjectType.Document\">\n{{ \'SEARCH.DOCUMENT\' | translate }}</i> <i ng-show=\"item[\'@class\'] == cvicSearchService.enumObjectType.User\" \nclass=\"icon s16 icon-account-box\"></i> <i class=\"smaller\" \nng-show=\"item[\'@class\'] == cvicSearchService.enumObjectType.User\">{{ \'SEARCH.USER\' | translate }}</i></div></div></div>\n</div></div><div ng-if=\"cvicSearchService.enumType == cvicSearchService.enumSearchType.Spaces\"><div \nclass=\"result-item\" ng-repeat=\"item in cvicSearchService.objResultSet.elements\" md-ink-ripple \nng-click=\"fnGoToItem(item)\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \nng-show=\"cvicSearchService.selectorMode\" ng-checked=\"cvicSearchService.isSelected(item)\" \nng-click=\"cvicSearchService.toggleSelected(item, $event)\" \naria-label=\"{{cvicSearchService.isSelected(item) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><img class=\"avatar\" \nng-if=\"item.coverImage != null\" ng-src=\"{{cvicImageService.fnGetResizedImageUrl(40, 40, item.coverImage.uid)}}\"><div \nclass=\"avatar\" ng-if=\"item.coverImage == null\" ms-random-class=\"vm.colors\">{{item.title.charAt(0)}}</div><div \nclass=\"info\" flex layout=\"column\"><div class=\"name text-truncate\">{{item.title}}</div><div \nclass=\"subject secondary-text text-truncate\">{{item.description}}</div></div><div layout=\"column\" \nlayout-align=\"center end\"><div class=\"time secondary-text\">{{mail.time}}</div></div></div></div></div><div \nng-if=\"cvicSearchService.enumType == cvicSearchService.enumSearchType.Events\"><div class=\"result-item\" \nng-repeat=\"item in cvicSearchService.objResultSet.elements\" md-ink-ripple ng-click=\"fnGoToItem(item)\"><div \nlayout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-show=\"cvicSearchService.selectorMode\" \nng-checked=\"cvicSearchService.isSelected(item)\" ng-click=\"cvicSearchService.toggleSelected(item, $event)\" \naria-label=\"{{cvicSearchService.isSelected(item) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><img class=\"avatar\" \nng-if=\"item.coverImage != null\" ng-src=\"{{cvicImageService.fnGetResizedImageUrl(40, 40, item.coverImage.uid)}}\"><div \nclass=\"avatar\" ng-if=\"item.coverImage == null\" ms-random-class=\"vm.colors\">{{item.title.charAt(0)}}</div><div \nclass=\"info\" flex layout=\"column\"><div class=\"name text-truncate\">{{item.title}} - {{ fnDisplayDate(item.startDate); }}\n</div><div class=\"subject secondary-text text-truncate\">{{item.description}}</div></div><div layout=\"column\" \nlayout-align=\"center end\"><div class=\"time secondary-text\">{{mail.time}}</div></div></div></div></div><div \nng-if=\"cvicSearchService.enumType == cvicSearchService.enumSearchType.Documents\"><div class=\"result-item\" \nng-class=\"{\'selected\' : vm.strUid == item.uid}\" ng-repeat=\"item in cvicSearchService.objResultSet.elements\" \nmd-ink-ripple ng-click=\"fnGoToItem(item)\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \nng-show=\"cvicSearchService.selectorMode\" ng-checked=\"cvicSearchService.isSelected(item)\" \nng-click=\"cvicSearchService.toggleSelected(item, $event)\" \naria-label=\"{{cvicSearchService.isSelected(item) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><img class=\"avatar\" \nng-if=\"item.coverImage != null\" ng-src=\"{{cvicImageService.fnGetResizedImageUrl(40, 40, item.coverImage.uid)}}\"> <i \nng-if=\"item.coverImage == null\" class=\"icon-{{cvicImageService.iconType(item.simpleType)}}\"></i><div class=\"info\" flex \nlayout=\"column\"><div class=\"name text-truncate\">{{item.title}}</div><div class=\"subject secondary-text\" layout=\"row\" \nlayout-align=\"start start\"><span class=\"text-truncate\" ng-if=\"item.organization\">{{item.organization.title}} </span>\n<span class=\"text-truncate\" ng-if=\"!item.organization\" translate=\"SEARCH.MY_COCUMENTS\">My documents </span><span \nclass=\"text-truncate\" ng-if=\"item.parentFolder\">>> {{item.title}}</span></div><div \nng-if=\"item.settings && item.settings.tags\" layout=\"row\" layout-align=\"start start\" class=\"labels\"><div class=\"label\" \nng-repeat=\"tag in item.settings.tags\">{{tag}}</div></div></div><div layout=\"column\" layout-align=\"center end\"><div \nclass=\"time secondary-text\">{{mail.time}}</div></div></div></div></div></div></md-content><div \nng-show=\"cvicSearchService.requestExecuted && cvicSearchService.fnGetPages() > 1\" class=\"simple-pagination\"><md-button \nng-disabled=\"cvicSearchService.intCurrentPage == 0\" ng-class=\"{\'disabled\': cvicSearchService.intCurrentPage == 0}\" \nclass=\"pagination-item\" ng-click=\"fnPreviousPage()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button>\n<md-button ng-disabled=\"cvicSearchService.intCurrentPage == $index\" \nng-class=\"{\'active\': cvicSearchService.intCurrentPage == $index}\" \nng-repeat=\"i in cvicSearchService.fnGetPagesForRepeat() track by $index\" class=\"pagination-item\" \nng-show=\"cvicSearchService.fnShowPage($index)\" ng-click=\"fnChangePage($index)\"><span>{{$index + 1}}</span></md-button>\n<md-button ng-disabled=\"(cvicSearchService.intCurrentPage + 1) == cvicSearchService.fnGetPages()\" \nng-class=\"{\'disabled\': (cvicSearchService.intCurrentPage + 1) == cvicSearchService.fnGetPages() }\" \nclass=\"pagination-item\" ng-click=\"fnNextPage()\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</md-content><md-sidenav class=\"sidenav details-sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"details-sidenav\" ng-if=\"vm.viewSideNav\" \nng-include=\"\'app/main/file-manager/sidenavs/details/details-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav>\n</div></div>");
$templateCache.put("app/main/spacedetails/spacedetails.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-md=\"100\"><ms-widget-front id=\"space-background-img\" \nclass=\"p-16 white-fg details-background-img\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex>\n<div class=\"md-display-3 pb-8 details-background-img-text\">{{vm.space.title}}</div></div><div><img \nng-repeat=\"c in vm.localChildren\" title=\"{{c.title}}\" alt=\"{{c.title}}\" ng-src=\"{{ avatar( c ) }}\" \nclass=\"profile-image avatar big\" style=\"border: 4px solid rgba(255, 255, 255, .5)\"></div></ms-widget-front><md-button \nng-if=\"vm.allowEditSpace\" class=\"add-space-button md-fab md-warn\" ng-click=\"vm.showSpaceEditFormDialog()\" \naria-label=\"\'Administration\'\" translate translate-attr-aria-label=\"\'Administration\'\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button ng-if=\"vm.allowDeleteSpace\" \nclass=\"delete-space-button md-fab md-warn\" ng-click=\"vm.deleteSpace()\" aria-label=\"\'Delete space\'\" translate \ntranslate-attr-aria-label=\"\'Delete space\'\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></ms-widget><div \nclass=\"content\" flex ms-scroll><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"tab container\"><md-tabs md-dynamic-height><md-tab><md-tab-label>{{\'Info\' | translate}}</md-tab-label>\n<md-tab-body><div ng-include=\"\'app/main/info/space-info/space-info-tab.html\'\"></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.showAudienceTabs\"><md-tab-label>{{\'Messages\' | translate}}</md-tab-label><md-tab-body><div \nclass=\"messages-tab\"><div class=\"content thread-list\" ng-include=\"\'app/main/mail/views/classic/classic-view.html\'\" \nms-scroll flex></div></div></md-tab-body></md-tab><md-tab ng-if=\"vm.showAudienceTabs\"><md-tab-label>\n{{\'Events\' | translate}}</md-tab-label><md-tab-body><div class=\"widget-group event-conferences\" layout=\"row\" \nflex=\"100\" layout-wrap><div class=\"compose-button\" layout=\"row\" flex=\"100\" flex-gt-md=\"100\" \nng-if=\"vm.showComposeMessageBtn\"><md-button class=\"md-accent md-raised\" aria-label=\"compose\" \nng-click=\"vm.showEventFormDialog($event)\" translate=\"MAIL.COMPOSE\">COMPOSE</md-button></div><ms-widget \nflippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"100\"><div class=\"event-container\"><ms-card \nng-repeat=\"row in vm.events.rows\" ui-sref=\"app.eventdetails({uid:row.uid})\" \ntemplate=\"\'app/core/directives/ms-card/templates/template-8/template-8.html\'\" ng-model=\"row\"></ms-card></div>\n</ms-widget></div></md-tab-body></md-tab><md-tab ng-if=\"vm.showAudienceTabs\"><md-tab-label>{{\'Documents\' | translate}}\n</md-tab-label><md-tab-body><div ng-include=\"\'app/main/file-manager/views/mixed_repo_list.html\'\"></div></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.showAudienceTabs\"><md-tab-label>{{\'UsersAndGroups\' | translate}}</md-tab-label><md-tab-body>\n<div ng-include=\"\'app/main/audience/views/list/list-view.html\'\"></div></md-tab-body></md-tab></md-tabs></div>\n</ms-widget-front></ms-widget></div></div></div></div>");
$templateCache.put("app/main/spaces/spaces.html","<div id=\"space\" class=\"page-layout simple tabbed\"><div class=\"header light-light-blue\"><div class=\"header-content\" \nlayout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\" \ntranslate=\"LearningSpaces\">Learning spaces</span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\">\n<div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input key-press-action=\"fnExecuteSearch()\" key-press-code=\"13\" \nclass=\"search-input\" ng-model=\"vm.strSearch\" type=\"text\" placeholder=\"Search..\" translate \ntranslate-attr-placeholder=\"Search\" flex></div></div></div></div><md-button class=\"add-space-button md-fab md-warn\" \nng-click=\"vm.addSpace($event)\" aria-label=\"Add space\" translate translate-attr-aria-label=\"AddSpace\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content\"><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"h1\">{{vm.mySpaces.title | translate}}</span></div></div><div \nclass=\"space-container\"><ms-card ng-repeat=\"row in vm.mySpaces.rows\" ui-sref=\"app.spacedetails({uid:row.uid})\" \ntemplate=\"\'app/core/directives/ms-card/templates/template-1/template-1.html\'\" ng-model=\"row\"></ms-card></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"h1\">{{vm.upcomingSpaces.title | translate}}</span></div></div>\n<div class=\"space-container\"><ms-card ng-repeat=\"row in vm.upcomingSpaces.rows\" \nui-sref=\"app.spacedetails({uid:row.uid})\" \ntemplate=\"\'app/core/directives/ms-card/templates/template-1/template-1.html\'\" ng-model=\"row\"></ms-card></div>\n</ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/trash/trash.html","<div id=\"trash\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg blue-grey-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input\" ng-model=\"vm.strSearchTerm\" \nkey-press-action=\"fnExecuteSearch()\" key-press-code=\"13\" type=\"text\" placeholder=\"Search..\" translate \ntranslate-attr-placeholder=\"TRASH.SEARCH\" flex></div></div><div class=\"content\" flex><div class=\"result-info\" \nlayout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\"><div><span \nclass=\"secondary-text\"><span>{{cvicTrashService.objResultSet.total}}</span> <span translate=\"TRASH.RESULTS\">Results\n</span></span></div><div class=\"pager\" layout=\"row\" layout-align=\"start center\"><span class=\"secondary-text\"><span \ntranslate=\"TRASH.RESULTS\">Results</span> <span>:</span> </span><span class=\"page-info\"><span>\n{{cvicTrashService.fnGetStartPosition()}}</span> <span>-</span> <span>{{cvicTrashService.fnGetEndPosition()}}</span> \n<span translate=\"TRASH.OF\">of</span> <span>{{cvicTrashService.objResultSet.total}}</span></span><md-button \nng-disabled=\"cvicTrashService.intCurrentPage == 0\" class=\"md-icon-button\" aria-label=\"previous page\" \nng-click=\"fnPreviousPage()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button \nng-disabled=\"(cvicTrashService.intCurrentPage + 1) == cvicTrashService.fnGetPages()\" class=\"md-icon-button\" \naria-label=\"next page\" ng-click=\"fnNextPage()\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><table class=\"results simple clickable\" ms-responsive-table><thead><tr><th></th><th translate=\"TRASH.CAPTION\">\nName</th><th translate=\"TRASH.DESCRIPTION\">Position</th><th translate=\"TRASH.TYPE\">Phone</th><th \ntranslate=\"TRASH.DELETED\">Email</th><th translate=\"TRASH.ACTIONS\">Actions</th></tr></thead><tbody><tr \nclass=\"result-item\" ng-repeat=\"item in cvicTrashService.objResultSet.elements\"><td class=\"text-left avatar-cell\" \nng-if=\"item.coverImage != null\"><img class=\"avatar\" alt=\"{{item.title}}\" \nng-src=\"{{cvicImageService.fnGetResizedImageUrl(40, 40, item.coverImage.uid)}}\"></td><td class=\"text-left avatar-cell\" \nng-if=\"item.coverImage == null\"><div class=\"avatar\" ms-random-class=\"vm.colors\">{{item.title[0]}}</div></td><td \nclass=\"name\">{{item.title}}</td><td class=\"position\">{{item.description}}</td><td class=\"phone\"><span \nng-show=\"cvicTrashService.fnIsSpace(item)\">{{ \'TRASH.SPACE\' | translate }}</span> <span \nng-show=\"cvicTrashService.fnIsEvent(item)\">{{ \'TRASH.EVENT\' | translate }}</span> <span \nng-show=\"cvicTrashService.fnIsMessage(item)\">{{ \'TRASH.MESSAGE\' | translate }}</span> <span \nng-show=\"cvicTrashService.fnIsDocument(item)\">{{ \'TRASH.DOCUMENT\' | translate }}</span> <span \nng-show=\"cvicTrashService.fnIsUser(item)\">{{ \'TRASH.USER\' | translate }}</span></td><td class=\"email\">\n{{ cvicDateService.fnGetDateObject(item.deleted) | date:cvicDateService.fnGetFormat() }}</td><td class=\"actions\"><i \nng-click=\"fnRestore(item)\" class=\"icon-backup-restore\"></i> <i ng-click=\"fnDelete(item)\" class=\"icon-delete\"></i></td>\n</tr></tbody></table><div class=\"simple-pagination\"><md-button ng-disabled=\"cvicTrashService.intCurrentPage == 0\" \nng-class=\"{\'disabled\': cvicTrashService.intCurrentPage == 0}\" class=\"pagination-item\" ng-click=\"fnPreviousPage()\">\n<md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button \nng-disabled=\"cvicTrashService.intCurrentPage == $index\" \nng-class=\"{\'active\': cvicTrashService.intCurrentPage == $index}\" \nng-repeat=\"i in cvicTrashService.fnGetPagesForRepeat() track by $index\" class=\"pagination-item\" \nng-show=\"cvicTrashService.fnShowPage($index)\" ng-click=\"fnChangePage($index)\"><span>{{$index + 1}}</span></md-button>\n<md-button ng-disabled=\"(cvicTrashService.intCurrentPage + 1) == cvicTrashService.fnGetPages()\" \nng-class=\"{\'disabled\': (cvicTrashService.intCurrentPage + 1) == cvicTrashService.fnGetPages() }\" \nclass=\"pagination-item\" ng-click=\"fnNextPage()\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div></div>");
$templateCache.put("app/core/errors/error-message/error-message.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"{{error + \'.TITLE\'}}\">Error</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CLOSE_ERROR_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"event-details\" layout=\"column\"><div \nclass=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><div class=\"h2\" translate=\"{{error + \'.MESSAGE\'}}\">\nERROR MESSAGE</div></div></div><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"closeDialog()\" class=\"save-button md-accent md-raised\" aria-label=\"OK\" translate=\"CLOSE_ERROR_DIALOG\" \ntranslate-attr-aria-label=\"Ok\">OK</md-button></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdMenu.open($event)\"><ms-color-picker-button><md-button\n aria-label=\"Row Color\" md-menu-origin ng-click=\"$mdMenu.open($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/audience/chips/chips.html","<div id=\"audiencechips\" ng-controller=\"AudienceChipController as vm\" layout=\"column\" ng-cloak><md-content \nclass=\"autocomplete\" layout=\"column\"><md-contact-chips ng-model=\"audience\" md-contacts=\"vm.delayedQuerySearch($query)\" \nmd-contact-name=\"name\" md-contact-image=\"image\" md-contact-email=\"contact_info\" md-require-match=\"true\" \nmd-highlight-flags=\"i\" filter-selected=\"vm.filterSelected\" placeholder=\"\"></md-contact-chips></md-content></div>");
$templateCache.put("app/main/auth/login/login-v2.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" class=\"flex-scrollable\" ms-scroll flex \nhide show-gt-sm><div class=\"row\"><div style=\"text-align:left\"><a href=\"https://classbg.online/\"><img \nsrc=\"assets/images/dummy/logo.png\" alt=\"img\" height=\"30\"></a></div></div><div><div class=\"title eu-project-text\" flex \ntranslate=\"LOGIN_V2.INTRO_TITLE\">Welcome to the C.VIC!</div><div class=\"description eu-project-text\" flex \ntranslate=\"LOGIN_V2.INTRO_DESCRIPTION\">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div><div class=\"description eu-project-text\" flex translate=\"LOGIN_V2.INTRO_DESCRIPTION_2\">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div class=\"footer-copyright\" flex layout=\"row\" layout-align=\"start end\" hide show-gt-sm><div \nclass=\"container\"><div class=\"row\"><div style=\"text-align:left\"><img style=\"height: 25%; width: 25%\" \nsrc=\"assets/images/dummy/eu_logos.png\" alt=\"img\" height=\"30\" \ntitle=\"Създадено с финансовата подкрепа на Оперативна програма „Иновации и конкурентоспособност“ 2014-2020 г. по проект № BG16RFOP002-1.001-0024-C01\">\n<p class=\"eu-project-text\">\nСъздадено с финансовата подкрепа на Оперативна програма „Иновации и конкурентоспособност“ 2014-2020 г.<br>\nпо проект № BG16RFOP002-1.001-0024-C01</p><p>\nСофтуер за интеграция със системи за дистанционно обучение и софтуер за създаване на съдържание - CViC-ILMS-1.0</p>\n</div></div></div></div></div><div id=\"login-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div \nid=\"login-v2-form\"><div style=\"margin-left: auto; margin-right: auto; padding-bottom: 30px; padding-top:20px\" \nhide-gt-sm><img class=\"md-logo-img\" src=\"assets/images/dummy/logo.png\" alt=\"img\" height=\"30\" title=\"logo\"></div><div \nclass=\"title\" translate=\"LOGIN_V2.TITLE\">Log in to your account</div><div class=\"description\" \ntranslate=\"LOGIN_V2.DESCRIPTION\">Sed mollis velit facilisis facilisis viverra</div><form name=\"loginForm\" \nng-submit=\"submit()\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"text\" name=\"email\" \nng-change=\"removeErrors()\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"LOGIN_V2.EMAIL\" required><div ng-messages=\"loginForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"invalid\"><span translate=\"LOGIN_V2.ERRORS.EMAIL_INVALID\">Invalid email or password\n</span></div><div ng-message=\"required\"><span translate=\"LOGIN_V2.ERRORS.EMAIL_REQUIRED\">Email field is required</span>\n</div><div ng-message=\"pattern\"><span translate=\"LOGIN_V2.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address\n</span></div><div ng-message=\"no_access\"><span translate=\"LOGIN_V2.ERRORS.EMAIL_NO_ACCESS\">\nYour account is temporary disabled</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input type=\"password\" name=\"password\" ng-change=\"removeErrors()\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"LOGIN_V2.PASSWORD\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"invalid\"><span \ntranslate=\"LOGIN_V2.ERRORS.PASSOWRD_INVALID\">Invalid email or password</span></div><div ng-message=\"required\"><span \ntranslate=\"LOGIN_V2.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"org-auto\"><md-autocomplete md-input-name=\"organization\" placeholder=\'{{\"LOGIN_V2.ORGANIZATION\" | translate }}\' \nmd-selected-item=\"vm.form.organization\" md-search-text=\"searchText\" md-items=\"org in getOrganizations(searchText)\" \nmd-item-text=\"org.title\" md-search-text-change=\"organizationErrorCheck(searchText)\" \nmd-selected-item-change=\"organizationErrorCheck(searchText)\"><md-item-template><span>{{org.title}} ({{org.type}})\n</span></md-item-template><md-not-found class=\"form-message-error\"><span translate=\"LOGIN_V2.ORG_NO_MATCHES\">\nNo matches found.</span></md-not-found></md-autocomplete><div class=\"form-message-error\" \nng-messages=\"loginForm.organization.$error\"><div ng-message=\"real_orgranization\"><span \ntranslate=\"LOGIN_V2.ERRORS.REAL_ORG\">Pleace select an organization from the menu or leave the field empty.</span></div>\n</div></div><div class=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-between center\">\n<md-checkbox class=\"remember-me\" ng-model=\"vm.data.cb1\" aria-label=\"Remember Me\"><span \ntranslate=\"LOGIN_V2.REMEMBER_ME\">Remember Me</span></md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" \nclass=\"forgot-password md-accent-color\" translate=\"LOGIN_V2.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN_V2.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN_V2.LOG_IN\">LOG IN</md-button></form><div class=\"register\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN_V2.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_register-v2\" translate=\"LOGIN_V2.CREATE_ACCOUNT\">\nCreate an account</a></div></div><div class=\"countdown\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\">\n<span>ИДЕНТ. №. ПО ЗЗЛД: 1137344</span></div><div class=\"footer-copyright\" flex layout=\"row\" \nlayout-align=\"center center\" hide show-xs show-sm><div class=\"container\"><div class=\"row\"><div \nstyle=\"text-align:center\"><img style=\"height: 25%; width: 25%\" src=\"assets/images/dummy/eu_logos.png\" alt=\"img\" \nheight=\"30\" \ntitle=\"Създадено с финансовата подкрепа на Оперативна програма „Иновации и конкурентоспособност“ 2014-2020 г. по проект № BG16RFOP002-1.001-0024-C01\">\n<p class=\"eu-project-text\">\nСъздадено с финансовата подкрепа на Оперативна програма „Иновации и конкурентоспособност“ 2014-2020 г.<br>\nпо проект № BG16RFOP002-1.001-0024-C01</p><p>Софтуер за мобилно приложение - CViC-APP-1.0</p></div></div></div></div>\n</div></div>");
$templateCache.put("app/main/auth/register/register-v2.html","<div id=\"register-v2\" layout=\"row\" layout-align=\"start\"><div id=\"register-v2-intro\" class=\"flex-scrollable\" ms-scroll \nflex hide show-gt-sm><div class=\"row\"><div style=\"text-align:left\"><a href=\"https://classbg.online/\"><img \nsrc=\"assets/images/dummy/logo.png\" alt=\"img\" height=\"30\"></a></div></div><div><div class=\"title eu-project-text\" flex \ntranslate=\"REGISTER_V2.INTRO_TITLE\">Welcome to the C.VIC!</div><div class=\"description eu-project-text\" flex \ntranslate=\"REGISTER_V2.INTRO_DESCRIPTION\"><h2>Your class in the cloud - useful, innovative, cutting-edge</h2></div><div\n class=\"description eu-project-text\" flex translate=\"REGISTER_V2.INTRO_DESCRIPTION_2\">\nCViC integrates all the possibilities of virtual classroom, learning management system and educational resources.</div>\n</div><div class=\"footer-copyright\" flex layout=\"row\" layout-align=\"start end\" hide show-gt-sm><div class=\"container\">\n<div class=\"row\"><div style=\"text-align:left\"><img style=\"height: 25%; width: 25%\" \nsrc=\"assets/images/dummy/eu_logos.png\" alt=\"img\" height=\"30\" \ntitle=\"Създадено с финансовата подкрепа на Оперативна програма „Иновации и конкурентоспособност“ 2014-2020 г. по проект № BG16RFOP002-1.001-0024-C01\">\n<p class=\"eu-project-text\">\nСъздадено с финансовата подкрепа на Оперативна програма „Иновации и конкурентоспособност“ 2014-2020 г.<br>\nпо проект № BG16RFOP002-1.001-0024-C01</p><p>\nСофтуер за интеграция със системи за дистанционно обучение и софтуер за създаване на съдържание - CViC-ILMS-1.0</p>\n</div></div></div></div></div><div class=\"register-v2-form-wrapper flex-scrollable md-whiteframe-8dp\" layout=\"column\" \nflex ms-scroll ng-show=\"true\"><div id=\"register-v2-form\"><div \nstyle=\"margin-left: auto; margin-right: auto; padding-bottom: 30px; padding-top:20px\" hide-gt-sm><img \nclass=\"md-logo-img\" src=\"assets/images/dummy/logo.png\" alt=\"img\" height=\"30\" title=\"logo\"></div><div class=\"title\" \ntranslate=\"REGISTER_V2.TITLE\">Create an account</div><div class=\"description\" translate=\"REGISTER_V2.DESCRIPTION\">\nSed mollis velit facilisis facilisis viverra</div><div ng-show=\"vm.error\" class=\"description reg_error\" \ntranslate=\"REGISTER_V2.ERROR\">An error occurred when trying to log the user</div><form name=\"registerForm\" \nng-submit=\"submit()\" novalidate><md-input-container class=\"md-block\" md-no-float><input name=\"username\" \nng-model=\"vm.form.username\" placeholder=\"Name\" translate translate-attr-placeholder=\"REGISTER_V2.NAME\" required><div \nng-messages=\"registerForm.username.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER_V2.ERRORS.USERNAME_REQUIRED\">Username field is required</span></div></div></md-input-container><div\n class=\"org-auto\" ng-show=\"organizations.length > 0\"><md-autocomplete md-input-name=\"organization\" \nplaceholder=\'{{\"REGISTER_V2.ORGANIZATION\" | translate }}\' md-selected-item=\"vm.form.organization\" \nmd-search-text=\"searchText\" md-items=\"org in getOrganizations(searchText)\" md-item-text=\"org.title\" \nmd-search-text-change=\"organizationErrorCheck(searchText)\" \nmd-selected-item-change=\"organizationErrorCheck(searchText)\"><md-item-template><span>{{org.title}}</span>\n</md-item-template><md-not-found class=\"form-message-error\"><span translate=\"REGISTER_V2.ORG_NO_MATCHES\">\nNo matches found.</span></md-not-found></md-autocomplete><div ng-messages=\"registerForm.organization.$error\" \nclass=\"form-message-error\"><div ng-message=\"real_orgranization\"><span translate=\"REGISTER_V2.ERRORS.REAL_ORG\">\nPleace select an organization from the menu or leave the field empty.</span></div></div></div><md-input-container \nclass=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"REGISTER_V2.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER_V2.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"REGISTER_V2.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"REGISTER_V2.PASSWORD\" \nng-minlength=\"5\" required><div ng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"REGISTER_V2.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div><div ng-message=\"minlength\">\n<span translate=\"REGISTER_V2.ERRORS.PASSWORD_MINLENGTH\">Password must be at least 5 symbols long</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" ng-change=\"removeMatchError()\" translate \ntranslate-attr-placeholder=\"REGISTER_V2.PASSWORD_CONFIRM\" required><div \nng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER_V2.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div><div \nng-message=\"match\"><span translate=\"REGISTER_V2.ERRORS.PASSWORD_CONFIRM_MATCH\">\nConfirm password doesn\'t match password field</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"REGISTER_V2.USER_PLAN\">User Plan</label><md-select ng-model=\"vm.form.plan\" required>\n<md-option ng-repeat=\"plan in userPlans\" value=\"{{plan.value}}\" translate=\"{{\'REGISTER_V2.USER_PLANS.\' + plan.trans}}\">\n{{plan}}</md-option></md-select></md-input-container><div class=\"plans\" layout=\"row\" layout-align=\"center center\" \nstyle=\"font-size:13px\"><a href=\"https://classbg.online/#plans\" target=\"_blank\" \ntranslate=\"REGISTER_V2.INTRO_DESCRIPTION_3\"></a></div><div class=\"terms\" layout=\"row\" layout-align=\"center center\">\n<md-checkbox name=\"terms\" ng-model=\"data.cb1\" aria-label=\"I read and accept\" required></md-checkbox><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"start center\"><span translate=\"REGISTER_V2.READ_ACCEPT\">I read and accept</span> <a \nhref=\"https://classbg.online/terms-of-use/\" target=\"_blank\" class=\"md-accent-color\" translate=\"REGISTER_V2.TERMS_COND\">\nterms and conditions</a></div></div><div vc-recaptcha theme=\"\'clean\'\" key=\"\'6LfNyzIUAAAAALMexUW98qP5Ab-aifFaY9TEGtYg\'\" \non-create=\"setWidgetId(widgetId)\" on-success=\"setResponse(response)\" on-expire=\"cbExpiration()\"></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER_V2.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER_V2.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER_V2.ALREADY_HAVE\">\nAlready have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login-v2\" translate=\"REGISTER_V2.LOGIN\">Log in\n</a></div><div class=\"countdown\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span>\nИДЕНТ. №. ПО ЗЗЛД: 1137344</span></div><div class=\"footer-copyright\" flex layout=\"row\" layout-align=\"center center\" \nhide show-xs show-sm><div class=\"container\"><div class=\"row\"><div style=\"text-align:center\"><img \nstyle=\"height: 25%; width: 25%\" src=\"assets/images/dummy/eu_logos.png\" alt=\"img\" height=\"30\" \ntitle=\"Създадено с финансовата подкрепа на Оперативна програма „Иновации и конкурентоспособност“ 2014-2020 г. по проект № BG16RFOP002-1.001-0024-C01\">\n<p class=\"eu-project-text\">\nСъздадено с финансовата подкрепа на Оперативна програма „Иновации и конкурентоспособност“ 2014-2020 г.<br>\nпо проект № BG16RFOP002-1.001-0024-C01</p><p>Софтуер за мобилно приложение - CViC-APP-1.0</p></div></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/eventdetails/admin/event_details_admin_view.html","<div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex><form name=\"eventForm\" ng-submit=\"vm.saveChange()\" \nclass=\"md-inline-form\" novalidate><div layout=\"row\"><div layout=\"column\" flex=\"40\"><md-input-container \nclass=\"md-block\"><label translate=\"CALENDAR.TITLE\">Title</label><input name=\"title\" ng-model=\"vm.eventCopy.title\" \nrequired md-autofocus><div ng-messages=\"eventForm.title.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CALENDAR.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container>\n<md-input-container flex class=\"md-block textarea-container\"><label translate=\"CALENDAR.DESCRIPTION\">Description\n</label><textarea ng-model=\"vm.eventCopy.description\"></textarea></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"CALENDAR.SUMMARY\">Summary</label><input name=\"title\" \nng-model=\"vm.eventSettingsCopy.summary\" md-autofocus></md-input-container></div><div layout=\"column\" flex=\"30\"><div \nlayout=\"row\" class=\"date-row margin-tb3\"><md-datepicker ng-model=\"vm.eventDates.start\" md-placeholder=\"Start Date\" \nng-model-options=\"{ timezone: \'UTC\' }\"></md-datepicker><md-input-container class=\"no-errors-spacer\" flex md-no-float>\n<input name=\"hoursStart\" type=\"time\" ng-model=\"vm.eventDates.startTime\" placeholder=\"Start Time\" translate \ntranslate-attr-placeholder=\"CALENDAR.START_TIME\"></md-input-container></div><div layout=\"row\" \nclass=\"date-row margin-tb3\"><md-datepicker ng-model=\"vm.eventDates.end\" md-placeholder=\"End Date\" \nng-model-options=\"{ timezone: \'UTC\' }\"></md-datepicker><md-input-container class=\"no-errors-spacer\" flex md-no-float>\n<input name=\"hoursEnd\" type=\"time\" ng-model=\"vm.eventDates.endTime\" placeholder=\"End Time\" translate \ntranslate-attr-placeholder=\"CALENDAR.END_TIME\"></md-input-container></div></div><div layout=\"column\" flex=\"30\">\n<md-input-container class=\"md-block\"><label translate=\"CALENDAR.ACCESSES\">Event Access</label><md-select \nname=\"accessType\" ng-model=\"vm.eventCopy.accessType\" required><md-option ng-repeat=\"accessType in vm.accessTypes\" \nvalue=\"{{accessType.value}}\" translate=\"{{\'CALENDAR.ACCESS.\' + accessType.trans}}\">Access Type</md-option></md-select>\n<div ng-messages=\"eventForm.accessType.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CALENDAR.ERRORS.ACCESS_TYPE_REQUIRED\">Access type field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"CALENDAR.EVENTS\">Event types</label><md-select name=\"eventType\" \nng-model=\"vm.eventCopy.eventType\" required><md-option ng-repeat=\"eventType in vm.eventTypes\" \nvalue=\"{{eventType.value}}\" translate=\"{{\'CALENDAR.EVENT.\' + eventType.trans}}\">EVENT TYPE</md-option></md-select><div \nng-messages=\"eventForm.eventType.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CALENDAR.ERRORS.EVENT_TYPE_REQUIRED\">Event type field is required</span></div></div></md-input-container>\n</div></div><div layout=\"row\"><div layout=\"column\" flex=\"40\"><md-input-container class=\"md-block\"><label \ntranslate=\"CALENDAR.ADDRESS\">Address</label><input name=\"title\" ng-model=\"vm.eventSettingsCopy.address\" md-autofocus>\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"CALENDAR.PLACE\">Place</label><input \nname=\"title\" ng-model=\"vm.eventSettingsCopy.place\" md-autofocus></md-input-container></div><div layout=\"column\" \nng-show=\"vm.showConferenceFields()\" flex=\"30\"><md-input-container class=\"md-block\"><label \ntranslate=\"CALENDAR.JOIN_PASSWORD\">Join password</label><input name=\"title\" \nng-model=\"vm.eventSettingsCopy.joinPassword\" ng-disabled=\"vm.isPasswordEditDisabled\" md-autofocus></md-input-container>\n<md-input-container class=\"md-block\" ng-show=\"vm.showAdminPassword()\"><label translate=\"CALENDAR.ADMIN_PASSWORD\">\nAdmin password</label><input name=\"title\" ng-model=\"vm.eventSettingsCopy.adminPassword\" \nng-disabled=\"vm.isPasswordEditDisabled\" md-autofocus></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"CALENDAR.JOIN_MESSAGE\">Join message</label><input name=\"title\" ng-model=\"vm.eventSettingsCopy.joinMessage\" \nmd-autofocus></md-input-container></div><div layout=\"column\" ng-show=\"vm.showConferenceFields()\" flex=\"30\">\n<md-input-container class=\"md-block\"><label translate=\"CALENDAR.CONFERENCE_TYPE\">Conference Type</label><md-select \nname=\"conferenceTypeType\" ng-model=\"vm.eventSettingsCopy.conferenceType\"><md-option \nng-repeat=\"conferenceType in vm.conferenceTypes\" value=\"{{conferenceType.value}}\" translate=\"{{conferenceType.trans}}\">\nConference Type</md-option></md-select></md-input-container><div class=\"remember-forgot-password\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-between center\"><md-checkbox class=\"remember-me\" \nng-model=\"vm.eventSettingsCopy.sharesAudio\" aria-label=\"\"><span translate=\"CALENDAR.PRESENTER_SHARES_AUDIO\">\nOnly presenter shares audio</span></md-checkbox></div><div class=\"remember-forgot-password\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-between center\"><md-checkbox class=\"remember-me\" \nng-model=\"vm.eventSettingsCopy.sharesVideo\" aria-label=\"\"><span translate=\"CALENDAR.PRESENTER_SHARES_VIDEO\">\nOnly presenter shares video</span></md-checkbox></div><div class=\"remember-forgot-password\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-between center\"><md-checkbox class=\"remember-me\" \nng-model=\"vm.eventSettingsCopy.automaticAudio\" aria-label=\"\"><span translate=\"CALENDAR.AUTOMATIC_AUDIO_START\">\nStart video automatically</span></md-checkbox></div><div class=\"remember-forgot-password\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-between center\"><md-checkbox class=\"remember-me\" \nng-model=\"vm.eventSettingsCopy.automaticVideo\" aria-label=\"\"><span translate=\"CALENDAR.AUTOMATIC_VIDEO_START\">\nStart video automatically</span></md-checkbox></div></div></div><div layout=\"row\"><md-button \nng-click=\"vm.cancelChange()\" class=\"md-raised md-accent submit-button\" translate=\"\" translate-attr-aria-label=\"\">Cancel\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Save\" \nng-disabled=\"eventForm.$invalid\" translate=\"\" translate-attr-aria-label=\"\">Save</md-button><md-button \nng-click=\"vm.deleteEvent()\" class=\"md-raised md-accent submit-button\" translate=\"\" translate-attr-aria-label=\"\">Delete\n</md-button></div></form></div></div>");
$templateCache.put("app/main/file-manager/views/document_more_menu.html","<md-menu><md-button aria-label=\"More\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate \ntranslate-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span \ntranslate=\"FM.MORE\">More</span></md-tooltip></md-button><md-menu-content width=\"4\"><md-menu-item><md-button \naria-label=\"Details\" translate-aria-label=\"FM.DETAILS\" ng-click=\"vm.cvicDocumentService.select(file)\"><span \ntranslate=\"FM.DETAILS\">Details</span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.cvicDocumentService.canAddToPortfolio(file)\"><md-button aria-label=\"PORTFOLIO\" \ntranslate-aria-label=\"FM.PORTFOLIO\" ng-click=\"vm.cvicDocumentService.addToPortfolio(file, $event)\"><span \ntranslate=\"FM.PORTFOLIO\">PORTFOLIO</span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.cvicDocumentService.canEditDocument(file)\"><md-button aria-label=\"Edit\" translate-aria-label=\"FM.EDIT_DOCM\" \nng-click=\"vm.cvicDocumentService.editDocument(file, $event)\"><span translate=\"FM.EDIT_DOCM\">Edit</span></md-button>\n</md-menu-item><md-menu-item ng-if=\"vm.cvicDocumentService.canDownloadDocument(file.entity)\"><md-button \naria-label=\"Download\" translate-aria-label=\"FM.DOWNLOAD\" ng-click=\"vm.cvicDocumentService.download(file)\"><span \ntranslate=\"FM.DOWNLOAD\">Download</span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.cvicDocumentService.canDeleteDocument(file, vm.cvicDocumentService.itemContainer())\"><md-button \naria-label=\"Delete\" translate-aria-label=\"FM.DELETE_DOCM\" \nng-click=\"vm.cvicDocumentService.deleteDocument(file, vm.cvicDocumentService.itemContainer(), $event)\"><span \ntranslate=\"FM.DELETE_DOCM\">Delete</span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.cvicDocumentService.canManageContainer()\"><md-button aria-label=\"Detach\" translate-aria-label=\"FM.DETACH_FM\" \nng-click=\"vm.cvicDocumentService.detachDocument(file, vm.cvicDocumentService.itemContainer(), $event)\"><span \ntranslate=\"FM.DETACH_FM\">Detach</span></md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("app/main/file-manager/views/folder_more_menu.html","<md-menu><md-button aria-label=\"More\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate \ntranslate-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span \ntranslate=\"FM.MORE\">More</span></md-tooltip></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \naria-label=\"Rename\" translate-aria-label=\"FM.RENAME\" ng-click=\"vm.cvicDocumentService.renameFolder(folder,$event)\">\n<span translate=\"FM.RENAME\">Rename</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Delete\" \ntranslate-aria-label=\"FM.DELETE_FOLDER\" ng-click=\"vm.cvicDocumentService.deleteFolder(folder,$event)\"><span \ntranslate=\"FM.DELETE_FOLDER\">Delete</span></md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("app/main/file-manager/views/location.html","<a ng-click=\"vm.cvicDocumentService.home()\" translate=\"FM.HOME_DIR\" \nclass=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\">..</a> <span \nng-repeat=\"folder in vm.cvicDocumentService.path()\">&raquo; <a ng-click=\"vm.cvicDocumentService.select(folder)\">\n{{folder.name}}</a> </span>");
$templateCache.put("app/main/file-manager/views/mixed_repo_list.html","<div id=\"file-manager-preview\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><md-content class=\"content\" flex ms-scroll><div \nng-include=\"\'app/main/file-manager/views/list/list-view.html\'\"></div></md-content></div><md-sidenav \nclass=\"sidenav details-sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"details-sidenav\" ng-if=\"vm.cvicDocumentService.selected()\" \nng-include=\"\'app/main/file-manager/sidenavs/details/details-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav>\n</div>");
$templateCache.put("app/main/file-manager/views/repo_tabs.html","<div id=\"file-manager-preview\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" \nlayout=\"column\" flex><md-content class=\"content\" flex ms-scroll><md-tabs md-dynamic-height><md-tab \nng-repeat=\"repository in vm.repo\" ng-if=\"repository.visible == true\" \nng-click=\"vm.cvicDocumentService.selectRepo(repository, false)\"><md-tab-label>{{ repository.label }}</md-tab-label>\n<md-tab-body><div ng-include=\"\'app/main/file-manager/views/list/list-view.html\'\"></div></md-tab-body></md-tab>\n</md-tabs></md-content></div><md-sidenav class=\"sidenav details-sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"details-sidenav\" ng-if=\"vm.cvicDocumentService.selected()\" \nng-include=\"\'app/main/file-manager/sidenavs/details/details-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav>\n</div>");
$templateCache.put("app/main/info/event-info/event-info-tab.html","<div id=\"entity-info-project\" class=\"demo-content\" layout-xs=\"column\" layout-sm=\"column\" layout-md=\"column\" \nlayout-gt-md=\"row\"><ms-widget class=\"h-300 card-styles\" layout-xs=\"row\" layout-sm=\"row\" layout-md=\"row\" \nlayout-gt-md=\"column\" flex-gt-md=\"25\"><ms-widget-front ng-if=\"!vm.showRecording\" \nng-class=\"vm.expired ? \'grey-bg p-16 white-fg\' : \'cyan-bg p-16 white-fg\'\" layout=\"column\" flex><div \nclass=\"info-center-text\" layout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-3 pb-8\">\n{{vm.event.startDate | date:\'dd\'}} <span translate=\"{{vm.monthTransKey}}\">{{vm.event.startDate | date:\'MMM\'}}</span>\n</div><div class=\"h1 font-weight-500\">{{vm.event.startDate | date:\'HH:mm\'}}</div><div class=\"h1 font-weight-500\" \nng-if=\"!vm.showExternalLink && !vm.expired && vm.event.accessType !== \'other\'\" translate=\"\">\n{{vm.event.accessType | uppercase | translate}}</div></div><div layout=\"row\" layout-align=\"center end\" \nng-if=\"!vm.expired && vm.showExternalLink && !(vm.showButtons.showAccept || vm.showButtons.showReject || vm.showButtons.showJoin || vm.showButtons.showRequest || vm.showButtons.showLeave)\" \nflex><md-button ng-click=\"vm.openConfLink()\" ng-if=\"vm.showExternalLink\" class=\"md-raised\" \ntranslate=\"ConferenceJoinButton\">Button</md-button></div><div layout=\"row\" layout-align=\"start end\" \nng-if=\"!vm.expired && (vm.showButtons.showAccept || vm.showButtons.showReject || vm.showButtons.showJoin || vm.showButtons.showRequest || vm.showButtons.showLeave)\" \nflex><div flex=\"auto\"><md-button ng-if=\"vm.showButtons.showAccept\" ng-click=\"vm.acceptEvent()\" class=\"md-fab md-mini\" \naria-label=\"Accept Event\"><i class=\"icon icon-account-check info-button\"></i></md-button><md-button \nclass=\"md-fab md-mini\" ng-if=\"vm.showButtons.showReject\" ng-click=\"vm.rejectEvent()\" aria-label=\"Reject Event\"><i \nclass=\"icon icon-account-remove info-button\"></i></md-button><md-button class=\"md-fab md-mini\" \nng-if=\"vm.showButtons.showJoin\" ng-click=\"vm.acceptEvent()\" aria-label=\"Join Event\"><i \nclass=\"icon icon-headphones info-button\"></i></md-button><md-button class=\"md-fab md-mini\" \nng-if=\"vm.showButtons.showRequest\" ng-click=\"vm.requestEvent()\" aria-label=\"Request Event\"><i \nclass=\"icon icon-message-text info-button\"></i></md-button><md-button class=\"md-fab md-mini\" \nng-if=\"vm.showButtons.showLeave\" ng-click=\"vm.rejectEvent()\" aria-label=\"Leave Event\"><i \nclass=\"icon icon-close-circle info-button\"></i></md-button></div><md-button flex=\"auto\" ng-click=\"vm.openConfLink()\" \nng-if=\"vm.showExternalLink\" class=\"md-raised go-right\" translate=\"ConferenceJoinButton\">Button</md-button></div><div \nclass=\"background-image-center\"><md-icon md-font-icon=\"icon-calendar-today\" class=\"s256 faint-text\"></md-icon></div>\n</ms-widget-front><ms-card template=\"\'app/core/directives/ms-card/templates/template-3/template-3.html\'\" \nng-if=\"vm.showRecording\" ng-model=\"vm.card\"></ms-card></ms-widget><div class=\"ms-card-content-wrapper\" layout-xs=\"row\" \nlayout-sm=\"row\" layout-md=\"row\" layout-gt-md=\"column\" flex-gt-md=\"70\"><div class=\"template-6\"><div \nclass=\"content pv-24 ph-16\"><div class=\"title h2\" translate=\"EVENT.TIME\">Time</div><div class=\"text pt-8\"><span \ntranslate=\"EVENT.FROM\">From</span>{{vm.event.startDate | date : \'dd/MM/yyyy, HH:mm\'}}<br><span translate=\"EVENT.TO\">to\n</span>{{vm.event.endDate | date : \'dd/MM/yyyy, HH:mm\'}}</div><div ng-if=\"vm.event.settings.place\" \nclass=\"title h2 margin-t18\" translate=\"CALENDAR.PLACE\">Place</div><div ng-if=\"vm.event.settings.place\" \nclass=\"text pt-8\">{{vm.event.settings.place}}</div><div ng-if=\"vm.event.container != null\" class=\"title h2 margin-t18\" \ntranslate=\"CALENDAR.SPACES\">Part of</div><div ng-if=\"vm.event.container != null\" ng-click=\"vm.openSpace( vm.event )\" \nclass=\"text pt-8\" style=\"cursor:pointer\">{{vm.event.container.title}}</div><div class=\"title h2 margin-t18\" \nng-if=\"vm.event.description\" translate=\"CALENDAR.DESCRIPTION\">Description</div><div class=\"text pt-8\" \nng-if=\"vm.event.description\">{{vm.event.description}}</div></div></div></div></div>");
$templateCache.put("app/main/info/space-info/space-info-tab.html","<div id=\"entity-info-project\" class=\"demo-content\" layout-xs=\"column\" layout-sm=\"column\" layout-md=\"column\" \nlayout-gt-md=\"row\"><ms-widget class=\"h-200\" layout-xs=\"row\" layout-sm=\"row\" layout-md=\"row\" layout-gt-md=\"column\" \nflex-gt-md=\"20\"><ms-widget-front class=\"p-16 cyan-bg white-fg\" layout=\"column\" flex><div \nng-if=\"vm.space.accessType !== \'other\'\" class=\"info-center-text\" layout=\"column\" layout-align=\"center center\" flex><div\n class=\"h1 font-weight-500\" translate=\"\">{{vm.space.accessType | uppercase | translate}}</div></div><div layout=\"row\" \nlayout-align=\"start end\" \nng-if=\"vm.showButtons.showAccept || vm.showButtons.showReject || vm.showButtons.showJoin || vm.showButtons.showRequest || vm.showButtons.showLeave\" \nflex><md-button ng-if=\"vm.showButtons.showAccept\" ng-click=\"vm.acceptEvent()\" class=\"md-fab md-mini\" \naria-label=\"Accept Event\"><i class=\"icon icon-account-check info-button\"></i></md-button><md-button \nclass=\"md-fab md-mini\" ng-if=\"vm.showButtons.showReject\" ng-click=\"vm.rejectEvent()\" aria-label=\"Reject Event\"><i \nclass=\"icon icon-account-remove info-button\"></i></md-button><md-button class=\"md-fab md-mini\" \nng-if=\"vm.showButtons.showJoin\" ng-click=\"vm.acceptEvent()\" aria-label=\"Join Event\"><i \nclass=\"icon icon-headphones info-button\"></i></md-button><md-button class=\"md-fab md-mini\" \nng-if=\"vm.showButtons.showRequest\" ng-click=\"vm.requestEvent()\" aria-label=\"Request Event\"><i \nclass=\"icon icon-message-text info-button\"></i></md-button><md-button class=\"md-fab md-mini\" \nng-if=\"vm.showButtons.showLeave\" ng-click=\"vm.rejectEvent()\" aria-label=\"Leave Event\"><i \nclass=\"icon icon-close-circle info-button\"></i></md-button></div><div class=\"background-image-center\"><md-icon \nmd-font-icon=\"icon-calendar-today\" class=\"s128 faint-text\"></md-icon></div></ms-widget-front></ms-widget><div \nclass=\"ms-card-content-wrapper\" layout-xs=\"row\" layout-sm=\"row\" layout-md=\"row\" layout-gt-md=\"column\" flex-gt-md=\"80\">\n<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"title h2 margin-t18\" ng-if=\"vm.space.description\" \ntranslate=\"CALENDAR.DESCRIPTION\">Description</div><div class=\"text pt-8\" ng-if=\"vm.space.description\">\n{{vm.space.description}}</div></div></div></div></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\" ng-if=\"false\"><md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>\n{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span \nclass=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\" ng-if=\"false\"><span translate=\"QUICKPANEL.EVENTS\">Events\n</span></md-subheader><md-list-item class=\"cursor-pointer md-2-line\" \nng-repeat=\"event in $root.cvicSchedule.upcomingEvents | orderBy: \'startDate\'\"><div class=\"md-list-item-text p-16\" \nng-controller=\"EventsScheduleController as evtSchCtrl\" layout=\"row\" layout-align=\"space-between center\" \nng-include=\"\'app/main/eventsconferences/views/schedule/list.html\'\"></div></md-list-item></md-list><md-divider>\n</md-divider><md-list ng-if=\"false\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span>\n</md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div \nclass=\"md-list-item-text\"><h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider \nng-if=\"false\"></md-divider><md-list ng-if=\"false\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">C</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><div class=\"toolbar-separator\"></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress || $root.loadingExternalContentProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" aria-label=\"User settings\" \nclass=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"4\">\n<md-menu-item class=\"md-indent\" ng-click=\"cvicProfileService.profile()\"><md-icon md-font-icon=\"icon-account\" \nclass=\"icon\"></md-icon><md-button translate=\"TOOLBAR.PROFILE\">My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\"><md-icon ng-click=\"vm.inboxClick()\" md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.inboxClick()\" translate=\"TOOLBAR.INBOX\">Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\">\n<md-icon ng-click=\"vm.sendMailToAdmin($event)\" md-font-icon=\"icon-account-network\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.sendMailToAdmin($event)\" translate=\"TOOLBAR.ADMIN\">Contact Admin</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\"><md-icon ng-click=\"vm.helpClick()\" md-font-icon=\"icon-help\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.helpClick()\" translate=\"TOOLBAR.HELP\">Help</md-button></md-menu-item><md-menu-divider></md-menu-divider>\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \ntranslate=\"TOOLBAR.LOGOUT\" ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdMenu.open()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">C</span> <span class=\"logo-text\">C.ViC</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress || $root.loadingExternalContentProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" aria-label=\"User settings\" \nclass=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"4\">\n<md-menu-item class=\"md-indent\" ng-click=\"cvicProfileService.profile()\"><md-icon md-font-icon=\"icon-account\" \nclass=\"icon\"></md-icon><md-button translate=\"TOOLBAR.PROFILE\">My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\"><md-icon ng-click=\"vm.inboxClick()\" md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.inboxClick()\" translate=\"TOOLBAR.INBOX\">Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\">\n<md-icon ng-click=\"vm.sendMailToAdmin($event)\" md-font-icon=\"icon-account-network\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.sendMailToAdmin($event)\" translate=\"TOOLBAR.ADMIN\">Contact Admin</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\"><md-icon ng-click=\"vm.helpClick()\" md-font-icon=\"icon-help\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.helpClick()\" translate=\"TOOLBAR.HELP\">Help</md-button></md-menu-item><md-menu-divider></md-menu-divider>\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \ntranslate=\"TOOLBAR.LOGOUT\" ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdMenu.open()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-disabled=\"!$root.loadingProgress && !$root.loadingExternalContentProgress\" class=\"md-accent\" md-diameter=\"32\">\n</md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" ng-src=\"{{vm.userAvatar}}\"><md-icon md-font-icon \nng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" aria-label=\"User settings\" \nclass=\"icon status s16\"></md-icon></div><span class=\"username\" hide show-gt-sm ng-model=\"vm.userName\">{{vm.userName}}\n</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content \nwidth=\"4\"><md-menu-item class=\"md-indent\" ng-click=\"cvicProfileService.profile()\"><md-icon md-font-icon=\"icon-account\" \nclass=\"icon\"></md-icon><md-button translate=\"TOOLBAR.PROFILE\">My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\"><md-icon ng-click=\"vm.inboxClick()\" md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.inboxClick()\" translate=\"TOOLBAR.INBOX\">Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\">\n<md-icon ng-click=\"vm.sendMailToAdmin($event)\" md-font-icon=\"icon-account-network\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.sendMailToAdmin($event)\" translate=\"TOOLBAR.ADMIN\">Contact Admin</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\"><md-icon ng-click=\"vm.helpClick()\" md-font-icon=\"icon-help\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.helpClick()\" translate=\"TOOLBAR.HELP\">Help</md-button></md-menu-item><md-menu-divider></md-menu-divider>\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \ntranslate=\"TOOLBAR.LOGOUT\" ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" \nmd-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress || $root.loadingExternalContentProgress\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" aria-label=\"User settings\" \nclass=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"4\">\n<md-menu-item class=\"md-indent\" ng-click=\"cvicProfileService.profile()\"><md-icon md-font-icon=\"icon-account\" \nclass=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nng-click=\"vm.inboxClick()\" md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button ng-click=\"vm.inboxClick()\" \ntranslate=\"TOOLBAR.INBOX\">Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nng-click=\"vm.sendMailToAdmin($event)\" md-font-icon=\"icon-account-network\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.sendMailToAdmin($event)\" translate=\"TOOLBAR.ADMIN\">Contact Admin</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\"><md-icon ng-click=\"vm.helpClick()\" md-font-icon=\"icon-help\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.helpClick()\" translate=\"TOOLBAR.HELP\">Help</md-button></md-menu-item><md-menu-divider></md-menu-divider>\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \ntranslate=\"TOOLBAR.LOGOUT\" ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress || $root.loadingExternalContentProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" aria-label=\"User settings\" \nclass=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"4\">\n<md-menu-item class=\"md-indent\" ng-click=\"cvicProfileService.profile()\"><md-icon md-font-icon=\"icon-account\" \nclass=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nng-click=\"vm.inboxClick()\" md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button ng-click=\"vm.inboxClick()\" \ntranslate=\"TOOLBAR.INBOX\">Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nng-click=\"vm.sendMailToAdmin($event)\" md-font-icon=\"icon-account-network\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.sendMailToAdmin($event)\" translate=\"TOOLBAR.ADMIN\">Contact Admin</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\"><md-icon ng-click=\"vm.helpClick()\" md-font-icon=\"icon-help\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.helpClick()\" translate=\"TOOLBAR.HELP\">Help</md-button></md-menu-item><md-menu-divider></md-menu-divider>\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \ntranslate=\"TOOLBAR.LOGOUT\" ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdMenu.open()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">C</span> <span class=\"logo-text\">CViC\n</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation><div class=\"moodle-link\" ng-if=\"vm.organization\" \nng-click=\"redirectToMoodle()\"><i class=\"icon s16 icon-school\"></i><span class=\"moodle-link-text\" \ntranslate=\"NAVIGATION.MOODLE\" style=\"font-weight: bolder\">Link to moodle</span></div><div class=\"moodle-link\" \nng-if=\"vm.school\" ng-click=\"redirectToSchool()\"><i class=\"icon s16 icon-school\"></i><span class=\"moodle-link-text\" \nstyle=\"font-weight: bolder\">{{vm.school.title}}</span></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/audience/views/list/list-view.html","<md-list id=\"listAudiencechips\" class=\"contacts-list\" ng-if=\"vm.audience\"><div class=\"chipsdemoContactChips\" \nlayout=\"column\" ng-controller=\"EntityAudienceController as eactrl\" ng-init=\"init(vm.chipSettings)\" ng-cloak><form \nname=\"audienceForm\" class=\"md-inline-form\" novalidate><md-content ng-if=\"canManage && !vm.expired\" ms-scroll><md-button\n ng-click=\"eactrl.addContainerAudience()\" ng-if=\"containerAudience\" \nclass=\"send-button md-accent md-raised margin-top-10\" aria-label=\"Send\" \ntranslate-attr-aria-label=\"AUDIENCE_FORM.ADD_CONTAINER_AUDIENCE\"><md-icon md-font-icon=\"icon-account-multiple-plus\">\n</md-icon></md-button><md-button ng-disabled=\"eactrl.isDeleteNewAudienceDisabled()\" ng-click=\"eactrl.deleteAudience()\" \nclass=\"{{\'send-button md-accent md-raised \' + marginClass + \' margin-top-10\'}}\" aria-label=\"Send\" \ntranslate-attr-aria-label=\"AUDIENCE_FORM.CLEAR\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon></md-button><div \nlayout=\"column\" layout-align=\"start start\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between center\">\n<md-input-container id=\"new_audience\" class=\"md-block width-80p-gt-md\"><div id=\"audiencechips\" \nng-controller=\"AudienceChipController as ctrl\" ng-init=\"ctrl.init(vm.audience)\" layout=\"column\" ng-cloak><md-content \nclass=\"autocomplete\" layout=\"column\"><md-contact-chips ng-model=\"audience\" \nmd-contacts=\"ctrl.delayedQuerySearch($query)\" md-contact-name=\"name\" md-contact-image=\"image\" md-contact-email=\"email\" \nmd-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"ctrl.filterSelected\" \nplaceholder=\"{{\'TypeHere\' | translate}}\" secondary-placeholder=\"{{\'TypeHere\' | translate}}\"></md-contact-chips>\n</md-content></div><input name=\"recipientsRequired\" type=\"hidden\" ng-model=\"vm.recipientsRequired\"><div \nng-messages=\"audienceForm.recipientsRequired.$error\" ng-show=\"audienceForm.recipientsRequired.$invalid\" role=\"alert\">\n<div ng-message=\"limit\"><span translate=\"MAIL.ERRORS.RECIPIENTS_LIMIT\">\nYour maximum number of participents is limited to </span><span>{{maxParticipants}}</span></div></div>\n</md-input-container><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-click=\"eactrl.submitDialog()\" ng-disabled=\"audienceForm.$pristine\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"AUDIENCE_FORM.ADD\" \ntranslate-attr-aria-label=\"AUDIENCE_FORM.ADD\">SEND</md-button></div></div></div></md-content></form><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"audienceTable\" class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"eactrl.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"AUDIENCE_TABLE.NAME\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"AUDIENCE_TABLE.LAST_ACTION\">Last action</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"AUDIENCE_TABLE.LAST_ACTION_DATE\">Date of last action</span></div></th><th ng-if=\"canManage && !vm.expired\" \nclass=\"secondary-text\"><div class=\"table-header\"><md-button class=\"edit-button md-icon-button\" \nng-click=\"eactrl.deleteTableAudience()\" aria-label=\"Remove users\" translate \ntranslate-attr-aria-label=\"AUDIENCE_TABLE.REMOVE_USERS\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div>\n</th></tr></thead><tbody><tr ng-repeat=\"audience in tableAudience\"><td class=\"h3\"><img class=\"tableAudience avatar\" \nng-src=\"{{audience.image}}\"><span>{{audience.name}}</span></td><td \nng-if=\"!audience.baseObj.canManage && eactrl.vm.event.owner.uid !== audience.uid\" class=\"h3\"><span \ntranslate=\"{{\'AUDIENCE_TABLE.LAST_ACTION_\' + audience.baseObj.lastAction | uppercase}}\">Last action</span><div \nng-show=\"{{audience.baseObj.lastAction == \'Request\'}}\" class=\"actions\" layout=\"row\" layout-align=\"start center\">\n<md-button ng-click=\"eactrl.acceptEntityAudience(audience.uid, $event)\" class=\"md-fab md-mini\" \naria-label=\"Accept entity audience\"><i class=\"icon icon-account-check info-button\"></i></md-button><md-button \nclass=\"margin-left-10 md-fab md-mini md-primary\" ng-click=\"eactrl.rejectEntityAudience(audience.uid, $event)\" \naria-label=\"Reject entity audience\"><i class=\"icon icon-account-remove info-button\"></i></md-button></div></td><td \nng-if=\"audience.baseObj.canManage || eactrl.vm.event.owner.uid === audience.uid\" class=\"h3\" \ntranslate=\"AUDIENCE_TABLE.LAST_ACTION_ADMIN\"></td><td class=\"h3\">{{audience.date | date : \'dd.MM.yyyy\'}}</td><td \nng-if=\"canManage && !vm.expired\"><md-button ng-if=\"showTableUserActions(audience)\" class=\"edit-button md-icon-button\" \nng-click=\"removeUserFromTableAudience(audience)\" aria-label=\"Remove user\" translate \ntranslate-attr-aria-label=\"AUDIENCE_TABLE.REMOVE_USER\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td>\n</tr></tbody></table></div></div></md-list><md-list-item class=\"no-results md-white-bg\" \nng-show=\"vm.audience.length === 0\"><p translate=\"CONTACTS.NO_RESULTS\">No results..</p></md-list-item>");
$templateCache.put("app/main/auth/passwd/forgot/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>C</span></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">Recover your password\n</div><form name=\"forgotPasswordForm\" novalidate ng-submit=\"submit()\"><md-input-container class=\"md-block\" md-no-float>\n<input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"FORGOTPASSWORD.PASSWORD\" ng-model=\"vm.form.password\" \nng-minlength=\"5\" required><div ng-messages=\"forgotPasswordForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"FORGOTPASSWORD.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div>\n<div ng-message=\"minlength\"><span translate=\"RESETPASSWORD.ERRORS.PASSWORD_MINLENGTH\">Password field is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"confirm_password\" placeholder=\"Password (Confirm)\" translate \ntranslate-attr-placeholder=\"FORGOTPASSWORD.PASSWORD_CONFIRM\" ng-model=\"confirm_password\" \nui-validate=\"{passmatch: \'checkPasswords($value)\'}\" ui-validate-watch=\" \'vm.form.password\' \" ng-minlength=\"5\" required>\n<div ng-messages=\"forgotPasswordForm.confirm_password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div><div \nng-message=\"passmatch\"><span translate=\"FORGOTPASSWORD.ERRORS.PASSWORD_CONFIRM_MATCHING\">\nPassword (Confirm) field is required</span></div></div></md-input-container><div vc-recaptcha theme=\"\'clean\'\" \nkey=\"\'6LfNyzIUAAAAALMexUW98qP5Ab-aifFaY9TEGtYg\'\" on-create=\"setWidgetId(widgetId)\" on-success=\"setResponse(response)\" \non-expire=\"cbExpiration()\"></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"RESET MY PASSWORD\" ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" \ntranslate=\"FORGOTPASSWORD.SEND_RESET_LINK\" translate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\">SEND RESET LINK\n</md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" \nui-sref=\"app.pages_auth_login-v2\" translate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/auth/passwd/reset/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>C</span></div><div class=\"title\" translate=\"RESETPASSWORD.TITLE\">Reset your password\n</div><form name=\"resetPasswordForm\" novalidate ng-submit=\"submit()\"><md-input-container class=\"md-block\" md-no-float>\n<input type=\"password\" name=\"password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.PASSWORD\" ng-model=\"vm.form.password\" ng-minlength=\"5\" required><div \nng-messages=\"resetPasswordForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div><div ng-message=\"minlength\">\n<span translate=\"RESETPASSWORD.ERRORS.PASSWORD_MINLENGTH\">Password field is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"confirm_password\" \nplaceholder=\"Password (Confirm)\" translate translate-attr-placeholder=\"RESETPASSWORD.PASSWORD_CONFIRM\" \nng-model=\"confirm_password\" ui-validate=\"{passmatch: \'checkPasswords($value)\'}\" \nui-validate-watch=\" \'vm.form.password\' \" ng-minlength=\"5\" required><div \nng-messages=\"resetPasswordForm.confirm_password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div><div \nng-message=\"passmatch\"><span translate=\"RESETPASSWORD.ERRORS.PASSWORD_CONFIRM_MATCHING\">\nPassword (Confirm) field is required</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"UPDATE MY PASSWORD\" \nng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" translate=\"RESETPASSWORD.UPDATE_PASSWORD\" \ntranslate-attr-aria-label=\"RESETPASSWORD.UPDATE_PASSWORD\">RESET MY PASSWORD</md-button></form><div class=\"login\" \nlayout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.profile\" translate=\"RESETPASSWORD.GO_BACK\">\nGo back to login</a></div></div></div></div>");
$templateCache.put("app/main/dashboard/statistics_list/events_list/events_statistics.html","<div id=\"calendar\" class=\"page-layout simple tabbed\"><div class=\"header orange-bg\"><div class=\"header-content\" \nlayout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\" \ntranslate=\"EventsAndConferences\">Calendar</span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\">\n<div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input key-press-action=\"fnExecuteSearch()\" key-press-code=\"13\" \nclass=\"search-input\" ng-model=\"vm.strSearch\" type=\"text\" placeholder=\"Search..\" translate \ntranslate-attr-placeholder=\"Search\" flex></div></div></div></div></div><div class=\"content\"><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget ng-if=\"vm.type == \'my_events\'\" flippable=\"false\" layout=\"row\" \nflex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h1\">\n{{\'STATISTICS.EVENTS_TITLE.UPCOMING_EVENTS\' | translate}}</span></div></div><div class=\"event-container\"><ms-card \nng-repeat=\"row in vm.nextEvents\" ui-sref=\"app.eventdetails({uid:row.uid})\" \ntemplate=\"\'app/core/directives/ms-card/templates/template-8/template-8.html\'\" ng-model=\"row\"></ms-card></div>\n</ms-widget-front></ms-widget><ms-widget ng-if=\"vm.type == \'my_events\'\" flippable=\"false\" layout=\"row\" flex=\"100\" \nflex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h1\">\n{{\'STATISTICS.EVENTS_TITLE.PAST_EVENTS\' | translate}}</span></div></div><div class=\"event-container\"><ms-card \nng-repeat=\"row in vm.pastEvents\" ui-sref=\"app.eventdetails({uid:row.uid})\" \ntemplate=\"\'app/core/directives/ms-card/templates/template-8/template-8.html\'\" ng-model=\"row\"></ms-card></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\">\n<div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"h1\">{{vm.title | translate}}</span></div></div><div \nng-if=\"vm.type != \'my_events\'\" class=\"tab container\"><div class=\"messages-tab messages-statistics\"><div \nclass=\"content thread-list\" ng-include=\"\'app/main/mail/views/classic/classic-view.html\'\" ms-scroll flex></div></div>\n</div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/dashboard/statistics_list/messages_list/messages_statistics.html","<div id=\"calendar\" class=\"page-layout simple tabbed\"><div class=\"header orange-bg\"><div class=\"header-content\" \nlayout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\" \ntranslate=\"Messages\">Messages</span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input key-press-action=\"fnExecuteSearch()\" key-press-code=\"13\" \nclass=\"search-input\" ng-model=\"vm.strSearch\" type=\"text\" placeholder=\"Search..\" translate \ntranslate-attr-placeholder=\"Search\" flex></div></div></div></div></div><div class=\"content\"><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"tab container\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h1\">\n{{vm.title | translate}}</span></div></div><div class=\"messages-tab messages-statistics\"><div \nclass=\"content thread-list\" ng-include=\"\'app/main/mail/views/classic/classic-view.html\'\" ms-scroll flex></div></div>\n</div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/dashboard/statistics_list/recordings_list/recordings_statistics.html","<div id=\"calendar\" class=\"page-layout simple tabbed\"><div class=\"header orange-bg\"><div class=\"header-content\" \nlayout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\" \ntranslate=\"Recordings\">Recordings</span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input key-press-action=\"fnExecuteSearch()\" key-press-code=\"13\" \nclass=\"search-input\" ng-model=\"vm.strSearch\" type=\"text\" placeholder=\"Search..\" translate \ntranslate-attr-placeholder=\"Search\" flex></div></div></div></div></div><div class=\"content\"><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><span class=\"h1\">{{vm.title | translate}}</span></div></div><div \nclass=\"event-container event-container-stat\"><ms-card ng-repeat=\"row in vm.recordings\" \ntemplate=\"\'app/core/directives/ms-card/templates/template-4/template-4.html\'\" ng-model=\"row\" \nng-click=\"redirectToPlayback(row)\" style=\"cursor: pointer\"></ms-card></div></ms-widget-front></ms-widget></div></div>\n</div>");
$templateCache.put("app/main/dashboard/statistics_list/spaces_list/spaces_statistics.html","<div id=\"calendar\" class=\"page-layout simple tabbed\"><div class=\"header orange-bg\"><div class=\"header-content\" \nlayout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\" \ntranslate=\"LearningSpaces\">LearningSpaces</span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\">\n<div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input key-press-action=\"fnExecuteSearch()\" key-press-code=\"13\" \nclass=\"search-input\" ng-model=\"vm.strSearch\" type=\"text\" placeholder=\"Search..\" translate \ntranslate-attr-placeholder=\"Search\" flex></div></div></div></div></div><div class=\"content\"><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"tab container\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h1\">\n{{vm.title | translate}}</span></div></div><div ng-if=\"vm.type == \'my_spaces\'\" \nclass=\"event-container event-container-stat\"><ms-card ng-repeat=\"row in vm.spaces\" \nui-sref=\"app.spacedetails({uid:row.uid})\" \ntemplate=\"\'app/core/directives/ms-card/templates/template-8/template-8.html\'\" ng-model=\"row\"></ms-card></div><div \nng-if=\"vm.type != \'my_spaces\'\" class=\"messages-tab messages-statistics\"><div class=\"content thread-list\" \nng-include=\"\'app/main/mail/views/classic/classic-view.html\'\" ms-scroll flex></div></div></div></ms-widget-front>\n</ms-widget></div></div></div>");
$templateCache.put("app/main/contacts/sidenavs/main/main-sidenav.html","<div ms-scroll class=\"content scrollable\"><md-list><md-list-item ng-click=\"vm.filterChange(\'frequent\')\" \nng-class=\"{\'selected\':vm.listType ===\'frequent\'}\"><p translate=\"CONTACTS.FREQUENTLY_CONTACTED\">Frequently contacted</p>\n</md-list-item><md-subheader class=\"md-no-sticky\" ng-show=\"vm.groupsSystem.length > 0\">\n{{\'CONTACTS.FROM_SCHOOL\' | translate}}</md-subheader><md-list-item ng-if=\"vm.groups\" \nng-repeat=\"group in vm.groupsSystem\" ng-click=\"vm.filterChange(group)\" \nng-class=\"{\'selected\':vm.listType.title === group.title}\"><p class=\"pl-8\">{{group.title}}</p></md-list-item>\n<md-subheader class=\"md-no-sticky\" ng-show=\"vm.groupsVirtual.length > 0\">{{\'CONTACTS.GROUPS_IN_CVIC\' | translate}}\n</md-subheader><md-list-item ng-if=\"vm.groupsVirtual\" ng-repeat=\"group in vm.groupsVirtual | orderBy : \'seq\'\" \nng-click=\"vm.filterChange(group)\" ng-class=\"{\'selected\':vm.listType.title === group.title}\"><p class=\"pl-8\">\n{{group.title | translate}}</p></md-list-item><md-subheader class=\"md-no-sticky\" ng-show=\"vm.groups.length > 0\">\n{{\'CONTACTS.GROUPS\' | translate}}</md-subheader><md-list-item ng-if=\"vm.groups\" ng-repeat=\"group in vm.groups\" \nng-click=\"vm.filterChange(group)\" ng-class=\"{\'selected\':vm.listType.title === group.title}\"><p class=\"pl-8\">\n{{group.title}}</p></md-list-item><md-list-item class=\"new-group-form\" ng-show=\"newGroupForm.$visible\"><form \neditable-form name=\"newGroupForm\" onaftersave=\"vm.addNewGroup()\"><p class=\"pl-8\" editable-text=\"vm.newGroupName\" \ne-required></p><div class=\"buttons\" layout=\"row\" layout-align=\"space-between center\"><button type=\"submit\" \nclass=\"btn md-raised md-accent md-button btn-primary\" ng-disabled=\"editableForm.$waiting\">\n{{ \'CONTACTS.SAVE\' | translate }}</button> <button type=\"button\" class=\"btn md-raised md-accent md-button btn-default\" \nng-disabled=\"editableForm.$waiting\" ng-click=\"newGroupForm.$cancel()\">{{ \'CONTACTS.CANCEL\' | translate }}</button>\n</div></form></md-list-item><md-list-item class=\"\" ng-click=\"newGroupForm.$show()\" ng-hide=\"newGroupForm.$visible\"><p \nclass=\"pl-8 md-accent-fg\" translate=\"CONTACTS.NEW_GROUP\">New Group</p></md-list-item></md-list></div>");
$templateCache.put("app/main/eventsconferences/dialogs/event-detail/event-detail-dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{vm.calendarEvent.title}}</span> <span flex></span><md-button \nclass=\"edit-event-button md-fab md-warn\" ng-click=\"vm.editEvent(vm.calendarEvent)\" aria-label=\"Edit event\" translate \ntranslate-attr-aria-label=\"CALENDAR.EDIT_EVENT\"><md-icon md-font-icon=\"icon-eye\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" \nlayout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\"><span translate=\"{{vm.monthStartTransKey}}\">month</span>\n {{vm.calendarEvent.start.format(\'DD YYYY, hh:mm \')}} <span ng-if=\"vm.calendarEvent.end\">-</span> <span \ntranslate=\"{{vm.monthEndTransKey}}\">month</span> {{vm.calendarEvent.end.format(\'DD YYYY, hh:mm\')}}</span></div></div>\n<div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\" \nng-if=\"vm.calendarEvent.baseObj.container != null\"><md-icon md-font-icon=\"icon icon-bulletin-board\"></md-icon><div \nlayout=\"column\" flex><span class=\"h4\" style=\"cursor:pointer\" ng-click=\"vm.openSpace( vm.calendarEvent )\">\n{{vm.calendarEvent.baseObj.container.title }}</span></div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon icon-file-document-box\"></md-icon><div layout=\"column\" flex>\n<span class=\"h4\">{{vm.calendarEvent.description | limitTo: 200}}<span \nng-if=\"vm.calendarEvent.description.length > 200\">...</span></span></div></div><div class=\"event-detail-row\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\"></md-icon><div flex><img \nng-repeat=\"user in vm.users\" ng-model=\"user\" title=\"{{user.title}}\" class=\"avatar\" alt=\"{{user.title}}\" \nng-src=\"{{user.image ? user.image: \'assets/images/avatars/profile.jpg\'}}\"></div></div></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/eventsconferences/dialogs/event-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"{{\'CALENDAR.DIALOG_TITLE.\' + vm.dialogTitle}}\">Dialog Title</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"horizontalStepper\" \nng-submit=\"vm.saveEvent()\" ng-model=\"vm.horizontalStepper\" novalidate><md-dialog-content ms-scroll><div \nclass=\"image-wrapper ng-scope\" style=\"\"><img class=\"md-card-image\" id=\"event-img\" ng-src=\"{{varImgSrc}}\"><md-button \nng-show=\"bImageIsAdded\" class=\"md-fab md-mini delete-image-button\" ng-click=\"fnRemoveImage()\" \naria-label=\"Delete Image\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button \nng-show=\"!bImageIsAdded\" class=\"add-img-button md-fab md-mini\" type=\"button\" aria-label=\"Add image\" upload-file \nfile-input-id=\"event-img-file\"><md-icon md-font-icon=\"icon-file-image-box\"></md-icon><input id=\"event-img-file\" \naccept=\"image/x-png,image/gif,image/jpeg\" file-change fn-change-handler=\"fnAddImage\" type=\"file\" \nstyle=\"visibility: hidden; position: absolute; width: 1px; height: 1px\"></md-button></div><md-input-container \nclass=\"md-block\"><label translate=\"CALENDAR.TITLE\">Title</label><input id=\"title\" name=\"title\" \nng-model=\"vm.calendarEvent.title\" required md-autofocus><div ng-messages=\"eventForm1.title.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CALENDAR.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"CALENDAR.EVENTS\">Event types</label>\n<md-select name=\"eventType\" ng-model=\"vm.calendarEvent.eventType\" required><md-option \nng-repeat=\"eventType in vm.eventTypes\" value=\"{{eventType.value}}\" translate=\"{{\'CALENDAR.EVENT.\' + eventType.trans}}\">\nEVENT TYPE</md-option></md-select><div ng-messages=\"eventForm1.eventType.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CALENDAR.ERRORS.EVENT_TYPE_REQUIRED\">Event type field is required</span></div>\n</div></md-input-container><md-input-container class=\"md-block\"><label translate=\"CALENDAR.ACCESSES\">Event Access\n</label><md-select name=\"accessType\" ng-model=\"vm.calendarEvent.accessType\" required><md-option \nng-repeat=\"accessType in vm.accessTypes\" value=\"{{accessType.value}}\" \ntranslate=\"{{\'CALENDAR.ACCESS.\' + accessType.trans}}\">Access Type</md-option></md-select><div \nng-messages=\"eventForm1.accessType.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CALENDAR.ERRORS.ACCESS_TYPE_REQUIRED\">Access type field is required</span></div></div></md-input-container>\n<div layout-xs=\"column\" layout-gt-xs=\"row\" class=\"date-row margin-tb3\"><md-datepicker \nng-model=\"vm.calendarEvent.start\" md-min-date=\"vm.now\" md-placeholder=\"Start Date\"></md-datepicker><md-input-container \nclass=\"no-errors-spacer\" flex md-no-float><md-icon class=\"event-clock-icon icon-alarm\"></md-icon><input \nclass=\"hour-input\" name=\"hoursStart\" type=\"time\" ng-model=\"vm.calendarEvent.startTime\" placeholder=\"Start Time\" \ntranslate translate-attr-placeholder=\"CALENDAR.START_TIME\"></md-input-container></div><div layout-xs=\"column\" \nlayout-gt-xs=\"row\" class=\"date-row margin-tb3\"><md-datepicker ng-model=\"vm.calendarEvent.end\" md-min-date=\"vm.now\" \nmd-placeholder=\"End Date\"></md-datepicker><md-input-container class=\"no-errors-spacer\" flex md-no-float><md-icon \nclass=\"event-clock-icon icon-alarm\"></md-icon><input class=\"hour-input\" name=\"hoursEnd\" type=\"time\" \nng-model=\"vm.calendarEvent.endTime\" placeholder=\"End Time\" translate translate-attr-placeholder=\"CALENDAR.END_TIME\">\n</md-input-container></div><div layout=\"row\" class=\"date-row margin-b18\" ng-if=\"vm.showDateError\"><div role=\"alert\">\n<span class=\"error-message\" translate=\"CALENDAR.ERRORS.DATE_ERROR\">Start date must be before end date</span></div>\n</div><div layout=\"row\" class=\"date-row margin-b18\" ng-if=\"vm.showUnacceptableStartDate\"><div role=\"alert\"><span \nclass=\"error-message\" translate=\"CALENDAR.ERRORS.DATE_NOW_ERROR\">Start date must be after current date</span></div>\n</div><div layout=\"row\" class=\"date-row margin-b18\" ng-if=\"vm.showDurationError\"><div role=\"alert\"><span \nclass=\"error-message\"><span translate=\"CALENDAR.ERRORS.DURATION_LIMIT_ERROR\">\nMaximum duration for events of this type can\'t exceed</span> {{vm.durationLimit}} <span ng-if=\"showMinutes\" \ntranslate=\"CALENDAR.ERRORS.DURATION_LIMIT_MINUTES\">minutes</span><span ng-if=\"showHours\" \ntranslate=\"CALENDAR.ERRORS.DURATION_LIMIT_HOURS\">hours</span></span></div></div><md-input-container flex \nclass=\"md-block textarea-container\"><label translate=\"CALENDAR.DESCRIPTION\">Description</label><textarea \nname=\"description\" ng-model=\"vm.calendarEvent.description\" required></textarea><div \nng-messages=\"eventForm1.description.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CALENDAR.ERRORS.DESCRIPTION_REQUIRED\">Description field is required</span></div></div></md-input-container>\n<md-input-container flex class=\"md-block textarea-container\"><label translate=\"CALENDAR.PLACE\">Place</label><input \nname=\"title\" ng-model=\"vm.calendarEvent.place\"></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"vm.saveEvent()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"horizontalStepper.$invalid\" \ntranslate=\"CALENDAR.WIZARD.SUBMIT\" translate-attr-aria-label=\"Save\">Save</md-button><md-button \nng-click=\"vm.closeDialog\" class=\"save-button md-accent md-raised\" aria-label=\"Cancel\" \nng-disabled=\"horizontalStepper.$invalid\" translate=\"CALENDAR.WIZARD.CANCEL\" translate-attr-aria-label=\"Cancel\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/eventsconferences/dialogs/event-submit-error/event-submit-error.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"{{vm.error + \'.TITLE\'}}\">Error</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"h2\" translate=\"{{vm.error + \'.MESSAGE\'}}\">SUBMIT ERROR</div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/eventsconferences/views/schedule/list.html","<div><div class=\"h3\"><div flex style=\"display: inline; float: left\"><img ng-repeat=\"c in localChildren\" \ntitle=\"{{c.title}}\" class=\"avatar\" alt=\"{{c.title}}\" ng-src=\"{{ avatar( c ) }}\"></div><a \nng-click=\"evtSchCtrl.eventDetails(event, $event)\">{{ event.title }}</a></div><div class=\"h4\" \nng-show=\"event.container != null\"><span>{{ event.container.title }}</span></div><div><span class=\"secondary-text\" \nstyle=\"font-weight:bold\">{{ evtSchCtrl.displayDate(event.startDate); }}</span></div></div><div layout=\"column\" \nlayout-align=\"center end\"><md-button flex=\"auto\" ng-click=\"evtSchCtrl.openConfLink(event)\" \nng-if=\"vm.showExternalLink(event)\" class=\"conf-link\" translate=\"ConferenceJoinButton\">Button</md-button></div>");
$templateCache.put("app/main/file-manager/dialogs/edit-docm-dialog/edit-docm-dialog.html","<md-dialog class=\"edit-document-form-dialog\" aria-label=\"Edit document\"><form name=\"editDocmForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"FM.EDIT_DOCM\">Edit document</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" ng-disabled=\"vm.documentSaving\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"FM.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label translate=\"FM.NAME\">Name</label><input \nid=\"title\" name=\"title\" ng-model=\"vm.document.title\" required md-autofocus><div \nng-messages=\"editDocmForm.title.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"FM.ERRORS.DOCUMENT_NAME_REQUIRED\">Document name is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"FM.DESCRIPTION\">Description</label><input id=\"description\" \nname=\"description\" ng-model=\"vm.document.description\"></md-input-container><div \nng-show=\"newsizebytes > vm.freediskspace\" style=\"color:rgb(213,0,0)\" layout=\"row\" layout-align=\"start start\"><span \nclass=\"title\" translate=\"NEW_FILE_ALERT.EXCEED_FREE_DISK_SPACE\">You exceed free disk space.</span></div><div \nlayout=\"row\" layout-align=\"space-between start\" style=\"margin-top:20px;margin-bottom:20px\"><span class=\"title\" \ntranslate=\"NEW_FILE_ALERT.FREE_DISK_SPACE\">free disk space</span> <span class=\"title\">\n{{vm.cvicFileService.formatFileSize(vm.freediskspace)}}</span></div><div ng-show=\"!fileuploading && newsizebytes > 0\" \nstyle=\"margin-bottom:20px\" layout=\"row\" layout-align=\"space-between start\"><span class=\"newTitle title\">{{newtitle}}\n</span> <span class=\"title\">{{newsize}}</span></div><div \nng-show=\"newsizebytes > vm.cvicJWTService.maxLimitedFileUploadSize()\" style=\"color:rgb(213,0,0)\" layout=\"row\" \nlayout-align=\"start start\"><span class=\"title\" translate=\"NEW_FILE_ALERT.EXCEED_FILE_UPLOAD_SIZE_TEXT\">\nCan not upload files larger than </span><span class=\"title\">\n&nbsp;{{vm.cvicFileService.formatFileSize(vm.cvicJWTService.maxLimitedFileUploadSize())}}.</span></div><div \nng-show=\"vm.documentSaving\" style=\"color:rgb(213,0,0)\" layout=\"row\" layout-align=\"start start\"><span class=\"title\" \ntranslate=\"FM.WAIT_TO_SAVE_DOCUMENT\">Please wait for the document to be saved.</span></div><div \nng-show=\"fileuploading == true || vm.documentSaving\" style=\"margin-bottom:20px\" layout=\"row\" \nlayout-align=\"start start\"><md-progress-linear md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-linear></div>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nclass=\"add-event-button md-accent md-raised\" upload-file file-input-id=\"document-update-upload\" aria-label=\"Upload\" \nng-disabled=\"fileuploading == true || vm.freediskspace == 0 || vm.documentSaving\" translate \ntranslate-attr-aria-label=\"FM.UPLOAD\"><span translate=\"FM.UPLOAD\">Upload</span></md-button><input type=\"file\" \nid=\"document-update-upload\" file-change fn-change-handler=\"executeUpdateUpload\" style=\"display:none\"><md-button \nng-click=\"vm.saveDocument()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"editDocmForm.$invalid  || vm.disableSave() || vm.documentSaving\" translate=\"Save\" \ntranslate-attr-aria-label=\"Save\">Save</md-button></md-dialog-actions></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/file-manager/dialogs/choose-docm-dialog/choose-docm-dialog.html","<md-dialog class=\"choose-docm-dialog\" aria-label=\"PLAY\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"text-truncate layout-align-start-center layout-row\" layout=\"row\" layout-align=\"left\"><span class=\"title\" \ntranslate=\"FM.CHOOSE_DOCUMENTS\">Choose Documents: </span><span class=\"title\">\'{{vm.container.title}}\'</span></div>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"FM.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding: 0px 0px 0px 0px\"><div ng-include=\"\'app/main/search/search.html\'\"></div>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"vm.chooseDocuments()\" \nclass=\"close-button md-accent md-raised\" aria-label=\"SAVE\" translate=\"Save\" translate-attr-aria-label=\"Save\">CLOSE\n</md-button></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/file-manager/dialogs/new-folder-form-dialog/new-folder-form-dialog.html","<md-dialog class=\"new-folder-form-dialog\" aria-label=\"New Folder\"><form name=\"folderForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"FM.NEW_FOLDER\">New folder</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"FM.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label translate=\"FM.NAME\">Name</label><input \nname=\"title\" ng-model=\"vm.folder.title\" required md-autofocus><div ng-messages=\"folderForm.title.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"FM.ERRORS.FOLDER_NAME_REQUIRED\">Folder name is required</span></div></div>\n</md-input-container><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"vm.newFolder()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"folderForm.$invalid\" \ntranslate=\"Save\" translate-attr-aria-label=\"Save\">Save</md-button></md-dialog-actions></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/file-manager/dialogs/play-docm-dialog/play-docm-dialog.html","<md-dialog class=\"play-form-dialog\" aria-label=\"PLAY\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.documentItem.title}}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"FM.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"padding: 10px 0px 0px 0px\"><md-input-container class=\"md-block\"><div id=\"player\" \nng-if=\"vm.documentItem.simpleType == \'video\' || vm.documentItem.simpleType == \'image\' || vm.documentItem.simpleType == \'flash\'\" \nclass=\"progressPlayer\" layout=\"column\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div \nng-if=\"vm.documentItem.simpleType != \'video\' && vm.documentItem.simpleType != \'image\' && vm.documentItem.simpleType != \'flash\' && vm.playerIFrameSrc == null\" \nclass=\"progressPlayer\" layout=\"column\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><iframe id=\"player\" name=\"player\" \nng-if=\"vm.playerIFrameSrc != null\" ng-src=\"{{vm.playerIFrameSrc}}\" width=\"100%\" style=\"height:85vh; border:0\"><p \ntranslate=\"FM.NO_IFRAMES\">Your browser does not support iframes.</p></iframe></md-input-container><md-dialog-actions \nng-if=\"false\" layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"vm.closeDialog()\" \nclass=\"close-button md-accent md-raised\" aria-label=\"CLOSE\" translate translate-attr-aria-label=\"FM.CLOSE\">CLOSE\n</md-button></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/file-manager/dialogs/rename-form-dialog/rename-form-dialog.html","<md-dialog class=\"rename-folder-form-dialog\" aria-label=\"Rename Folder\"><form name=\"folderForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"FM.RENAME\">Rename folder</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"FM.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label translate=\"FM.NAME\">Name</label><input \nname=\"title\" ng-model=\"vm.folder.title\" required md-autofocus><div ng-messages=\"folderForm.title.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"FM.ERRORS.FOLDER_NAME_REQUIRED\">Folder name is required</span></div></div>\n</md-input-container><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"vm.renameFolder()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"folderForm.$invalid\" translate=\"Save\" translate-attr-aria-label=\"Save\">Save</md-button>\n</md-dialog-actions></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/file-manager/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button md-mini md-fab md-warn\" \nng-if=\"vm.cvicDocumentService.canAddToPortfolio(vm.cvicDocumentService.selected())\" \nng-click=\"vm.cvicDocumentService.addToPortfolio(vm.cvicDocumentService.selected(), $event)\" \naria-label=\"Add into portfolio\" translate translate-attr-aria-label=\"FM.PORTFOLIO\"><md-icon \nmd-font-icon=\"icon-account\"></md-icon><md-tooltip><span translate=\"FM.PORTFOLIO\">Add into portfolio</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button md-mini md-fab md-warn\" \nng-click=\"vm.cvicDocumentService.editDocument(vm.cvicDocumentService.selected(), $event)\" \nng-if=\"vm.cvicDocumentService.canEditDocument(vm.cvicDocumentService.selected())\" aria-label=\"Edit\" translate \ntranslate-attr-aria-label=\"FM.EDIT_DOCM\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip><span \ntranslate=\"FM.EDIT_DOCM\">Edit</span></md-tooltip></md-button><md-button class=\"md-icon-button md-mini md-fab\" \nng-click=\"vm.cvicDocumentService.download(vm.cvicDocumentService.selected())\" \nng-if=\"vm.cvicDocumentService.canDownloadDocument(vm.cvicDocumentService.selected().entity)\" aria-label=\"Download\" \ntranslate translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span \ntranslate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button md-mini md-fab\" \nng-click=\"vm.cvicDocumentService.deleteDocument(vm.cvicDocumentService.selected(), vm.cvicDocumentService.itemContainer(), $event)\" \nng-if=\"vm.cvicDocumentService.canDeleteDocument(vm.cvicDocumentService.selected(), vm.cvicDocumentService.itemContainer())\" \naria-label=\"Delete\" translate translate-attr-aria-label=\"FM.DELETE_DOCM\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n<md-tooltip><span translate=\"FM.DELETE_DOCM\">Delete</span></md-tooltip></md-button><md-button ng-if=\"false\" \nclass=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"FM.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button>\n</div><div><div class=\"title text-truncate\" style=\"margin-top: 15px\">{{vm.cvicDocumentService.selected().name}}</div>\n</div></div><md-content class=\"content\" flex ms-scroll><div class=\"file-details\"><div \nng-if=\"vm.cvicDocumentService.selected().preview\" class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\">\n<img ng-if=\"vm.cvicDocumentService.selected().preview\" alt=\"{{vm.cvicDocumentService.selected().name}}\" \nng-src=\"{{vm.cvicDocumentService.selected().preview}}\"></div><div \nng-if=\"vm.cvicDocumentService.selected().preview === undefined && vm.cvicDocumentService.selected().entity.playOptions === undefined\" \nclass=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i \nclass=\"icon-{{vm.cvicDocumentService.selected().icontype}}\"></i></div><div \nng-if=\"vm.cvicDocumentService.selected().entity.playOptions !== undefined && vm.cvicDocumentService.selected().entity.playOptions == \'inline\'\" \nclass=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button playerBtn\" \nng-click=\"vm.cvicDocumentService.play(vm.cvicDocumentService.selected(),vm.cvicDocumentService.itemContainer(), $event)\" \nng-show=\"vm.cvicDocumentService.selectedPlayer() == null\" aria-label=\"Play\" translate \ntranslate-attr-aria-label=\"FM.PLAY\"><md-icon md-font-icon=\"icon-play-circle-outline\" class=\"playerIcon\"></md-icon>\n<md-tooltip><span translate=\"FM.PLAY\">PLAY</span></md-tooltip></md-button><md-progress-circular \nclass=\"md-accent playerProgress\" md-mode=\"indeterminate\" md-diameter=\"64\" \nng-show=\"vm.cvicDocumentService.selectedPlayer() == \'loading\'\"></md-progress-circular><div id=\"player\" layout=\"row\" \nlayout-align=\"center center\" ng-show=\"vm.cvicDocumentService.selectedPlayer() == \'loaded\'\"></div></div><div \nng-if=\"vm.cvicDocumentService.selected().entity.playOptions !== undefined && vm.cvicDocumentService.selected().entity.playOptions == \'dialog\'\" \nclass=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button playerBtn\" \nng-click=\"vm.cvicDocumentService.play(vm.cvicDocumentService.selected(),vm.cvicDocumentService.itemContainer(), $event)\" \nng-if=\"vm.cvicDocumentService.selected().entity.playOptions\" aria-label=\"Play\" translate \ntranslate-attr-aria-label=\"FM.PLAY\"><md-icon md-font-icon=\"icon-play-circle-outline\" class=\"playerIcon\"></md-icon>\n<md-tooltip><span translate=\"FM.PLAY\">PLAY</span></md-tooltip></md-button></div><div \nng-if=\"vm.cvicDocumentService.selected().entity.playOptions !== undefined && vm.cvicDocumentService.selected().entity.playOptions.indexOf(\'http\') == 0\" \nclass=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button playerBtn\" \nng-click=\"vm.cvicDocumentService.open( vm.cvicDocumentService.selected() )\" \nng-if=\"vm.cvicDocumentService.selected().entity.playOptions\" aria-label=\"Play\" translate \ntranslate-attr-aria-label=\"FM.PLAY\"><md-icon md-font-icon=\"icon-play-circle-outline\" class=\"playerIcon\"></md-icon>\n<md-tooltip><span translate=\"FM.PLAY\">PLAY</span></md-tooltip></md-button></div><md-list ng-if=\"false\" \nclass=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch \nclass=\"md-secondary\" ng-model=\"vm.cvicDocumentService.selected().offline\" aria-label=\"Toggle offline\" translate \ntranslate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title text-truncate\">\n{{vm.cvicDocumentService.selected().name}}</div><table><tr ng-if=\"vm.cvicDocumentService.selected().description\"><th \ntranslate=\"FM.DESCRIPTION\">Description</th><td>{{vm.cvicDocumentService.selected().description}}</td></tr><tr \nclass=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.cvicDocumentService.selected().type}}</td></tr><tr class=\"size\">\n<th translate=\"FM.SIZE\">Size</th><td>\n{{vm.cvicDocumentService.selected().size == \'\' ? \'-\': vm.cvicDocumentService.size(vm.cvicDocumentService.selected().entity)}}\n</td></tr><tr ng-if=\"false\" class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>\n{{vm.cvicDocumentService.selected().location}}</td></tr><tr ng-if=\"false\" class=\"owner\"><th translate=\"FM.OWNER\">Owner\n</th><td>{{vm.cvicDocumentService.selected().owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.EDITED\">Edited\n</th><td>{{vm.cvicDocumentService.selected().modified}}</td></tr><tr ng-if=\"false\" class=\"opened\"><th \ntranslate=\"FM.OPENED\">Opened</th><td>{{vm.cvicDocumentService.selected().opened}}</td></tr><tr ng-if=\"false\" \nclass=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.cvicDocumentService.selected().created}}</td></tr><tr \nng-if=\"vm.cvicDocumentService.selected().tags\" class=\"tags\"><th translate=\"FM.TAGS\">Tags</th><td><div \nlayout-align=\"start start\" class=\"labels\"><div class=\"label\" ng-repeat=\"tag in vm.cvicDocumentService.selected().tags\">\n{{tag}}</div></div></td></tr></table></div></md-content>");
$templateCache.put("app/main/file-manager/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon>\n</span><span class=\"logo-text\" translate=\"FM.FILE_MANAGER\">File Manager</span></div><div class=\"account\"></div></div>\n<div class=\"content\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\"><div \nclass=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" class=\"s16\"></md-icon><div\n class=\"title\" translate=\"FM.MY_FILES\">My Files</div></div></md-button><md-button class=\"item\" aria-label=\"starred\">\n<div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon>\n<div class=\"title\" translate=\"FM.STARRED\">Starred</div></div></md-button><md-button class=\"item\" aria-label=\"starred\">\n<div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder-account\" class=\"s16\">\n</md-icon><div class=\"title\" translate=\"FM.SHARRED_WITH_ME\">Sharred with me</div></div></md-button><md-button \nclass=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-clock\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.RECENT\">Recent</div></div></md-button>\n<md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.OFFLINE\">Offline\n</div></div></md-button></div></div>");
$templateCache.put("app/main/file-manager/views/grid/grid-view.html","<div ng-show=\"vm.cvicDocumentService.path().length > 0\" \nclass=\"breadcrumb text-truncate layout-align-start-center layout-row\" layout=\"row\" layout-align=\"left\" \nng-if=\"!vm.cvicDocumentService.isDocumentsArea()\" ng-include=\"\'app/main/file-manager/views/location.html\'\"></div><div \nng-if=\"vm.cvicDocumentService.canAddFolder()\" class=\"new-folder-button\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-accent md-raised\" aria-label=\"compose\" ng-click=\"vm.cvicDocumentService.addFolder($event)\" \ntranslate=\"FM.NEW_FOLDER\">New folder</md-button></div><div class=\"grid-view\" layout=\"column\" \nng-if=\"!vm.cvicDocumentService.loading\"><div class=\"folders\" layout=\"row\" layout-wrap><div \nclass=\"md-background-bg md-hue-2 md-whiteframe-1dp item folder\" ng-click=\"vm.cvicDocumentService.select(folder)\" \nng-repeat=\"folder in vm.cvicDocumentService.folders() | filter:global.search\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" class=\"title\" layout-align=\"start center\"><span \nclass=\"file-icon\"><i class=\"icon-{{folder.type}}\"></i> </span><span class=\"name text-truncate\">{{folder.name}}</span>\n</div><div class=\"show-details\"><div layout=\"row\" layout-align=\"left\" \nng-if=\"vm.cvicDocumentService.canManageFolder(folder)\" \nng-include=\"\'app/main/file-manager/views/folder_more_menu.html\'\"></div></div></div></div><div class=\"files\" \nlayout=\"row\" layout-wrap><div ng-click=\"vm.cvicDocumentService.select(file)\" class=\"md-whiteframe-1dp item file\" \nng-repeat=\"file in vm.cvicDocumentService.filesTmp | filter:global.search\" layout=\"column\"><div ng-if=\"file.preview\" \nclass=\"preview\"><img ng-if=\"file.preview\" alt=\"{{file.name}}\" ng-src=\"{{file.preview}}\"></div><div \nclass=\"bottom md-background-bg md-hue-2\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nclass=\"title\" layout-align=\"start center\" flex><span class=\"file-icon\"><i class=\"icon-{{file.icontype}}\"></i> </span>\n<span class=\"name text-truncate\">{{file.name}}</span></div><div class=\"show-details\" hide-gt-md><md-button \nclass=\"md-icon-button sidenav-toggle\" aria-label=\"Details\" translate translate-attr-aria-label=\"FM.DETAILS\"><md-icon \nmd-font-icon=\"icon-{{file.icontype}}\" ng-click=\"vm.cvicDocumentService.toggleDetails(file)\"></md-icon></md-button>\n</div><div class=\"show-details\"><div layout=\"row\" layout-align=\"left\" \nng-include=\"\'app/main/file-manager/views/document_more_menu.html\'\"></div></div></div></div></div></div><div \nclass=\"loading-documents\" layout=\"column\" layout-align=\"center center\" ng-if=\"vm.cvicDocumentService.loading\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div \ntranslate=\"FM.LOADING\">Loading documents...</div></div>");
$templateCache.put("app/main/file-manager/views/list/list-view.html","<div ng-show=\"vm.cvicDocumentService.path().length > 0 && !vm.cvicDocumentService.isDocumentsArea()\" \nclass=\"breadcrumb text-truncate layout-align-start-center layout-row\" layout=\"row\" layout-align=\"left\" \nng-include=\"\'app/main/file-manager/views/location.html\'\"></div><div layout=\"row\" layout-align=\"space-between end\" \nwidth=\"100%\"><div ng-if=\"vm.cvicDocumentService.canAddFolder()\" class=\"new-folder-button\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-accent md-raised\" aria-label=\"compose\" \nng-click=\"vm.cvicDocumentService.addFolder($event)\" translate=\"FM.NEW_FOLDER\">New folder</md-button></div><div \nng-show=\"(!vm.cvicDocumentService.loading || vm.cvicDocumentService.newPageLoading) \n      				&& !vm.cvicDocumentService.isMixedReposList() \n      				&& vm.cvicDocumentService.paging.total > 1\" \nclass=\"pager\" layout=\"row\" layout-align=\"end center\"><span class=\"page-info\"><span><span translate=\"FM.RESULTS_FILES\">\nFiles:</span> </span><span>{{vm.cvicDocumentService.paging.startPosition()}}</span> <span>-</span> <span>\n{{vm.cvicDocumentService.paging.endPosition()}}</span> <span translate=\"SEARCH.OF\">of</span> <span>\n{{vm.cvicDocumentService.paging.total}}</span></span><md-button ng-show=\"vm.cvicDocumentService.paging.pages() > 1\" \nng-disabled=\"vm.cvicDocumentService.paging.currentPage == 0\" class=\"md-icon-button\" aria-label=\"previous page\" \nng-click=\"vm.cvicDocumentService.paging.previousPage()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button ng-show=\"vm.cvicDocumentService.paging.pages() > 1\" \nng-disabled=\"(vm.cvicDocumentService.paging.currentPage + 1) == vm.cvicDocumentService.paging.pages()\" \nclass=\"md-icon-button\" aria-label=\"next page\" ng-click=\"vm.cvicDocumentService.paging.nextPage()\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><div layout=\"row\" layout-align=\"space-between end\">\n<div \nng-if=\"vm.cvicDocumentService.canAddDocument() \n	     		&& vm.cvicDocumentService.itemContainer() != null\n	     		&& vm.cvicDocumentService.selectedFolder() == null\n	     		&& vm.cvicDocumentService.canManageContainer()\" \nclass=\"new-docm-button\" layout=\"row\" layout-align=\"space-between start\"><md-button class=\"md-accent md-raised\" \nng-if=\"!vm.cvicDocumentService.noFreeDiskSpace()\" upload-file file-input-id=\"new-document-upload\" \naria-label=\"New document\" translate translate-attr-aria-label=\"FM.NEW_DOCUMENT\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><span translate=\"FM.NEW_DOCUMENT\">New document</span></md-button><input type=\"file\" id=\"new-document-upload\" \nfile-change fn-change-handler=\"uploadNewDocument\" \nng-if=\"vm.cvicDocumentService.canAddDocument() && !vm.cvicDocumentService.noFreeDiskSpace()\" style=\"display:none\">\n<md-button class=\"md-accent md-raised\" ng-if=\"vm.cvicDocumentService.noFreeDiskSpace()\" \nng-click=\"vm.cvicDocumentService.noFreeDiskSpaceAlert()\" translate translate-attr-aria-label=\"FM.NEW_DOCUMENT\"><md-icon\n md-font-icon=\"icon-plus\"></md-icon><span translate=\"FM.NEW_DOCUMENT\">New document</span></md-button><md-button \nclass=\"md-accent md-raised\" style=\"margin-left: 10px\" aria-label=\"Select document\" \nng-click=\"vm.cvicDocumentService.chooseDocuments($event)\" translate translate-attr-aria-label=\"FM.SELECT_DOCUMENT\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><span translate=\"FM.SELECT_DOCUMENT\">Select document</span></md-button>\n</div></div><table class=\"simple list-view\" ng-if=\"!vm.cvicDocumentService.loading\" ms-responsive-table><thead><tr><th>\n<div ng-if=\"vm.cvicDocumentService.canReorderFiles() && vm.cvicDocumentService.filesTmp.length > 1\" layout=\"row\" \nlayout-align=\"start right\"><md-button class=\"md-accent md-raised\" aria-label=\"Store order\" \nng-disabled=\"!vm.cvicDocumentService.newOrder\" ng-class=\"{\'disabled\' : !vm.cvicDocumentService.newOrder}\" \nng-click=\"vm.cvicDocumentService.storeContainerFiles([], false);\" translate translate-attr-aria-label=\"FM.STORE_ORDER\">\n<md-icon md-font-icon=\"icon-drag-vertical\"></md-icon><span translate=\"FM.STORE_ORDER\">Store order</span></md-button>\n</div></th><th translate=\"FM.NAME\">Name</th><th hide-xs translate=\"FM.SIZE\">Size</th><th hide-gt-md></th></tr></thead>\n<tbody><tr ng-repeat=\"folder in vm.cvicDocumentService.folders() | filter:global.search\" \nng-click=\"vm.cvicDocumentService.select(folder)\" \nng-class=\"{\'selected\' : vm.cvicDocumentService.selectedFolder() === folder}\"><td class=\"file-icon\"><i \nclass=\"icon-{{folder.type}}\"></i></td><td class=\"name\"><span class=\"text-truncate\">\n{{folder.name | limitTo: vm.cvicDocumentService.fileAndFolderVMLimit}}<span \nng-if=\"folder.name.length > vm.cvicDocumentService.fileAndFolderVMLimit\">...</span><md-tooltip>{{folder.name}}\n</md-tooltip></span></td><td class=\"size\" hide-xs><span ng-if=\"folder.entity.foldersCount > 0\">\n{{ \'FM.SUBFOLDERS\' | translate }}: {{folder.entity.foldersCount}}</span> <span ng-if=\"folder.entity.docsCount > 0\">\n{{ \'FM.DOCUMENTS\' | translate }}: {{folder.entity.docsCount}}</span> <span \nng-if=\"folder.entity.foldersCount == 0 && folder.entity.docsCount==0\">-</span></td><td class=\"show-details tooltip\">\n<div layout=\"row\" layout-align=\"left\" ng-if=\"vm.cvicDocumentService.canManageFolder(folder)\" \nng-include=\"\'app/main/file-manager/views/folder_more_menu.html\'\"></div></td></tr></tbody><tbody \nng-sortable=\"vm.cvicDocumentService.sortableOptions\" ng-model=\"vm.cvicDocumentService.filesTmp\"><tr \nng-repeat=\"file in vm.cvicDocumentService.filesTmp | filter:global.search\" \nng-click=\"vm.cvicDocumentService.select(file)\" ng-class=\"{\'selected\' : vm.cvicDocumentService.selected() === file}\"><td\n class=\"file-icon\"><div ng-if=\"vm.cvicDocumentService.canReorderFiles() && vm.cvicDocumentService.filesTmp.length > 1\" \nng-click=\"vm.cvicDocumentService.preventDefault($event)\" layout=\"row\" layout-align=\"start start\" class=\"handle\">\n<md-icon md-font-icon=\"icon-drag-vertical\" class=\"icon\"></md-icon><i class=\"icon-{{file.icontype}}\"></i></div><i \nng-if=\"!vm.cvicDocumentService.canReorderFiles($event) || vm.cvicDocumentService.filesTmp.length == 1\" \nclass=\"icon-{{file.icontype}}\"></i></td><td class=\"name\"><span class=\"text-truncate\">\n{{file.name | limitTo: vm.cvicDocumentService.fileAndFolderVMLimit}}<span \nng-if=\"file.name.length > vm.cvicDocumentService.fileAndFolderVMLimit\">...</span><md-tooltip>{{file.name}}</md-tooltip>\n</span><div layout=\"row\" layout-align=\"start start\"><span class=\"text-truncate\" \nng-if=\"vm.cvicDocumentService.isMixedReposList() && file.entity.organization\">{{file.entity.organization.title}} \n</span><span class=\"text-truncate\" ng-if=\"vm.cvicDocumentService.isMixedReposList() && !file.entity.organization\" \ntranslate=\"FM.REPOS.local\">My documents </span><span class=\"text-truncate\" \nng-if=\"vm.cvicDocumentService.isMixedReposList() && file.entity.parentFolder\">» {{file.entity.parentFolder.title}}\n</span></div><div layout=\"row\" layout-align=\"start start\" class=\"labels\"><div class=\"label\" \nng-repeat=\"tag in file.tags\">{{tag}}</div></div><div class=\"show-details\" hide-gt-md><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.cvicDocumentService.toggleDetails(file)\" aria-label=\"Details\" \ntranslate translate-attr-aria-label=\"FM.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon>\n</md-button></div></td><td class=\"size\" hide-xs>{{file.size === \'\' ? \'-\': file.size}}</td><td \nclass=\"show-details tooltip\"><div layout=\"row\" layout-align=\"left\" \nng-include=\"\'app/main/file-manager/views/document_more_menu.html\'\"></div></td></tr></tbody></table><div \nclass=\"loading-documents\" layout=\"column\" layout-align=\"center center\" ng-if=\"vm.cvicDocumentService.loading\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div \ntranslate=\"FM.LOADING\">Loading documents...</div></div><div \nng-show=\"(!vm.cvicDocumentService.loading || vm.cvicDocumentService.newPageLoading )\n  			&& !vm.cvicDocumentService.isMixedReposList() \n  			&& vm.cvicDocumentService.paging.pages() > 1\" \nclass=\"simple-pagination\" layout=\"row\" layout-align=\"end center\"><md-button \nng-disabled=\"vm.cvicDocumentService.paging.currentPage == 0\" \nng-class=\"{\'disabled\': vm.cvicDocumentService.paging.currentPage == 0}\" class=\"pagination-item\" \nng-click=\"vm.cvicDocumentService.paging.previousPage()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button ng-disabled=\"vm.cvicDocumentService.paging.currentPage == $index\" \nng-repeat=\"i in vm.cvicDocumentService.paging.pagesNumbersArray() track by $index\" \nng-class=\"{\'active\': vm.cvicDocumentService.paging.currentPage == $index}\" class=\"pagination-item\" \nng-show=\"vm.cvicDocumentService.paging.showPage($index)\" ng-click=\"vm.cvicDocumentService.paging.changePage($index)\">\n<span>{{$index + 1}}</span></md-button><md-button \nng-disabled=\"(vm.cvicDocumentService.paging.currentPage + 1) == vm.cvicDocumentService.paging.pages()\" \nng-class=\"{\'disabled\': (vm.cvicDocumentService.paging.currentPage + 1) == vm.cvicDocumentService.paging.pages() }\" \nclass=\"pagination-item\" ng-click=\"vm.cvicDocumentService.paging.nextPage()\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon></md-button></div>");
$templateCache.put("app/main/file-manager/views/shortlist/list-view.html","<div id=\"file-manager-preview\"><table class=\"simple list-view\" ng-if=\"!vm.cvicDocumentService.loading\" \nms-responsive-table><tbody><tr ng-repeat=\"folder in vm.cvicDocumentService.folders() | filter:global.search\" \nng-click=\"vm.cvicDocumentService.select(folder)\" \nng-class=\"{\'selected\' : vm.cvicDocumentService.selectedFolder() === folder}\"><td class=\"file-icon\"><i \nclass=\"icon-{{folder.type}}\"></i></td><td class=\"name\"><span class=\"text-truncate\">\n{{folder.name | limitTo: vm.cvicDocumentService.fileAndFolderShortVMLimit}}<span \nng-if=\"folder.name.length > vm.cvicDocumentService.fileAndFolderShortVMLimit\">...</span><md-tooltip>{{folder.name}}\n</md-tooltip></span></td></tr></tbody><tbody ng-sortable=\"vm.cvicDocumentService.sortableOptions\" \nng-model=\"vm.cvicDocumentService.filesTmp\"><tr \nng-repeat=\"file in vm.cvicDocumentService.filesTmp | filter:global.search\" \nng-click=\"vm.cvicDocumentService.select(file,true)\" \nng-class=\"{\'selected\' : vm.cvicDocumentService.selected() === file}\"><td class=\"file-icon\"><div \nng-if=\"vm.cvicDocumentService.canReorderFiles() && vm.cvicDocumentService.filesTmp.length > 1\" \nng-click=\"vm.cvicDocumentService.preventDefault($event)\" layout=\"row\" layout-align=\"start start\" class=\"handle\">\n<md-icon md-font-icon=\"icon-drag-vertical\" class=\"icon\"></md-icon><i class=\"icon-{{file.icontype}}\"></i></div><i \nng-if=\"!vm.cvicDocumentService.canReorderFiles($event) || vm.cvicDocumentService.filesTmp.length == 1\" \nclass=\"icon-{{file.icontype}}\"></i></td><td class=\"name\"><span class=\"text-truncate\">\n{{file.name | limitTo: vm.cvicDocumentService.fileAndFolderShortVMLimit}}<span \nng-if=\"file.name.length > vm.cvicDocumentService.fileAndFolderShortVMLimit\">...</span><md-tooltip>{{file.name}}\n</md-tooltip></span></td></tr></tbody></table><div class=\"loading-documents\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.cvicDocumentService.loading\"><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div translate=\"FM.LOADING\">Loading documents...</div>\n</div></div>");
$templateCache.put("app/main/mail/dialogs/compose/compose-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\"><form name=\"messageForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\" translate=\"MAIL.NEW_MESSAGE\">New Message</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nng-if=\"vm.form.to != null\" class=\"md-block to\" ng-class=\"{\'hidden-cc\': vm.hiddenCC, \'hidden-bcc\': vm.hiddenBCC}\"><label\n translate=\"MAIL.TO\">To</label><input ng-model=\"vm.form.to\" type=\"email\" md-autofocus ng-disabled=\"true\">\n</md-input-container><md-input-container \nng-if=\"vm.form.to == null\n            			&& (vm.fwTo \n            				|| ( (vm.spaceUid === undefined || vm.spaceUid == null) \n            				&& (vm.eventUid === undefined || vm.eventUid == null)))\" \nclass=\"md-block\"><label translate=\"MAIL.TO\">To</label><div \nng-if=\"vm.form.to == null\n            			&& (vm.fwTo \n            				|| ( (vm.spaceUid === undefined || vm.spaceUid == null) \n            				&& (vm.eventUid === undefined || vm.eventUid == null)))\" \nng-include=\"\'app/main/audience/chips/chips.html\'\"></div><input name=\"recipientsRequired\" ng-model=\"vm.form.recipients\" \ntype=\"hidden\" required><div ng-messages=\"messageForm.recipientsRequired.$error\" \nng-show=\"messageForm.recipientsRequired.$touched || vm.recipientsRequired==true\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MAIL.ERRORS.RECIPIENTS_REQUIRED\">Recipients field is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"MAIL.SUBJECT\">Subject</label><input \nname=\"subject\" ng-model=\"vm.form.subject\" type=\"text\" required><div ng-messages=\"messageForm.subject.$error\" \nng-show=\"messageForm.subject.$touched || vm.subjectRequired==true\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MAIL.ERRORS.SUBJECT_REQUIRED\">Subject field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><input name=\"bodyRequired\" ng-model=\"vm.form.body\" type=\"hidden\" required><div \nng-messages=\"messageForm.bodyRequired.$error\" ng-show=\"messageForm.bodyRequired.$touched || vm.bodyRequired==true\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"MAIL.ERRORS.BODY_REQUIRED\">Body field is required</span></div>\n</div><text-angular ng-model=\"vm.form.message\"></text-angular></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button ng-click=\"vm.sendDialog()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"MAIL.SEND\" \ntranslate-attr-aria-label=\"MAIL.SEND\">SEND</md-button></div><div ng-if=\"false\" layout=\"row\"><md-button \nclass=\"md-icon-button\" aria-label=\"Delete\" translate-attr-aria-label=\"MAIL.DELETE\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><md-tooltip><span translate=\"MAIL.DELETE\"></span></md-tooltip></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/mail/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"header-content\" layout=\"column\" \nlayout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-text\" \ntranslate=\"MAIL.MAILBOX\">Mailbox</span></div></div></div></div><md-content ms-scroll class=\"content\" flex><div \nclass=\"compose-button\"><md-button class=\"md-accent md-raised\" aria-label=\"compose\" ng-click=\"vm.composeDialog($event)\" \ntranslate=\"MAIL.COMPOSE\">COMPOSE</md-button></div><div class=\"navigation-simple\" layout=\"column\"><md-button \nclass=\"item\" aria-label=\"inbox\" ng-repeat=\"folder in vm.folders\" ng-click=\"vm.loadFolder(folder.name)\" \nng-class=\"{\'selected\':vm.isFolderActive(folder.name)}\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{folder.icon}}\" class=\"s16\"></md-icon><span class=\"title\">\n{{\"MAIL.\" + folder.title | uppercase | translate}}</span></div></md-button><div ng-show=\"vm.labels.length > 0\" \nclass=\"item subheader\" translate=\"MAIL.LABELS\">Labels</div><md-button class=\"item\" ng-repeat=\"label in vm.labels\" \nng-if=\"vm.labels\" ng-click=\"vm.loadLabel(label.name)\" ng-class=\"{\'selected\':vm.isLabelActive(label.name)}\"><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"h-10 w-10 mr-16\" ng-class=\"label.color\"></div><span class=\"title\">\n{{label.title}}</span></div></md-button></div></md-content>");
$templateCache.put("app/main/mail/views/classic/classic-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div ng-if=\"(vm.currentFilter.type == \'space\' || vm.currentFilter.type == \'event\') && vm.showComposeMessageBtn\" \nng-show=\"!vm.currentThread()\" class=\"compose-button\"><md-button class=\"md-accent md-raised\" aria-label=\"compose\" \nng-click=\"vm.composeDialog($event)\" translate=\"MAIL.COMPOSE\">COMPOSE</md-button></div><md-checkbox \nng-show=\"vm.currentFilter.type == null || vm.currentFilter.type == \'label\'\" class=\"no-label\" \naria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\" ng-if=\"!vm.currentThread()\">\n</md-checkbox><md-menu ng-show=\"vm.currentFilter.type == null || vm.currentFilter.type == \'label\'\" class=\"select-menu\" \nng-if=\"!vm.currentThread()\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"Filters\" \ntranslate translate-attr-aria-label=\"MAIL.FILTERS\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectThreads()\" aria-label=\"All\" \ntranslate=\"MAIL.ALL\" translate-attr-aria-label=\"MAIL.ALL\">All</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.deselectThreads()\" aria-label=\"None\" translate=\"MAIL.NONE\" translate-attr-aria-label=\"MAIL.NONE\">None\n</md-button></md-menu-item><md-menu-item ng-show=\"vm.currentFilter.filter == \'inbox\'\"><md-button \nng-click=\"vm.selectThreads(\'read\', true)\" aria-label=\"Read\" translate=\"MAIL.READ\" \ntranslate-attr-aria-label=\"MAIL.READ\">Read</md-button></md-menu-item><md-menu-item \nng-show=\"vm.currentFilter.filter == \'inbox\'\"><md-button ng-click=\"vm.selectThreads(\'read\', false)\" aria-label=\"Unread\" \ntranslate=\"MAIL.UNREAD\" translate-attr-aria-label=\"MAIL.UNREAD\">Unread</md-button></md-menu-item><md-menu-item \nng-show=\"false\"><md-button ng-click=\"vm.selectThreads(\'important\', true)\" aria-label=\"Important\" \ntranslate=\"MAIL.IMPORTANT\" translate-attr-aria-label=\"MAIL.IMPORTANT\">Important</md-button></md-menu-item><md-menu-item\n ng-show=\"false\"><md-button ng-click=\"vm.selectThreads(\'important\', false)\" aria-label=\"Not Important\" \ntranslate=\"MAIL.NOT_IMPORTANT\" translate-attr-aria-label=\"MAIL.NOT_IMPORTANT\">Not Important</md-button></md-menu-item>\n<md-menu-item ng-show=\"false\"><md-button ng-click=\"vm.selectThreads(\'starred\', true)\" aria-label=\"Starred\" \ntranslate=\"MAIL.STARRED\" translate-attr-aria-label=\"MAIL.STARRED\">Starred</md-button></md-menu-item><md-menu-item \nng-show=\"false\"><md-button ng-click=\"vm.selectThreads(\'starred\', false)\" aria-label=\"Unstarred\" \ntranslate=\"MAIL.UNSTARRED\" translate-attr-aria-label=\"MAIL.UNSTARRED\">Unstarred</md-button></md-menu-item>\n</md-menu-content></md-menu><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nng-click=\"vm.closeThread(vm)\" ng-if=\"vm.currentThread()\" translate translate-attr-aria-label=\"MAIL.BACK\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"action-buttons\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"vm.selectedThreads.length > 0 || vm.currentThread()\" \nng-if=\"vm.currentFilter.type == null || vm.currentFilter.type == \'label\'\" hide show-gt-xs><div \nclass=\"divider-vertical\"></div><md-button ng-show=\"false\" class=\"md-icon-button\" aria-label=\"Archive\" translate \ntranslate-attr-aria-label=\"MAIL.ARCHIVE\"><md-icon md-font-icon=\"icon-archive\"></md-icon><md-tooltip><span \ntranslate=\"MAIL.ARCHIVE\">Archive</span></md-tooltip></md-button><md-button ng-show=\"false\" class=\"md-icon-button\" \naria-label=\"Spam\" translate translate-attr-aria-label=\"MAIL.SPAM\"><md-icon md-font-icon=\"icon-alert-octagon\"></md-icon>\n<md-tooltip><span translate=\"MAIL.SPAM\">Spam</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \naria-label=\"Delete\" ng-click=\"vm.deleteThread()\" translate translate-attr-aria-label=\"MAIL.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"MAIL.DELETE\">Delete</span></md-tooltip></md-button>\n<div ng-show=\"false\" class=\"divider-vertical\"></div><md-button ng-show=\"false\" class=\"md-icon-button\" \naria-label=\"Move to\" translate translate-attr-aria-label=\"MAIL.MOVE_TO\"><md-icon md-font-icon=\"icon-folder\"></md-icon>\n<md-tooltip><span translate=\"MAIL.MOVE_TO\">Move to</span></md-tooltip></md-button><md-menu ng-show=\"false\"><md-button \nclass=\"md-icon-button\" aria-label=\"Labels\" translate translate-attr-aria-label=\"MAIL.LABELS\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-label\"></md-icon><md-tooltip><span translate=\"MAIL.LABELS\">\nLabels</span></md-tooltip></md-button><md-menu-content class=\"thread-labels-toggle-list\" width=\"3\"><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"MAIL.LABELS\">Labels</span></md-subheader><md-list-item \nng-repeat=\"label in vm.labels\" ng-click=\"vm.toggleLabel(label)\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"w-10 h-10 mr-16\" ng-class=\"label.color\"></div><div>{{label.title}}</div></div><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\" class=\"md-secondary\" ng-if=\"vm.currentThread() && !vm.isLabelExist(label)\">\n</md-icon><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent md-secondary\" \nng-if=\"vm.currentThread() && vm.isLabelExist(label)\"></md-icon></md-list-item></md-list></md-menu-content></md-menu>\n<div class=\"divider-vertical\"></div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"MAIL.MORE\" translate translate-attr-aria-label=\"MAIL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'read\', true)\">\n<span translate=\"MAIL.MARK_AS_READ\">Mark as read</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setThreadStatus(\'read\', false)\"><span translate=\"MAIL.MARK_AS_UNREAD\">Mark as unread</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'important\', true)\"><span \ntranslate=\"MAIL.MARK_AS_IMPORTANT\">Mark as important</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setThreadStatus(\'important\', false)\"><span translate=\"MAIL.MARK_AS_NOT_IMPORTANT\">Mark as not important\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'starred\', true)\"><span \ntranslate=\"MAIL.ADD_STAR\">Add star</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setThreadStatus(\'starred\', false)\"><span translate=\"MAIL.REMOVE_STAR\">Remove star</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div><md-menu class=\"actions-menu\" \nng-show=\"vm.selectedThreads.length > 0 || vm.currentThread()\" hide-gt-xs><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"Mail Actions\" translate translate-attr-aria-label=\"MAIL.ACTIONS\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-show=\"false\" aria-label=\"Archive\" translate-attr-aria-label=\"MAIL.ARCHIVE\"><md-icon md-font-icon=\"icon-archive\">\n</md-icon><span translate=\"MAIL.ARCHIVE\">Archive</span></md-button></md-menu-item><md-menu-item><md-button \nng-show=\"false\" aria-label=\"Spam\" translate-attr-aria-label=\"MAIL.SPAM\"><md-icon md-font-icon=\"icon-alert-octagon\">\n</md-icon><span translate=\"MAIL.SPAM\">Spam</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Delete\" ng-click=\"vm.deleteThread()\" translate-aria-label=\"MAIL.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"MAIL.DELETE\">Delete</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-show=\"false\" aria-label=\"Move To\" translate-attr-aria-label=\"MAIL.MOVE_TO\"><md-icon \nmd-font-icon=\"icon-folder-move\"></md-icon><span translate=\"MAIL.MOVE_TO\">Move To</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-show=\"false\" aria-label=\"Labels\" translate-attr-aria-label=\"MAIL.LABELS\"><md-icon \nmd-font-icon=\"icon-label\"></md-icon><span translate=\"MAIL.LABELS\">Labels</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout=\"row\" layout-align=\"start center\"><span ng-if=\"false\" class=\"page-info\" \nhide-sm>1 - 100 of 980</span><md-button ng-if=\"false\" class=\"md-icon-button arrow\" aria-label=\"Previous\" translate \ntranslate-attr-aria-label=\"MAIL.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span \ntranslate=\"MAIL.PREVIOUS\">Previous</span></md-tooltip></md-button><md-button ng-if=\"false\" \nclass=\"md-icon-button arrow\" aria-label=\"Next\" translate translate-attr-aria-label=\"MAIL.NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span translate=\"MAIL.NEXT\">Next</span></md-tooltip>\n</md-button><md-menu ng-show=\"vm.currentFilter.type == null || vm.currentFilter.type == \'label\'\" class=\"settings-menu\">\n<md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"Settings\" translate \ntranslate-attr-aria-label=\"MAIL.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.changeView(\'classic\')\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView !== \'classic\'\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView === \'classic\'\"></md-icon><span \ntranslate=\"MAIL.CLASSIC_VIEW\">Classic View</span></md-button></md-menu-item><md-menu-item hide-xs><md-button \nng-click=\"vm.changeView(\'outlook\')\"><md-icon md-font-icon=\"icon-checkbox-blank-outline\" \nng-if=\"vm.currentView !== \'outlook\'\"></md-icon><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" \nng-if=\"vm.currentView === \'outlook\'\"></md-icon><span translate=\"MAIL.OUTLOOK_VIEW\">Outlook View</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class=\"content-wrapper\" layout=\"column\" flex><div \nclass=\"content thread-detail\" ng-if=\"vm.currentThread()\" ng-include=\"\'app/main/mail/views/classic/detail/detail.html\'\" \nms-scroll flex></div><div class=\"content thread-list\" ng-if=\"!vm.currentThread()\" \nng-include=\"\'app/main/mail/views/classic/list/list.html\'\" ms-scroll flex></div></div>");
$templateCache.put("app/main/mail/views/outlook/outlook-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-checkbox ng-show=\"vm.currentFilter.type == null || vm.currentFilter.type == \'label\'\" class=\"no-label\" \naria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox><md-menu \nclass=\"select-menu\" ng-if=\"!vm.currentThread()\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"Filters\" translate translate-attr-aria-label=\"MAIL.FILTERS\"><md-icon md-font-icon=\"icon-menu-down\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectThreads()\" \naria-label=\"All\" translate=\"MAIL.ALL\" translate-attr-aria-label=\"MAIL.ALL\">All</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deselectThreads()\" aria-label=\"None\" translate=\"MAIL.NONE\" \ntranslate-attr-aria-label=\"MAIL.NONE\">None</md-button></md-menu-item><md-menu-item \nng-show=\"vm.currentFilter.filter == \'inbox\'\"><md-button ng-click=\"vm.selectThreads(\'read\', true)\" aria-label=\"Read\" \ntranslate=\"MAIL.READ\" translate-attr-aria-label=\"MAIL.READ\">Read</md-button></md-menu-item><md-menu-item \nng-show=\"vm.currentFilter.filter == \'inbox\'\"><md-button ng-click=\"vm.selectThreads(\'read\', false)\" aria-label=\"Unread\" \ntranslate=\"MAIL.UNREAD\" translate-attr-aria-label=\"MAIL.UNREAD\">Unread</md-button></md-menu-item><md-menu-item \nng-show=\"false\"><md-button ng-click=\"vm.selectThreads(\'important\', true)\" aria-label=\"Important\" \ntranslate=\"MAIL.IMPORTANT\" translate-attr-aria-label=\"MAIL.IMPORTANT\">Important</md-button></md-menu-item><md-menu-item\n ng-show=\"false\"><md-button ng-click=\"vm.selectThreads(\'important\', false)\" aria-label=\"Not Important\" \ntranslate=\"MAIL.NOT_IMPORTANT\" translate-attr-aria-label=\"MAIL.NOT_IMPORTANT\">Not Important</md-button></md-menu-item>\n<md-menu-item ng-show=\"false\"><md-button ng-click=\"vm.selectThreads(\'starred\', true)\" aria-label=\"Starred\" \ntranslate=\"MAIL.STARRED\" translate-attr-aria-label=\"MAIL.STARRED\">Starred</md-button></md-menu-item><md-menu-item \nng-show=\"false\"><md-button ng-click=\"vm.selectThreads(\'starred\', false)\" aria-label=\"Unstarred\" \ntranslate=\"MAIL.UNSTARRED\" translate-attr-aria-label=\"MAIL.UNSTARRED\">Unstarred</md-button></md-menu-item>\n</md-menu-content></md-menu><div class=\"action-buttons\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.selectedThreads.length > 0 || vm.currentThread()\" hide show-gt-xs><div class=\"divider-vertical\"></div>\n<md-button ng-show=\"false\" class=\"md-icon-button\" aria-label=\"Archive\" translate \ntranslate-attr-aria-label=\"MAIL.ARCHIVE\"><md-icon md-font-icon=\"icon-archive\"></md-icon><md-tooltip><span \ntranslate=\"MAIL.ARCHIVE\">Archive</span></md-tooltip></md-button><md-button ng-show=\"false\" class=\"md-icon-button\" \naria-label=\"Spam\" translate translate-attr-aria-label=\"MAIL.SPAM\"><md-icon md-font-icon=\"icon-alert-octagon\"></md-icon>\n<md-tooltip><span translate=\"MAIL.SPAM\">Spam</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \naria-label=\"Delete\" ng-click=\"vm.deleteThread()\" translate translate-attr-aria-label=\"MAIL.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"MAIL.DELETE\">Delete</span></md-tooltip></md-button>\n<div ng-show=\"false\" class=\"divider-vertical\"></div><md-button ng-show=\"false\" class=\"md-icon-button\" \naria-label=\"Move to\" translate translate-attr-aria-label=\"MAIL.MOVE_TO\"><md-icon md-font-icon=\"icon-folder\"></md-icon>\n<md-tooltip><span translate=\"MAIL.MOVE_TO\">Move to</span></md-tooltip></md-button><md-menu ng-show=\"false\"><md-button \nclass=\"md-icon-button\" aria-label=\"Labels\" translate translate-attr-aria-label=\"MAIL.LABELS\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-label\"></md-icon><md-tooltip><span translate=\"MAIL.LABELS\">\nLabels</span></md-tooltip></md-button><md-menu-content class=\"thread-labels-toggle-list\" width=\"3\"><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"MAIL.LABELS\">Labels</span></md-subheader><md-list-item \nng-repeat=\"label in vm.labels\" ng-click=\"vm.toggleLabel(label)\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"w-10 h-10 mr-16\" ng-class=\"label.color\"></div><div>{{label.title}}</div></div><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\" class=\"md-secondary\" ng-if=\"vm.currentThread() && !vm.isLabelExist(label)\">\n</md-icon><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent md-secondary\" \nng-if=\"vm.currentThread() && vm.isLabelExist(label)\"></md-icon></md-list-item></md-list></md-menu-content></md-menu>\n<div class=\"divider-vertical\"></div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"MAIL.MORE\" translate translate-attr-aria-label=\"MAIL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'read\', true)\">\n<span translate=\"MAIL.MARK_AS_READ\">Mark as read</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setThreadStatus(\'read\', false)\"><span translate=\"MAIL.MARK_AS_UNREAD\">Mark as unread</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'important\', true)\"><span \ntranslate=\"MAIL.MARK_AS_IMPORTANT\">Mark as important</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setThreadStatus(\'important\', false)\"><span translate=\"MAIL.MARK_AS_NOT_IMPORTANT\">Mark as not important\n</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'starred\', true)\"><span \ntranslate=\"MAIL.ADD_STAR\">Add star</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setThreadStatus(\'starred\', false)\"><span translate=\"MAIL.REMOVE_STAR\">Remove star</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div><md-menu class=\"actions-menu\" \nng-show=\"vm.selectedThreads.length > 0 || vm.currentThread()\" hide-gt-xs><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"Mail Actions\" translate translate-attr-aria-label=\"MAIL.ACTIONS\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-show=\"false\" aria-label=\"Archive\" translate-attr-aria-label=\"MAIL.ARCHIVE\"><md-icon md-font-icon=\"icon-archive\">\n</md-icon><span translate=\"MAIL.ARCHIVE\">Archive</span></md-button></md-menu-item><md-menu-item><md-button \nng-show=\"false\" aria-label=\"Spam\" translate-attr-aria-label=\"MAIL.SPAM\"><md-icon md-font-icon=\"icon-alert-octagon\">\n</md-icon><span translate=\"MAIL.SPAM\">Spam</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Delete\" ng-click=\"vm.deleteThread()\" translate-aria-label=\"MAIL.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><span translate=\"MAIL.DELETE\">Delete</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-show=\"false\" aria-label=\"Move To\" translate-attr-aria-label=\"MAIL.MOVE_TO\"><md-icon \nmd-font-icon=\"icon-folder-move\"></md-icon><span translate=\"MAIL.MOVE_TO\">Move To</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-show=\"false\" aria-label=\"Labels\" translate-attr-aria-label=\"MAIL.LABELS\"><md-icon \nmd-font-icon=\"icon-label\"></md-icon><span translate=\"MAIL.LABELS\">Labels</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout=\"row\" layout-align=\"start center\"><span ng-if=\"false\" class=\"page-info\" \nhide-sm>1 - 100 of 980</span><md-button ng-if=\"false\" class=\"md-icon-button arrow\" aria-label=\"Previous\" translate \ntranslate-attr-aria-label=\"MAIL.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span \ntranslate=\"MAIL.PREVIOUS\">Previous</span></md-tooltip></md-button><md-button ng-if=\"false\" \nclass=\"md-icon-button arrow\" aria-label=\"Next\" translate translate-attr-aria-label=\"MAIL.NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span translate=\"MAIL.NEXT\">Next</span></md-tooltip>\n</md-button><md-menu class=\"settings-menu\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"Settings\" translate translate-attr-aria-label=\"MAIL.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.changeView(\'classic\')\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView !== \'classic\'\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView === \'classic\'\"></md-icon><span \ntranslate=\"MAIL.CLASSIC_VIEW\">Classic View</span></md-button></md-menu-item><md-menu-item hide-xs><md-button \nng-click=\"vm.changeView(\'outlook\')\"><md-icon md-font-icon=\"icon-checkbox-blank-outline\" \nng-if=\"vm.currentView !== \'outlook\'\"></md-icon><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" \nng-if=\"vm.currentView === \'outlook\'\"></md-icon><span translate=\"MAIL.OUTLOOK_VIEW\">Outlook View</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class=\"content-wrapper\" layout=\"row\" flex><div \nclass=\"content thread-list\" ng-include=\"\'app/main/mail/views/outlook/list/list.html\'\" ms-scroll flex=\"50\"></div><div \nclass=\"content thread-detail\" ng-include=\"\'app/main/mail/views/outlook/detail/detail.html\'\" ms-scroll layout=\"column\" \nflex=\"50\"></div></div>");
$templateCache.put("app/main/profile/dialogs/order-child/order-child.html","<md-dialog id=\"order-child\" aria-label=\"Add child\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"{{\'ORDER_CHILD.DIALOG_TITLE\'}}\">Add child</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"ORDER_CHILD.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"childRequestForm\" \nms-horizontal-stepper ng-submit=\"vm.sendChildRequest()\" novalidate><ms-horizontal-stepper-step \nng-form=\"childRequestForm1\" step=\"1\" step-title=\"\'Search teacher\'\" step-title-translate=\"\'ORDER_CHILD.SEARCH_TEACHER\'\" \nstep-back-translate=\"\'ORDER_CHILD.WIZARD.BACK\'\" step-forward-translate=\"\'ORDER_CHILD.WIZARD.FORWARD\'\">\n<md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label translate=\"ORDER_CHILD.CHILD_NAME\">Child name\n</label><input ng-change=\"vm.searchTeachers(\'name\')\" name=\"childName\" ng-model=\"vm.filter.childName\" \nng-minlength=\"vm.childNameMinLen\" required><div ng-messages=\"childRequestForm1.childName.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"ORDER_CHILD.ERRORS.CHILD_NAME_REQUIRED\">\'Child name\' field is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><label translate=\"ORDER_CHILD.CHILD_EMAIL\">\nChild email</label><input type=\"email\" ng-change=\"vm.searchTeachers(\'email\')\" name=\"childEmail\" \nng-minlength=\"vm.childEmailMinLen\" ng-model=\"vm.filter.childEmail\"><div \nng-messages=\"childRequestForm1.childEmail.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"ORDER_CHILD.ERRORS.CHILD_EMAIL_REQUIRED\">\'Child email\' field is required</span></div><div \nng-message=\"email\"><span translate=\"ORDER_CHILD.ERRORS.CHILD_EMAIL_NOT_VALID\">Invalid email address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"ORDER_CHILD.CLASS\">Class</label><input \nng-change=\"vm.searchTeachers(\'stclass\')\" name=\"childClass\" ng-model=\"vm.filter.childClass\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"ORDER_CHILD.SCHOOL\">School</label><md-select \nng-change=\"vm.searchTeachers(\'school\')\" name=\"school\" ng-model=\"vm.filter.school\"><md-option value=\"\"></md-option>\n<md-option ng-repeat=\"school in vm.schools\" value=\"{{school.uid}}\">{{school.title}}</md-option></md-select>\n</md-input-container></md-dialog-content></ms-horizontal-stepper-step><ms-horizontal-stepper-step \nng-form=\"childRequestForm2\" step=\"2\" step-title=\"\'Request message\'\" \nstep-title-translate=\"\'ORDER_CHILD.REQUEST_MESSAGE\'\" step-back-translate=\"\'ORDER_CHILD.WIZARD.BACK\'\" \nstep-forward-translate=\"\'ORDER_CHILD.WIZARD.FORWARD\'\" step-submit-translate=\"\'ORDER_CHILD.WIZARD.SUBMIT\'\">\n<md-dialog-content ms-scroll><div ng-if=\"vm.loadingTeachers || (!vm.loadingTeachers && vm.teachers.length == 0)\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"loading\" ng-if=\"vm.loadingTeachers\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular><div translate=\"ORDER_CHILD.LOADING_TEACHERS\">Loading teachers...</div></div><div \nclass=\"search_feedback\" ng-if=\"vm.toManyMatchesWithFilter\" translate=\"ORDER_CHILD.TO_MANY_MATCHES\">\nThere are too many matches to the set criterion.</div><div class=\"search_feedback\" \nng-if=\"!vm.toManyMatchesWithFilter && !vm.loadingTeachers && vm.teachers.length == 0\" \ntranslate=\"ORDER_CHILD.NO_MATCHES\">No matches to the set criterion.</div><div class=\"search_feedback\" \nng-if=\"!vm.loadingTeachers && vm.teachers.length == 0\" translate=\"ORDER_CHILD.GO_TO_FILTER_STEP\">\nGo back and change search criterion.</div></div><md-input-container class=\"md-block\" \nng-if=\"!vm.loadingTeachers && vm.teachers.length > 0\"><label translate=\"ORDER_CHILD.CHOOSE_APPROVER_TEACHER\">\nElected teacher to confirm the request</label><md-select name=\"teachers\" ng-model=\"vm.teacher\" \nng-if=\"!vm.loadingTeachers && vm.teachers.length > 0\" required><md-option ng-repeat=\"teacher in vm.teachers\" \nvalue=\"{{teacher.uid}}\"><div layout=\"column\" layout-align=\"space-between start\">{{teacher.title}} <span \nclass=\"font-size-12 font-weight-300\" ng-show=\"teacher.organization.length > 0 \">{{teacher.organization}}</span></div>\n</md-option></md-select><div ng-messages=\"childRequestForm2.teachers.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"ORDER_CHILD.ERRORS.TEACHER_REQUIRED\">\'Teacher\' field is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"!vm.loadingTeachers && vm.teachers.length > 0\"><label \ntranslate=\"ORDER_CHILD.PARENT_PHONE\">Phone</label><input name=\"parentPhone\" ng-model=\"vm.parentPhone\" required><div \nng-messages=\"childRequestForm2.parentPhone.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"ORDER_CHILD.ERRORS.PARENT_PHONE_REQUIRED\">\'Phone\' field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block textarea-container\" ng-if=\"!vm.loadingTeachers && vm.teachers.length > 0\"><div \nstyle=\"color: gray; font-size: 0.8em\" translate=\"ORDER_CHILD.DESCR\">Descr</div><div \nng-messages=\"childRequestForm2.message.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"ORDER_CHILD.ERRORS.MESSAGE_REQUIRED\">\'Message\' field is required</span></div></div><textarea name=\"message\" \nng-model=\"vm.message\" required md-maxlength=\"900\" translate \ntranslate-attr-placeholder=\"ORDER_CHILD.MESSAGE_PLACEHOLDER\"></textarea><div \nng-messages=\"childRequestForm2.message.$error\" role=\"alert\"><div ng-message=\"md-maxlength\"><span \ntranslate=\"ORDER_CHILD.ERRORS.MESSAGE_TO_LONG\">\'Message\' field can be at most 900 characters long.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.loadingTeachers || vm.teachers.length == 0\"><input \ntype=\"hidden\" ng-model=\"vm.hdnDisableReadyBtn\" ng-if=\"vm.loadingTeachers || vm.teachers.length == 0\" required>\n</md-input-container></md-dialog-content></ms-horizontal-stepper-step></form></md-dialog>");
$templateCache.put("app/main/profile/tabs/about/about.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title\" translate=\"PROFILE.GENERAL_INFORMATION\">General Information</div></header><div \nclass=\"content\"><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.TITLE\">Title</div><div class=\"info\">\n{{ cvicProfileService.objAboutResult.title }}</div></div><div class=\"info-line\" \nng-show=\"cvicProfileService.objAboutResult.description != null || vm.bIsEditAllowed\"><div class=\"title\" \ntranslate=\"PROFILE.DESCRIPTION\">Description</div><div class=\"info\">{{ cvicProfileService.objAboutResult.description }}\n</div></div><div class=\"info-line\" ng-show=\"cvicProfileService.objAboutResult.organization != null\"><div class=\"title\" \ntranslate=\"PROFILE.ORG\">Organization</div><div class=\"info\">\n{{ cvicProfileService.objAboutResult.organization.title | translate }}</div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.LAST_UPDATED\">Last updated</div><div class=\"info\">\n{{ cvicDateService.fnGetDateObject(cvicProfileService.objAboutResult.updated) | date:cvicDateService.fnGetFormat() }}\n</div></div></div></div></div><div class=\"about-sidebar\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\" ng-if=\"vm.cvicDocumentService.filesTmp.length > 0\"><div class=\"profile-box groups md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" \ntranslate=\"PROFILE.PORTFOLIO\">Portfolio</div></header><div class=\"content\" \nng-include=\"\'app/main/file-manager/views/shortlist/list-view.html\'\"></div></div></div></div>");
$templateCache.put("app/main/profile/tabs/about/about_ch.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" \nflex-gt-md=\"30\"><div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title\" translate=\"PROFILE.GENERAL_INFORMATION\">General Information</div></header><div \nclass=\"content\"><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.TITLE\">Title</div><div class=\"info\">\n{{ cvicProfileService.objAboutResult.title }}</div></div><div class=\"info-line\" \nng-show=\"cvicProfileService.objAboutResult.description != null || vm.bIsEditAllowed\"><div class=\"title\" \ntranslate=\"PROFILE.DESCRIPTION\">Description</div><div class=\"info\">{{ cvicProfileService.objAboutResult.description }}\n</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.EMAIL\">Email</div><div class=\"info\">\n{{ cvicProfileService.objAboutResult.email }}</div></div><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.CURRENT_PLAN\">Current Plan</div><div class=\"info\">\n{{ \'PROFILE.PLAN.\' + cvicProfileService.objAboutResult.currentPlan.toUpperCase() | translate }}</div></div><div \nclass=\"info-line\" ng-show=\"cvicProfileService.objAboutResult.organization != null\"><div class=\"title\" \ntranslate=\"PROFILE.ORG\">Organization</div><div class=\"info\">\n{{ cvicProfileService.objAboutResult.organization.title | translate }}</div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.CREATED\">Created</div><div class=\"info\">\n{{ cvicDateService.fnGetDateObject(cvicProfileService.objAboutResult.inserted) | date:cvicDateService.fnGetFormat() }}\n</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.LAST_UPDATED\">Last updated</div><div \nclass=\"info\">\n{{ cvicDateService.fnGetDateObject(cvicProfileService.objAboutResult.updated) | date:cvicDateService.fnGetFormat() }}\n</div></div></div></div></div><div class=\"about-sidebar\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" \nflex-gt-md=\"30\" \nng-if=\"(cvicProfileService.objParentResult && cvicProfileService.objParentResult.length > 0 )\n    				|| (cvicProfileService.objFrequentResult && cvicProfileService.objFrequentResult.length > 0)\">\n<div class=\"profile-box groups md-whiteframe-1dp\" layout=\"column\"><contact-list \nng-if=\"cvicProfileService.objParentResult.length > 0\" collection=\"cvicProfileService.objParentResult\" \nlabel=\"ORDER_CHILD.OTHER_PARENTS\"></contact-list><contact-list ng-if=\"cvicProfileService.objFrequentResult.length > 0\" \ncollection=\"cvicProfileService.objFrequentResult\" label=\"PROFILE.FREQUENT_CONTACTS\"></contact-list></div></div><div \nclass=\"about-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"40\" \nng-if=\"vm.cvicDocumentService.filesTmp.length > 0\"><div class=\"profile-box groups md-whiteframe-1dp\" layout=\"column\">\n<header class=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" \ntranslate=\"PROFILE.PORTFOLIO\">Portfolio</div></header><div class=\"content\" \nng-include=\"\'app/main/file-manager/views/shortlist/list-view.html\'\"></div></div></div></div>");
$templateCache.put("app/main/profile/tabs/about/about_me.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" \nflex-gt-md=\"40\"><div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title\" translate=\"PROFILE.GENERAL_INFORMATION\">General Information</div></header><div \nclass=\"content\"><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.TITLE\">Title</div><div \nng-show=\"!bIsEditTitle\" class=\"info\">{{ cvicProfileService.objAboutResult.title }} <button ng-click=\"fnEditTitle()\" \ntype=\"button\" ng-show=\"vm.bIsEditAllowed\"><i class=\"icon-pencil\"></i></button></div><div ng-show=\"bIsEditTitle\" \nclass=\"info\"><input type=\"text\" ng-model=\"cvicProfileService.objAboutResult.title\"> <button ng-click=\"fnSave()\" \ntype=\"button\"><i class=\"icon-check\"></i></button></div></div><div class=\"info-line\" \nng-show=\"cvicProfileService.objAboutResult.description != null || vm.bIsEditAllowed\"><div class=\"title\" \ntranslate=\"PROFILE.DESCRIPTION\">Description</div><div ng-show=\"!bIsEditDescription\" class=\"info\">\n{{ cvicProfileService.objAboutResult.description }} <button ng-click=\"fnEditDescription()\" type=\"button\" \nng-show=\"vm.bIsEditAllowed\"><i class=\"icon-pencil\"></i></button></div><div ng-show=\"bIsEditDescription\" class=\"info\">\n<input type=\"text\" placeholder=\"Description\" translate translate-attr-placeholder=\"PROFILE.DESCRIPTION_PLACEHOLDER\" \nng-model=\"cvicProfileService.objAboutResult.description\"> <button ng-click=\"fnSave()\" type=\"button\"><i \nclass=\"icon-check\"></i></button></div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.EMAIL\">Email\n</div><div ng-show=\"!bIsEditEmail\" class=\"info\">{{ cvicProfileService.objAboutResult.settings.email }} <button \nng-click=\"fnEditEmail()\" type=\"button\" ng-show=\"vm.bIsEditEmailAllowed\"><i class=\"icon-pencil\"></i></button></div><div \nng-show=\"bIsEditEmail\" class=\"info\"><input type=\"text\" ng-model=\"cvicProfileService.objAboutResult.settings.email\"> \n<button ng-click=\"fnSave()\" type=\"button\"><i class=\"icon-check\"></i></button></div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.CURRENT_PLAN\">Current Plan</div><div class=\"info\">\n{{ \'PROFILE.PLAN.\' + cvicProfileService.objAboutResult.currentPlan.toUpperCase() | translate }}</div><md-select \nname=\"upgrades\" ng-model=\"vm.upgrade\" ng-if=\"vm.upgrades.length > 0\" placeholder=\"⟰ Промяна на плана\" \nng-change=\"onUpgradeChanged()\"><md-option>⇶ Без промяна на плана</md-option><md-option \nng-repeat=\"upgrade in vm.upgrades\" value=\"{{upgrade.index}}\"><div layout=\"column\" layout-align=\"start stretch\"><span \nclass=\"font-weight-600\">⟰ {{ \'PROFILE.PLAN.\' + upgrade.name.toUpperCase() | translate }}</span> <span \nclass=\"font-size-12 font-weight-300\">\n{{upgrade.amount}}лв. за {{upgrade.validityMonths}} {{ upgrade.validityMonths > 1 ? \'месеца\' : \'месец\'}} (до {{upgrade.validUntil | date:\'dd.MM.yyyy\'}})\n</span> <span id=\"epay{{upgrade.index}}\" style=\"display:none\" ng-bind-html=\"upgrade.renderedForm | to_trusted\"></span>\n</div></md-option></md-select></div><div class=\"info-line\" \nng-show=\"cvicProfileService.objAboutResult.organization != null\"><div class=\"title\" translate=\"PROFILE.ORG\">\nOrganization</div><div class=\"info\">{{ cvicProfileService.objAboutResult.organization.title | translate }}</div></div>\n<div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.CREATED\">Created</div><div class=\"info\">\n{{ cvicDateService.fnGetDateObject(cvicProfileService.objAboutResult.inserted) | date:cvicDateService.fnGetFormat() }}\n</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.LAST_UPDATED\">Last updated</div><div \nclass=\"info\">\n{{ cvicDateService.fnGetDateObject(cvicProfileService.objAboutResult.updated) | date:cvicDateService.fnGetFormat() }}\n</div></div></div></div></div><div class=\"about-sidebar\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" \nflex-gt-md=\"30\" \nng-if=\"( (cvicProfileService.objChildrenResult && cvicProfileService.objChildrenResult.length > 0 ) \n    				|| (cvicProfileService.objParentResult && cvicProfileService.objParentResult.length > 0 ))\">\n<div class=\"profile-box groups md-whiteframe-1dp\" layout=\"column\"><contact-list \nng-if=\"cvicProfileService.objChildrenResult.length > 0\" collection=\"cvicProfileService.objChildrenResult\" \nlabel=\"ORDER_CHILD.MY_STUDENTS\"></contact-list><contact-list ng-if=\"cvicProfileService.objParentResult.length > 0\" \ncollection=\"cvicProfileService.objParentResult\" label=\"ORDER_CHILD.OTHER_PARENTS\"></contact-list></div></div><div \nclass=\"about-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"30\" \nng-if=\"cvicProfileService.objFrequentResult && cvicProfileService.objFrequentResult.length > 0\"><div \nclass=\"profile-box groups md-whiteframe-1dp\" layout=\"column\"><contact-list \nng-if=\"cvicProfileService.objFrequentResult.length > 0\" collection=\"cvicProfileService.objFrequentResult\" \nlabel=\"PROFILE.FREQUENT_CONTACTS\"></contact-list></div></div></div>");
$templateCache.put("app/main/profile/tabs/grades/grades.html","<div layout=\"row\" layout-wrap class=\"grades-layout\"><table width=\"100%\" class=\"wrapper-table\"><thead><tr><th><i \nclass=\"icon-bulletin-board\"></i> {{ \'PROFILE.SPACE\' | translate }}</th><th>{{ \'PROFILE.COURSE.TITLE\' | translate }}\n</th><th>{{ \'PROFILE.COURSE.GRADES\' | translate }}</th><th>{{ \'PROFILE.COURSE.GRADED\' | translate }}</th></tr></thead>\n<tbody><tr ng-if=\"0\" ng-repeat-start=\"item in value\"></tr><tr ng-repeat=\"course in item.grades.usergrades\" \nng-if=\"!fnIsCourseEmpty(course)\"><td ng-if=\"$index == 0\" rowspan=\"{{fnGetNotEmptyLength(item)}}\"><a \nng-click=\"fnSpaceClick( item.space )\">{{ item.space.title }}</a></td><td style=\"font-size: 1em; white-space: nowrap\">\n<span ng-repeat=\"grade in course.gradeitems\" ng-if=\"grade.itemname\">{{ grade.itemname }}<br></span><div \nstyle=\"font-size:1.2em; border-top:1px solid lightgray\">Обща за курс</div></td><td \nstyle=\"font-size: 1em; white-space: nowrap\"><span ng-repeat=\"grade in course.gradeitems\" \nng-if=\"grade.itemtype != \'course\'\">{{ grade.gradeformatted }}<br></span><div \nstyle=\"font-size:1.2em; border-top:1px solid lightgray\" ng-repeat=\"grade in course.gradeitems\" \nng-if=\"grade.itemtype == \'course\'\">{{ grade.gradeformatted }}</div></td><td \nstyle=\"font-size: 1em; white-space: nowrap\"><span ng-repeat=\"grade in course.gradeitems\" \nng-show=\"grade.gradedategraded != null\">\n{{ cvicDateService.fnGetDateObject(grade.gradedategraded * 1000) | date:cvicDateService.fnGetOnlyDateFormat() }}<br>\n</span></td></tr><tr ng-repeat=\"course in item.grades.items\" ng-if=\"!fnIsCourseEmpty(course)\"><td ng-if=\"$index == 0\" \nrowspan=\"{{fnGetNotEmptyLength(item)}}\"><a ng-click=\"fnSpaceClick(item.space)\">{{ item.space.title }}</a></td><td>\n{{ course.name }}</td><td><span ng-repeat=\"grade in course.grades\">{{ grade.str_grade }}<br></span></td><td><span \nng-repeat=\"grade in course.grades\" ng-show=\"grade.dategraded != null\">\n{{ cvicDateService.fnGetDateObject(grade.dategraded * 1000) | date:cvicDateService.fnGetOnlyDateFormat() }}<br></span>\n</td></tr><tr ng-if=\"0\" ng-repeat-end></tr></tbody></table></div>");
$templateCache.put("app/main/spaces/dialogs/space-form/space-form-dialog.html","<md-dialog class=\"space-form-dialog\" aria-label=\"New Space\"><form name=\"spaceForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.dialogTitle | translate}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CloseDialog\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"image-wrapper ng-scope\" style=\"\"><img\n class=\"md-card-image\" id=\"space-img\" ng-src=\"{{varImgSrc}}\"><md-button ng-show=\"bImageIsAdded\" \nclass=\"md-fab md-mini delete-image-button\" ng-click=\"fnRemoveImage()\" aria-label=\"Delete Image\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button><md-button ng-show=\"!bImageIsAdded\" \nclass=\"add-img-button md-fab md-mini\" type=\"button\" aria-label=\"Add image\" upload-file file-input-id=\"space-img-file\">\n<md-icon md-font-icon=\"icon-file-image-box\"></md-icon><input id=\"space-img-file\" \naccept=\"image/x-png,image/gif,image/jpeg\" file-change fn-change-handler=\"fnAddImage\" type=\"file\" \nstyle=\"visibility: hidden; position: absolute; width: 1px; height: 1px\"></md-button></div><md-input-container \nclass=\"md-block\"><label translate=\"SpaceTitle\">Title</label><input id=\"title\" name=\"title\" ng-model=\"vm.space.title\" \nrequired md-autofocus><div ng-messages=\"spaceForm.title.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"SpaceDescription\">Description</label><input name=\"description\" \nng-model=\"vm.space.description\" required><div ng-messages=\"spaceForm.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"ERRORS.DESCRIPTION_REQUIRED\">Description field is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"SpaceAccessType\">Access type</label>\n<md-select name=\"accessType\" ng-model=\"vm.space.accessType\"><md-option value=\"\"></md-option><md-option \nng-repeat=\"x in vm.accessTypes\" value=\"{{x.value}}\">{{x.trans | translate}}</md-option></md-select>\n</md-input-container><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"vm.saveSpace()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"spaceForm.$invalid\" \ntranslate=\"Save\" translate-attr-aria-label=\"Save\">Save</md-button></md-dialog-actions></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 white-fg\" layout=\"row\" layout-align=\"space-between\" ng-class=\"card.class\"><div \nlayout=\"column\" layout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\">\n<md-button class=\"m-0\" href=\"{{card.media.playback}}\" target=\"_blank\">{{card.cta}}</md-button></div></div><div \nclass=\"media pl-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\" ng-if=\"false\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button \nclass=\"m-0 md-accent\">{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div>\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">{{ \'CALENDAR.OPTIONAL\' | translate }}</div></div></md-button></div>\n</div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\" translate=\"CALENDAR.WIZARD.BACK\">Back</md-button><div class=\"ms-stepper-dots\">\n<span ng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\" \ntranslate=\"CALENDAR.WIZARD.FORWARD\">Next</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" \nng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isFormValid()\" \ntranslate=\"CALENDAR.WIZARD.SUBMIT\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/mail/views/classic/detail/detail.html","<div class=\"thread-header\" layout=\"row\" layout-align=\"space-between center\"><div><div class=\"subject\" flex>\n{{vm.currentThread().subject}}</div><div class=\"labels\"><div class=\"label\" \nng-repeat=\"labelId in vm.currentThread().labels\" ng-class=\"vm.getLabelColor(labelId)\">{{vm.getLabelTitle(labelId)}}\n</div></div></div><div ng-if=\"vm.currentFilter.type == null || vm.currentFilter.type == \'label\'\" class=\"actions\" \nlayout=\"row\" layout-align=\"start center\"><md-button ng-if=\"vm.currentThread().Accept\" \nng-click=\"vm.acceptEntityAudience(vm.currentThread().entity.container, vm.currentThread().from.uid, $event, vm.currentThread().uid, vm.currentThread())\" \nclass=\"md-fab md-mini\" aria-label=\"Accept entity audience\"><i class=\"icon icon-account-check info-button\"></i>\n</md-button><md-button class=\"md-fab md-mini md-primary\" ng-if=\"vm.currentThread().Reject\" \nng-click=\"vm.rejectEntityAudience(vm.currentThread().entity.container, vm.currentThread().from.uid, $event, vm.currentThread().uid, vm.currentThread())\" \naria-label=\"Reject entity audience\"><i class=\"icon icon-account-remove info-button\"></i></md-button></div></div><div \nclass=\"thread-content\"><div class=\"info\" layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" \nlayout-align=\"start start\"><div layout=\"row\" layout-align=\"start start\"><div><img \nng-if=\"vm.currentThread().from.avatar\" alt=\"{{vm.currentThread().from.name}}\" \nng-src=\"{{vm.currentThread().from.avatar}}\" class=\"avatar\"><div ng-if=\"!vm.currentThread().from.avatar\" class=\"avatar\" \nms-random-class=\"vm.colors\">{{vm.currentThread().from.name[0]}}</div></div><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"name\">{{vm.currentThread().from.name}}</div><div class=\"to\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"to-text\" translate=\"MAIL.DETAILS.DATE\">to</div><div>{{vm.currentThread().time}}\n</div></div><div class=\"to\" layout=\"row\" layout-align=\"start center\" ng-if=\"vm.currentThread().to.length > 0\"><div \nclass=\"to-text\" translate=\"MAIL.INFO.TO\">to</div><div><span ng-repeat=\"toUser in vm.currentThread().to\">\n{{toUser.name}},</span></div></div></div></div><a ng-if=\"false\" class=\"toggle-details md-accent-color\" \nng-hide=\"vm.selectedMailShowDetails\" ng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" \ntranslate=\"MAIL.SHOW_DETAILS\">Show Details </a><a class=\"toggle-details md-accent-color\" \nng-show=\"vm.selectedMailShowDetails\" ng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" \ntranslate=\"MAIL.HIDE_DETAILS\">Hide Details</a><div ng-if=\"false\" ng-show=\"vm.selectedMailShowDetails\" class=\"details\" \nlayout=\"row\" layout-align=\"start start\"><div layout=\"column\"><span class=\"title\" translate=\"MAIL.DETAILS.FROM\">From:\n</span> <span class=\"title\" translate=\"MAIL.DETAILS.DATE\">Date:</span> <span ng-if=\"vm.currentThread().to.length > 0\" \nclass=\"title\" translate=\"MAIL.DETAILS.TO\">To:</span></div><div layout=\"column\"><span class=\"detail\">\n{{vm.currentThread().from.email}}</span> <span class=\"detail\">{{vm.currentThread().time}}</span> <span \nng-if=\"vm.currentThread().to.length > 0\" ng-repeat=\"toUser in vm.currentThread().to\">{{toUser.name}},</span></div>\n</div></div><md-menu><md-button aria-label=\"More\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate \ntranslate-aria-label=\"MAIL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span \ntranslate=\"MAIL.MORE\">More</span></md-tooltip></md-button><md-menu-content width=\"3\"><md-menu-item \nng-if=\"vm.canReply(vm.currentThread())\"><md-button aria-label=\"Reply\" translate-aria-label=\"MAIL.REPLY\" \nng-click=\"vm.replyDialog($event)\"><md-icon md-font-icon=\"icon-reply\"></md-icon><span translate=\"MAIL.REPLY\">Reply\n</span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.currentFilter.type == null || vm.currentFilter.type == \'label\'\"><md-button aria-label=\"Forward\" \ntranslate-aria-label=\"MAIL.FORWARD\" ng-click=\"vm.forwardDialog($event)\"><md-icon md-font-icon=\"icon-forward\"></md-icon>\n<span translate=\"MAIL.FORWARD\">Forward</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Print\" \ntranslate-aria-label=\"MAIL.PRINT\" ng-click=\"vm.printMail(vm.currentThread())\"><md-icon md-font-icon=\"icon-printer\">\n</md-icon><span translate=\"MAIL.PRINT\">Print</span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nng-bind-html=\"vm.currentThread().entity.description\"></div></div><div ng-if=\"vm.currentThread().attachments\" \nclass=\"thread-attachments\"><div class=\"title\"><span translte=\"MAIL.ATTACHMENTS\">Attachments</span>\n ({{vm.currentThread().attachments.length}})</div><div class=\"attachment-list\" layout-wrap layout=\"row\"><div \nclass=\"attachment\" layout=\"column\" ng-repeat=\"attachment in vm.currentThread().attachments\"><img class=\"preview\" \nng-src=\"{{attachment.preview}}\"><div layout=\"column\"><a href=\"#\" class=\"md-accent-color link\" translate=\"MAIL.VIEW\">\nView</a> <a href=\"#\" class=\"md-accent-color link\" translate=\"MAIL.DOWNLOAD\">Download</a><div class=\"size\">\n({{attachment.size}})</div></div></div></div></div>");
$templateCache.put("app/main/mail/views/outlook/detail/detail.html","<div ng-if=\"!vm.currentThread()\" class=\"no-thread-selected\" layout=\"column\" layout-align=\"center center\" flex><md-icon \nmd-font-icon=\"icon-email\" class=\"s120 grey-400-fg\"></md-icon><span class=\"hint-text\" \ntranslate=\"MAIL.SELECT_MESSAGE_TO_READ\">Select a message to read</span></div><div ng-if=\"vm.currentThread()\"><div \nclass=\"thread-header\" layout=\"row\" layout-align=\"space-between center\"><div><div class=\"subject\" flex>\n{{vm.currentThread().subject}}</div><div class=\"labels\"><div class=\"label\" \nng-repeat=\"labelId in vm.currentThread().labels\" ng-class=\"vm.getLabelColor(labelId)\">{{vm.getLabelTitle(labelId)}}\n</div></div></div><div class=\"actions\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleThreadStatus(\'starred\')\" aria-label=\"Toggle starred\" translate \ntranslate-attr-toogle-starred=\"MAIL.TOGGLE_STARRED\"><md-icon ng-if=\"vm.currentThread().starred\" \nmd-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon ng-if=\"!vm.currentThread().starred\" \nmd-font-icon=\"icon-star-outline\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleThreadStatus(\'important\')\" aria-label=\"Toggle important\" translate \ntranslate-attr-toogle-starred=\"MAIL.TOGGLE_IMPORTANT\"><md-icon ng-if=\"vm.currentThread().important\" \nmd-font-icon=\"icon-label\" class=\"amber-300-fg\"></md-icon><md-icon ng-if=\"!vm.currentThread().important\" \nmd-font-icon=\"icon-label-outline\"></md-icon></md-button></div></div><div class=\"thread-content\"><div class=\"info\" \nlayout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" layout-align=\"start start\"><div layout=\"row\" \nlayout-align=\"start start\"><div><img ng-if=\"vm.currentThread().from.avatar\" alt=\"{{vm.currentThread().from.name}}\" \nng-src=\"{{vm.currentThread().from.avatar}}\" class=\"avatar\"><div ng-if=\"!vm.currentThread().from.avatar\" class=\"avatar\" \nms-random-class=\"vm.colors\">{{vm.currentThread().from.name[0]}}</div></div><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"name\">{{vm.currentThread().from.name}}</div><div class=\"to\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"to-text\" translate=\"MAIL.DETAILS.DATE\">Date</div><div>\n{{vm.currentThread().time}}</div></div><div class=\"to\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.currentThread().to.length > 0\"><div class=\"to-text\" translate=\"MAIL.INFO.TO\">TO</div><div><span \nng-repeat=\"toUser in vm.currentThread().to\">{{toUser.name}},</span></div></div></div></div><a ng-if=\"false\" \nclass=\"toggle-details md-accent-color\" ng-hide=\"vm.selectedMailShowDetails\" \nng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" translate=\"MAIL.SHOW_DETAILS\">Show Details </a><a \nclass=\"toggle-details md-accent-color\" ng-show=\"vm.selectedMailShowDetails\" \nng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" translate=\"MAIL.HIDE_DETAILS\">Hide Details</a><div \nng-if=\"false\" ng-show=\"vm.selectedMailShowDetails\" class=\"details\" layout=\"row\" layout-align=\"start start\"><div \nlayout=\"column\"><span class=\"title\" translate=\"MAIL.DETAILS.FROM\">From:</span> <span class=\"title\" \ntranslate=\"MAIL.DETAILS.DATE\">Date:</span> <span ng-if=\"vm.currentThread().to.length > 0\" class=\"title\" \ntranslate=\"MAIL.DETAILS.TO\">To:</span></div><div layout=\"column\"><span class=\"detail\">{{vm.currentThread().from.email}}\n</span> <span class=\"detail\">{{vm.currentThread().time}}</span> <span ng-if=\"vm.currentThread().to.length > 0\" \nng-repeat=\"toUser in vm.currentThread().to\">{{toUser.email}},</span></div></div></div><md-menu><md-button \naria-label=\"More\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate translate-aria-label=\"MAIL.MORE\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item \nng-if=\"vm.canReply(vm.currentThread())\"><md-button aria-label=\"Reply\" translate-aria-label=\"MAIL.REPLY\" \nng-click=\"vm.replyDialog($event)\"><md-icon md-font-icon=\"icon-reply\"></md-icon><span translate=\"MAIL.REPLY\">Reply\n</span></md-button></md-menu-item><md-menu-item \nng-if=\"vm.currentFilter.type == null || vm.currentFilter.type == \'label\'\"><md-button aria-label=\"Forward\" \ntranslate-aria-label=\"MAIL.FORWARD\" ng-click=\"vm.forwardDialog($event)\"><md-icon md-font-icon=\"icon-forward\"></md-icon>\n<span translate=\"MAIL.FORWARD\">Forward</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Print\" \ntranslate-aria-label=\"MAIL.PRINT\" ng-click=\"vm.printMail(vm.currentThread())\"><md-icon md-font-icon=\"icon-printer\">\n</md-icon><span translate=\"MAIL.PRINT\">Print</span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nng-bind-html=\"vm.currentThread().message\"></div></div><div ng-if=\"vm.currentThread().attachments\" \nclass=\"thread-attachments\"><div class=\"title\"><span translte=\"MAIL.ATTACHMENTS\">Attachments</span>\n ({{vm.currentThread().attachments.length}})</div><div class=\"attachment-list\" layout-wrap layout=\"row\"><div \nclass=\"attachment\" layout=\"column\" ng-repeat=\"attachment in vm.currentThread().attachments\"><img class=\"preview\" \nng-src=\"{{attachment.preview}}\"><div layout=\"column\"><a href=\"#\" class=\"md-accent-color link\" translate=\"MAIL.VIEW\">\nView</a> <a href=\"#\" class=\"md-accent-color link\" translate=\"MAIL.DOWNLOAD\">Download</a><div class=\"size\">\n({{attachment.size}})</div></div></div></div></div></div>");
$templateCache.put("app/main/mail/views/outlook/list/list.html","<div class=\"no-threads\" ng-if=\"vm.threads.length === 0\"><label translate=\"MAIL.NO_MESSAGES\">There are no messages in\n</label><label ng-if=\"vm.currentFilter.type === null\">\'{{\"MAIL.\" + vm.currentFilter.filter | uppercase | translate }}\'\n</label>!</div><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.threads && vm.loadingThreads\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><div translate=\"MAIL.LOADING\">Loading your mails...</div></div><div \nclass=\"thread {{thread.status}}\" md-ink-ripple ng-if=\"!vm.loadingThreads\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" ng-click=\"vm.openThread(vm, thread)\" \nng-class=\"{\'unread\': !thread.read, \'current-thread\': vm.currentThread() === thread, \'selected\': vm.isSelected(thread)}\">\n<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" flex layout=\"column\"><div ng-if=\"vm.currentFilter.filter != \'sent\'\" class=\"name\" \nlayout=\"row\" layout-align=\"start center\"><img class=\"avatar\" ng-if=\"thread.from.avatar\" alt=\"{{thread.from.name}}\" \nng-src=\"{{thread.from.avatar}}\"><div class=\"avatar\" ng-if=\"!thread.from.avatar\" ms-random-class=\"vm.colors\">\n{{thread.from.name[0]}}</div><span class=\"text-truncate\">{{thread.from.name}}</span><md-icon \nmd-font-icon=\"icon-paperclip\" class=\"has-attachment s16\" ng-if=\"thread.hasAttachments\"></md-icon></div><div \nng-if=\"vm.currentFilter.filter == \'sent\' && thread.to.length > 0\" class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><md-chips ng-model=\"thread.to\" readonly=\"true\" md-removable=\"false\" \nclass=\"ng-scope md-default-theme\"><md-chip-template class=\"ng-scope\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><img ng-if=\"$chip.image\" ng-src=\"{{$chip.image}}\" class=\"avatar\" alt=\"{{$chip.name}}\"> \n<span class=\"text-truncate\">{{$chip.name}}</span></div></md-chip-template></md-chips></div><div \nclass=\"subject text-truncate\">{{thread.subject}}</div><div class=\"message text-truncate\">\n{{thread.message | htmlToPlaintext | limitTo:90}}{{thread.message.length > 90 ? \'...\' : \'\'}}<div class=\"labels\"><div \nclass=\"label\" ng-repeat=\"labelId in thread.labels\" ng-class=\"vm.getLabelColor(labelId)\">{{vm.getLabelTitle(labelId)}}\n</div></div></div></div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"time\">{{thread.time}}</div>\n</div></div></div>");
$templateCache.put("app/main/mail/views/classic/list/list.html","<div class=\"no-threads\" ng-if=\"vm.threads.length === 0\"><label translate=\"MAIL.NO_MESSAGES\">There are no messages in\n</label><label ng-if=\"vm.currentFilter.type === null\">\'{{\"MAIL.\" + vm.currentFilter.filter | uppercase | translate }}\'\n</label>!</div><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.threads && vm.loadingThreads\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><div translate=\"MAIL.LOADING\">Loading your mails...</div></div><div \nclass=\"thread {{thread.status}}\" md-ink-ripple ng-if=\"!vm.loadingThreads\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" ng-click=\"vm.openThread(vm,thread)\" \nng-class=\"{\'unread\': !thread.read, \'current-thread\': vm.currentThread() === thread, \'selected\': vm.isSelected(thread)}\">\n<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" \nng-show=\"vm.currentFilter.type == null || vm.currentFilter.type == \'label\'\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" flex layout=\"column\"><div ng-if=\"vm.currentFilter.filter != \'sent\'\" class=\"name\" \nlayout=\"row\" layout-align=\"start center\"><img class=\"avatar\" ng-if=\"thread.from.avatar\" alt=\"{{thread.from.name}}\" \nng-src=\"{{thread.from.avatar}}\"><div class=\"avatar\" ng-if=\"!thread.from.avatar\" ms-random-class=\"vm.colors\">\n{{thread.from.name[0]}}</div><span class=\"text-truncate\">{{thread.from.name}}</span><md-icon \nmd-font-icon=\"icon-paperclip\" class=\"has-attachment s16\" ng-if=\"thread.hasAttachments\"></md-icon></div><div \nng-if=\"vm.currentFilter.filter == \'sent\' && thread.to.length > 0\" layout=\"row\" layout-align=\"start center\"><md-chips \nng-model=\"thread.to\" readonly=\"true\" md-removable=\"false\" class=\"ng-scope md-default-theme\"><md-chip-template \nclass=\"ng-scope\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><img ng-if=\"$chip.image\" \nng-src=\"{{$chip.image}}\" class=\"avatar\" alt=\"{{$chip.name}}\"> <span class=\"text-truncate\">{{$chip.name}}</span></div>\n</md-chip-template></md-chips></div><div class=\"subject text-truncate\">{{thread.subject}}</div><div \nclass=\"message text-truncate\">\n{{thread.message | htmlToPlaintext | limitTo:100}}{{thread.message.length > 100 ? \'...\' : \'\'}}<div class=\"labels\"><div \nclass=\"label\" ng-repeat=\"labelId in thread.labels\" ng-class=\"vm.getLabelColor(labelId)\">{{vm.getLabelTitle(labelId)}}\n</div></div></div></div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"time\">{{thread.time}}</div>\n<div \nng-show=\"vm.currentFilter.type == null || vm.currentFilter.type == \'label\' || vm.currentFilter.type == \'space\' || vm.currentFilter.type == \'event\' || vm.currentFilter.type == \'message\'\" \nclass=\"actions\" layout=\"row\" layout-align=\"start center\"><md-button ng-if=\"thread.Accept\" \nng-click=\"vm.acceptEntityAudience(thread.entity.container, thread.from.uid, $event, thread.uid, thread)\" \nclass=\"md-fab md-mini\" aria-label=\"Accept entity audience\"><i class=\"icon icon-account-check info-button\"></i>\n</md-button><md-button class=\"md-fab md-mini md-primary\" ng-if=\"thread.Reject\" \nng-click=\"vm.rejectEntityAudience(thread.entity.container, thread.from.uid, $event, thread.uid, thread)\" \naria-label=\"Reject entity audience\"><i class=\"icon icon-account-remove info-button\"></i></md-button></div></div></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\" \ntranslate=\"{{step.stepBackTranslate}}\">Back</md-button><md-button class=\"md-accent md-raised\" \nng-if=\"!MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" \nng-click=\"MsStepper.gotoNextStep()\" translate=\"{{step.stepForwardTranslate}}\">Next</md-button><md-button type=\"submit\" \nclass=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\" translate=\"{{step.stepSubmitTranslate}}\">Submit</md-button></div>");}]);